var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _defs1, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _defs19, _defs20, _defs21, _defs22, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212, _symbol213, _symbol214, _symbol215, _symbol216, _symbol217, _symbol218, _symbol219, _symbol220, _symbol221, _symbol222, _symbol223, _symbol224, _symbol225, _symbol226, _symbol227, _symbol228, _symbol229, _symbol230, _symbol231, _symbol232, _symbol233, _symbol234, _symbol235, _symbol236, _symbol237, _symbol238, _symbol239, _symbol240, _symbol241, _symbol242, _symbol243, _symbol244, _symbol245, _symbol246, _symbol247, _symbol248, _symbol249, _symbol250, _symbol251, _symbol252, _symbol253, _symbol254, _symbol255, _symbol256, _symbol257, _symbol258, _symbol259, _symbol260, _symbol261, _symbol262, _symbol263, _symbol264, _symbol265, _symbol266, _symbol267, _symbol268, _symbol269, _symbol270, _symbol271, _symbol272, _symbol273, _symbol274, _symbol275, _symbol276, _symbol277, _symbol278, _symbol279, _symbol280, _symbol281, _symbol282, _symbol283, _symbol284, _symbol285, _symbol286, _symbol287, _symbol288, _symbol289, _symbol290, _symbol291, _symbol292, _symbol293, _symbol294, _symbol295, _symbol296, _symbol297, _symbol298, _symbol299, _symbol300, _symbol301, _symbol302, _symbol303, _symbol304, _symbol305, _symbol306, _symbol307, _symbol308, _symbol309, _symbol310, _symbol311, _symbol312, _symbol313, _symbol314, _symbol315, _symbol316, _symbol317, _symbol318, _symbol319, _symbol320, _symbol321, _symbol322, _symbol323, _symbol324, _symbol325, _symbol326, _symbol327, _symbol328, _symbol329, _symbol330, _symbol331, _symbol332, _symbol333, _symbol334, _symbol335, _symbol336, _symbol337, _symbol338, _symbol339, _symbol340, _symbol341, _symbol342, _symbol343, _symbol344, _symbol345, _symbol346, _symbol347, _symbol348, _symbol349, _symbol350, _symbol351, _symbol352, _symbol353, _symbol354, _symbol355, _symbol356, _symbol357, _symbol358, _symbol359, _defs23, _path, _path2, _symbol360, _symbol361, _defs24, _symbol362, _symbol363, _symbol364, _symbol365, _symbol366, _symbol367, _symbol368, _symbol369, _symbol370, _symbol371, _symbol372, _symbol373, _symbol374, _symbol375, _symbol376, _symbol377, _symbol378, _symbol379, _symbol380, _symbol381, _defs25, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs26, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs27, _path24, _path25, _defs28, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs29, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs30, _path47, _path48, _path49, _path50, _path51, _symbol382, _symbol383, _symbol384, _symbol385, _symbol386, _symbol387, _symbol388, _symbol389, _symbol390, _symbol391, _symbol392, _symbol393, _symbol394, _symbol395, _symbol396, _symbol397, _symbol398, _symbol399, _symbol400, _symbol401, _symbol402, _symbol403, _symbol404, _symbol405, _symbol406, _symbol407, _symbol408, _path52, _symbol409, _symbol410, _symbol411, _symbol412, _symbol413;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sprite",
    width: 0,
    height: 0,
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-account",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M363.3 363.9c-12.9-4.6-31.4-6.2-43.2-8.8-6.8-1.5-16.7-5.3-20-9.2-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6 9.4-18c3.3-8.4 6.9-31.4 6.9-31.4s6.8 0 9.2-11.9c2.6-13 6.6-18.4 6.1-28.1-.5-9-5.2-9.5-5.7-9.5 0 0 4.9-13.6 5.6-42.4C331.1 129.6 305 96 256 96s-75 33.5-74.3 67.6c.6 28.7 5.6 42.4 5.6 42.4-.5 0-5.2.5-5.7 9.5-.5 9.7 3.6 14.9 6.1 27.9 2.4 11.9 9.2 12 9.2 12s3.6 23.1 6.9 31.5c3.3 8.5 9.4 18 9.4 18s2 36.9-1.3 40.9-13.2 7.7-20 9.2c-11.9 2.6-30.3 4.3-43.2 8.9C135.8 368.5 96 384 96 416h320c0-32-39.8-47.5-52.7-52.1Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 22 27",
    id: "icon-alert",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 27.333a2.666 2.666 0 0 0 2.667-2.666H9.333A2.666 2.666 0 0 0 12 27.333Zm8-8v-6.666c0-4.1-2.18-7.52-6-8.427v-.907c0-1.106-.893-2-2-2s-2 .894-2 2v.907c-3.82.907-6 4.327-6 8.427v6.666L1.333 22v1.333h21.334V22L20 19.333Z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 18",
    id: "icon-archive",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h24v24H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.54 2.23 16.15.55C15.88.21 15.47 0 15 0H3c-.47 0-.88.21-1.16.55L.46 2.23C.17 2.57 0 3.02 0 3.5V16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3.5c0-.48-.17-.93-.46-1.27ZM3.24 2h11.52l.81.97H2.44l.8-.97ZM2 16V5h14v11H2Zm8.45-9h-2.9v3H5l4 4 4-4h-2.55V7Z",
    fill: "currentColor"
  })))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-arrow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0 8.238 1.763l6.974 6.987H0v2.5h15.212l-6.974 6.987L10 20l10-10z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-awards",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.992 3.822c-.003-.152-.005-.283-.005-.393h-4.33C19.74 1.574 19.683 0 19.683 0H4.283s-.057 1.574.027 3.429H.012L0 4.529v.614C.052 6.54.275 8.41 1.205 10.325a10.741 10.741 0 0 0 3.375 4.037 11.7 11.7 0 0 0 4.082 1.88c.871.93 1.73 1.442 2.48 1.649v1.908c-.107.567-.757 2.487-5.29 2.487h-.71V24h13.715v-1.714h-.706c-5.319 0-5.294-2.643-5.294-2.643V17.89c.75-.206 1.592-.716 2.46-1.641a11.682 11.682 0 0 0 4.104-1.887 10.74 10.74 0 0 0 3.374-4.037c1.269-2.612 1.222-5.143 1.197-6.503ZM2.746 9.576C1.971 7.98 1.77 6.375 1.724 5.143H4.43c.046.477.105.948.18 1.392.456 2.716 1.082 5.115 2.268 7.232a9.107 9.107 0 0 1-4.13-4.191Zm18.507 0a9.11 9.11 0 0 1-4.164 4.208c1.19-2.121 1.812-4.526 2.269-7.25.074-.443.133-.914.18-1.391h2.737c-.045 1.232-.247 2.837-1.022 4.433Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icon-badge1-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 77A37 37 0 1 0 3 40a37 37 0 0 0 37 37Zm0 3a40 40 0 1 1 40-40 40 40 0 0 1-40 40Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icon-badge1-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dfa",
    "data-name": "Bronze-gradient",
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 77A37 37 0 1 0 3 40a37 37 0 0 0 37 37Zm0 3a40 40 0 1 1 40-40 40 40 0 0 1-40 40Z",
    style: {
      fill: "url(#dfa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 53.43a.5.5 0 0 0-.9.44 31.67 31.67 0 0 0 3.2 5.18.52.52 0 0 0 .71.1.51.51 0 0 0 .09-.71 30.31 30.31 0 0 1-3.1-5.01ZM52.8 67.69a29.75 29.75 0 0 1-5.56 2 .5.5 0 0 0-.37.6.51.51 0 0 0 .49.38h.11a31.58 31.58 0 0 0 5.75-2 .51.51 0 0 0 .25-.67.5.5 0 0 0-.67-.24ZM26.19 67.2a29.94 29.94 0 0 1-5-3.17.52.52 0 0 0-.71.08.51.51 0 0 0 .09.71 31.61 31.61 0 0 0 5.13 3.27.46.46 0 0 0 .23.06.5.5 0 0 0 .45-.28.51.51 0 0 0-.19-.67ZM39.44 70.5a31.24 31.24 0 0 1-5.86-.68.51.51 0 0 0-.59.39.49.49 0 0 0 .37.59 32.43 32.43 0 0 0 6.05.7.52.52 0 0 0 .5-.5.5.5 0 0 0-.47-.5ZM40 9.5a31.22 31.22 0 0 1 5.87.56H46a.49.49 0 0 0 .49-.4.5.5 0 0 0-.37-.59A32.82 32.82 0 0 0 40 8.5a.5.5 0 0 0 0 1ZM53.31 12.55a31.63 31.63 0 0 1 5 3.07.46.46 0 0 0 .3.11.5.5 0 0 0 .5-.5.48.48 0 0 0-.2-.4 31 31 0 0 0-5.19-3.18.5.5 0 1 0-.44.9ZM9 39.64a.5.5 0 0 0-.5.5 31.69 31.69 0 0 0 .61 6.06.5.5 0 0 0 .49.4h.1a.5.5 0 0 0 .39-.59 31.14 31.14 0 0 1-.59-5.86.5.5 0 0 0-.5-.51ZM27.51 12.12a.67.67 0 0 0 .2 0 29.14 29.14 0 0 1 5.6-1.84.51.51 0 0 0-.22-1 31 31 0 0 0-5.78 1.9.51.51 0 0 0 .2 1ZM12.25 26.15a.5.5 0 0 0-.66.23A31.33 31.33 0 0 0 9.5 32.1a.5.5 0 0 0 .36.61H10a.51.51 0 0 0 .49-.38 30.94 30.94 0 0 1 2-5.53.5.5 0 0 0-.24-.65ZM16.39 20.41a.52.52 0 0 0 .38-.17 30.37 30.37 0 0 1 4.23-4.1.51.51 0 0 0 .08-.71.49.49 0 0 0-.69-.08A30.73 30.73 0 0 0 16 19.59a.49.49 0 0 0 0 .69.55.55 0 0 0 .39.13ZM63.59 59.33a31.52 31.52 0 0 1-4.15 4.18.49.49 0 0 0-.08.69.49.49 0 0 0 .38.18.52.52 0 0 0 .32-.11A32.81 32.81 0 0 0 64.37 60a.5.5 0 1 0-.78-.64ZM68 25.61a32.39 32.39 0 0 0-3.3-5.12.49.49 0 0 0-.7-.09.5.5 0 0 0-.08.7 30.71 30.71 0 0 1 3.19 5 .51.51 0 0 0 .44.27.46.46 0 0 0 .23-.06.48.48 0 0 0 .25-.64ZM70.27 46.73a.5.5 0 0 0-.6.37 30.4 30.4 0 0 1-1.92 5.58.5.5 0 0 0 .25.66.34.34 0 0 0 .2 0 .51.51 0 0 0 .46-.29 31.58 31.58 0 0 0 2-5.75.51.51 0 0 0-.39-.57ZM70.77 33.23a.51.51 0 0 0-.59-.38.52.52 0 0 0-.39.6 30.26 30.26 0 0 1 .7 5.85.51.51 0 0 0 .5.49.5.5 0 0 0 .49-.51 31.63 31.63 0 0 0-.71-6.05ZM40 16a24 24 0 1 0 24 24 24 24 0 0 0-24-24Zm0 47a23 23 0 1 1 23-23 23 23 0 0 1-23 23Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 6,
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e68f17"
    },
    d: "M39.46 27.02h1.08v4.33h-1.08zM39.46 48.66h1.08v4.33h-1.08zM48.66 39.46h4.33v1.08h-4.33zM27.02 39.46h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.65 32.352)",
    style: {
      fill: "#e68f17"
    },
    d: "M45.49 31.81h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.348 47.651)",
    style: {
      fill: "#e68f17"
    },
    d: "M30.18 47.11h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.649 47.653)",
    style: {
      fill: "#e68f17"
    },
    d: "M47.11 45.49h1.08v4.33h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.35 32.35)",
    style: {
      fill: "#e68f17"
    },
    d: "M31.81 30.18h1.08v4.33h-1.08z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icon-badge1-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dga",
    "data-name": "argentgradient",
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 77A37 37 0 1 0 3 40a37 37 0 0 0 37 37Zm0 3a40 40 0 1 1 40-40 40 40 0 0 1-40 40Z",
    style: {
      fill: "url(#dga)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 53.43a.5.5 0 0 0-.9.44 31.67 31.67 0 0 0 3.2 5.18.52.52 0 0 0 .71.1.51.51 0 0 0 .09-.71 30.31 30.31 0 0 1-3.1-5.01ZM52.8 67.69a29.75 29.75 0 0 1-5.56 2 .5.5 0 0 0-.37.6.51.51 0 0 0 .49.38h.11a31.58 31.58 0 0 0 5.75-2 .51.51 0 0 0 .25-.67.5.5 0 0 0-.67-.24ZM26.19 67.2a29.94 29.94 0 0 1-5-3.17.52.52 0 0 0-.71.08.51.51 0 0 0 .09.71 31.61 31.61 0 0 0 5.13 3.27.46.46 0 0 0 .23.06.5.5 0 0 0 .45-.28.51.51 0 0 0-.19-.67ZM39.44 70.5a31.24 31.24 0 0 1-5.86-.68.51.51 0 0 0-.59.39.49.49 0 0 0 .37.59 32.43 32.43 0 0 0 6.05.7.52.52 0 0 0 .5-.5.5.5 0 0 0-.47-.5ZM40 9.5a31.22 31.22 0 0 1 5.87.56H46a.49.49 0 0 0 .49-.4.5.5 0 0 0-.37-.59A32.82 32.82 0 0 0 40 8.5a.5.5 0 0 0 0 1ZM53.31 12.55a31.63 31.63 0 0 1 5 3.07.46.46 0 0 0 .3.11.5.5 0 0 0 .5-.5.48.48 0 0 0-.2-.4 31 31 0 0 0-5.19-3.18.5.5 0 1 0-.44.9ZM9 39.64a.5.5 0 0 0-.5.5 31.69 31.69 0 0 0 .61 6.06.5.5 0 0 0 .49.4h.1a.5.5 0 0 0 .39-.59 31.14 31.14 0 0 1-.59-5.86.5.5 0 0 0-.5-.51ZM27.51 12.12a.67.67 0 0 0 .2 0 29.14 29.14 0 0 1 5.6-1.84.51.51 0 0 0-.22-1 31 31 0 0 0-5.78 1.9.51.51 0 0 0 .2 1ZM12.25 26.15a.5.5 0 0 0-.66.23A31.33 31.33 0 0 0 9.5 32.1a.5.5 0 0 0 .36.61H10a.51.51 0 0 0 .49-.38 30.94 30.94 0 0 1 2-5.53.5.5 0 0 0-.24-.65ZM16.39 20.41a.52.52 0 0 0 .38-.17 30.37 30.37 0 0 1 4.23-4.1.51.51 0 0 0 .08-.71.49.49 0 0 0-.69-.08A30.73 30.73 0 0 0 16 19.59a.49.49 0 0 0 0 .69.55.55 0 0 0 .39.13ZM63.59 59.33a31.52 31.52 0 0 1-4.15 4.18.49.49 0 0 0-.08.69.49.49 0 0 0 .38.18.52.52 0 0 0 .32-.11A32.81 32.81 0 0 0 64.37 60a.5.5 0 1 0-.78-.64ZM68 25.61a32.39 32.39 0 0 0-3.3-5.12.49.49 0 0 0-.7-.09.5.5 0 0 0-.08.7 30.71 30.71 0 0 1 3.19 5 .51.51 0 0 0 .44.27.46.46 0 0 0 .23-.06.48.48 0 0 0 .25-.64ZM70.27 46.73a.5.5 0 0 0-.6.37 30.4 30.4 0 0 1-1.92 5.58.5.5 0 0 0 .25.66.34.34 0 0 0 .2 0 .51.51 0 0 0 .46-.29 31.58 31.58 0 0 0 2-5.75.51.51 0 0 0-.39-.57ZM70.77 33.23a.51.51 0 0 0-.59-.38.52.52 0 0 0-.39.6 30.26 30.26 0 0 1 .7 5.85.51.51 0 0 0 .5.49.5.5 0 0 0 .49-.51 31.63 31.63 0 0 0-.71-6.05ZM40 16a24 24 0 1 0 24 24 24 24 0 0 0-24-24Zm0 47a23 23 0 1 1 23-23 23 23 0 0 1-23 23Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 6,
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a9399"
    },
    d: "M39.46 27.02h1.08v4.33h-1.08zM39.46 48.66h1.08v4.33h-1.08zM48.66 39.46h4.33v1.08h-4.33zM27.02 39.46h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.65 32.352)",
    style: {
      fill: "#8a9399"
    },
    d: "M45.49 31.81h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.348 47.651)",
    style: {
      fill: "#8a9399"
    },
    d: "M30.18 47.11h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.649 47.653)",
    style: {
      fill: "#8a9399"
    },
    d: "M47.11 45.49h1.08v4.33h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.35 32.35)",
    style: {
      fill: "#8a9399"
    },
    d: "M31.81 30.18h1.08v4.33h-1.08z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icon-badge1-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dha",
    "data-name": "Or-gradient",
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 77A37 37 0 1 0 3 40a37 37 0 0 0 37 37Zm0 3a40 40 0 1 1 40-40 40 40 0 0 1-40 40Z",
    style: {
      fill: "url(#dha)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 53.43a.5.5 0 0 0-.9.44 31.67 31.67 0 0 0 3.2 5.18.52.52 0 0 0 .71.1.51.51 0 0 0 .09-.71 30.31 30.31 0 0 1-3.1-5.01ZM52.8 67.69a29.75 29.75 0 0 1-5.56 2 .5.5 0 0 0-.37.6.51.51 0 0 0 .49.38h.11a31.58 31.58 0 0 0 5.75-2 .51.51 0 0 0 .25-.67.5.5 0 0 0-.67-.24ZM26.19 67.2a29.94 29.94 0 0 1-5-3.17.52.52 0 0 0-.71.08.51.51 0 0 0 .09.71 31.61 31.61 0 0 0 5.13 3.27.46.46 0 0 0 .23.06.5.5 0 0 0 .45-.28.51.51 0 0 0-.19-.67ZM39.44 70.5a31.24 31.24 0 0 1-5.86-.68.51.51 0 0 0-.59.39.49.49 0 0 0 .37.59 32.43 32.43 0 0 0 6.05.7.52.52 0 0 0 .5-.5.5.5 0 0 0-.47-.5ZM40 9.5a31.22 31.22 0 0 1 5.87.56H46a.49.49 0 0 0 .49-.4.5.5 0 0 0-.37-.59A32.82 32.82 0 0 0 40 8.5a.5.5 0 0 0 0 1ZM53.31 12.55a31.63 31.63 0 0 1 5 3.07.46.46 0 0 0 .3.11.5.5 0 0 0 .5-.5.48.48 0 0 0-.2-.4 31 31 0 0 0-5.19-3.18.5.5 0 1 0-.44.9ZM9 39.64a.5.5 0 0 0-.5.5 31.69 31.69 0 0 0 .61 6.06.5.5 0 0 0 .49.4h.1a.5.5 0 0 0 .39-.59 31.14 31.14 0 0 1-.59-5.86.5.5 0 0 0-.5-.51ZM27.51 12.12a.67.67 0 0 0 .2 0 29.14 29.14 0 0 1 5.6-1.84.51.51 0 0 0-.22-1 31 31 0 0 0-5.78 1.9.51.51 0 0 0 .2 1ZM12.25 26.15a.5.5 0 0 0-.66.23A31.33 31.33 0 0 0 9.5 32.1a.5.5 0 0 0 .36.61H10a.51.51 0 0 0 .49-.38 30.94 30.94 0 0 1 2-5.53.5.5 0 0 0-.24-.65ZM16.39 20.41a.52.52 0 0 0 .38-.17 30.37 30.37 0 0 1 4.23-4.1.51.51 0 0 0 .08-.71.49.49 0 0 0-.69-.08A30.73 30.73 0 0 0 16 19.59a.49.49 0 0 0 0 .69.55.55 0 0 0 .39.13ZM63.59 59.33a31.52 31.52 0 0 1-4.15 4.18.49.49 0 0 0-.08.69.49.49 0 0 0 .38.18.52.52 0 0 0 .32-.11A32.81 32.81 0 0 0 64.37 60a.5.5 0 1 0-.78-.64ZM68 25.61a32.39 32.39 0 0 0-3.3-5.12.49.49 0 0 0-.7-.09.5.5 0 0 0-.08.7 30.71 30.71 0 0 1 3.19 5 .51.51 0 0 0 .44.27.46.46 0 0 0 .23-.06.48.48 0 0 0 .25-.64ZM70.27 46.73a.5.5 0 0 0-.6.37 30.4 30.4 0 0 1-1.92 5.58.5.5 0 0 0 .25.66.34.34 0 0 0 .2 0 .51.51 0 0 0 .46-.29 31.58 31.58 0 0 0 2-5.75.51.51 0 0 0-.39-.57ZM70.77 33.23a.51.51 0 0 0-.59-.38.52.52 0 0 0-.39.6 30.26 30.26 0 0 1 .7 5.85.51.51 0 0 0 .5.49.5.5 0 0 0 .49-.51 31.63 31.63 0 0 0-.71-6.05ZM40 16a24 24 0 1 0 24 24 24 24 0 0 0-24-24Zm0 47a23 23 0 1 1 23-23 23 23 0 0 1-23 23Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 6,
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6c317"
    },
    d: "M39.46 27.02h1.08v4.33h-1.08zM39.46 48.66h1.08v4.33h-1.08zM48.66 39.46h4.33v1.08h-4.33zM27.02 39.46h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.65 32.352)",
    style: {
      fill: "#e6c317"
    },
    d: "M45.49 31.81h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.348 47.651)",
    style: {
      fill: "#e6c317"
    },
    d: "M30.18 47.11h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.649 47.653)",
    style: {
      fill: "#e6c317"
    },
    d: "M47.11 45.49h1.08v4.33h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.35 32.35)",
    style: {
      fill: "#e6c317"
    },
    d: "M31.81 30.18h1.08v4.33h-1.08z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 80",
    id: "icon-badge1-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dia",
    "data-name": "Diamant-gradient",
    y1: 40,
    x2: 80,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 77A37 37 0 1 0 3 40a37 37 0 0 0 37 37Zm0 3a40 40 0 1 1 40-40 40 40 0 0 1-40 40Z",
    style: {
      fill: "url(#dia)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 53.43a.5.5 0 0 0-.9.44 31.67 31.67 0 0 0 3.2 5.18.52.52 0 0 0 .71.1.51.51 0 0 0 .09-.71 30.31 30.31 0 0 1-3.1-5.01ZM52.8 67.69a29.75 29.75 0 0 1-5.56 2 .5.5 0 0 0-.37.6.51.51 0 0 0 .49.38h.11a31.58 31.58 0 0 0 5.75-2 .51.51 0 0 0 .25-.67.5.5 0 0 0-.67-.24ZM26.19 67.2a29.94 29.94 0 0 1-5-3.17.52.52 0 0 0-.71.08.51.51 0 0 0 .09.71 31.61 31.61 0 0 0 5.13 3.27.46.46 0 0 0 .23.06.5.5 0 0 0 .45-.28.51.51 0 0 0-.19-.67ZM39.44 70.5a31.24 31.24 0 0 1-5.86-.68.51.51 0 0 0-.59.39.49.49 0 0 0 .37.59 32.43 32.43 0 0 0 6.05.7.52.52 0 0 0 .5-.5.5.5 0 0 0-.47-.5ZM40 9.5a31.22 31.22 0 0 1 5.87.56H46a.49.49 0 0 0 .49-.4.5.5 0 0 0-.37-.59A32.82 32.82 0 0 0 40 8.5a.5.5 0 0 0 0 1ZM53.31 12.55a31.63 31.63 0 0 1 5 3.07.46.46 0 0 0 .3.11.5.5 0 0 0 .5-.5.48.48 0 0 0-.2-.4 31 31 0 0 0-5.19-3.18.5.5 0 1 0-.44.9ZM9 39.64a.5.5 0 0 0-.5.5 31.69 31.69 0 0 0 .61 6.06.5.5 0 0 0 .49.4h.1a.5.5 0 0 0 .39-.59 31.14 31.14 0 0 1-.59-5.86.5.5 0 0 0-.5-.51ZM27.51 12.12a.67.67 0 0 0 .2 0 29.14 29.14 0 0 1 5.6-1.84.51.51 0 0 0-.22-1 31 31 0 0 0-5.78 1.9.51.51 0 0 0 .2 1ZM12.25 26.15a.5.5 0 0 0-.66.23A31.33 31.33 0 0 0 9.5 32.1a.5.5 0 0 0 .36.61H10a.51.51 0 0 0 .49-.38 30.94 30.94 0 0 1 2-5.53.5.5 0 0 0-.24-.65ZM16.39 20.41a.52.52 0 0 0 .38-.17 30.37 30.37 0 0 1 4.23-4.1.51.51 0 0 0 .08-.71.49.49 0 0 0-.69-.08A30.73 30.73 0 0 0 16 19.59a.49.49 0 0 0 0 .69.55.55 0 0 0 .39.13ZM63.59 59.33a31.52 31.52 0 0 1-4.15 4.18.49.49 0 0 0-.08.69.49.49 0 0 0 .38.18.52.52 0 0 0 .32-.11A32.81 32.81 0 0 0 64.37 60a.5.5 0 1 0-.78-.64ZM68 25.61a32.39 32.39 0 0 0-3.3-5.12.49.49 0 0 0-.7-.09.5.5 0 0 0-.08.7 30.71 30.71 0 0 1 3.19 5 .51.51 0 0 0 .44.27.46.46 0 0 0 .23-.06.48.48 0 0 0 .25-.64ZM70.27 46.73a.5.5 0 0 0-.6.37 30.4 30.4 0 0 1-1.92 5.58.5.5 0 0 0 .25.66.34.34 0 0 0 .2 0 .51.51 0 0 0 .46-.29 31.58 31.58 0 0 0 2-5.75.51.51 0 0 0-.39-.57ZM70.77 33.23a.51.51 0 0 0-.59-.38.52.52 0 0 0-.39.6 30.26 30.26 0 0 1 .7 5.85.51.51 0 0 0 .5.49.5.5 0 0 0 .49-.51 31.63 31.63 0 0 0-.71-6.05ZM40 16a24 24 0 1 0 24 24 24 24 0 0 0-24-24Zm0 47a23 23 0 1 1 23-23 23 23 0 0 1-23 23Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 6,
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a6ac3"
    },
    d: "M39.46 27.02h1.08v4.33h-1.08zM39.46 48.66h1.08v4.33h-1.08zM48.66 39.46h4.33v1.08h-4.33zM27.02 39.46h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.65 32.352)",
    style: {
      fill: "#9a6ac3"
    },
    d: "M45.49 31.81h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.348 47.651)",
    style: {
      fill: "#9a6ac3"
    },
    d: "M30.18 47.11h4.33v1.08h-4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 47.649 47.653)",
    style: {
      fill: "#9a6ac3"
    },
    d: "M47.11 45.49h1.08v4.33h-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 32.35 32.35)",
    style: {
      fill: "#9a6ac3"
    },
    d: "M31.81 30.18h1.08v4.33h-1.08z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 80",
    id: "icon-badge2-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 4A26 26 0 0 0 4 30v20a26 26 0 0 0 52 0V30A26 26 0 0 0 30 4Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0A30 30 0 0 0 0 30v20a30 30 0 0 0 60 0V30A30 30 0 0 0 30 0Zm26 50a26 26 0 0 1-52 0V30a26 26 0 0 1 52 0Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 80",
    id: "icon-badge2-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dka",
    "data-name": "Bronze-gradient",
    y1: 40,
    x2: 60,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M30 11a19 19 0 0 0-19 19v20a19 19 0 0 0 38 0V30a19 19 0 0 0-19-19Zm11.09 24.5c.24.6-.37 1.4-1.84 2.23a14.42 14.42 0 0 0-4 .1A16.49 16.49 0 0 0 38 35.21a6.46 6.46 0 0 1 1.85-.31c.65 0 1.09.2 1.24.57ZM32.26 31c.71-1.32 1.52-2.08 2.12-2.08a.71.71 0 0 1 .28.06c.6.25.72 1.18.27 2.88a13.64 13.64 0 0 0-2.8 2.94 16.16 16.16 0 0 0 .13-3.8Zm-6.78-2.1a.66.66 0 0 1 .27-.06c.56 0 1.25.63 2 1.89a13.28 13.28 0 0 0 .1 4A17.71 17.71 0 0 0 25.22 32c-.51-1.91-.37-2.9.26-3.15Zm-6.54 6.43c.15-.36.57-.55 1.22-.55a5.17 5.17 0 0 1 1.65.26 19.37 19.37 0 0 0 2.94 2.81 16.31 16.31 0 0 0-3.75-.18c-1.53-.79-2.33-1.76-2.06-2.39Zm-.08 9.17c-.24-.6.37-1.4 1.83-2.23a17.71 17.71 0 0 0 4.06-.1A14.62 14.62 0 0 0 22 44.71a6 6 0 0 1-1.86.31c-.7-.02-1.14-.2-1.28-.57Zm8.82 4.5c-.79 1.39-1.51 2.09-2.11 2.09a.67.67 0 0 1-.28-.06c-.6-.25-.73-1.24-.28-2.87a14.52 14.52 0 0 0 2.8-2.94 15.19 15.19 0 0 0-.13 3.78Zm6.78 2.11a.6.6 0 0 1-.27.06c-.56 0-1.33-.72-1.95-1.89a15.45 15.45 0 0 0-.1-4.06A13.9 13.9 0 0 0 34.72 48c.51 1.74.38 2.82-.26 3.07ZM41 44.64c-.15.36-.57.55-1.23.55a4.72 4.72 0 0 1-1.64-.27 17.34 17.34 0 0 0-2.94-2.8 12.88 12.88 0 0 0 3.78.13c1.6.89 2.3 1.75 2.03 2.39Zm-3.6-3.18a22.09 22.09 0 0 1-5-.78 3 3 0 0 1-.22.52 22 22 0 0 1 4.06 3c2.11 2.11 2.78 3.66 2.16 4.28s-2.17 0-4.28-2.17a21.35 21.35 0 0 1-3-4.06 2.36 2.36 0 0 1-.52.21 22.36 22.36 0 0 1 .78 5c0 3-.62 4.53-1.5 4.53s-1.49-1.54-1.49-4.53a21.79 21.79 0 0 1 .78-5 2.18 2.18 0 0 1-.52-.21 22.25 22.25 0 0 1-3 4.06c-2.12 2.12-3.66 2.78-4.28 2.17s.05-2.17 2.16-4.28a21.35 21.35 0 0 1 4.06-3 2.39 2.39 0 0 1-.22-.52 22.27 22.27 0 0 1-5 .78c-3 0-4.54-.64-4.54-1.51s1.55-1.49 4.54-1.49a22.1 22.1 0 0 1 4.95.78 3.11 3.11 0 0 1 .22-.53 21.67 21.67 0 0 1-4.05-3c-2.11-2.11-2.78-3.66-2.16-4.28s2.16.05 4.28 2.17a22.4 22.4 0 0 1 2.95 4 2.39 2.39 0 0 1 .52-.22 22 22 0 0 1-.77-4.94c0-3 .62-4.56 1.49-4.56s1.5 1.57 1.5 4.56a22 22 0 0 1-.77 4.94 2.39 2.39 0 0 1 .52.22 21.93 21.93 0 0 1 3-4c2.11-2.12 3.66-2.79 4.28-2.17s-.05 2.17-2.16 4.28a22 22 0 0 1-4 3 2.44 2.44 0 0 1 .21.53 22.18 22.18 0 0 1 5-.78c3 0 4.54.62 4.54 1.5s-1.52 1.5-4.51 1.5Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 4A26 26 0 0 0 4 30v20a26 26 0 0 0 52 0V30A26 26 0 0 0 30 4Zm20 46a20 20 0 0 1-40 0V30a20 20 0 0 1 40 0Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 10a20 20 0 0 0-20 20v20a20 20 0 0 0 40 0V30a20 20 0 0 0-20-20Zm19 40a19 19 0 0 1-38 0V30a19 19 0 0 1 38 0Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14 45.18a15.45 15.45 0 0 1 .1 4.06c.62 1.17 1.39 1.89 1.95 1.89a.6.6 0 0 0 .27-.06c.64-.25.77-1.33.26-3.12a13.9 13.9 0 0 1-2.58-2.77ZM25 48.12c-.45 1.63-.32 2.62.28 2.87a.67.67 0 0 0 .28.06c.6 0 1.32-.7 2.11-2.09a15.19 15.19 0 0 1 .13-3.78 14.52 14.52 0 0 1-2.8 2.94ZM39 42.25a12.88 12.88 0 0 1-3.78-.13 17.34 17.34 0 0 1 2.94 2.8 4.72 4.72 0 0 0 1.64.27c.66 0 1.08-.19 1.23-.55.24-.64-.46-1.5-2.03-2.39ZM24.75 42.12a17.71 17.71 0 0 1-4.06.1c-1.46.83-2.07 1.63-1.83 2.23.15.37.58.57 1.27.57a6 6 0 0 0 1.87-.31 14.62 14.62 0 0 1 2.75-2.59ZM35.2 37.8a14.42 14.42 0 0 1 4-.1c1.47-.83 2.08-1.63 1.84-2.23-.15-.37-.59-.57-1.28-.57a6.46 6.46 0 0 0-1.85.31 16.49 16.49 0 0 1-2.71 2.59Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41 38.46a22.18 22.18 0 0 0-5 .78 2.44 2.44 0 0 0-.21-.53 22 22 0 0 0 4-3c2.11-2.11 2.78-3.66 2.16-4.28s-2.17.05-4.28 2.17a21.93 21.93 0 0 0-3 4 2.39 2.39 0 0 0-.52-.22 22 22 0 0 0 .77-4.94c0-3-.62-4.56-1.5-4.56s-1.49 1.57-1.49 4.56a22 22 0 0 0 .77 4.94 2.39 2.39 0 0 0-.52.22 22.4 22.4 0 0 0-2.95-4c-2.12-2.12-3.66-2.79-4.28-2.17s.05 2.17 2.16 4.28a21.67 21.67 0 0 0 4.05 3 3.11 3.11 0 0 0-.22.53 22.1 22.1 0 0 0-4.95-.78c-3 0-4.54.61-4.54 1.49s1.55 1.51 4.54 1.51a22.27 22.27 0 0 0 5-.78 2.39 2.39 0 0 0 .22.52 21.35 21.35 0 0 0-4.06 3c-2.11 2.11-2.78 3.66-2.16 4.28s2.16 0 4.28-2.17a22.25 22.25 0 0 0 3-4.06 2.18 2.18 0 0 0 .52.21 21.79 21.79 0 0 0-.78 5c0 3 .62 4.53 1.49 4.53s1.5-1.54 1.5-4.53a22.36 22.36 0 0 0-.78-5 2.36 2.36 0 0 0 .52-.21 21.35 21.35 0 0 0 3 4.06c2.11 2.12 3.66 2.78 4.28 2.17s-.05-2.17-2.16-4.28a22 22 0 0 0-4.06-3 3 3 0 0 0 .22-.52 22.09 22.09 0 0 0 5 .78c3 0 4.54-.62 4.54-1.5s-1.57-1.5-4.56-1.5Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.81 34.73a13.28 13.28 0 0 1-.1-4c-.71-1.26-1.4-1.89-2-1.89a.66.66 0 0 0-.27.06c-.63.25-.77 1.24-.26 3.12a17.71 17.71 0 0 1 2.63 2.71ZM34.93 31.81c.45-1.7.33-2.63-.27-2.88a.71.71 0 0 0-.28-.06c-.6 0-1.41.76-2.12 2.08a16.16 16.16 0 0 1-.13 3.8 13.64 13.64 0 0 1 2.8-2.94ZM21 37.67a16.31 16.31 0 0 1 3.78.13 19.37 19.37 0 0 1-2.97-2.8 5.17 5.17 0 0 0-1.65-.26c-.65 0-1.07.19-1.22.55-.27.62.53 1.59 2.06 2.38Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0A30 30 0 0 0 0 30v20a30 30 0 0 0 60 0V30A30 30 0 0 0 30 0Zm26 50a26 26 0 0 1-52 0V30a26 26 0 0 1 52 0Z",
    style: {
      fill: "url(#dka)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 80",
    id: "icon-badge2-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dla",
    "data-name": "argentgradient",
    y1: 40,
    x2: 60,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M30 4A26 26 0 0 0 4 30v20a26 26 0 0 0 52 0V30A26 26 0 0 0 30 4Zm20 46a20 20 0 0 1-40 0V30a20 20 0 0 1 40 0Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11a19 19 0 0 0-19 19v20a19 19 0 0 0 38 0V30a19 19 0 0 0-19-19Zm11.09 24.5c.24.6-.37 1.4-1.84 2.22a14.42 14.42 0 0 0-4 .1A16.24 16.24 0 0 0 38 35.24a6.46 6.46 0 0 1 1.85-.31c.65 0 1.09.19 1.24.57ZM32.26 31c.71-1.32 1.52-2.08 2.12-2.08a.69.69 0 0 1 .28.05c.6.26.72 1.19.27 2.89a13.4 13.4 0 0 0-2.8 2.94 16.2 16.2 0 0 0 .13-3.8Zm-6.78-2.11a.86.86 0 0 1 .27-.05c.56 0 1.25.63 2 1.88a13.26 13.26 0 0 0 .1 4.05A17.82 17.82 0 0 0 25.22 32c-.51-1.89-.37-2.87.26-3.13Zm-6.54 6.41c.15-.35.57-.55 1.22-.55a5.2 5.2 0 0 1 1.65.27 19.1 19.1 0 0 0 2.94 2.8A16.57 16.57 0 0 0 21 37.7c-1.53-.79-2.33-1.77-2.06-2.4Zm-.08 9.18c-.24-.61.37-1.4 1.83-2.23a17.71 17.71 0 0 0 4.06-.1A14.62 14.62 0 0 0 22 44.74a6.26 6.26 0 0 1-1.86.31c-.7 0-1.14-.2-1.28-.57ZM27.68 49c-.79 1.39-1.51 2.09-2.11 2.09a.67.67 0 0 1-.28-.06c-.6-.25-.73-1.25-.28-2.87a14.52 14.52 0 0 0 2.8-2.94 15.19 15.19 0 0 0-.13 3.78Zm6.78 2.11a.76.76 0 0 1-.27 0c-.56 0-1.33-.72-1.95-1.88a15.42 15.42 0 0 0-.1-4.06A13.68 13.68 0 0 0 34.72 48c.51 1.76.38 2.84-.26 3.1ZM41 44.67c-.15.36-.57.55-1.23.55a4.72 4.72 0 0 1-1.63-.22 17.34 17.34 0 0 0-2.94-2.8 13.25 13.25 0 0 0 3.78.13c1.59.84 2.29 1.67 2.02 2.34Zm-3.6-3.19a22.08 22.08 0 0 1-5-.77 3.38 3.38 0 0 1-.22.52 22.42 22.42 0 0 1 4.06 3c2.11 2.12 2.78 3.66 2.16 4.28s-2.17-.05-4.28-2.16a22 22 0 0 1-3-4.06 2.36 2.36 0 0 1-.52.21 22.27 22.27 0 0 1 .78 5c0 3-.62 4.53-1.5 4.53s-1.49-1.54-1.49-4.53a21.71 21.71 0 0 1 .78-5 2.18 2.18 0 0 1-.52-.21 23 23 0 0 1-3 4.06c-2.12 2.11-3.66 2.78-4.28 2.16s.05-2.16 2.16-4.28a21.74 21.74 0 0 1 4.06-3 2.62 2.62 0 0 1-.22-.52 22.25 22.25 0 0 1-5 .77c-3 0-4.54-.63-4.54-1.51s1.55-1.48 4.54-1.48a21.54 21.54 0 0 1 4.95.78 3.11 3.11 0 0 1 .22-.53 21.67 21.67 0 0 1-4.05-3c-2.11-2.11-2.78-3.66-2.16-4.28s2.16 0 4.28 2.16a22.13 22.13 0 0 1 2.95 4 2 2 0 0 1 .52-.22 22.17 22.17 0 0 1-.77-5c0-3 .62-4.55 1.49-4.55s1.5 1.56 1.5 4.55a22.17 22.17 0 0 1-.77 5 2 2 0 0 1 .52.22 21.67 21.67 0 0 1 3-4c2.11-2.11 3.66-2.78 4.28-2.16s-.05 2.17-2.16 4.28a22 22 0 0 1-4 3 2.44 2.44 0 0 1 .21.53 21.62 21.62 0 0 1 5-.78c3 0 4.54.62 4.54 1.5s-1.52 1.49-4.51 1.49Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 10a20 20 0 0 0-20 20v20a20 20 0 0 0 40 0V30a20 20 0 0 0-20-20Zm19 40a19 19 0 0 1-38 0V30a19 19 0 0 1 38 0Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.81 34.75a13.26 13.26 0 0 1-.1-4.05c-.71-1.25-1.4-1.88-2-1.88a.86.86 0 0 0-.27.05c-.63.26-.77 1.24-.26 3.13a17.82 17.82 0 0 1 2.63 2.75ZM21 37.7a16.57 16.57 0 0 1 3.78.12A19.1 19.1 0 0 1 21.81 35a5.2 5.2 0 0 0-1.65-.27c-.65 0-1.07.2-1.22.55-.27.65.53 1.63 2.06 2.42ZM24.75 42.15a17.71 17.71 0 0 1-4.06.1c-1.46.83-2.07 1.62-1.83 2.23.15.37.58.57 1.27.57a6.26 6.26 0 0 0 1.87-.31 14.62 14.62 0 0 1 2.75-2.59ZM34.93 31.84c.45-1.7.33-2.63-.27-2.89a.69.69 0 0 0-.28-.05c-.6 0-1.41.76-2.12 2.08a16.2 16.2 0 0 1-.13 3.8 13.4 13.4 0 0 1 2.8-2.94ZM35.2 37.82a14.42 14.42 0 0 1 4-.1c1.47-.82 2.08-1.62 1.84-2.22-.15-.38-.59-.57-1.28-.57a6.46 6.46 0 0 0-1.85.31 16.24 16.24 0 0 1-2.71 2.58ZM39 42.28a13.25 13.25 0 0 1-3.78-.13A17.34 17.34 0 0 1 38.14 45a4.72 4.72 0 0 0 1.64.27c.66 0 1.08-.19 1.23-.55.26-.72-.44-1.55-2.01-2.44Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41 38.49a21.62 21.62 0 0 0-5 .78 2.44 2.44 0 0 0-.21-.53 22 22 0 0 0 4-3c2.11-2.11 2.78-3.66 2.16-4.28s-2.17 0-4.28 2.16a21.67 21.67 0 0 0-3 4 2 2 0 0 0-.52-.22 22.17 22.17 0 0 0 .77-5c0-3-.62-4.55-1.5-4.55s-1.49 1.56-1.49 4.55a22.17 22.17 0 0 0 .77 5 2 2 0 0 0-.52.22 22.13 22.13 0 0 0-2.95-4c-2.12-2.11-3.66-2.78-4.28-2.16s.05 2.17 2.16 4.28a21.67 21.67 0 0 0 4.05 3 3.11 3.11 0 0 0-.22.53 21.54 21.54 0 0 0-4.95-.78c-3 0-4.54.61-4.54 1.48s1.55 1.51 4.54 1.51a22.25 22.25 0 0 0 5-.77 2.62 2.62 0 0 0 .22.52 21.74 21.74 0 0 0-4.06 3c-2.11 2.12-2.78 3.66-2.16 4.28s2.16-.05 4.28-2.16a23 23 0 0 0 3-4.06 2.18 2.18 0 0 0 .52.21 21.71 21.71 0 0 0-.78 5c0 3 .62 4.53 1.49 4.53s1.5-1.54 1.5-4.53a22.27 22.27 0 0 0-.78-5 2.36 2.36 0 0 0 .52-.21 22 22 0 0 0 3 4.06c2.11 2.11 3.66 2.78 4.28 2.16s-.05-2.16-2.16-4.28a22.42 22.42 0 0 0-4.06-3 3.38 3.38 0 0 0 .22-.52 22.08 22.08 0 0 0 5 .77c3 0 4.54-.62 4.54-1.49s-1.57-1.5-4.56-1.5Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 48.15c-.45 1.62-.32 2.62.28 2.87a.67.67 0 0 0 .28.06c.6 0 1.32-.7 2.11-2.09a15.19 15.19 0 0 1 .13-3.78 14.52 14.52 0 0 1-2.8 2.94ZM32.14 45.21a15.42 15.42 0 0 1 .1 4.06c.62 1.16 1.39 1.88 1.95 1.88a.76.76 0 0 0 .27 0c.64-.26.77-1.34.26-3.13a13.68 13.68 0 0 1-2.58-2.81Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0A30 30 0 0 0 0 30v20a30 30 0 0 0 60 0V30A30 30 0 0 0 30 0Zm26 50a26 26 0 0 1-52 0V30a26 26 0 0 1 52 0Z",
    style: {
      fill: "url(#dla)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 80",
    id: "icon-badge2-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dma",
    "data-name": "Or-gradient",
    y1: 40,
    x2: 60,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M30 4A26 26 0 0 0 4 30v20a26 26 0 0 0 52 0V30A26 26 0 0 0 30 4Zm20 46a20 20 0 0 1-40 0V30a20 20 0 0 1 40 0Z",
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0A30 30 0 0 0 0 30v20a30 30 0 0 0 60 0V30A30 30 0 0 0 30 0Zm26 50a26 26 0 0 1-52 0V30a26 26 0 0 1 52 0Z",
    style: {
      fill: "url(#dma)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11a19 19 0 0 0-19 19v20a19 19 0 0 0 38 0V30a19 19 0 0 0-19-19Zm11.14 24.51c.24.61-.37 1.41-1.84 2.24a14.48 14.48 0 0 0-4.06.1 15.89 15.89 0 0 0 2.76-2.6 6.52 6.52 0 0 1 1.86-.31c.69 0 1.14.2 1.28.57ZM32.29 31c.72-1.33 1.53-2.09 2.12-2.09a.87.87 0 0 1 .28.05c.61.26.73 1.19.28 2.9a13.36 13.36 0 0 0-2.8 2.94 15.81 15.81 0 0 0 .12-3.8Zm-6.79-2.13a.86.86 0 0 1 .27-.05c.56 0 1.25.63 2 1.89a13.7 13.7 0 0 0 .1 4.06A17.71 17.71 0 0 0 25.24 32c-.52-1.88-.38-2.87.26-3.13Zm-6.56 6.45c.15-.36.57-.55 1.23-.55a4.84 4.84 0 0 1 1.64.27 19.47 19.47 0 0 0 3 2.8 16.63 16.63 0 0 0-3.81-.12c-1.52-.79-2.33-1.72-2.06-2.4Zm-.08 9.19c-.24-.6.37-1.4 1.84-2.23a17.81 17.81 0 0 0 4.07-.1A14.55 14.55 0 0 0 22 44.77a6 6 0 0 1-1.86.32c-.69 0-1.14-.2-1.28-.58ZM27.71 49c-.8 1.39-1.53 2.09-2.12 2.09a.67.67 0 0 1-.28-.06c-.6-.25-.74-1.25-.28-2.87a14.72 14.72 0 0 0 2.8-3 15 15 0 0 0-.12 3.84Zm6.79 2.11a.65.65 0 0 1-.27.05c-.56 0-1.34-.72-2-1.88a15.51 15.51 0 0 0-.1-4.07A14.1 14.1 0 0 0 34.76 48c.51 1.81.38 2.89-.26 3.15Zm6.56-6.44c-.15.36-.57.55-1.23.55a5 5 0 0 1-1.65-.22 17 17 0 0 0-3-2.81 13 13 0 0 0 3.8.13c1.64.88 2.35 1.76 2.08 2.39Zm-3.61-3.2a21.71 21.71 0 0 1-5-.78 2.71 2.71 0 0 1-.22.52 22.24 22.24 0 0 1 4.07 3c2.12 2.12 2.79 3.67 2.16 4.29s-2.16 0-4.28-2.17a21.79 21.79 0 0 1-3-4.07 2.36 2.36 0 0 1-.52.21 22.36 22.36 0 0 1 .78 5c0 3-.62 4.54-1.5 4.54s-1.5-1.54-1.5-4.54a22.36 22.36 0 0 1 .78-5 2.36 2.36 0 0 1-.52-.21 21.79 21.79 0 0 1-3 4.07c-2.12 2.12-3.66 2.79-4.28 2.17s0-2.17 2.16-4.29a22.24 22.24 0 0 1 4.07-3 2.71 2.71 0 0 1-.22-.52 21.71 21.71 0 0 1-5 .78c-3 0-4.55-.63-4.55-1.51s1.55-1.49 4.55-1.49a22.09 22.09 0 0 1 5 .78 3.49 3.49 0 0 1 .22-.53 22.07 22.07 0 0 1-4.06-2.95c-2.12-2.12-2.79-3.67-2.16-4.29s2.16.05 4.28 2.16a22.12 22.12 0 0 1 3 4.06 2.27 2.27 0 0 1 .53-.22 21.62 21.62 0 0 1-.78-5c0-3 .62-4.56 1.5-4.56s1.5 1.57 1.5 4.56a21.62 21.62 0 0 1-.78 5 2.27 2.27 0 0 1 .53.22 22.12 22.12 0 0 1 3-4.06c2.12-2.11 3.66-2.78 4.28-2.16s0 2.17-2.16 4.29a22.07 22.07 0 0 1-4.06 2.95 3.49 3.49 0 0 1 .22.53 22.09 22.09 0 0 1 5-.78c3 0 4.55.63 4.55 1.5s-1.59 1.54-4.59 1.54Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 10a20 20 0 0 0-20 20v20a20 20 0 0 0 40 0V30a20 20 0 0 0-20-20Zm19 40a19 19 0 0 1-38 0V30a19 19 0 0 1 38 0Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 42.31a13 13 0 0 1-3.8-.13 17 17 0 0 1 3 2.81 5 5 0 0 0 1.65.27c.66 0 1.08-.19 1.23-.55.25-.63-.46-1.51-2.08-2.4ZM32.17 45.25a15.51 15.51 0 0 1 .1 4.07c.62 1.16 1.4 1.88 2 1.88a.65.65 0 0 0 .27-.05c.64-.26.77-1.34.26-3.13a14.1 14.1 0 0 1-2.63-2.77ZM35.24 37.85a14.48 14.48 0 0 1 4.06-.1c1.47-.83 2.08-1.63 1.84-2.24-.15-.37-.59-.57-1.28-.57a6.52 6.52 0 0 0-1.86.31 15.89 15.89 0 0 1-2.76 2.6Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45 38.51a22.09 22.09 0 0 0-5 .78 3.49 3.49 0 0 0-.22-.53 22.07 22.07 0 0 0 4.06-2.95c2.12-2.12 2.79-3.67 2.16-4.29s-2.16.05-4.28 2.16a22.12 22.12 0 0 0-3 4.06 2.27 2.27 0 0 0-.53-.22 21.62 21.62 0 0 0 .78-5c0-3-.62-4.56-1.5-4.56s-1.5 1.57-1.5 4.56a21.62 21.62 0 0 0 .78 5 2.27 2.27 0 0 0-.53.22 22.12 22.12 0 0 0-3-4.06c-2.12-2.11-3.66-2.78-4.28-2.16s0 2.17 2.16 4.29a22.07 22.07 0 0 0 4.06 2.95 3.49 3.49 0 0 0-.22.53 22.09 22.09 0 0 0-5-.78c-3 0-4.55.61-4.55 1.49s1.55 1.51 4.55 1.51a21.71 21.71 0 0 0 5-.78 2.71 2.71 0 0 0 .22.52 22.24 22.24 0 0 0-4.07 3c-2.12 2.12-2.79 3.67-2.16 4.29s2.16 0 4.28-2.17a21.79 21.79 0 0 0 3-4.07 2.36 2.36 0 0 0 .52.21 22.36 22.36 0 0 0-.78 5c0 3 .62 4.54 1.5 4.54s1.5-1.54 1.5-4.54a22.36 22.36 0 0 0-.78-5 2.36 2.36 0 0 0 .52-.21 21.79 21.79 0 0 0 3 4.07c2.12 2.12 3.66 2.79 4.28 2.17s0-2.17-2.16-4.29a22.24 22.24 0 0 0-4.07-3 2.71 2.71 0 0 0 .22-.52 21.71 21.71 0 0 0 5 .78c3 0 4.55-.62 4.55-1.5s-1.51-1.5-4.51-1.5Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 48.2c-.46 1.62-.32 2.62.28 2.87a.67.67 0 0 0 .28.06c.59 0 1.32-.7 2.12-2.09a15 15 0 0 1 .12-3.79A14.72 14.72 0 0 1 25 48.2ZM35 31.85c.45-1.71.33-2.64-.28-2.9a.87.87 0 0 0-.28-.05c-.59 0-1.4.76-2.12 2.09a15.81 15.81 0 0 1-.12 3.8 13.36 13.36 0 0 1 2.8-2.94ZM27.83 34.77a13.7 13.7 0 0 1-.1-4.06c-.71-1.26-1.4-1.89-2-1.89a.86.86 0 0 0-.27.05c-.64.26-.78 1.25-.26 3.14a17.71 17.71 0 0 1 2.63 2.76ZM24.77 42.18a17.81 17.81 0 0 1-4.07.1c-1.47.83-2.08 1.63-1.84 2.23.15.38.59.58 1.28.58a6 6 0 0 0 1.86-.32 14.55 14.55 0 0 1 2.77-2.59ZM21 37.72a16.63 16.63 0 0 1 3.79.12 19.47 19.47 0 0 1-3-2.8 4.84 4.84 0 0 0-1.64-.27c-.66 0-1.08.19-1.23.55-.25.68.56 1.61 2.08 2.4Z",
    style: {
      fill: "#e6c317"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 60 80",
    id: "icon-badge2-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dna",
    "data-name": "Diamant-gradient",
    y1: 40,
    x2: 60,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M30 4A26 26 0 0 0 4 30v20a26 26 0 0 0 52 0V30A26 26 0 0 0 30 4Zm20 46a20 20 0 0 1-40 0V30a20 20 0 0 1 40 0Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 11a19 19 0 0 0-19 19v20a19 19 0 0 0 38 0V30a19 19 0 0 0-19-19Zm11.14 24.51c.24.61-.37 1.41-1.84 2.24a14.48 14.48 0 0 0-4.06.1 15.89 15.89 0 0 0 2.76-2.6 6.52 6.52 0 0 1 1.86-.31c.69 0 1.14.2 1.28.57ZM32.29 31c.72-1.33 1.53-2.09 2.12-2.09a.87.87 0 0 1 .28.05c.61.26.73 1.19.28 2.9a13.36 13.36 0 0 0-2.8 2.94 15.81 15.81 0 0 0 .12-3.8Zm-6.79-2.13a.86.86 0 0 1 .27-.05c.56 0 1.25.63 2 1.89a13.7 13.7 0 0 0 .1 4.06A17.71 17.71 0 0 0 25.24 32c-.52-1.88-.38-2.87.26-3.13Zm-6.56 6.45c.15-.36.57-.55 1.23-.55a4.84 4.84 0 0 1 1.64.27 19.47 19.47 0 0 0 3 2.8 16.63 16.63 0 0 0-3.81-.12c-1.52-.79-2.33-1.72-2.06-2.4Zm-.08 9.19c-.24-.6.37-1.4 1.84-2.23a17.81 17.81 0 0 0 4.07-.1A14.55 14.55 0 0 0 22 44.77a6 6 0 0 1-1.86.32c-.69 0-1.14-.2-1.28-.58ZM27.71 49c-.8 1.39-1.53 2.09-2.12 2.09a.67.67 0 0 1-.28-.06c-.6-.25-.74-1.25-.28-2.87a14.72 14.72 0 0 0 2.8-3 15 15 0 0 0-.12 3.84Zm6.79 2.11a.65.65 0 0 1-.27.05c-.56 0-1.34-.72-2-1.88a15.51 15.51 0 0 0-.1-4.07A14.1 14.1 0 0 0 34.76 48c.51 1.81.38 2.89-.26 3.15Zm6.56-6.44c-.15.36-.57.55-1.23.55a5 5 0 0 1-1.65-.22 17 17 0 0 0-3-2.81 13 13 0 0 0 3.8.13c1.64.88 2.35 1.76 2.08 2.39Zm-3.61-3.2a21.71 21.71 0 0 1-5-.78 2.71 2.71 0 0 1-.22.52 22.24 22.24 0 0 1 4.07 3c2.12 2.12 2.79 3.67 2.16 4.29s-2.16 0-4.28-2.17a21.79 21.79 0 0 1-3-4.07 2.36 2.36 0 0 1-.52.21 22.36 22.36 0 0 1 .78 5c0 3-.62 4.54-1.5 4.54s-1.5-1.54-1.5-4.54a22.36 22.36 0 0 1 .78-5 2.36 2.36 0 0 1-.52-.21 21.79 21.79 0 0 1-3 4.07c-2.12 2.12-3.66 2.79-4.28 2.17s0-2.17 2.16-4.29a22.24 22.24 0 0 1 4.07-3 2.71 2.71 0 0 1-.22-.52 21.71 21.71 0 0 1-5 .78c-3 0-4.55-.63-4.55-1.51s1.55-1.49 4.55-1.49a22.09 22.09 0 0 1 5 .78 3.49 3.49 0 0 1 .22-.53 22.07 22.07 0 0 1-4.06-2.95c-2.12-2.12-2.79-3.67-2.16-4.29s2.16.05 4.28 2.17a21.72 21.72 0 0 1 3 4.05 2.27 2.27 0 0 1 .53-.22 21.62 21.62 0 0 1-.78-5c0-3 .62-4.56 1.5-4.56s1.5 1.57 1.5 4.56a21.62 21.62 0 0 1-.78 5 2.27 2.27 0 0 1 .53.22 21.72 21.72 0 0 1 3-4.05c2.12-2.12 3.66-2.79 4.28-2.17s0 2.17-2.16 4.29a22.6 22.6 0 0 1-4.06 3 3 3 0 0 1 .22.52 22.09 22.09 0 0 1 5-.78c3 0 4.55.63 4.55 1.5s-1.59 1.5-4.59 1.5Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 10a20 20 0 0 0-20 20v20a20 20 0 0 0 40 0V30a20 20 0 0 0-20-20Zm19 40a19 19 0 0 1-38 0V30a19 19 0 0 1 38 0Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.17 45.25a15.51 15.51 0 0 1 .1 4.07c.62 1.16 1.4 1.88 2 1.88a.65.65 0 0 0 .27-.05c.64-.26.77-1.34.26-3.13a14.1 14.1 0 0 1-2.63-2.77ZM35.24 37.85a14.48 14.48 0 0 1 4.06-.1c1.47-.83 2.08-1.63 1.84-2.24-.15-.37-.59-.57-1.28-.57a6.52 6.52 0 0 0-1.86.31 15.89 15.89 0 0 1-2.76 2.6ZM39 42.31a13 13 0 0 1-3.8-.13 17 17 0 0 1 3 2.81 5 5 0 0 0 1.65.27c.66 0 1.08-.19 1.23-.55.25-.63-.46-1.51-2.08-2.4Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45 38.51a22.09 22.09 0 0 0-5 .78 3 3 0 0 0-.22-.52 22.6 22.6 0 0 0 4.06-3c2.12-2.12 2.79-3.67 2.16-4.29s-2.16.05-4.28 2.17a21.72 21.72 0 0 0-3 4.05 2.27 2.27 0 0 0-.53-.22 21.62 21.62 0 0 0 .78-5c0-3-.62-4.56-1.5-4.56s-1.5 1.57-1.5 4.56a21.62 21.62 0 0 0 .78 5 2.27 2.27 0 0 0-.53.22 21.72 21.72 0 0 0-3-4.05c-2.12-2.12-3.66-2.79-4.28-2.17s0 2.17 2.16 4.29a22.07 22.07 0 0 0 4.06 2.95 3.49 3.49 0 0 0-.22.53 22.09 22.09 0 0 0-5-.78c-3 0-4.55.61-4.55 1.49s1.55 1.51 4.55 1.51a21.71 21.71 0 0 0 5-.78 2.71 2.71 0 0 0 .22.52 22.24 22.24 0 0 0-4.07 3c-2.12 2.12-2.79 3.67-2.16 4.29s2.16 0 4.28-2.17a21.79 21.79 0 0 0 3-4.07 2.36 2.36 0 0 0 .52.21 22.36 22.36 0 0 0-.78 5c0 3 .62 4.54 1.5 4.54s1.5-1.54 1.5-4.54a22.36 22.36 0 0 0-.78-5 2.36 2.36 0 0 0 .52-.21 21.79 21.79 0 0 0 3 4.07c2.12 2.12 3.66 2.79 4.28 2.17s0-2.17-2.16-4.29a22.24 22.24 0 0 0-4.07-3 2.71 2.71 0 0 0 .22-.52 21.71 21.71 0 0 0 5 .78c3 0 4.55-.62 4.55-1.5s-1.51-1.46-4.51-1.46Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 48.2c-.46 1.62-.32 2.62.28 2.87a.67.67 0 0 0 .28.06c.59 0 1.32-.7 2.12-2.09a15 15 0 0 1 .12-3.79A14.72 14.72 0 0 1 25 48.2ZM35 31.85c.45-1.71.33-2.64-.28-2.9a.87.87 0 0 0-.28-.05c-.59 0-1.4.76-2.12 2.09a15.81 15.81 0 0 1-.12 3.8 13.36 13.36 0 0 1 2.8-2.94ZM27.83 34.77a13.7 13.7 0 0 1-.1-4.06c-.71-1.26-1.4-1.89-2-1.89a.86.86 0 0 0-.27.05c-.64.26-.78 1.25-.26 3.14a17.71 17.71 0 0 1 2.63 2.76ZM24.77 42.18a17.81 17.81 0 0 1-4.07.1c-1.47.83-2.08 1.63-1.84 2.23.15.38.59.58 1.28.58a6 6 0 0 0 1.86-.32 14.55 14.55 0 0 1 2.77-2.59ZM21 37.72a16.63 16.63 0 0 1 3.79.12 19.47 19.47 0 0 1-3-2.8 4.84 4.84 0 0 0-1.64-.27c-.66 0-1.08.19-1.23.55-.25.68.56 1.61 2.08 2.4Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0A30 30 0 0 0 0 30v20a30 30 0 0 0 60 0V30A30 30 0 0 0 30 0Zm26 50a26 26 0 0 1-52 0V30a26 26 0 0 1 52 0Z",
    style: {
      fill: "url(#dna)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge3-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc"
    },
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41 4 18.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge3-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dpa",
    "data-name": "Bronze-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M39.59 37.69a1.93 1.93 0 0 0 .47-1.2 28.28 28.28 0 0 1-11.92-7.85s4.91 7.04 11.45 9.05Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 22.14v19.72l21.52 10 21.51-10V22.14l-21.51-10ZM41.46 36.7s.19.38 2.67.77c.84.13.48 2-.22 1.92a10.15 10.15 0 0 1-3-.6 6.14 6.14 0 0 1-1.86 1.46 8.82 8.82 0 0 1-9.33-1.84c-5.1-4.76-5.65-17.33-4.7-16.3 4.07 4.41 9.31 2.3 12.75 5.2a11 11 0 0 1 3.69 9.39Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 21.5v21L34.62 53l22.51-10.5v-21L34.62 11Zm44 20.36-21.51 10-21.52-10V22.14l21.52-10 21.51 10Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 38.41a8.82 8.82 0 0 0 9.33 1.84 6.14 6.14 0 0 0 1.86-1.46 10.15 10.15 0 0 0 3 .6c.7.08 1.06-1.79.22-1.92-2.48-.39-2.67-.77-2.67-.77a11 11 0 0 0-3.66-9.39c-3.44-2.9-8.68-.79-12.75-5.2-.98-1.03-.43 11.54 4.67 16.3Zm10.31-1.92a1.93 1.93 0 0 1-.47 1.2c-6.54-2-11.45-9-11.45-9a28.28 28.28 0 0 0 11.92 7.8Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.13 42.5 34.62 53 12.1 42.5v-21L34.62 11l22.51 10.5Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#dpa)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge3-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dqa",
    "data-name": "argentgradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.57-5.66-16.64-4.71-15.66 4.08 4.24 9.31 2.22 12.75 5a10.37 10.37 0 0 1 3.68 9Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.37 10.37 0 0 0-3.66-9c-3.44-2.78-8.67-.76-12.75-5-1.01-1-.46 11.07 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#dqa)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge3-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dra",
    "data-name": "Or-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#dra)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.58-5.66-16.65-4.71-15.66 4.08 4.24 9.31 2.21 12.75 5a10.36 10.36 0 0 1 3.68 9Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.36 10.36 0 0 0-3.66-9c-3.44-2.79-8.67-.76-12.75-5-1.01-1.01-.46 11.06 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#e6c317"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge3-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dsa",
    "data-name": "Diamant-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#dsa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.57-5.66-16.64-4.71-15.66 4.08 4.24 9.31 2.22 12.75 5a10.37 10.37 0 0 1 3.68 9Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.37 10.37 0 0 0-3.66-9c-3.44-2.78-8.67-.76-12.75-5-1.01-1-.46 11.07 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#9a6ac3"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 65 80",
    id: "icon-badge4-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 17.14v19.22c0 18.1 12.22 35 28.5 39.51C48.78 71.34 61 54.46 61 36.36V17.14L32.5 4.38Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0 0 14.55v21.81c0 20 13.75 38.75 32 43.51l.5.13.5-.13c18.25-4.76 32-23.46 32-43.51V14.55ZM61 36.36c0 18.1-12.22 35-28.5 39.51C16.22 71.34 4 54.46 4 36.36V17.14L32.5 4.38 61 17.14Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 65 80",
    id: "icon-badge4-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dua",
    "data-name": "Bronze-gradient",
    y1: 40,
    x2: 65,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.56v15.71C9 52 19.09 65.56 32.5 69 45.91 65.56 56 52 56 37.27V21.56L32.5 11.1ZM42 37 27.87 56.6l2.61-14H22L36.13 23l-2.61 14Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.91v16.36C8 52.45 18.48 66.5 32.38 70h.24C46.52 66.51 57 52.45 57 37.27V20.91L32.7 10.09l-.2-.09Zm48 .65v15.71C56 52 45.91 65.56 32.5 69 19.09 65.56 9 52 9 37.27V21.56L32.5 11.1Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e68f17"
    },
    d: "M22 42.6h8.48l-2.61 14L42 37h-8.48l2.61-14L22 42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17.14v19.22c0 18.1 12.22 35 28.5 39.51C48.78 71.34 61 54.46 61 36.36V17.14L32.5 4.38Zm53 3.77v16.36C57 52.45 46.52 66.51 32.62 70h-.24C18.48 66.5 8 52.45 8 37.27V20.91L32.5 10l.2.09Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0 0 14.55v21.81c0 20 13.75 38.75 32 43.51l.5.13.5-.13c18.25-4.76 32-23.46 32-43.51V14.55ZM61 36.36c0 18.1-12.22 35-28.5 39.51C16.22 71.34 4 54.46 4 36.36V17.14L32.5 4.38 61 17.14Z",
    style: {
      fill: "url(#dua)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 65 80",
    id: "icon-badge4-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dva",
    "data-name": "argentgradient",
    y1: 40,
    x2: 65,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 17.14v19.22c0 18.1 12.22 35 28.5 39.51C48.78 71.34 61 54.46 61 36.36V17.14L32.5 4.38Zm53 3.77v16.36C57 52.45 46.52 66.5 32.62 70h-.24C18.48 66.5 8 52.45 8 37.27V20.91L32.5 10l.2.09Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0 0 14.55v21.81c0 20 13.75 38.75 32 43.51l.5.13.5-.13c18.25-4.76 32-23.46 32-43.51V14.55ZM61 36.36c0 18.1-12.22 35-28.5 39.51C16.22 71.34 4 54.46 4 36.36V17.14L32.5 4.38 61 17.14Z",
    style: {
      fill: "url(#dva)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.56v15.71C9 52 19.09 65.56 32.5 69 45.91 65.56 56 52 56 37.27V21.56L32.5 11.09ZM42 37 27.87 56.6l2.61-14H22L36.13 23l-2.61 14Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.91v16.36C8 52.45 18.48 66.5 32.38 70h.24C46.52 66.5 57 52.45 57 37.27V20.91L32.7 10.09l-.2-.09Zm48 .65v15.71C56 52 45.91 65.56 32.5 69 19.09 65.56 9 52 9 37.27V21.56l23.5-10.47Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8a9399"
    },
    d: "M22 42.6h8.48l-2.61 14L42 37h-8.48l2.61-14L22 42.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 65 80",
    id: "icon-badge4-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dwa",
    "data-name": "Or-gradient",
    y1: 40,
    x2: 65,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 17.14v19.22c0 18.1 12.22 35 28.5 39.51C48.78 71.34 61 54.46 61 36.36V17.14L32.5 4.38Zm53 3.77v16.36C57 52.45 46.52 66.5 32.62 70h-.24C18.48 66.5 8 52.45 8 37.27V20.91L32.5 10l.2.09Z",
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0 0 14.55v21.81c0 20 13.75 38.75 32 43.51l.5.13.5-.13c18.25-4.76 32-23.46 32-43.51V14.55ZM61 36.36c0 18.1-12.22 35-28.5 39.51C16.22 71.34 4 54.46 4 36.36V17.14L32.5 4.38 61 17.14Z",
    style: {
      fill: "url(#dwa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.56v15.71C9 52 19.09 65.56 32.5 69 45.91 65.56 56 52 56 37.27V21.56L32.5 11.09ZM42 37 27.87 56.6l2.61-14H22L36.13 23l-2.61 14Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.91v16.36C8 52.45 18.48 66.5 32.38 70h.24C46.52 66.5 57 52.45 57 37.27V20.91L32.7 10.09l-.2-.09Zm48 .65v15.71C56 52 45.91 65.56 32.5 69 19.09 65.56 9 52 9 37.27V21.56l23.5-10.47Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6c317"
    },
    d: "M22 42.6h8.48l-2.61 14L42 37h-8.48l2.61-14L22 42.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 65 80",
    id: "icon-badge4-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dxa",
    "data-name": "Diamant-gradient",
    y1: 40,
    x2: 65,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 17.14v19.22c0 18.1 12.22 35 28.5 39.51C48.78 71.34 61 54.46 61 36.36V17.14L32.5 4.38Zm53 3.77v16.36C57 52.45 46.52 66.5 32.62 70h-.24C18.48 66.5 8 52.45 8 37.27V20.91L32.5 10l.2.09Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0 0 14.55v21.81c0 20 13.75 38.75 32 43.51l.5.13.5-.13c18.25-4.76 32-23.46 32-43.51V14.55ZM61 36.36c0 18.1-12.22 35-28.5 39.51C16.22 71.34 4 54.46 4 36.36V17.14L32.5 4.38 61 17.14Z",
    style: {
      fill: "url(#dxa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21.56v15.71C9 52 19.09 65.56 32.5 69 45.91 65.56 56 52 56 37.27V21.56L32.5 11.09ZM42 37 27.87 56.6l2.61-14H22L36.13 23l-2.61 14Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.91v16.36C8 52.45 18.48 66.5 32.38 70h.24C46.52 66.5 57 52.45 57 37.27V20.91L32.7 10.09l-.2-.09Zm48 .65v15.71C56 52 45.91 65.56 32.5 69 19.09 65.56 9 52 9 37.27V21.56l23.5-10.47Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9a6ac3"
    },
    d: "M22 42.6h8.48l-2.61 14L42 37h-8.48l2.61-14L22 42.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 60",
    id: "icon-badge5-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 4H30a26 26 0 0 0 0 52h20a26 26 0 0 0 0-52Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H30a30 30 0 0 0 0 60h20a30 30 0 0 0 0-60Zm0 56H30a26 26 0 0 1 0-52h20a26 26 0 0 1 0 52Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 60",
    id: "icon-badge5-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dza",
    "data-name": "Bronze-gradient",
    y1: 30,
    x2: 80,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M50 11H30a19 19 0 0 0 0 38h20a19 19 0 0 0 0-38Zm-10 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm14.71-9a8 8 0 0 1-11 0l-9.2-9a5.3 5.3 0 0 0-7.37 0 5 5 0 0 0 0 7.16 5.3 5.3 0 0 0 7.37 0l2.85-2.76 1.84 1.8-2.89 2.8a7.95 7.95 0 0 1-11 0 7.5 7.5 0 0 1 0-10.79A7.79 7.79 0 0 1 30.8 22a7.88 7.88 0 0 1 5.51 2.22l9.2 9a5.3 5.3 0 0 0 7.37 0 5 5 0 0 0 0-7.16 5.3 5.3 0 0 0-7.37 0l-2.85 2.77L40.83 27l2.86-2.78a7.95 7.95 0 0 1 11 0 7.51 7.51 0 0 1 0 10.79Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 4H30a26 26 0 0 0 0 52h20a26 26 0 0 0 0-52Zm0 46H30a20 20 0 0 1 0-40h20a20 20 0 0 1 0 40Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H30a30 30 0 0 0 0 60h20a30 30 0 0 0 0-60Zm0 56H30a26 26 0 0 1 0-52h20a26 26 0 0 1 0 52Z",
    style: {
      fill: "url(#dza)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10H30a20 20 0 0 0 0 40h20a20 20 0 0 0 0-40Zm0 39H30a19 19 0 0 1 0-38h20a19 19 0 0 1 0 38Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 22a7.86 7.86 0 0 0-5.51 2.22L40.83 27l1.83 1.81L45.51 26a5.3 5.3 0 0 1 7.37 0 5 5 0 0 1 0 7.16 5.3 5.3 0 0 1-7.37 0l-9.2-9A7.88 7.88 0 0 0 30.8 22a7.79 7.79 0 0 0-5.51 2.23 7.5 7.5 0 0 0 0 10.79 7.95 7.95 0 0 0 11 0l2.86-2.78-1.84-1.8-2.83 2.76a5.3 5.3 0 0 1-7.37 0 5 5 0 0 1 0-7.16 5.3 5.3 0 0 1 7.37 0l9.2 9a8 8 0 0 0 11 0 7.51 7.51 0 0 0 0-10.79A7.83 7.83 0 0 0 49.2 22Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 2,
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    r: 2,
    style: {
      fill: "#e68f17"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 60",
    id: "icon-badge5-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eaa",
    "data-name": "argentgradient",
    y1: 30,
    x2: 80,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M50 4H30a26 26 0 0 0 0 52h20a26 26 0 0 0 0-52Zm0 46H30a20 20 0 0 1 0-40h20a20 20 0 0 1 0 40Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 11H30a19 19 0 0 0 0 38h20a19 19 0 0 0 0-38Zm-10 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm14.7-9a7.95 7.95 0 0 1-11 0l-9.2-9a5.3 5.3 0 0 0-7.37 0 5 5 0 0 0 0 7.16 5.3 5.3 0 0 0 7.37 0l2.85-2.76 1.84 1.8-2.88 2.8a7.95 7.95 0 0 1-11 0 7.5 7.5 0 0 1 0-10.79A7.79 7.79 0 0 1 30.8 22a7.88 7.88 0 0 1 5.51 2.22l9.2 9a5.3 5.3 0 0 0 7.37 0 5 5 0 0 0 0-7.16 5.3 5.3 0 0 0-7.37 0l-2.85 2.77L40.83 27l2.86-2.78a7.94 7.94 0 0 1 11 0A7.49 7.49 0 0 1 54.7 35Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10H30a20 20 0 0 0 0 40h20a20 20 0 0 0 0-40Zm0 39H30a19 19 0 0 1 0-38h20a19 19 0 0 1 0 38Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 22a7.86 7.86 0 0 0-5.51 2.22L40.83 27l1.83 1.81L45.51 26a5.3 5.3 0 0 1 7.37 0 5 5 0 0 1 0 7.16 5.3 5.3 0 0 1-7.37 0l-9.2-9A7.88 7.88 0 0 0 30.8 22a7.79 7.79 0 0 0-5.51 2.23 7.5 7.5 0 0 0 0 10.79 7.95 7.95 0 0 0 11 0l2.86-2.78-1.84-1.8-2.83 2.76a5.3 5.3 0 0 1-7.37 0 5 5 0 0 1 0-7.16 5.3 5.3 0 0 1 7.37 0l9.2 9a7.95 7.95 0 0 0 11 0 7.49 7.49 0 0 0 0-10.79A7.79 7.79 0 0 0 49.2 22Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 2,
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    r: 2,
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H30a30 30 0 0 0 0 60h20a30 30 0 0 0 0-60Zm0 56H30a26 26 0 0 1 0-52h20a26 26 0 0 1 0 52Z",
    style: {
      fill: "url(#eaa)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 60",
    id: "icon-badge5-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eba",
    "data-name": "Or-gradient",
    y1: 30,
    x2: 80,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M50 4H30a26 26 0 0 0 0 52h20a26 26 0 0 0 0-52Zm0 46H30a20 20 0 0 1 0-40h20a20 20 0 0 1 0 40Z",
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H30a30 30 0 0 0 0 60h20a30 30 0 0 0 0-60Zm0 56H30a26 26 0 0 1 0-52h20a26 26 0 0 1 0 52Z",
    style: {
      fill: "url(#eba)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 11H30a19 19 0 0 0 0 38h20a19 19 0 0 0 0-38Zm-10 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm14.71-9a8 8 0 0 1-11 0l-9.2-9a5.3 5.3 0 0 0-7.37 0 5 5 0 0 0 0 7.16 5.3 5.3 0 0 0 7.37 0l2.85-2.76 1.84 1.8-2.89 2.8a7.95 7.95 0 0 1-11 0 7.5 7.5 0 0 1 0-10.79A7.79 7.79 0 0 1 30.8 22a7.88 7.88 0 0 1 5.51 2.22l9.2 9a5.3 5.3 0 0 0 7.37 0 5 5 0 0 0 0-7.16 5.3 5.3 0 0 0-7.37 0l-2.85 2.77L40.83 27l2.86-2.78a7.95 7.95 0 0 1 11 0 7.51 7.51 0 0 1 0 10.79Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10H30a20 20 0 0 0 0 40h20a20 20 0 0 0 0-40Zm0 39H30a19 19 0 0 1 0-38h20a19 19 0 0 1 0 38Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 22a7.86 7.86 0 0 0-5.51 2.22L40.83 27l1.83 1.81L45.51 26a5.3 5.3 0 0 1 7.37 0 5 5 0 0 1 0 7.16 5.3 5.3 0 0 1-7.37 0l-9.2-9A7.88 7.88 0 0 0 30.8 22a7.79 7.79 0 0 0-5.51 2.23 7.5 7.5 0 0 0 0 10.79 7.95 7.95 0 0 0 11 0l2.86-2.78-1.84-1.8-2.83 2.76a5.3 5.3 0 0 1-7.37 0 5 5 0 0 1 0-7.16 5.3 5.3 0 0 1 7.37 0l9.2 9a8 8 0 0 0 11 0 7.51 7.51 0 0 0 0-10.79A7.83 7.83 0 0 0 49.2 22Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 2,
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    r: 2,
    style: {
      fill: "#e6c317"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 80 60",
    id: "icon-badge5-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eca",
    "data-name": "Diamant-gradient",
    y1: 30,
    x2: 80,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M50 4H30a26 26 0 0 0 0 52h20a26 26 0 0 0 0-52Zm0 46H30a20 20 0 0 1 0-40h20a20 20 0 0 1 0 40Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 0H30a30 30 0 0 0 0 60h20a30 30 0 0 0 0-60Zm0 56H30a26 26 0 0 1 0-52h20a26 26 0 0 1 0 52Z",
    style: {
      fill: "url(#eca)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 11H30a19 19 0 0 0 0 38h20a19 19 0 0 0 0-38Zm-10 5a2 2 0 1 1-2 2 2 2 0 0 1 2-2Zm0 28a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm14.71-9a8 8 0 0 1-11 0l-9.2-9a5.3 5.3 0 0 0-7.37 0 5 5 0 0 0 0 7.16 5.3 5.3 0 0 0 7.37 0l2.85-2.76 1.84 1.8-2.89 2.8a7.95 7.95 0 0 1-11 0 7.5 7.5 0 0 1 0-10.79A7.79 7.79 0 0 1 30.8 22a7.88 7.88 0 0 1 5.51 2.22l9.2 9a5.3 5.3 0 0 0 7.37 0 5 5 0 0 0 0-7.16 5.3 5.3 0 0 0-7.37 0l-2.85 2.77L40.83 27l2.86-2.78a7.95 7.95 0 0 1 11 0 7.51 7.51 0 0 1 0 10.79Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 10H30a20 20 0 0 0 0 40h20a20 20 0 0 0 0-40Zm0 39H30a19 19 0 0 1 0-38h20a19 19 0 0 1 0 38Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 22a7.86 7.86 0 0 0-5.51 2.22L40.83 27l1.83 1.81L45.51 26a5.3 5.3 0 0 1 7.37 0 5 5 0 0 1 0 7.16 5.3 5.3 0 0 1-7.37 0l-9.2-9A7.88 7.88 0 0 0 30.8 22a7.79 7.79 0 0 0-5.51 2.23 7.5 7.5 0 0 0 0 10.79 7.95 7.95 0 0 0 11 0l2.86-2.78-1.84-1.8-2.83 2.76a5.3 5.3 0 0 1-7.37 0 5 5 0 0 1 0-7.16 5.3 5.3 0 0 1 7.37 0l9.2 9a8 8 0 0 0 11 0 7.51 7.51 0 0 0 0-10.79A7.83 7.83 0 0 0 49.2 22Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 18,
    r: 2,
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42,
    r: 2,
    style: {
      fill: "#9a6ac3"
    }
  })), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 92 98",
    id: "icon-badge6-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.97 89.112c1.327 2.44 4.833 2.435 6.154-.01l31.322-57.951c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.652.004-4.338 2.842-3.07 5.172L42.97 89.112Z",
    fill: "#CCC",
    stroke: "#E5E5E5",
    strokeWidth: 3
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 92 98",
    id: "icon-badge6-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.124 89.103 80.446 31.15c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.652.004-4.338 2.842-3.07 5.172L42.97 89.112c1.327 2.44 4.833 2.435 6.154-.01Z",
    fill: "#FFEFD9",
    stroke: "url(#eea)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.263 79.304 22.006-43.305c.846-1.664-.365-3.635-2.232-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.808 79.31c.93 1.819 3.53 1.815 4.455-.006Z",
    fill: "#FFEFD9",
    stroke: "#E7911A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.806 59.353v-2.368c0-2.788-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.321-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.084v-1.789h1.592v-2.275H36.882v2.275h1.593v1.788c0 2.79 2.166 4.39 4.14 6.085.315.27.637.905.637 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368h-1.593v2.276h17.516v-2.276h-1.592ZM41.619 44.074c-.587-.678-.915-1.33-.915-2.112v-1.789h9.873v1.788c0 .783-.328 1.435-.915 2.114h-8.043Zm8.958 14.645-3.75-1.494c-.653-.26-1.72-.26-2.373 0l-3.75 1.494v-1.733c0-1.578 1.229-2.644 3.234-4.252l.053-.042a3.944 3.944 0 0 0 1.422-2.393c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.234 2.673 3.234 4.252v1.733Z",
    fill: "#EA9827"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eea",
    x1: 46.057,
    y1: 97.931,
    x2: 45.91,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7911A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA80"
  }))))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 93 98",
    id: "icon-badge6-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.977 89.112c1.328 2.44 4.833 2.435 6.154-.01l31.323-57.951c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.653.004-4.338 2.842-3.071 5.172l31.457 57.858Z",
    fill: "#E6EDF2",
    stroke: "url(#efa)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.816 79.31c.93 1.819 3.529 1.815 4.454-.006l22.006-43.305c.846-1.664-.364-3.635-2.231-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.816 79.31Z",
    fill: "#E6EDF2",
    stroke: "#8A9399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.924 59.455v-2.368c0-2.789-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.32-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.085v-1.787h1.592V38H37v2.276h1.592v1.787c0 2.79 2.166 4.39 4.14 6.085.316.27.638.905.638 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368H37v2.276h17.516v-2.276h-1.592ZM41.737 44.176c-.587-.678-.915-1.33-.915-2.113v-1.787h9.872v1.787c0 .783-.328 1.435-.915 2.114h-8.042Zm8.957 14.645-3.749-1.494c-.653-.26-1.72-.26-2.374 0l-3.75 1.494v-1.733c0-1.578 1.23-2.644 3.235-4.252l.053-.042A3.943 3.943 0 0 0 45.53 50.4c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.233 2.673 3.233 4.252v1.733Z",
    fill: "#8A9399"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "efa",
    x1: 46.065,
    y1: 97.931,
    x2: 45.918,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C959B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3D0D9"
  }))))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 93 98",
    id: "icon-badge6-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.977 89.112c1.327 2.44 4.833 2.435 6.154-.01l31.323-57.951c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.653.004-4.338 2.842-3.071 5.172l31.457 57.858Z",
    fill: "#FFF6CC",
    stroke: "url(#ega)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.816 79.31c.93 1.819 3.529 1.815 4.454-.006l22.006-43.305c.846-1.664-.364-3.635-2.231-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.816 79.31Z",
    fill: "#FFF6CC",
    stroke: "#E6C317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.924 59.455v-2.368c0-2.789-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.32-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.085v-1.787h1.592V38H37v2.276h1.592v1.787c0 2.79 2.166 4.39 4.14 6.085.316.27.638.905.638 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368H37v2.276h17.516v-2.276h-1.592ZM41.737 44.176c-.587-.678-.915-1.33-.915-2.113v-1.787h9.872v1.787c0 .783-.328 1.435-.915 2.114h-8.042Zm8.957 14.645-3.749-1.494c-.653-.26-1.72-.26-2.374 0l-3.75 1.494v-1.733c0-1.578 1.23-2.644 3.235-4.252l.053-.042A3.943 3.943 0 0 0 45.53 50.4c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.233 2.673 3.233 4.252v1.733Z",
    fill: "#E6C317"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ega",
    x1: 46.065,
    y1: 97.931,
    x2: 45.918,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA80"
  }))))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 93 98",
    id: "icon-badge6-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.977 89.112c1.327 2.44 4.833 2.435 6.154-.01l31.323-57.951c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.653.004-4.338 2.842-3.071 5.172l31.457 57.858Z",
    fill: "#E5F5FF",
    stroke: "url(#eha)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.816 79.31c.93 1.819 3.529 1.815 4.454-.006l22.006-43.305c.846-1.664-.364-3.635-2.231-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.816 79.31Z",
    fill: "#E5F5FF",
    stroke: "#9A6AC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.924 59.455v-2.368c0-2.789-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.32-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.085v-1.787h1.592V38H37v2.276h1.592v1.787c0 2.79 2.166 4.39 4.14 6.085.316.27.638.905.638 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368H37v2.276h17.516v-2.276h-1.592ZM41.737 44.176c-.587-.678-.915-1.33-.915-2.113v-1.787h9.872v1.787c0 .783-.328 1.435-.915 2.114h-8.042Zm8.957 14.645-3.749-1.494c-.653-.26-1.72-.26-2.374 0l-3.75 1.494v-1.733c0-1.578 1.23-2.644 3.235-4.252l.053-.042A3.943 3.943 0 0 0 45.53 50.4c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.233 2.673 3.233 4.252v1.733Z",
    fill: "#9A6AC3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eha",
    x1: 46.065,
    y1: 97.931,
    x2: 45.918,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B6CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F2"
  }))))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 93 98",
    id: "icon-badge6-5",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.977 89.112c1.327 2.44 4.833 2.435 6.154-.01l31.323-57.951c1.261-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.653.004-4.338 2.842-3.071 5.172l31.457 57.858Z",
    fill: "#FEEFEF",
    stroke: "url(#eia)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.816 79.31c.93 1.819 3.529 1.815 4.454-.006l22.006-43.305c.846-1.664-.364-3.635-2.231-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.816 79.31Z",
    fill: "#FEEFEF",
    stroke: "#DA1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.924 59.455v-2.368c0-2.789-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.32-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.085v-1.787h1.592V38H37v2.276h1.592v1.787c0 2.79 2.166 4.39 4.14 6.085.316.27.638.905.638 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368H37v2.276h17.516v-2.276h-1.592ZM41.737 44.176c-.587-.678-.915-1.33-.915-2.113v-1.787h9.872v1.787c0 .783-.328 1.435-.915 2.114h-8.042Zm8.957 14.645-3.749-1.494c-.653-.26-1.72-.26-2.374 0l-3.75 1.494v-1.733c0-1.578 1.23-2.644 3.235-4.252l.053-.042A3.943 3.943 0 0 0 45.53 50.4c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.233 2.673 3.233 4.252v1.733Z",
    fill: "#DA1414"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eia",
    x1: 46.065,
    y1: 97.931,
    x2: 45.918,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA1414"
  }))))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 92 98",
    id: "icon-badge6-red",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.97 89.112c1.327 2.44 4.833 2.435 6.154-.01l31.322-57.951c1.262-2.334-.43-5.168-3.083-5.164l-62.78.095c-2.652.004-4.338 2.842-3.07 5.172L42.97 89.112Z",
    fill: "#FFDCE1",
    stroke: "url(#eja)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.808 79.31c.93 1.819 3.53 1.815 4.455-.006l22.006-43.305c.846-1.664-.365-3.635-2.232-3.632l-44.113.067c-1.867.002-3.073 1.976-2.223 3.638L43.808 79.31Z",
    fill: "#FFDCE1",
    stroke: "#EE1233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.806 59.353v-2.368c0-2.788-2.111-4.456-4.14-6.084a1.648 1.648 0 0 1-.637-1.3c0-.65.321-1.284.637-1.555 1.974-1.696 4.14-3.296 4.14-6.084v-1.789h1.592v-2.275H36.882v2.275h1.593v1.788c0 2.79 2.166 4.39 4.14 6.085.315.27.637.905.637 1.555 0 .65-.357 1.076-.637 1.3-2.03 1.628-4.14 3.296-4.14 6.084v2.368h-1.593v2.276h17.516v-2.276h-1.592ZM41.619 44.074c-.587-.678-.915-1.33-.915-2.112v-1.789h9.873v1.788c0 .783-.328 1.435-.915 2.114h-8.043Zm8.958 14.645-3.75-1.494c-.653-.26-1.72-.26-2.373 0l-3.75 1.494v-1.733c0-1.578 1.229-2.644 3.234-4.252l.053-.042a3.943 3.943 0 0 0 1.422-2.393c.15.034.304.034.454 0a3.94 3.94 0 0 0 1.422 2.392l.054.043c2.005 1.608 3.234 2.673 3.234 4.252v1.733Z",
    fill: "#EE1233"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eja",
    x1: 46.057,
    y1: 97.931,
    x2: 45.91,
    y2: 0.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE1233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D83"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge7-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc"
    },
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41 4 18.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "#e5e5e5"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge7-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ela",
    "data-name": "Bronze-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e68f17"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M39.59 37.69a1.93 1.93 0 0 0 .47-1.2 28.28 28.28 0 0 1-11.92-7.85s4.91 7.04 11.45 9.05Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1 22.14v19.72l21.52 10 21.51-10V22.14l-21.51-10ZM41.46 36.7s.19.38 2.67.77c.84.13.48 2-.22 1.92a10.15 10.15 0 0 1-3-.6 6.14 6.14 0 0 1-1.86 1.46 8.82 8.82 0 0 1-9.33-1.84c-5.1-4.76-5.65-17.33-4.7-16.3 4.07 4.41 9.31 2.3 12.75 5.2a11 11 0 0 1 3.69 9.39Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 21.5v21L34.62 53l22.51-10.5v-21L34.62 11Zm44 20.36-21.51 10-21.52-10V22.14l21.52-10 21.51 10Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 38.41a8.82 8.82 0 0 0 9.33 1.84 6.14 6.14 0 0 0 1.86-1.46 10.15 10.15 0 0 0 3 .6c.7.08 1.06-1.79.22-1.92-2.48-.39-2.67-.77-2.67-.77a11 11 0 0 0-3.66-9.39c-3.44-2.9-8.68-.79-12.75-5.2-.98-1.03-.43 11.54 4.67 16.3Zm10.31-1.92a1.93 1.93 0 0 1-.47 1.2c-6.54-2-11.45-9-11.45-9a28.28 28.28 0 0 0 11.92 7.8Z",
    style: {
      fill: "#e68f17"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.13 42.5 34.62 53 12.1 42.5v-21L34.62 11l22.51 10.5Z",
    style: {
      fill: "#ffefd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#ela)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge7-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ema",
    "data-name": "argentgradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3d0d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a9399"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.57-5.66-16.64-4.71-15.66 4.08 4.24 9.31 2.22 12.75 5a10.37 10.37 0 0 1 3.68 9Z",
    style: {
      fill: "#e6edf2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.37 10.37 0 0 0-3.66-9c-3.44-2.78-8.67-.76-12.75-5-1.01-1-.46 11.07 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#8a9399"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#ema)"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge7-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ena",
    "data-name": "Or-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffea80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6c317"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#fff4bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#ena)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.58-5.66-16.65-4.71-15.66 4.08 4.24 9.31 2.21 12.75 5a10.36 10.36 0 0 1 3.68 9Z",
    style: {
      fill: "#fff7cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#e6c317"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.36 10.36 0 0 0-3.66-9c-3.44-2.79-8.67-.76-12.75-5-1.01-1.01-.46 11.06 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#e6c317"
    }
  })), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 69.28 64",
    id: "icon-badge7-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eoa",
    "data-name": "Diamant-gradient",
    y1: 32,
    x2: 69.28,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#caa3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9a6ac3"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.56v26.88l30.64 14.15 30.64-14.15V18.56L34.64 4.41ZM57.16 42.5 34.64 53 12.12 42.5v-21L34.64 11l22.52 10.5Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64 0 0 16v32l34.64 16 34.64-16V16Zm30.64 45.44L34.64 59.59 4 45.44V18.56L34.64 4.41l30.64 14.15Z",
    style: {
      fill: "url(#eoa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.61 37.06a1.72 1.72 0 0 0 .47-1.14 28.4 28.4 0 0 1-11.92-7.54s4.92 6.76 11.45 8.68Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 22.14v19.72l21.52 10 21.52-10V22.14l-21.52-10Zm28.36 14s.19.36 2.67.74c.84.12.49 1.92-.21 1.84a10.45 10.45 0 0 1-3-.58 5.91 5.91 0 0 1-1.86 1.41 9.11 9.11 0 0 1-9.32-1.77c-5.11-4.57-5.66-16.64-4.71-15.66 4.08 4.24 9.31 2.22 12.75 5a10.37 10.37 0 0 1 3.68 9Z",
    style: {
      fill: "#e6f5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12 21.5v21L34.64 53l22.52-10.5v-21L34.64 11Zm44 20.36-21.52 10-21.52-10V22.14l21.52-10 21.52 10Z",
    style: {
      fill: "#9a6ac3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.78 37.76a9.11 9.11 0 0 0 9.32 1.77 5.91 5.91 0 0 0 1.9-1.41 10.45 10.45 0 0 0 3 .58c.7.08 1.05-1.72.21-1.84-2.48-.38-2.67-.74-2.67-.74a10.37 10.37 0 0 0-3.66-9c-3.44-2.78-8.67-.76-12.75-5-1.01-1-.46 11.07 4.65 15.64Zm10.3-1.84a1.72 1.72 0 0 1-.47 1.14c-6.53-1.92-11.45-8.68-11.45-8.68a28.4 28.4 0 0 0 11.92 7.54Z",
    style: {
      fill: "#9a6ac3"
    }
  })), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 23",
    fill: "none",
    id: "icon-bills",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.322 9.198c-.588 0-1.065.455-1.065 1.017 0 .561.477 1.016 1.065 1.016h6.385c.588 0 1.065-.455 1.065-1.016 0-.562-.477-1.017-1.065-1.017H5.322ZM4.257 14.28c0-.56.477-1.016 1.065-1.016h6.385c.588 0 1.065.455 1.065 1.017 0 .561-.477 1.016-1.065 1.016H5.322c-.588 0-1.065-.455-1.065-1.016ZM5.322 5.132c-.588 0-1.065.455-1.065 1.017 0 .561.477 1.016 1.065 1.016h6.385c.588 0 1.065-.455 1.065-1.016 0-.562-.477-1.017-1.065-1.017H5.322Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.129.05C.953.05 0 .96 0 2.083v19.313c0 .38.223.73.577.904.355.174.782.144 1.106-.077l3.106-2.12 3.107 2.12c.37.253.867.253 1.237 0l3.107-2.12 3.106 2.12c.324.221.751.251 1.106.077.354-.174.577-.523.577-.904V2.083C17.029.96 16.076.05 14.9.05H2.13Zm0 2.033H14.9V19.42l-2.042-1.393a1.106 1.106 0 0 0-1.237 0l-3.107 2.119-3.106-2.12a1.105 1.105 0 0 0-1.237 0l-2.042 1.394V2.083Z",
    fill: "currentColor"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 26 24",
    id: "icon-book",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m18.405 6.338-1.424.906V0h3.98v7.244l-1.424-.906-.566-.4-.566.4ZM23.947 0C25.117 0 26 .831 26 2v17.881C26 21.056 25.117 22 23.947 22h-8.913c-.858 0-1.536.256-1.536 1.213V24h-.996v-.787c0-.95-.678-1.213-1.536-1.213H2.053C.883 22 0 21.056 0 19.881V2C0 .831.883 0 2.053 0h9.355c.522 0 1.094.5 1.094.938V21.5l.498.344.498-.344V.937c0-.487.59-.937 1.094-.937h1.394v9.156l2.985-2 2.986 2V0h1.99Z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 24",
    id: "icon-bookmark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 0c.275 0 .5.225.5.5V4H0V.5C0 .225.225 0 .5 0h11ZM0 24V5h12v19l-6-6-6 6Z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-calendar",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M144 128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32ZM368 128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M472 64h-56v40.7c0 22.5-23.2 39.3-47.2 39.3-24 0-48.8-16.8-48.8-39.3V64H192v40.7c0 22.5-24 39.3-48 39.3s-48-16.8-48-39.3V64H40c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8Zm-40 368H80V176h352v256Z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    fill: "red",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-account_balance",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.17 6.021 7.9-4.16c.58-.31 1.28-.31 1.86 0l7.9 4.16c.41.21.67.64.67 1.1 0 .69-.56 1.25-1.24 1.25H3.75c-.69 0-1.25-.56-1.25-1.25 0-.46.26-.89.67-1.1Zm1.33 5.85v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5Zm6 0v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5Zm11 9c0 .83-.67 1.5-1.5 1.5H4c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h16c.83 0 1.5.67 1.5 1.5Zm-5-9v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5Z",
    fill: "currentColor"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-account_balance_wallet",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 16V8a2 2 0 0 1 2-2h9V5c0-1.1-.9-2-2-2h-14a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-1h-9a2 2 0 0 1-2-2Zm3-8c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h9V8h-9Zm1.5 4c0 .83.67 1.5 1.5 1.5S17 12.83 17 12s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5Z",
    fill: "currentColor"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-account_box",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5a2 2 0 0 0-2 2Zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3Zm-3 4.9c-2 0-6 1.1-6 3.1v1h12v-1c0-2-4-3.1-6-3.1Z",
    fill: "currentColor"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-account_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3ZM6 15.98a7.2 7.2 0 0 0 12 0c-.03-1.99-4.01-3.08-6-3.08-2 0-5.97 1.09-6 3.08Z",
    fill: "currentColor"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-bookmark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2Z",
    fill: "currentColor"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-bookmark_border",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h10c1.1 0 2 .9 2 2v16l-7-3-7 3V5c0-1.1.9-2 2-2Zm5 12.82L17 18V6c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v12l5-2.18Z",
    fill: "currentColor"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-bookmarks",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21 19-2-1V5c0-1.1-.9-2-2-2H7c0-1.1.89-2 1.99-2H19c1.1 0 2 .9 2 2v16ZM5 5h10c1.1 0 2 .9 2 2v16l-7-3-7 3V7c0-1.1.9-2 2-2Z",
    fill: "currentColor"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-build",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.472 3.247c-2.01-2.01-5.02-2.42-7.44-1.24l3.63 3.63c.39.39.39 1.02 0 1.41l-1.59 1.59c-.39.4-1.02.4-1.41 0l-3.63-3.63c-1.17 2.43-.76 5.42 1.25 7.43a6.507 6.507 0 0 0 6.89 1.48l7.96 7.96a2.613 2.613 0 0 0 3.71 0 2.613 2.613 0 0 0 0-3.71l-7.92-7.93c.92-2.34.44-5.1-1.45-6.99Z",
    fill: "currentColor"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-card_travel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6.5h3c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2v-11c0-1.11.89-2 2-2h3v-2c0-1.11.89-2 2-2h6c1.11 0 2 .89 2 2v2Zm-2-2H9v2h6v-2Zm5 15H4v-2h16v2Zm-16-5h16v-5c0-.55-.45-1-1-1h-2v1c0 .55-.45 1-1 1s-1-.45-1-1v-1H9v1c0 .55-.45 1-1 1s-1-.45-1-1v-1H5c-.55 0-1 .45-1 1v5Z",
    fill: "currentColor"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-check_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm3.7.7 3.59 3.59c.39.39 1.03.39 1.41 0l7.59-7.59a.996.996 0 1 0-1.41-1.41L10 14.17l-2.89-2.88A.996.996 0 1 0 5.7 12.7Z",
    fill: "currentColor"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-check_circle_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm-2-5.83 5.88-5.88c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41l-6.59 6.59a.996.996 0 0 1-1.41 0L6.71 13.7a.996.996 0 1 1 1.41-1.41L10 14.17Z",
    fill: "currentColor"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-code",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.2 12-3.9 3.9a.984.984 0 0 0 0 1.4c.39.39 1.01.39 1.4 0l4.59-4.6a.996.996 0 0 0 0-1.41L16.7 6.7a.984.984 0 0 0-1.4 0 .984.984 0 0 0 0 1.4l3.9 3.9ZM4.8 12l3.9 3.9c.39.39.39 1.01 0 1.4a.984.984 0 0 1-1.4 0l-4.59-4.6a.996.996 0 0 1 0-1.41L7.3 6.7a.984.984 0 0 1 1.4 0c.39.39.39 1.01 0 1.4L4.8 12Z",
    fill: "currentColor"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-credit_card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2Zm-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1ZM4 8h16V6H4v2Z",
    fill: "currentColor"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-dashboard",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13H4c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1Zm0 8H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1Zm4 0h6c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1ZM13 8V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1Z",
    fill: "currentColor"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 4H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29l.71.71ZM8 21c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8Z",
    fill: "currentColor"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-delete_forever",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.79 3.29.71.71H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29ZM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10Zm3.17-7.83a.996.996 0 0 1 1.41 0L12 12.59l1.42-1.42a.996.996 0 1 1 1.41 1.41L13.41 14l1.42 1.42a.996.996 0 1 1-1.41 1.41L12 15.41l-1.42 1.42a.996.996 0 1 1-1.41-1.41L10.59 14l-1.42-1.42a.996.996 0 0 1 0-1.41Z",
    fill: "currentColor"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-delete_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.79 3.29.71.71H18c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1h2.5l.71-.71c.18-.18.44-.29.7-.29h4.18c.26 0 .52.11.7.29ZM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10ZM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Z",
    fill: "currentColor"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-done",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.802 15.905-3.5-3.5a.984.984 0 0 0-1.4 0 .984.984 0 0 0 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0l10.6-10.59a.984.984 0 0 0 0-1.4.984.984 0 0 0-1.4 0l-9.9 9.9Z",
    fill: "currentColor"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-done_all",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m21.506 5.994-9.88 9.88-3.48-3.47a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.59-10.58a.996.996 0 0 0 0-1.41h-.01a.975.975 0 0 0-1.4-.01Zm-4.24.01a.996.996 0 0 0-1.41 0l-5.64 5.64 1.41 1.41 5.64-5.65c.38-.38.38-1.02 0-1.4Zm-12 12-4.18-4.18c-.39-.39-.39-1.03 0-1.42a.996.996 0 0 1 1.41 0l4.88 4.9-.7.7a.996.996 0 0 1-1.41 0Z",
    fill: "currentColor"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-done_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.43 13.445 9.93-9.93c.78-.78 2.04-.78 2.83 0l1.4 1.4c.78.78.78 2.05 0 2.83L9.84 20.485c-.78.78-2.05.78-2.83 0l-5.6-5.6c-.78-.78-.78-2.05 0-2.83l1.4-1.4c.78-.78 2.05-.78 2.83 0l2.79 2.79Zm12.04-6.41a.984.984 0 0 0 0-1.4.984.984 0 0 0-1.4 0L8.43 16.275l-3.5-3.5a.984.984 0 0 0-1.4 0 .984.984 0 0 0 0 1.4l4.2 4.2c.39.39 1.01.39 1.4 0l11.34-11.34Z",
    fill: "currentColor"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-exit_to_app",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-3c0-.55.45-1 1-1s1 .45 1 1v2c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V5a2 2 0 0 1 2-2Zm10.79 9.7-3.59 3.59a.996.996 0 1 1-1.41-1.41L12.67 13H4c-.55 0-1-.45-1-1s.45-1 1-1h8.67l-1.88-1.89A.996.996 0 1 1 12.2 7.7l3.59 3.59c.39.39.39 1.02 0 1.41Z",
    fill: "currentColor"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-extension",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5h-1.5v-4c0-1.1-.9-2-2-2h-4V4a2.5 2.5 0 0 0-5 0v1.5h-4c-1.1 0-1.99.9-1.99 2v3.8H3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7H1.5v3.8c0 1.1.9 2 2 2h3.8V21c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7v1.5h3.8c1.1 0 2-.9 2-2v-4H20a2.5 2.5 0 0 0 0-5Z",
    fill: "currentColor"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-favorite",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.35 20.307c-.76.69-1.93.69-2.69-.01l-.11-.1C5.3 15.447 1.87 12.337 2 8.457c.06-1.7.93-3.33 2.34-4.29 2.64-1.8 5.9-.96 7.66 1.1 1.76-2.06 5.02-2.91 7.66-1.1 1.41.96 2.28 2.59 2.34 4.29.14 3.88-3.3 6.99-8.55 11.76l-.1.09Z",
    fill: "currentColor"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-favorite_border",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.267c1.76-2.06 5.02-2.9 7.66-1.1 1.4.96 2.28 2.58 2.34 4.28.13 3.88-3.3 6.99-8.55 11.75l-.11.1c-.76.7-1.93.7-2.69.01l-.1-.09-.06-.054C5.274 15.423 1.86 12.323 2 8.457c.06-1.71.94-3.33 2.34-4.29 2.64-1.81 5.9-.96 7.66 1.1Zm0 13.56.1-.1c4.76-4.31 7.9-7.16 7.9-10.05 0-2-1.5-3.5-3.5-3.5-1.54 0-3.04.99-3.56 2.36h-1.87c-.53-1.37-2.03-2.36-3.57-2.36-2 0-3.5 1.5-3.5 3.5 0 2.89 3.14 5.74 7.9 10.05l.1.1Z",
    fill: "currentColor"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-favorite_border2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.19c0 1.59-1.34 2.874-3 2.874S9 6.78 9 5.19c0-1.59 1.34-2.875 3-2.875S15 3.6 15 5.19ZM5.32 8.255c2.56.44 4.86 1.581 6.68 3.21 1.82-1.629 4.12-2.769 6.68-3.21 1.21-.201 2.32.719 2.32 1.898v6.631c0 .92-.77 1.811-1.71 1.936a13.46 13.46 0 0 0-6.68 2.78c-.35.268-.92.239-1.27-.039a13.377 13.377 0 0 0-6.63-2.75C3.72 18.587 3 17.744 3 16.134v-5.98c0-1.18 1.11-2.1 2.32-1.898Z",
    fill: "currentColor"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-fingerprint",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.813 4.47c-.08 0-.16-.02-.23-.06-1.92-.99-3.58-1.41-5.57-1.41-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2a.506.506 0 0 1 .2-.68C7.823 2.52 9.863 2 12.013 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67a.49.49 0 0 1-.44.28ZM3.503 9.72a.499.499 0 0 1-.41-.79c.99-1.4 2.25-2.5 3.75-3.27 3.14-1.62 7.16-1.63 10.31-.01 1.5.77 2.76 1.86 3.75 3.25a.5.5 0 0 1-.12.7c-.23.16-.54.11-.7-.12a9.388 9.388 0 0 0-3.39-2.94c-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21Zm5.9 11.92c.09.1.22.15.35.15.13 0 .26-.05.37-.15.19-.2.19-.51 0-.71-.77-.78-1.21-1.27-1.85-2.42-.61-1.08-.93-2.41-.93-3.85 0-2.42 2.09-4.39 4.66-4.39 2.57 0 4.66 1.97 4.66 4.39 0 .28.22.5.5.5s.5-.22.5-.5c0-2.97-2.54-5.39-5.66-5.39s-5.66 2.42-5.66 5.39c0 1.61.36 3.11 1.05 4.34.67 1.21 1.14 1.77 2.01 2.64Zm7.52-1.7c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12Zm-2.14 2.04c.04.01.09.02.13.02.21 0 .42-.15.47-.38a.496.496 0 0 0-.35-.61c-1.41-.39-2.32-.91-3.27-1.85a6.297 6.297 0 0 1-1.87-4.51c0-1.07.93-1.94 2.08-1.94s2.08.87 2.08 1.94c0 1.62 1.38 2.94 3.08 2.94 1.7 0 3.08-1.32 3.08-2.94 0-4.32-3.7-7.83-8.25-7.83-3.23 0-6.18 1.81-7.51 4.6-.45.95-.68 2.04-.68 3.24 0 1.35.24 2.65.73 3.96.09.25.38.39.64.29.26-.09.39-.38.29-.64-.6-1.6-.67-2.83-.67-3.61 0-1.04.2-1.99.59-2.8 1.17-2.45 3.77-4.03 6.61-4.03 4 0 7.25 3.06 7.25 6.83 0 1.07-.93 1.94-2.08 1.94s-2.08-.87-2.08-1.94c0-1.62-1.38-2.94-3.08-2.94-1.7 0-3.08 1.32-3.08 2.94 0 1.98.77 3.83 2.17 5.22 1.09 1.07 2.13 1.66 3.72 2.1Z",
    fill: "currentColor"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-g_translate",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2ZM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42 0 1.33 1.07 2.42 2.38 2.42 1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4Zm7.22-.01c-.45-.52-.86-1.1-1.19-1.7l.65 2.23.54-.53Zm-.42-2.46h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7ZM20 21c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1h-8.82l1.18 4.04h1.96V9h1.04v1.04H19v1.04h-1.27c-.32 1.26-1.02 2.48-1.92 3.51l2.71 2.68-.73.73-2.68-2.69-.92.92L15 19l-2 2h7Z",
    fill: "currentColor"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-highlight_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2Zm1.89 6.7L12 10.59 10.11 8.7a.996.996 0 1 0-1.41 1.41L10.59 12 8.7 13.89a.996.996 0 1 0 1.41 1.41L12 13.41l1.89 1.89a.996.996 0 1 0 1.41-1.41L13.41 12l1.89-1.89a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.38-1.41 0ZM4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-history",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.143 12.002c0-5.05 4.17-9.14 9.26-9 4.69.13 8.61 4.05 8.74 8.74.14 5.09-3.95 9.26-9 9.26-2.09 0-4-.71-5.52-1.91-.47-.36-.5-1.07-.08-1.49.36-.36.92-.39 1.32-.08 1.18.93 2.67 1.48 4.28 1.48 3.9 0 7.05-3.19 7-7.1-.05-3.72-3.18-6.85-6.9-6.9-3.92-.05-7.1 3.1-7.1 7h1.79a.5.5 0 0 1 .36.85l-2.79 2.8c-.2.2-.51.2-.71 0l-2.79-2.8c-.32-.31-.1-.85.35-.85h1.79Zm8-3.25c0-.41.34-.75.75-.75s.75.34.75.74v3.4l2.88 1.71c.35.21.47.67.26 1.03-.21.35-.67.47-1.03.26l-3.12-1.85c-.3-.18-.49-.51-.49-.86v-3.68Z",
    fill: "currentColor"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-home",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.999 19.327v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87l-8.36-7.53c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87h1.7v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1Z",
    fill: "currentColor"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-https",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm-3-11v2h6v-2c0-1.66-1.34-3-3-3s-3 1.34-3 3Z",
    fill: "currentColor"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 15c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Zm-1-8h2V7h-2v2Z",
    fill: "currentColor"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-info_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1 5v2h2V7h-2Zm2 9c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4Zm-9-4c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-input",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.01h18c1.1 0 2 .9 2 2v13.98c0 1.1-.9 2-2 2H2.98C1.89 20.99 1 20.1 1 19.01V16c0-.55.45-1 1-1s1 .45 1 1v2.02c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V5.99c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1V8c0 .55-.45 1-1 1s-1-.45-1-1V5.01c0-1.1.9-2 2-2Zm11.64 9.35-2.79 2.79a.5.5 0 0 1-.85-.36V13H2c-.55 0-1-.45-1-1s.45-1 1-1h9V9.21c0-.45.54-.67.85-.35l2.79 2.79c.2.2.2.51 0 .71Z",
    fill: "currentColor"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-language",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm13.97-4h2.95a8.03 8.03 0 0 0-4.33-3.56c.6 1.11 1.06 2.31 1.38 3.56ZM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96ZM4 12c0 .69.1 1.36.26 2h3.38c-.08-.66-.14-1.32-.14-2 0-.68.06-1.34.14-2H4.26c-.16.64-.26 1.31-.26 2Zm1.08 4h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16Zm0-8h2.95c.32-1.25.78-2.45 1.38-3.56-1.84.63-3.37 1.9-4.33 3.56ZM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96ZM9.5 12c0 .68.07 1.34.16 2h4.68c.09-.66.16-1.32.16-2 0-.68-.07-1.35-.16-2H9.66c-.09.65-.16 1.32-.16 2Zm5.09 7.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56ZM16.5 12c0 .68-.06 1.34-.14 2h3.38c.16-.64.26-1.31.26-2s-.1-1.36-.26-2h-3.38c.08.66.14 1.32.14 2Z",
    fill: "currentColor"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-lock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm-3-11v2h6v-2c0-1.66-1.34-3-3-3s-3 1.34-3 3Z",
    fill: "currentColor"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-lock_open",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5h-1v-2c0-2.76-2.24-5-5-5-2.28 0-4.27 1.54-4.84 3.75-.14.54.18 1.08.72 1.22a1 1 0 0 0 1.22-.72A2.996 2.996 0 0 1 12 3.5c1.65 0 3 1.35 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2Zm-6 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm5 7c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h10Z",
    fill: "currentColor"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-lock_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8.5h1c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h1v-2c0-2.76 2.24-5 5-5s5 2.24 5 5v2Zm-5-5c-1.66 0-3 1.34-3 3v2h6v-2c0-1.66-1.34-3-3-3Zm-5 17c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H7Zm7-5c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z",
    fill: "currentColor"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-pan_tool",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.182 4c-.83 0-1.5.67-1.5 1.5v5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-8c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v8c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-9c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v8.99c0 .28-.22.5-.5.5s-.5-.22-.5-.5V4.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v11.41l-4.12-2.35c-.58-.33-1.3-.24-1.78.22-.6.58-.62 1.54-.03 2.13l6.78 6.89c.75.77 1.77 1.2 2.85 1.2h7.3c2.21 0 4-1.79 4-4V5.5c0-.83-.67-1.5-1.5-1.5Z",
    fill: "currentColor"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-power_settings_new",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.004 4.003c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1s-1-.45-1-1v-8Zm6.13 3.25a.99.99 0 0 1 .01-1.39c.4-.4 1.06-.39 1.44.02a8.89 8.89 0 0 1 2.42 6.11c0 5.07-4.19 9.16-9.29 9-4.88-.15-8.85-4.37-8.71-9.25a8.92 8.92 0 0 1 2.43-5.86.993.993 0 0 1 1.43-.02c.38.38.38.99.01 1.38a6.97 6.97 0 0 0-1.87 4.76c0 3.9 3.18 7.05 7.09 6.99 3.83-.04 7-3.34 6.91-7.17a6.864 6.864 0 0 0-1.87-4.57Z",
    fill: "currentColor"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-remove_shopping_cart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.277 2.68a.996.996 0 1 1 1.41-1.41l20.04 20.05a.996.996 0 1 1-1.41 1.41l-2.13-2.13c-.36.51-.95.84-1.62.84a1.997 1.997 0 0 1-1.16-3.62l-1.38-1.38h-7.33c-1.06 0-2.02-.76-2.12-1.82-.04-.42.05-.82.24-1.15l1.35-2.45-2.21-4.66-3.68-3.68Zm7.39 9.76-1.1 2h5.46l-2-2h-2.36Zm7.95-.06c.54-.14.99-.49 1.25-.97l3.58-6.49c.37-.66-.12-1.48-.88-1.48H7.687l8.93 8.94Zm-11.04 7.06c0-1.1.89-2 1.99-2s2 .9 2 2-.9 2-2 2-1.99-.9-1.99-2Z",
    fill: "currentColor"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-reorder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1H4Zm0 4h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1Zm16 4H4c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1Zm0 4H4c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-report_problem",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.733 21.001h18.53c.77 0 1.25-.83.87-1.5l-9.27-16a.996.996 0 0 0-1.73 0l-9.27 16c-.38.67.1 1.5.87 1.5Zm10.27-3h-2v-2h2v2Zm-2-5c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-search",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.187 14.471h.79l4.24 4.26c.41.41.41 1.08 0 1.49-.41.41-1.08.41-1.49 0l-4.25-4.25v-.79l-.27-.28a6.5 6.5 0 0 1-5.34 1.48c-2.78-.47-5-2.79-5.34-5.59a6.505 6.505 0 0 1 7.27-7.27c2.8.34 5.12 2.56 5.59 5.34a6.5 6.5 0 0 1-1.48 5.34l.28.27Zm-9.71-4.5c0 2.49 2.01 4.5 4.5 4.5s4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5Z",
    fill: "currentColor"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.503 12c0 .34-.03.66-.07.98l2.11 1.65c.19.15.24.42.12.64l-2 3.46c-.12.22-.38.31-.61.22l-2.49-1c-.52.39-1.08.73-1.69.98l-.38 2.65c-.03.24-.24.42-.49.42h-4c-.25 0-.46-.18-.49-.42l-.38-2.65c-.61-.25-1.17-.58-1.69-.98l-2.49 1c-.22.08-.49 0-.61-.22l-2-3.46a.505.505 0 0 1 .12-.64l2.11-1.65a7.93 7.93 0 0 1-.07-.98c0-.33.03-.66.07-.98l-2.11-1.65a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.38-.31.61-.22l2.49 1c.52-.39 1.08-.73 1.69-.98l.38-2.65c.03-.24.24-.42.49-.42h4c.25 0 .46.18.49.42l.38 2.65c.61.25 1.17.58 1.69.98l2.49-1c.22-.08.49 0 .61.22l2 3.46c.12.22.07.49-.12.64l-2.11 1.65c.04.32.07.64.07.98Zm-11 0c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5Z",
    fill: "currentColor"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-shopping_basket",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.506h-4.79l-4.39-6.57a1 1 0 0 0-1.66 0l-4.39 6.57H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27.03-.27c0-.55-.45-1-1-1Zm-10.01-4.21 2.81 4.21H9.18l2.81-4.21ZM10 15.506c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Z",
    fill: "currentColor"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-shopping_cart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.996 3c0 .55.45 1 1 1h1l3.6 7.59-1.35 2.44c-.73 1.34.23 2.97 1.75 2.97h11c.55 0 1-.45 1-1s-.45-1-1-1h-11l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49a.996.996 0 0 0-.87-1.48h-14.8l-.67-1.43a.993.993 0 0 0-.9-.57h-1.64c-.55 0-1 .45-1 1Zm6 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2Zm8.01 2c0-1.1.89-2 1.99-2s2 .9 2 2-.9 2-2 2-1.99-.9-1.99-2Z",
    fill: "currentColor"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-store",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6h14c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1Zm15.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8l-1 5c-.12.62.35 1.2.98 1.2H4v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5h.18c.63 0 1.1-.58.98-1.2l-1-5ZM6 18h6v-4H6v4Z",
    fill: "currentColor"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-supervised_user_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm3.61 6.34c1.07 0 1.93.86 1.93 1.93 0 1.07-.86 1.93-1.93 1.93-1.07 0-1.93-.86-1.93-1.93-.01-1.07.86-1.93 1.93-1.93Zm-3.64.78c0-1.3-1.06-2.36-2.36-2.36-1.31 0-2.36 1.05-2.36 2.36 0 1.3 1.06 2.36 2.36 2.36 1.3 0 2.36-1.06 2.36-2.36Zm-2.36 6.77v3.75c-2.4-.75-4.3-2.6-5.14-4.96 1.05-1.12 3.67-1.69 5.14-1.69.53 0 1.2.08 1.9.22-1.64.87-1.9 2.02-1.9 2.68Zm1.6 4.07c.26.03.52.04.79.04 3.39 0 6.28-2.12 7.45-5.09-.92-.76-2.77-1.15-3.84-1.15-1.46 0-4.4.71-4.4 2.13v4.07Z",
    fill: "currentColor"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-supervisor_account",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 8c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3Zm7 1.5c0 1.38-1.11 2.5-2.49 2.5a2.5 2.5 0 0 1 0-5c1.38 0 2.49 1.12 2.49 2.5ZM16.5 14c-1.83 0-5.5.92-5.5 2.75V18c0 .55.45 1 1 1h9c.55 0 1-.45 1-1v-1.25c0-1.83-3.67-2.75-5.5-2.75ZM2 16.5C2 14.17 6.67 13 9 13c.66 0 1.5.1 2.37.28C9.33 14.41 9 15.9 9 16.75V19H3c-.55 0-1-.45-1-1v-1.5Z",
    fill: "currentColor"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-thumbs_up_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.824 5h4.24c1.43 0 2.4 1.47 1.84 2.79l-2.14 5c-.32.73-1.04 1.21-1.84 1.21h-5.92c-1.1 0-2-.9-2-2V6.21c0-.53.21-1.04.6-1.41l4-4a1.11 1.11 0 0 1 1.58 0c.26.27.38.65.3 1.02L5.824 5Zm10.26 5h5.92c1.1 0 2 .9 1.99 2v5.79c0 .53-.21 1.03-.59 1.41l-4 4c-.43.44-1.14.44-1.58 0a1.13 1.13 0 0 1-.3-1.02l.66-3.18h-4.24c-1.44 0-2.4-1.47-1.84-2.79l2.14-5c.32-.73 1.04-1.21 1.84-1.21Z",
    fill: "currentColor"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-timeline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 8c0 1.1-.9 2-2 2a1.7 1.7 0 0 1-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56A1.7 1.7 0 0 1 19 8c0-1.1.9-2 2-2s2 .9 2 2Z",
    fill: "currentColor"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-visibility",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5ZM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Z",
    fill: "currentColor"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-action-visibility_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71 4.54a.996.996 0 0 1 0-1.41c.39-.39 1.03-.39 1.42 0l16.31 16.33a.996.996 0 1 1-1.41 1.41l-2.72-2.72c-1.34.52-2.79.82-4.31.82-5 0-9.27-3.11-11-7.5.77-1.97 2.06-3.67 3.68-4.96L2.71 4.54ZM17 11.47c0-2.76-2.24-5-5-5-.51 0-1 .1-1.47.24L8.36 4.54c1.15-.37 2.37-.57 3.64-.57 5 0 9.27 3.11 11 7.49-.69 1.76-1.79 3.3-3.18 4.53l-3.06-3.06c.14-.46.24-.95.24-1.46Zm-5 5c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07l1.57 1.57c-.65.32-1.37.5-2.14.5Zm2.97-5.33a2.97 2.97 0 0 0-2.64-2.64l2.64 2.64Z",
    fill: "currentColor"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 16.75v-6c0-3.35-2.36-6.15-5.5-6.83V2.75c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v1.17C7.36 4.6 5 7.4 5 10.75v6l-1.29 1.29c-.63.63-.19 1.71.7 1.71h15.17c.89 0 1.34-1.08.71-1.71L19 16.75Zm-7 6c1.1 0 1.99-.89 1.99-1.99h-3.98c0 1.1.89 1.99 1.99 1.99Zm1-9.99h2c.55 0 1-.45 1-1v-.01c0-.55-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1v.01c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2Z",
    fill: "currentColor"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-error",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1Zm-1 2v2h2v-2h-2Z",
    fill: "currentColor"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-error_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm11-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V8Zm-1 12c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-1-5v2h2v-2h-2Z",
    fill: "currentColor"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-notification_important",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19 16.75 1.29 1.29c.63.63.19 1.71-.71 1.71H4.41c-.89 0-1.33-1.08-.7-1.71L5 16.75v-6C5 7.4 7.36 4.6 10.5 3.92V2.75c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v1.17c3.14.68 5.5 3.48 5.5 6.83v6Zm-5.01 4.01c0 1.1-.89 1.99-1.99 1.99s-1.99-.89-1.99-1.99h3.98ZM11 15.75v-2h2v2h-2Zm1-4c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.53 20.504c1.54 0 2.5-1.67 1.73-3l-7.53-13.01c-.77-1.33-2.69-1.33-3.46 0l-7.53 13.01c-.77 1.33.19 3 1.73 3h15.06Zm-7.53-7c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Zm-1 2v2h2v-2h-2Z",
    fill: "currentColor"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-alert-warning_amber",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.47 20.504c-1.54 0-2.5-1.67-1.73-3l7.53-13.01c.77-1.33 2.69-1.33 3.46 0l7.53 13.01c.77 1.33-.19 3-1.73 3H4.47Zm15.06-2L12 5.494l-7.53 13.01h15.06Zm-8.53-8v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1Zm2 7v-2h-2v2h2Z",
    fill: "currentColor"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-loop",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.21V4c4.42 0 8 3.58 8 8 0 1.04-.2 2.04-.57 2.95-.27.67-1.13.85-1.64.34-.27-.27-.38-.68-.23-1.04.29-.69.44-1.46.44-2.25 0-3.31-2.69-6-6-6v1.79c0 .45-.54.67-.86.36L8.35 5.36c-.2-.2-.2-.51 0-.71l2.8-2.79c.31-.32.85-.1.85.35ZM6 12c0 3.31 2.69 6 6 6v-1.79a.5.5 0 0 1 .85-.36l2.79 2.79c.2.2.2.51 0 .71l-2.79 2.79c-.31.32-.85.1-.85-.35V20c-4.42 0-8-3.58-8-8 0-1.04.2-2.04.57-2.95.27-.67 1.13-.85 1.64-.34.27.27.38.68.23 1.04C6.15 10.44 6 11.21 6 12Z",
    fill: "currentColor"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-mic",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.999 11.5c0 1.66-1.34 3-3 3s-3-1.34-3-3v-6c0-1.66 1.34-3 3-3s3 1.34 3 3v6Zm1.93.85c.08-.49.49-.85.98-.85.61 0 1.1.54 1 1.14-.49 3-2.89 5.35-5.91 5.78v2.08c0 .55-.45 1-1 1s-1-.45-1-1v-2.08a6.993 6.993 0 0 1-5.91-5.78c-.09-.6.39-1.14 1-1.14.49 0 .9.36.98.85.41 2.35 2.46 4.15 4.93 4.15 2.47 0 4.52-1.8 4.93-4.15Z",
    fill: "currentColor"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-mic_none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 14.5c1.66 0 3-1.34 3-3v-6c0-1.66-1.34-3-3-3s-3 1.34-3 3v6c0 1.66 1.34 3 3 3Zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1v-6Zm5.93 6.85c.08-.49.49-.85.98-.85.61 0 1.1.54 1 1.14-.49 3-2.89 5.35-5.91 5.78v2.08c0 .55-.45 1-1 1s-1-.45-1-1v-2.08a6.993 6.993 0 0 1-5.91-5.78c-.09-.6.39-1.14 1-1.14.49 0 .9.36.98.85.41 2.35 2.46 4.15 4.93 4.15 2.47 0 4.52-1.8 4.93-4.15Z",
    fill: "currentColor"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-mic_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.918 11.1V5.5c0-1.66-1.34-3-3-3-1.54 0-2.79 1.16-2.96 2.65l5.96 5.95Zm3.08.4c-.41 0-.77.3-.83.71-.05.32-.12.64-.22.93l1.27 1.27c.3-.6.52-1.25.63-1.94a.857.857 0 0 0-.85-.97ZM3.628 5.47a.996.996 0 1 1 1.41-1.41l15.33 15.34a.996.996 0 1 1-1.41 1.41l-3.49-3.49c-.78.45-1.64.77-2.55.9v2.28c0 .55-.45 1-1 1s-1-.45-1-1v-2.28c-2.97-.45-5.47-2.79-5.93-5.75-.07-.51.33-.97.85-.97.41 0 .77.3.83.71.37 2.62 2.71 4.39 5.25 4.39.81 0 1.6-.19 2.31-.52l-1.66-1.66c-.61.13-1.27.12-2.02-.31-1.03-.59-1.63-1.72-1.63-2.91v-.43l-5.29-5.3Z",
    fill: "currentColor"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-pause",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17c0 1.1-.9 2-2 2s-2-.9-2-2V7c0-1.1.9-2 2-2s2 .9 2 2v10Zm4 0V7c0-1.1.9-2 2-2s2 .9 2 2v10c0 1.1-.9 2-2 2s-2-.9-2-2Z",
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-pause_circle_filled",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-2 14c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1Zm3-1c0 .55.45 1 1 1s1-.45 1-1V9c0-.55-.45-1-1-1s-1 .45-1 1v6Z",
    fill: "currentColor"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-pause_circle_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm9 3c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6Zm1 5c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm3-5c0 .55-.45 1-1 1s-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v6Z",
    fill: "currentColor"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-play_arrow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.926 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 0 0 0-1.69l-8.14-5.17a.998.998 0 0 0-1.54.84Z",
    fill: "currentColor"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-play_circle_filled_white",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm8.8-3.9a.5.5 0 0 0-.8.4v7c0 .41.47.65.8.4l4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1Z",
    fill: "currentColor"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-play_circle_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm-1.2 13.9 4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1a.5.5 0 0 0-.8.4v7c0 .41.47.65.8.4ZM4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-replay",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.964 5.643v-2.79c0-.45-.54-.67-.85-.35l-3.8 3.79c-.2.2-.2.51 0 .71l3.79 3.79c.32.31.86.09.86-.36v-2.79c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01a1 1 0 0 0-.98-.85c-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24.99-5.13-2.91-9.61-7.85-9.61Z",
    fill: "currentColor"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-subtitles",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2ZM5 12h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1Zm0 6h8c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1 .45-1 1s.45 1 1 1Zm14 0h-2c-.55 0-1-.45-1-1s.45-1 1-1h2c.55 0 1 .45 1 1s-.45 1-1 1Zm-8-4h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-videocam",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l2.29 2.29c.63.63 1.71.18 1.71-.71V8.91c0-.89-1.08-1.34-1.71-.71L17 10.5Z",
    fill: "currentColor"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-videocam_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.54a.996.996 0 1 1 1.41-1.41l16.32 16.33a.996.996 0 1 1-1.41 1.41l-2.48-2.48c-.16.1-.34.18-.55.18h-12c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1h.73L3 4.54Zm18.29 4.94v5.29c0 .89-1.08 1.34-1.7.71l-8.91-8.91h5.61c.55 0 1 .45 1 1v3.5l2.29-2.3c.63-.63 1.71-.18 1.71.71Z",
    fill: "currentColor"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-volume_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63 5.045a.996.996 0 0 1 0-1.41c.4-.39 1.03-.39 1.42 0l15.31 15.32a.996.996 0 1 1-1.41 1.41l-1.34-1.34c-.67.54-1.42.98-2.22 1.31-.66.27-1.39-.19-1.39-.91 0-.39.22-.77.58-.92.58-.23 1.11-.54 1.6-.91L12 13.415v4.17c0 .89-1.08 1.34-1.71.71L7 15.005H4c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3l.29-.3-3.66-3.66Zm14.96 9.3c.26-.73.41-1.52.41-2.34 0-2.94-1.82-5.46-4.39-6.5-.36-.14-.61-.47-.61-.85v-.19c0-.63.63-1.09 1.22-.86a8.995 8.995 0 0 1 5.78 8.4c0 1.39-.32 2.7-.88 3.87l-1.53-1.53Zm-8.3-8.63-.17.17L12 7.765v-1.35c0-.89-1.08-1.33-1.71-.7ZM14 7.975a4.5 4.5 0 0 1 2.5 4.03c0 .08-.01.16-.02.24L14 9.765v-1.79Z",
    fill: "currentColor"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-volume_up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.652v-.2c0-.63.63-1.08 1.21-.85a8.98 8.98 0 0 1 5.79 8.4c0 3.84-2.4 7.11-5.79 8.4-.58.22-1.21-.22-1.21-.85v-.2c0-.38.24-.71.6-.85a7.004 7.004 0 0 0 4.4-6.5c0-2.94-1.82-5.47-4.4-6.5a.93.93 0 0 1-.6-.85Zm-11 5.35v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71V6.412c0-.89-1.08-1.34-1.71-.71L7 9.002H4c-.55 0-1 .45-1 1Zm13.5 2a4.5 4.5 0 0 0-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02Z",
    fill: "currentColor"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-av-web_asset",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4h14a2 2 0 0 1 2 2v12c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm1 14h12c.55 0 1-.45 1-1V8H5v9c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-add_call",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.992 8.013h-2c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2Zm.67 6.98 2.54.29c1.01.11 1.78.97 1.77 1.97v1.73c0 1.13-.94 2.07-2.07 2-8.53-.53-15.36-7.35-15.89-15.89-.07-1.13.87-2.07 2-2.07h1.73a2 2 0 0 1 1.98 1.78l.29 2.52c.07.6-.14 1.21-.57 1.64l-1.85 1.85c1.44 2.84 3.76 5.15 6.59 6.59l1.84-1.84a1.99 1.99 0 0 1 1.64-.57Z",
    fill: "currentColor"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-business",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5v2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2ZM4 19h2v-2H4v2Zm2-4H4v-2h2v2Zm-2-4h2V9H4v2Zm2-4H4V5h2v2Zm2 12h2v-2H8v2Zm2-4H8v-2h2v2Zm-2-4h2V9H8v2Zm2-4H8V5h2v2Zm2 12h7c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-7v2h2v2h-2v2h2v2h-2v2Zm6-8h-2v2h2v-2Zm-2 4h2v2h-2v-2Z",
    fill: "currentColor"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-call",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.223 15.268-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.045 15.045 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 0 0-1.99-1.77h-1.73c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98Z",
    fill: "currentColor"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-call_end",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.581 16.03 2-1.59c.48-.38.76-.96.76-1.57v-2.6c3.02-.98 6.29-.99 9.32 0v2.61c0 .61.28 1.19.76 1.57l1.99 1.58c.8.63 1.94.57 2.66-.15l1.22-1.22c.8-.8.8-2.13-.05-2.88-6.41-5.66-16.07-5.66-22.48 0-.85.75-.85 2.08-.05 2.88l1.22 1.22c.71.72 1.85.78 2.65.15Z",
    fill: "currentColor"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-chat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4 .01-18c0-1.1.89-2 1.99-2Zm13 7H7c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm-4 5H7c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1ZM7 8h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-chat_bubble",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Z",
    fill: "currentColor"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-chat_bubble_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2Zm2 14h13c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v13l2-2Z",
    fill: "currentColor"
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-duo",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2h8c1.1 0 2 .9 2 2v8c0 5.62-4.61 10-10.28 10C6.49 22 2 17.5 2 12.28 2 6.66 6.38 2 12 2Zm2 11 3 2V9l-3 2V9H7v6h7v-2Z",
    fill: "currentColor"
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2Zm8.53 8.67 7.07-4.42a.85.85 0 1 0-.9-1.44L12 11 5.3 6.81a.85.85 0 1 0-.9 1.44l7.07 4.42c.32.2.74.2 1.06 0Z",
    fill: "currentColor"
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-forum",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4v7c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2h11c1.1 0 2 .9 2 2Zm2 2h1c1.1 0 2 .9 2 2v14l-4-4H8c-1.1 0-2-.9-2-2v-1h12c.55 0 1-.45 1-1V6Z",
    fill: "currentColor"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-import_contacts",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004 5.178c1.45-1.1 3.55-1.5 5.5-1.5 1.45 0 2.99.22 4.27.79.73.33 1.22 1.04 1.22 1.85v11.28c0 1.31-1.22 2.27-2.48 1.94-.98-.25-2.02-.36-3.02-.36-1.56 0-3.22.25-4.56.92-.59.3-1.27.3-1.87 0-1.34-.66-3-.92-4.56-.92-1 0-2.04.11-3.02.36-1.26.32-2.48-.64-2.48-1.94V6.318c0-.81.49-1.52 1.22-1.85 1.29-.57 2.83-.79 4.28-.79 1.95 0 4.05.4 5.5 1.5Zm7.8 12.21c.62.11 1.2-.35 1.2-.98v-9.47c0-.47-.34-.88-.8-.98-.87-.19-1.78-.28-2.7-.28-1.7 0-4.15.65-5.5 1.5v11.51c1.35-.85 3.8-1.5 5.5-1.5.77 0 1.55.06 2.3.2Z",
    fill: "currentColor"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-import_export",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.855 6.145 2.79-2.79c.19-.19.51-.19.7 0l2.79 2.79c.32.31.1.85-.35.85h-1.79v6.01c0 .55-.45 1-1 1s-1-.45-1-1v-6.01h-1.79c-.45 0-.67-.54-.35-.85Zm10.14 4.86v6.01h1.8c.44 0 .67.54.35.85l-2.79 2.78c-.2.19-.51.19-.71 0l-2.79-2.78c-.32-.31-.1-.85.35-.85h1.79v-6.01c0-.55.45-1 1-1s1 .45 1 1Z",
    fill: "currentColor"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-location_on",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.265c0-3.87 3.13-7 7-7s7 3.13 7 7c0 4.17-4.42 9.92-6.23 12.11-.4.48-1.13.48-1.53 0C9.42 19.185 5 13.435 5 9.265Zm4.5 0a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z",
    fill: "currentColor"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-communication-mail_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 13c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V8l6.94 4.34c.65.41 1.47.41 2.12 0L20 8v9ZM4 6l8 5 8-5H4Z",
    fill: "currentColor"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-add_box",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm8 10h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3Z",
    fill: "currentColor"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-add_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm11 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1s-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3Z",
    fill: "currentColor"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-add_circle_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 5c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1Zm-8 5c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-archive",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.54 5.23-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27Zm-8.89 11.92L6.5 12H10v-2h4v2h3.5l-5.15 5.15c-.19.19-.51.19-.7 0ZM5.93 4l-.81 1h13.75l-.94-1h-12Z",
    fill: "currentColor"
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-clear",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.299 5.71a.996.996 0 0 0-1.41 0l-4.89 4.88-4.89-4.89a.996.996 0 1 0-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 1 0 1.41 1.41l4.89-4.89 4.89 4.89a.996.996 0 1 0 1.41-1.41L13.409 12l4.89-4.89c.38-.38.38-1.02 0-1.4Z",
    fill: "currentColor"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1h-11c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm4 4h-11c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-10 16h9c.55 0 1-.45 1-1V8c0-.55-.45-1-1-1h-9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-create",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.71 5.631c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM3 20.501v-3.04c0-.14.05-.26.15-.36l10.91-10.91 3.75 3.75-10.92 10.91a.47.47 0 0 1-.35.15H3.5c-.28 0-.5-.22-.5-.5Z",
    fill: "currentColor"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-cut",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.002 9 6.59-6.59c.89-.89 2.41-.26 2.41.99v.01c0 .38-.15.74-.41 1L15.002 11l-2-2Zm-3.36-1.36c.29-.62.42-1.33.34-2.09-.19-1.73-1.54-3.2-3.26-3.49a4.008 4.008 0 0 0-4.66 4.65c.3 1.72 1.76 3.07 3.49 3.26.76.08 1.46-.05 2.09-.34l2.36 2.37-2.36 2.36c-.62-.29-1.33-.42-2.09-.34-1.73.19-3.2 1.54-3.49 3.26a4.002 4.002 0 0 0 4.65 4.65c1.72-.3 3.07-1.76 3.26-3.49.08-.76-.05-1.46-.34-2.09l2.37-2.35 7.59 7.59c.89.89 2.41.26 2.41-1v-.01c0-.37-.15-.73-.41-1L9.642 7.64ZM6.002 8a2 2 0 1 1 0-3.999 2 2 0 0 1 0 4Zm-2 10a2 2 0 1 0 4 .001 2 2 0 0 0-4 0Zm8-5.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5Z",
    fill: "currentColor"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-drafts",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.05 7.644c.57.35.94.98.94 1.7l.01 10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-10c0-.72.38-1.35.95-1.7l8.04-4.71c.62-.37 1.4-.37 2.02 0l8.04 4.71ZM3.74 9.184l7.2 4.5c.65.4 1.47.4 2.12 0l7.2-4.5-7.25-4.25c-.62-.37-1.4-.37-2.02 0l-7.25 4.25Z",
    fill: "currentColor"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-file_copy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 1h-11c-1.1 0-2 .9-2 2v13c0 .55.45 1 1 1s1-.45 1-1V4c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm.59 4.59 4.83 4.83c.37.37.58.88.58 1.41V21c0 1.1-.9 2-2 2H8.49c-1.1 0-1.99-.9-1.99-2l.01-14c0-1.1.89-2 1.99-2h6.17c.53 0 1.04.21 1.42.59ZM20 12h-4.5c-.55 0-1-.45-1-1V6.5L20 12Z",
    fill: "currentColor"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-filter_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39A.998.998 0 0 0 18.95 4H5.04c-.83 0-1.3.95-.79 1.61Z",
    fill: "currentColor"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-filter_list",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1Zm8 11h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1Zm6-5H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15h3c.55 0 1 .45 1 1s-.45 1-1 1H7c-2.76 0-5-2.24-5-5s2.24-5 5-5h3c.55 0 1 .45 1 1s-.45 1-1 1H7c-1.65 0-3 1.35-3 3s1.35 3 3 3Zm10-8h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.65 0 3 1.35 3 3s-1.35 3-3 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c2.76 0 5-2.24 5-5s-2.24-5-5-5Zm-9 5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-link_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.12 3.63a.996.996 0 1 0-1.41 1.41l2.4 2.4c-1.94.8-3.27 2.77-3.09 5.04.21 2.64 2.57 4.59 5.21 4.59h2.82c.52 0 .95-.43.95-.95s-.43-.95-.95-.95H7.16c-1.63 0-3.1-1.19-3.25-2.82A3.095 3.095 0 0 1 6.66 9l2.1 2.1c-.43.09-.76.46-.76.92v.1c0 .52.43.95.95.95h1.78L13 15.34v1.73h1.73l3.3 3.3a.996.996 0 1 0 1.41-1.41L4.12 3.63Zm17.82 7.67c-.37-2.47-2.62-4.23-5.12-4.23h-2.87c-.52 0-.95.43-.95.95s.43.95.95.95h2.9c1.6 0 3.04 1.14 3.22 2.73.17 1.43-.64 2.69-1.85 3.22l1.4 1.4c1.63-1.02 2.64-2.91 2.32-5.02Zm-6.89-.23c.52 0 .95.43.95.95v.1c0 .16-.05.31-.12.44l-1.49-1.49h.66Z",
    fill: "currentColor"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-mail",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Zm9.06 8.34 6.54-4.09a.85.85 0 1 0-.9-1.44L12 11 5.3 6.81a.85.85 0 1 0-.9 1.44l6.54 4.09c.65.41 1.47.41 2.12 0Z",
    fill: "currentColor"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-paste",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1ZM5 20c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1h-1v1c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2V5H6c-.55 0-1 .45-1 1v14Z",
    fill: "currentColor"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-remove",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 13H6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1Z",
    fill: "currentColor"
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-remove_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm5 0c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-remove_circle_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2ZM7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1Zm-3 0c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-reply",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.796 7.797v-1.59c0-.89-1.08-1.34-1.71-.71l-4.59 4.59a.996.996 0 0 0 0 1.41l4.59 4.59c.63.63 1.71.19 1.71-.7v-1.69c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11Z",
    fill: "currentColor"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-reply_all",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.79 6.207v1.59c7 1 10 6 11 11-2.5-3.5-6-5.1-11-5.1v1.68c0 .89-1.08 1.34-1.71.71l-4.59-4.59a.996.996 0 0 1 0-1.41l4.59-4.59c.63-.63 1.71-.18 1.71.71Zm-7.81-.6c.67-.67 1.81-.19 1.81.75 0 .28-.11.55-.31.75l-3.69 3.69 3.69 3.69c.2.2.31.47.31.75 0 .94-1.14 1.42-1.81.74L.5 11.497a.996.996 0 0 1 0-1.41l4.48-4.48Z",
    fill: "currentColor"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-report",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.324 3h-6.64c-.26 0-.52.11-.7.29l-4.69 4.69c-.18.18-.29.44-.29.7v6.63c0 .27.11.52.29.71l4.68 4.68c.19.19.45.3.71.3h6.63c.27 0 .52-.11.71-.29l4.68-4.68a.99.99 0 0 0 .29-.71V8.68c0-.27-.11-.52-.29-.71l-4.68-4.68c-.18-.18-.44-.29-.7-.29Zm-3.32 14.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3Zm-1-5.3c0 .55.45 1 1 1s1-.45 1-1V8c0-.55-.45-1-1-1s-1 .45-1 1v4Z",
    fill: "currentColor"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-report_gmailerrorred",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.034 3.3 4.68 4.68c.18.18.29.44.28.7v6.64c0 .27-.1.52-.29.71l-4.68 4.68c-.19.18-.44.29-.71.29h-6.63c-.26 0-.52-.11-.71-.3l-4.68-4.68c-.18-.19-.29-.44-.29-.71V8.68c0-.26.11-.52.29-.7l4.69-4.69c.18-.18.44-.29.7-.29h6.64c.26 0 .52.11.71.3ZM14.904 19l4.1-4.1V9.1l-4.1-4.1h-5.8l-4.1 4.1v5.8l4.1 4.1h5.8Zm-2.9-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-1-7c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1s-1-.45-1-1V8Z",
    fill: "currentColor"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-report_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7 1.29 1.29 2.7l3.64 3.64-1.35 1.35c-.18.18-.29.44-.29.7v6.63c0 .27.11.52.29.71l4.68 4.68c.19.19.45.3.71.3h6.63c.27 0 .52-.11.71-.29l1.35-1.35 3.64 3.64 1.41-1.41L2.7 1.29Zm9.59 5.42c.55 0 1 .45 1 1v1.33l7.2 7.2.51-.51a.99.99 0 0 0 .29-.71V8.39c0-.27-.11-.52-.29-.71L16.32 3c-.19-.18-.45-.29-.71-.29H8.97c-.26 0-.52.11-.7.29l-.51.51 3.69 3.69c.17-.29.48-.49.84-.49Zm-1.3 9c0 .72.58 1.3 1.3 1.3.72 0 1.3-.58 1.3-1.3 0-.72-.58-1.3-1.3-1.3-.72 0-1.3.58-1.3 1.3Z",
    fill: "currentColor"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-save_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.88 10.79 13 12.67V4c0-.55-.45-1-1-1s-1 .45-1 1v8.67l-1.89-1.88A.996.996 0 1 0 7.7 12.2l3.59 3.59c.39.39 1.02.39 1.41 0l3.59-3.59a.996.996 0 1 0-1.41-1.41ZM19 18v-5c0-.55.45-1 1-1s1 .45 1 1v6c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6c0-.55.45-1 1-1s1 .45 1 1v5c0 .55.45 1 1 1h12c.55 0 1-.45 1-1Z",
    fill: "currentColor"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-send",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.67 20.4 17.45-7.48a1 1 0 0 0 0-1.84L3.67 3.6a.993.993 0 0 0-1.39.91l-.01 4.61c0 .5.37.93.87.99L17.27 12 3.14 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91Z",
    fill: "currentColor"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-content-unarchive",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.55 5.22-1.39-1.68A1.51 1.51 0 0 0 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28Zm-8.2 4.63L17.5 15H14v2h-4v-2H6.5l5.15-5.15c.19-.19.51-.19.7 0ZM5.94 4l-.82 1h13.75l-.93-1h-12Z",
    fill: "currentColor"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-access_alarm",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.171 3.88-3.07 2.56c-.42.35-1.05.3-1.4-.13a1 1 0 0 1 .12-1.41l3.08-2.56a.988.988 0 0 1 1.4.13c.36.42.3 1.05-.13 1.41Zm14.01 1.02-3.08-2.56c-.42-.35-1.05-.3-1.41.13-.35.42-.29 1.05.13 1.41l3.07 2.56c.42.35 1.05.3 1.41-.13a1 1 0 0 0-.12-1.41Zm-5.31 10.24-3.37-2V8.61c0-.4-.32-.72-.72-.72h-.06c-.4 0-.72.32-.72.72v4.72c0 .35.18.68.49.86l3.65 2.19c.34.2.78.1.98-.24.21-.35.1-.8-.25-1Zm-3.87-11.25a9 9 0 1 0 .002 18.002A9 9 0 0 0 12 3.891Zm-7 9c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7Z",
    fill: "currentColor"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-access_time",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-.28-13h.06c.4 0 .72.32.72.72v4.54l3.87 2.3c.35.2.46.65.25.99-.2.34-.64.44-.98.24l-4.15-2.49a.99.99 0 0 1-.49-.86V7.72c0-.4.32-.72.72-.72Z",
    fill: "currentColor"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-airplanemode_active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.66c0-.36-.19-.69-.49-.89L13.5 9.08v-5.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.5l-7.51 4.69a1.05 1.05 0 0 0 .87 1.89l6.64-2.08v5.5l-1.8 1.35a.48.48 0 0 0-.2.4v.59c0 .33.32.57.64.48l2.86-.82 2.86.82c.32.09.64-.15.64-.48v-.59a.48.48 0 0 0-.2-.4l-1.8-1.35v-5.5l6.64 2.08c.68.21 1.36-.3 1.36-1Z",
    fill: "currentColor"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-airplanemode_inactive",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 14.66c0 .71-.69 1.21-1.36 1l-.99-.32-8.65-8.65V3.58c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5.5l7.51 4.69c.3.2.49.53.49.89Zm-.86 5.01-1.41 1.41-5.73-5.73v3.73l1.8 1.35c.13.09.2.24.2.4v.59c0 .33-.32.57-.64.48L12 21.08l-2.86.82a.503.503 0 0 1-.64-.48v-.59c0-.16.07-.31.2-.4l1.8-1.35v-5.5l-6.64 2.08c-.68.21-1.36-.3-1.36-1 0-.36.19-.7.49-.88l5.5-3.44L3.5 5.35l1.41-1.41 15.73 15.73Z",
    fill: "currentColor"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-battery_std",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.67 4H14V3c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1v1H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.34 22h7.32c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4Z",
    fill: "currentColor"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-bluetooth",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.651 6.996-4.29-4.29c-.63-.63-1.71-.19-1.71.7v6.18l-3.89-3.89a.996.996 0 1 0-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 1 0 1.41 1.41l3.89-3.89v6.18c0 .89 1.08 1.34 1.71.71l4.29-4.3a.996.996 0 0 0 0-1.41l-3.59-3.59 3.59-3.58c.39-.39.39-1.03 0-1.42Zm-4-1.17 1.88 1.88-1.88 1.88v-3.76Zm0 12.34 1.88-1.88-1.88-1.88v3.76Z",
    fill: "currentColor"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-sd_storage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.83 2H18c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8.82c0-.52.23-1.03.6-1.4l4.81-4.83c.38-.38.89-.59 1.42-.59ZM10 7c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v2Zm4 1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Zm2-1c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-signal_cellular_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4c.83 0 1.5.67 1.5 1.5v13c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-13c0-.83.67-1.5 1.5-1.5ZM6 14c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5v-3c0-.83.67-1.5 1.5-1.5Zm7.5-3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-8Z",
    fill: "currentColor"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-storage",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2Zm18 14H4c-1.1 0-2-.9-2-2s.9-2 2-2h16c1.1 0 2 .9 2 2s-.9 2-2 2ZM6 17H4v2h2v-2ZM4 7h2V5H4v2Zm0 7h16c1.1 0 2-.9 2-2s-.9-2-2-2H4c-1.1 0-2 .9-2 2s.9 2 2 2Zm2-3H4v2h2v-2Z",
    fill: "currentColor"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-device-widgets",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.247 7.086 4.25-4.24c.39-.39 1.03-.39 1.42 0l4.24 4.24c.39.39.39 1.02 0 1.41l-4.25 4.25a.996.996 0 0 1-1.41 0l-4.25-4.25a.996.996 0 0 1 0-1.41Zm-8.7-2.64v6c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1h-6c-.55 0-1 .45-1 1Zm7 17h-6c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm3-1v-6c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1h-6c-.55 0-1-.45-1-1Z",
    fill: "currentColor"
  }))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-attach_file",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 6.748v10.58c0 2.09-1.53 3.95-3.61 4.15A3.993 3.993 0 0 1 8 17.498V5.138c0-1.31.94-2.5 2.24-2.63A2.5 2.5 0 0 1 13 4.998v10.5c0 .55-.45 1-1 1s-1-.45-1-1v-8.75c0-.41-.34-.75-.75-.75s-.75.34-.75.75v8.61c0 1.31.94 2.5 2.24 2.63a2.5 2.5 0 0 0 2.76-2.49V5.168c0-2.09-1.53-3.95-3.61-4.15a3.998 3.998 0 0 0-4.39 3.98v12.27c0 2.87 2.1 5.44 4.96 5.71 3.29.3 6.04-2.26 6.04-5.48V6.748c0-.41-.34-.75-.75-.75s-.75.34-.75.75Z",
    fill: "currentColor"
  }))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-attach_money",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.42 0 2.13.54 2.39 1.4.12.4.45.7.87.7h.3c.66 0 1.13-.65.9-1.27-.42-1.18-1.4-2.16-2.96-2.54V4.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.66C8.56 5.58 7 6.84 7 8.77c0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-1.65 0-2.5-.59-2.83-1.43-.15-.39-.49-.67-.9-.67h-.28c-.67 0-1.14.68-.89 1.3.57 1.39 1.9 2.21 3.4 2.53v.67c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-.65c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4Z",
    fill: "currentColor"
  }))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-bar_chart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5c.77 0 1.4.63 1.4 1.4v11.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4V6.4c0-.77.63-1.4 1.4-1.4ZM6.4 9.2h.2c.77 0 1.4.63 1.4 1.4v7c0 .77-.63 1.4-1.4 1.4h-.2c-.77 0-1.4-.63-1.4-1.4v-7c0-.77.63-1.4 1.4-1.4ZM19 14.4c0-.77-.63-1.4-1.4-1.4-.77 0-1.4.63-1.4 1.4v3.2c0 .77.63 1.4 1.4 1.4.77 0 1.4-.63 1.4-1.4v-3.2Z",
    fill: "currentColor"
  }))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-format_color_fill",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.32.496 8.24 8.24c.59.59.59 1.54 0 2.12l-5.5 5.5c-.29.29-.68.44-1.06.44s-.77-.15-1.06-.44l-5.5-5.5a1.49 1.49 0 0 1 0-2.12l5.15-5.15-1.68-1.68A.996.996 0 1 1 8.32.496ZM10 5.006l-4.79 4.79h9.58L10 5.006Zm9 6.29s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5Zm3 8.5H2c-1.1 0-2 .9-2 2s.9 2 2 2h20c1.1 0 2-.9 2-2s-.9-2-2-2Z",
    fill: "currentColor"
  }))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-format_line_spacing",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.536 6.155c.32.31.1.85-.35.85h-1.29v10h1.29a.5.5 0 0 1 .36.85l-2.29 2.29c-.2.2-.51.2-.71 0l-2.29-2.29c-.32-.31-.1-.85.35-.85h1.29v-10h-1.29a.5.5 0 0 1-.36-.85l2.29-2.3c.2-.2.51-.2.71 0l2.29 2.3Zm13.36.85h-10c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1Zm0 10h-10c-.55 0-1 .45-1 1s.45 1 1 1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm-10-6h10c.55 0 1 .45 1 1s-.45 1-1 1h-10c-.55 0-1-.45-1-1s.45-1 1-1Z",
    fill: "currentColor"
  }))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-format_list_bulleted",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 6c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5Zm0 6c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5Zm1.5 4.5c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5Zm16 2.5h-12c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1Zm-12-6h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1Zm0-6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1h-12Z",
    fill: "currentColor"
  }))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-format_list_numbered",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5h.5v2.5c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.28-.22-.5-.5-.5H3c-.28 0-.5.22-.5.5s.22.5.5.5Zm17.5 2h-12c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1Zm-12 10h12c.55 0 1 .45 1 1s-.45 1-1 1h-12c-.55 0-1-.45-1-1s.45-1 1-1Zm12-6h-12c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1ZM5 16c.28 0 .5.22.5.5v3c0 .28-.22.5-.5.5H3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1.5v-.5H4c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h.5V17H3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h2Zm-2.5-5.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v.22c0 .11-.04.23-.12.32L3.7 13H5c.28 0 .5.22.5.5s-.22.5-.5.5H3c-.28 0-.5-.22-.5-.5v-.22c0-.11.04-.23.12-.32L4.3 11H3c-.28 0-.5-.22-.5-.5Z",
    fill: "currentColor"
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-format_quote",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37 16.26c-.22.45-.69.74-1.2.74-1 0-1.65-1.05-1.2-1.94L7 13H5c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4.53c0 .31-.07.61-.21.89l-1.42 2.84Zm10 0c-.22.45-.69.74-1.2.74-1 0-1.65-1.05-1.2-1.94L17 13h-2c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v4.53c0 .31-.07.61-.21.89l-1.42 2.84Z",
    fill: "currentColor"
  }))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_chart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm2 13c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v5Zm5 1c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1Zm3-1c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_chart_outlined",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm1 16c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H6Zm6-2c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1Zm-4 0c-.55 0-1-.45-1-1v-5c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1Zm7-1c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_comment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h16c1.1 0 2 .9 2 2v18l-4-4H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2Zm3 12h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1Zm10-3H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1ZM7 8h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_drive_file",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5Z",
    fill: "currentColor"
  }))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_invitation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-1V3c0-.55-.45-1-1-1s-1 .45-1 1Zm0 10h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1ZM6 20h12c.55 0 1-.45 1-1V9H5v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-insert_link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.954 11.38c.28-1.47 1.66-2.48 3.16-2.48h2.93c.52 0 .95-.43.95-.95s-.43-.95-.95-.95h-2.83c-2.61 0-4.94 1.91-5.19 4.51A4.995 4.995 0 0 0 6.994 17h3.05c.52 0 .95-.43.95-.95s-.43-.95-.95-.95h-3.05a3.11 3.11 0 0 1-3.04-3.72ZM8.994 13h6c.55 0 1-.45 1-1s-.45-1-1-1h-6c-.55 0-1 .45-1 1s.45 1 1 1Zm4.95-6h2.83c2.61 0 4.95 1.91 5.2 4.51a5.008 5.008 0 0 1-4.98 5.49h-3.05c-.52 0-.95-.43-.95-.95s.43-.95.95-.95h3.05a3.11 3.11 0 0 0 3.04-3.72c-.28-1.47-1.66-2.48-3.16-2.48h-2.93c-.52 0-.95-.43-.95-.95s.43-.95.95-.95Z",
    fill: "currentColor"
  }))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-mode",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.71 5.631c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM3 20.501v-3.04c0-.14.05-.26.15-.36l10.91-10.91 3.75 3.75-10.92 10.91a.47.47 0 0 1-.35.15H3.5c-.28 0-.5-.22-.5-.5Z",
    fill: "currentColor"
  }))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-mode_comment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4Z",
    fill: "currentColor"
  }))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-monetization_on",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm11.41 6.67v-.58c1.74-.33 3.11-1.33 3.13-3.16 0-2.52-2.16-3.39-4.18-3.91-2.02-.52-2.67-1.07-2.67-1.91 0-.96.9-1.64 2.4-1.64 1.26 0 1.89.49 2.12 1.25.1.36.4.62.77.62h.26c.59 0 1.01-.58.81-1.13-.38-1.06-1.25-1.92-2.63-2.26v-.62c0-.73-.6-1.33-1.33-1.33h-.01c-.73 0-1.33.6-1.33 1.33v.6c-1.72.37-3.11 1.49-3.11 3.21 0 2.05 1.7 3.07 4.18 3.67 2.23.53 2.67 1.31 2.67 2.14 0 .61-.44 1.59-2.4 1.59-1.46 0-2.22-.52-2.51-1.27-.14-.35-.44-.6-.81-.6h-.24c-.6 0-1.03.61-.8 1.16.5 1.23 1.68 1.96 3.01 2.24v.6c0 .73.6 1.33 1.33 1.33h.01c.73 0 1.33-.6 1.33-1.33Z",
    fill: "currentColor"
  }))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-editor-show_chart",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.187 17.764 5.3-5.3 3.25 3.25c.41.41 1.07.39 1.45-.04l7.17-8.07c.35-.39.33-.99-.04-1.37a1 1 0 0 0-1.45.04l-6.39 7.18-3.29-3.29a.996.996 0 0 0-1.41 0l-6.09 6.1a.996.996 0 0 0 0 1.41l.09.09c.39.39 1.03.39 1.41 0Z",
    fill: "currentColor"
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-attachment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.254 16H6.674c-2.09 0-3.95-1.53-4.15-3.61A3.998 3.998 0 0 1 6.504 8h12.36c1.31 0 2.5.94 2.63 2.24a2.5 2.5 0 0 1-2.49 2.76h-10.5c-.55 0-1-.45-1-1s.45-1 1-1h8.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.61c-1.31 0-2.5.94-2.63 2.24a2.5 2.5 0 0 0 2.49 2.76h10.33c2.09 0 3.95-1.53 4.15-3.61a3.993 3.993 0 0 0-3.98-4.39H6.734c-2.87 0-5.44 2.1-5.71 4.96a5.505 5.505 0 0 0 5.48 6.04h10.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Z",
    fill: "currentColor"
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-cloud",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96Z",
    fill: "currentColor"
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-cloud_download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4Zm.35 13.65L17 13h-3V9h-4v4H7l4.64 4.65c.2.2.51.2.71 0Z",
    fill: "currentColor"
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-cloud_queue",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4ZM6 18h13c1.66 0 3-1.34 3-3s-1.34-3-3-3h-1.5v-.5C17.5 8.46 15.04 6 12 6c-2.52 0-4.63 1.69-5.29 4H6c-2.21 0-4 1.79-4 4s1.79 4 4 4Z",
    fill: "currentColor"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-cloud_upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.496 7.496 0 0 1 12 4Zm2 13v-4h3l-4.64-4.65c-.2-.2-.51-.2-.71 0L7 13h3v4h4Z",
    fill: "currentColor"
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.5h1.59c.89 0 1.33 1.08.7 1.71L12.7 15.8a.996.996 0 0 1-1.41 0L6.7 11.21c-.63-.63-.18-1.71.71-1.71H9v-5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v5Zm-9 11c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1H6Z",
    fill: "currentColor"
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.59 4.59C10.21 4.21 9.7 4 9.17 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-1.41-1.41Z",
    fill: "currentColor"
  }))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-folder_open",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2h5.17c.53 0 1.04.21 1.42.59L12 6ZM4 17c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v8Z",
    fill: "currentColor"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-file-upload",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.296h-4c-.55 0-1-.45-1-1v-5H7.41c-.89 0-1.33-1.08-.7-1.71l4.59-4.59a.996.996 0 0 1 1.41 0l4.59 4.59c.63.63.18 1.71-.71 1.71H15v5c0 .55-.45 1-1 1Zm4 2H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1Z",
    fill: "currentColor"
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-computer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.99 16c0 1.1-.89 2-1.99 2h3c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2l-.01 10ZM19 6H5c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1Z",
    fill: "currentColor"
  }))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-desktop_windows",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2h18c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2h-7v2h1c.55 0 1 .45 1 1s-.45 1-1 1H9c-.55 0-1-.45-1-1s.45-1 1-1h1v-2H3c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2Zm1 14h16c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-headset",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 2.52C6.62 2.83 3 7.02 3 11.81v6.69c0 1.66 1.34 3 3 3h1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2H5v-1.71c0-3.84 2.96-7.18 6.79-7.29a6.999 6.999 0 0 1 7.21 7v2h-2c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h1c1.66 0 3-1.34 3-3v-7c0-5.17-4.36-9.32-9.6-8.98Z",
    fill: "currentColor"
  }))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-keyboard",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-10c0-1.1.89-2 1.99-2Zm9 3h-2v2h2V8Zm-2 3h2v2h-2v-2Zm-1-3H8v2h2V8Zm-2 3h2v2H8v-2Zm-3 2h2v-2H5v2Zm2-3H5V8h2v2Zm2 7h6c.55 0 1-.45 1-1s-.45-1-1-1H9c-.55 0-1 .45-1 1s.45 1 1 1Zm7-4h-2v-2h2v2Zm-2-3h2V8h-2v2Zm5 3h-2v-2h2v2Zm-2-3h2V8h-2v2Z",
    fill: "currentColor"
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-keyboard_voice",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.99 11.5c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3v-6c0-1.66 1.34-3 3-3s3 1.34 3 3l-.01 6Zm2.26.71c.06-.41.41-.71.83-.71.52 0 .92.46.85.97-.46 2.97-2.97 5.32-5.93 5.75v2.28c0 .55-.45 1-1 1s-1-.45-1-1v-2.28c-2.97-.45-5.47-2.78-5.93-5.75-.07-.51.33-.97.85-.97.41 0 .77.3.83.71.37 2.62 2.72 4.39 5.25 4.39s4.88-1.78 5.25-4.39Z",
    fill: "currentColor"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-mouse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1.035v7.93h7c0-4.08-3.05-7.44-7-7.93Zm-9 13.93c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4Zm0-6c0-4.08 3.05-7.44 7-7.93v7.93H4Z",
    fill: "currentColor"
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-phone_iphone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1H8a2.5 2.5 0 0 0-2.5 2.5v17A2.5 2.5 0 0 0 8 23h8a2.5 2.5 0 0 0 2.5-2.5v-17A2.5 2.5 0 0 0 16 1Zm-4 21c-.83 0-1.5-.67-1.5-1.5S11.17 19 12 19s1.5.67 1.5 1.5S12.83 22 12 22Zm-4.5-4h9V4h-9v14Z",
    fill: "currentColor"
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-security",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.19 4.376 7-3.11c.51-.23 1.11-.23 1.62 0l7 3.11c.72.32 1.19 1.04 1.19 1.83v4.7c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12v-4.7c0-.79.47-1.51 1.19-1.83ZM19 11.896h-7v-8.8l-7 3.11v5.7h7v8.93c3.72-1.15 6.47-4.82 7-8.94Z",
    fill: "currentColor"
  }))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-smartphone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7 1 10 .01c1.1 0 2 .89 2 1.99v18c0 1.1-.9 2-2 2H7c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2Zm0 18h10V5H7v14Z",
    fill: "currentColor"
  }))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-speaker",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2h10c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2l-10-.01c-1.1 0-2-.89-2-1.99V4c0-1.1.9-2 2-2Zm7 4a2 2 0 1 0-4.001-.001A2 2 0 0 0 14 6Zm-2 14c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Z",
    fill: "currentColor"
  }))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-tablet_mac",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0H5a2.5 2.5 0 0 0-2.5 2.5v19A2.5 2.5 0 0 0 5 24h14a2.5 2.5 0 0 0 2.5-2.5v-19A2.5 2.5 0 0 0 19 0Zm-7 23c-.83 0-1.5-.67-1.5-1.5S11.17 20 12 20s1.5.67 1.5 1.5S12.83 23 12 23Zm-7.5-4h15V3h-15v16Z",
    fill: "currentColor"
  }))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-tv",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h18c1.1 0 2 .9 2 2l-.01 12c0 1.1-.89 2-1.99 2h-5v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-1H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm1 14h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-hardware-watch",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.96 5.73A7.976 7.976 0 0 1 20 12c0 2.54-1.19 4.81-3.04 6.27l-.68 4.06c-.16.96-.99 1.67-1.97 1.67H9.7c-.98 0-1.82-.71-1.98-1.67l-.67-4.06A7.94 7.94 0 0 1 4 12a7.94 7.94 0 0 1 3.05-6.27l.67-4.06C7.88.71 8.72 0 9.7 0h4.61c.97 0 1.81.71 1.97 1.67l.68 4.06ZM12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6Z",
    fill: "currentColor"
  }))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-add_to_photos",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1Zm12 5h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3h-3c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3Z",
    fill: "currentColor"
  }))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-brush",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.87 3.291 1.34 1.34c.39.39.39 1.02 0 1.41l-8.96 8.96-2.75-2.75 8.96-8.96a.996.996 0 0 1 1.41 0ZM4.5 17.001c0-1.66 1.34-3 3-3s3 1.34 3 3c0 2.21-1.79 4-4 4-1.51 0-3.08-.78-4-2 .84 0 2-.69 2-2Z",
    fill: "currentColor"
  }))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-camera_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5h-3.17l-1.24-1.35A1.99 1.99 0 0 0 14.12 3H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-8 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5Z",
    fill: "currentColor"
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-center_focus_strong",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V5c0-1.1.9-2 2-2h3c.55 0 1 .45 1 1s-.45 1-1 1H6Zm6 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm-8 7c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1ZM19 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2Zm-1 16c.55 0 1-.45 1-1v-2c0-.55.45-1 1-1s1 .45 1 1v3c0 1.1-.9 2-2 2h-3c-.55 0-1-.45-1-1s.45-1 1-1h2Z",
    fill: "currentColor"
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-center_focus_weak",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1V5c0-1.1.9-2 2-2h3c.55 0 1 .45 1 1s-.45 1-1 1H6ZM3 16c0-.55.45-1 1-1s1 .45 1 1v2c0 .55.45 1 1 1h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-1.1 0-2-.9-2-2v-3ZM19 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1 .45 1 1v2c0 .55.45 1 1 1s1-.45 1-1V5c0-1.1-.9-2-2-2Zm-1 16c.55 0 1-.45 1-1v-2c0-.55.45-1 1-1s1 .45 1 1v3c0 1.1-.9 2-2 2h-3c-.55 0-1-.45-1-1s.45-1 1-1h2ZM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm-2 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Z",
    fill: "currentColor"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-collections",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2Zm-10.6-3.47 1.63 2.18 2.58-3.22a.5.5 0 0 1 .78 0l2.96 3.7c.26.33.03.81-.39.81H9a.5.5 0 0 1-.4-.8l2-2.67c.2-.26.6-.26.8 0ZM2 20V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55.45 1 1 1h12c.55 0 1 .45 1 1s-.45 1-1 1H4c-1.1 0-2-.9-2-2Z",
    fill: "currentColor"
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-color_lens",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 0 0 0 18c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8Zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12ZM8 6.5C8 7.33 8.67 8 9.5 8S11 7.33 11 6.5 10.33 5 9.5 5 8 5.67 8 6.5ZM14.5 8c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8Zm1.5 2.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5S18.33 9 17.5 9s-1.5.67-1.5 1.5Z",
    fill: "currentColor"
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-colorize",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.37 3.291 2.34 2.34a.99.99 0 0 1-.02 1.42l-3.12 3.12 1.22 1.22a.996.996 0 1 1-1.41 1.41l-.72-.72-8.77 8.77a.47.47 0 0 1-.35.15H3.5c-.28 0-.5-.22-.5-.5v-4.04c0-.14.05-.26.15-.36l8.77-8.77-.72-.72a.996.996 0 0 1 0-1.41c.39-.38 1.02-.39 1.41 0l1.23 1.21 3.12-3.12a.996.996 0 0 1 1.41 0ZM5 17.081l1.92 1.92 8.06-8.06-1.92-1.92L5 17.081Z",
    fill: "currentColor"
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-control_point",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2Zm0 5c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1Zm-8 5c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z",
    fill: "currentColor"
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-crop",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16c0 .55.45 1 1 1h14c.55 0 1 .45 1 1s-.45 1-1 1h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H7c-1.1 0-2-.9-2-2V7H2c-.55 0-1-.45-1-1s.45-1 1-1h3V2c0-.55.45-1 1-1s1 .45 1 1v14Zm12-1h-2V8c0-.55-.45-1-1-1H9V5h8c1.1 0 2 .9 2 2v8Z",
    fill: "currentColor"
  }))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-crop_free",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8V5c0-1.1.9-2 2-2h3c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1 .45-1 1v2c0 .55-.45 1-1 1s-1-.45-1-1Zm0 8c0-.55.45-1 1-1s1 .45 1 1v2c0 .55.45 1 1 1h2c.55 0 1 .45 1 1s-.45 1-1 1H5c-1.1 0-2-.9-2-2v-3Zm16 2c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2ZM16 3h3c1.1 0 2 .9 2 2v3c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55-.45-1-1-1h-2c-.55 0-1-.45-1-1s.45-1 1-1Z",
    fill: "currentColor"
  }))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-crop_original",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-1 16H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h12c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1Zm-6.79-3.17 2.35-3.02c.2-.26.6-.26.79 0l2.55 3.39a.5.5 0 0 1-.4.8H7.52a.5.5 0 0 1-.39-.81l1.74-2.23a.5.5 0 0 1 .78-.01l1.56 1.88Z",
    fill: "currentColor"
  }))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-dehaze",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8c-.55 0-1-.45-1-1s.45-1 1-1h18c.55 0 1 .45 1 1s-.45 1-1 1H3Zm-1 4c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1Zm0 5c0 .55.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-edit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.71 5.631c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75 1.83-1.83a.996.996 0 0 1 1.41 0l2.34 2.34ZM3 20.501v-3.04c0-.14.05-.26.15-.36l10.91-10.91 3.75 3.75-10.92 10.91a.47.47 0 0 1-.35.15H3.5c-.28 0-.5-.22-.5-.5Z",
    fill: "currentColor"
  }))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-eye",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.906 14.625a2.625 2.625 0 0 0 2.615-2.853l-2.844 2.843c.076.007.152.01.229.01ZM20.594 3.88l-1-1a.188.188 0 0 0-.266 0l-2.562 2.563c-1.413-.722-3.002-1.084-4.767-1.084-4.504 0-7.865 2.347-10.082 7.039a1.413 1.413 0 0 0 0 1.207c.886 1.866 1.952 3.362 3.2 4.487l-2.48 2.478a.187.187 0 0 0 0 .265l1.001 1.001a.187.187 0 0 0 .265 0l16.691-16.69a.186.186 0 0 0 .041-.205.186.186 0 0 0-.04-.06ZM7.781 12a4.125 4.125 0 0 1 6.067-3.64l-1.14 1.14a2.627 2.627 0 0 0-3.302 3.303l-1.14 1.14A4.104 4.104 0 0 1 7.781 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.081 11.395c-.825-1.737-1.807-3.154-2.946-4.25l-3.378 3.379a4.128 4.128 0 0 1-5.329 5.329l-2.866 2.865c1.33.615 2.808.923 4.436.923 4.505 0 7.866-2.346 10.083-7.038a1.414 1.414 0 0 0 0-1.208Z",
    fill: "currentColor"
  }))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-filter",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2ZM1 6c0-.55.45-1 1-1s1 .45 1 1v14c0 .55.45 1 1 1h14c.55 0 1 .45 1 1s-.45 1-1 1H3c-1.1 0-2-.9-2-2V6Zm12.21 7.83 2.35-3.02c.2-.26.6-.26.79 0l2.55 3.39a.5.5 0 0 1-.4.8H9.52a.5.5 0 0 1-.39-.81l1.74-2.23a.5.5 0 0 1 .78-.01l1.56 1.88ZM8 17h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-filter_center_focus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6c0-.55.45-1 1-1h2c.55 0 1-.45 1-1s-.45-1-1-1H5c-1.1 0-2 .9-2 2v3c0 .55.45 1 1 1s1-.45 1-1V6Zm-1 9c-.55 0-1 .45-1 1v3c0 1.1.9 2 2 2h3c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1v-2c0-.55-.45-1-1-1ZM16 3h3c1.1 0 2 .9 2 2v3c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55-.45-1-1-1h-2c-.55 0-1-.45-1-1s.45-1 1-1Zm3 15c0 .55-.45 1-1 1h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2-.9 2-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v2ZM9 12c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Z",
    fill: "currentColor"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-filter_drama",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.1 2.35-5.64 5.36-5.96A7.48 7.48 0 0 1 12 4ZM6.17 18H19c1.85 0 3.32-1.69 2.93-3.6-.28-1.43-1.62-2.4-3.07-2.4h-1.37v-.27c0-2.89-2.13-5.46-5.01-5.71-2-.17-3.79.74-4.89 2.2 2.18.6 3.86 2.39 4.29 4.63.12.6-.38 1.15-.99 1.15-.48 0-.88-.35-.98-.83a3.998 3.998 0 0 0-7.89 1.22C2.22 16.47 4.08 18 6.17 18Z",
    fill: "currentColor"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-filter_hdr",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.2 6.738-2.95 3.93 2.25 3c.33.44.24 1.07-.2 1.4a.994.994 0 0 1-1.4-.2c-1.05-1.4-2.31-3.07-3.1-4.14-.4-.53-1.2-.53-1.6 0l-4 5.33c-.49.67-.02 1.61.8 1.61h18c.82 0 1.29-.94.8-1.6l-7-9.33a.993.993 0 0 0-1.6 0Z",
    fill: "currentColor"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-filter_none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2ZM2 5c-.55 0-1 .45-1 1v15c0 1.1.9 2 2 2h15c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1-.45-1-1V6c0-.55-.45-1-1-1Zm6 12h12c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-flash_auto",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59 3.175v10c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l5.19-8.9a.995.995 0 0 0-.86-1.5H8.59l3.38-7.59c.29-.67-.2-1.41-.92-1.41H3.59c-.55 0-1 .45-1 1Zm15-1c-.6 0-1.13.38-1.34.94l-2.44 6.86c-.2.59.23 1.2.85 1.2.38 0 .72-.24.84-.6l.49-1.4h3.2l.49 1.4c.13.36.46.6.84.6.62 0 1.05-.61.84-1.19l-2.44-6.86c-.2-.57-.73-.95-1.33-.95Zm0 2-1.15 3.65h2.3l-1.15-3.65Z",
    fill: "currentColor"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-flash_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.706 4.125c.33-.67-.15-1.45-.9-1.45h-7.38c-.55 0-1 .45-1 1v.61l6.13 6.13 3.15-6.29Zm-.16 8.05a.995.995 0 0 0-.86-1.5h-1.87l2.28 2.28.45-.78Zm-12-7.94 14.32 14.32c.39.39.39 1.02-.01 1.41a.996.996 0 0 1-1.41 0l-3.44-3.44-2.65 4.55c-.26.44-.93.26-.93-.25v-7.15h-2c-.55 0-1-.45-1-1v-2.73l-4.29-4.3a.996.996 0 1 1 1.41-1.41Z",
    fill: "currentColor"
  }))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-flash_on",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.371 3.675v9c0 .55.45 1 1 1h2v7.15c0 .51.67.69.93.25l5.19-8.9a.995.995 0 0 0-.86-1.5h-2.26l2.49-6.65a.994.994 0 0 0-.93-1.35h-6.56c-.55 0-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-image",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2ZM11 16.51l-2.1-2.53a.493.493 0 0 0-.78.02l-2.49 3.2c-.26.33-.03.81.39.81h11.99a.5.5 0 0 0 .4-.8l-3.51-4.68c-.2-.27-.6-.27-.8-.01L11 16.51Z",
    fill: "currentColor"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-movie_creation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 4 1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L15 4h-2l1.82 3.64c.08.16-.04.36-.22.36h-1.98c-.38 0-.73-.21-.89-.55L10 4H8l1.82 3.64c.08.16-.04.36-.22.36H7.62c-.38 0-.73-.21-.9-.55L5 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-.55-.45-1-1-1h-3Z",
    fill: "currentColor"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-music_note",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.998 5v8.55c-.94-.54-2.1-.75-3.33-.32-1.34.48-2.37 1.67-2.61 3.07a4.007 4.007 0 0 0 4.59 4.65c1.96-.31 3.35-2.11 3.35-4.1V7h2c1.1 0 2-.9 2-2s-.9-2-2-2h-2c-1.1 0-2 .9-2 2Z",
    fill: "currentColor"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-music_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.93 7v2.61l-2-2V4c0-.55.45-1 1-1h3c1.1 0 2 .9 2 2s-.9 2-2 2h-2ZM4.345 3.267c.265 0 .518.105.705.293l15.31 15.32a.996.996 0 1 1-1.41 1.41l-5.02-5.02v1.58c0 1.99-1.39 3.79-3.35 4.1a4.007 4.007 0 0 1-4.59-4.65c.24-1.4 1.27-2.59 2.61-3.07 1.23-.43 2.39-.22 3.33.32v-.28l-8.29-8.3a.996.996 0 0 1 .705-1.703Z",
    fill: "currentColor"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-photo_library",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2Zm-10.6-3.47 1.63 2.18 2.58-3.22a.5.5 0 0 1 .78 0l2.96 3.7c.26.33.03.81-.39.81H9a.5.5 0 0 1-.4-.8l2-2.67c.2-.26.6-.26.8 0ZM2 20V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55.45 1 1 1h12c.55 0 1 .45 1 1s-.45 1-1 1H4c-1.1 0-2-.9-2-2Z",
    fill: "currentColor"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-picture_as_pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1H10c.83 0 1.5.67 1.5 1.5v1ZM15 13c.83 0 1.5-.67 1.5-1.5v-3c0-.83-.67-1.5-1.5-1.5h-2c-.28 0-.5.22-.5.5v5c0 .28.22.5.5.5h2Zm5.5-5.25c0 .41-.34.75-.75.75H19v1h.75c.41 0 .75.34.75.75s-.34.75-.75.75H19v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8c0-.55.45-1 1-1h1.25c.41 0 .75.34.75.75ZM10 9.5H9v-1h1v1ZM3 6c-.55 0-1 .45-1 1v13c0 1.1.9 2 2 2h13c.55 0 1-.45 1-1s-.45-1-1-1H5c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1Zm12 5.5h-1v-3h1v3Z",
    fill: "currentColor"
  }))), _symbol213 || (_symbol213 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-portrait",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-4.75 7c0 1.24-1.01 2.25-2.25 2.25S9.75 11.24 9.75 10 10.76 7.75 12 7.75s2.25 1.01 2.25 2.25ZM12 14c1.5 0 4.5.75 4.5 2.25V17h-9v-.75c0-1.5 3-2.25 4.5-2.25Zm-6 5h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol214 || (_symbol214 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-remove_red_eye",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5ZM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm-3-5c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3Z",
    fill: "currentColor"
  }))), _symbol215 || (_symbol215 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-timelapse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm4.24 5.76A5.974 5.974 0 0 0 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0a5.99 5.99 0 0 0-.01-8.48ZM4 12c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8Z",
    fill: "currentColor"
  }))), _symbol216 || (_symbol216 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-timer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.003 1.5h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1Zm3 12c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4Zm6.03-5.61.75-.75a.993.993 0 0 0 0-1.4l-.01-.01a.993.993 0 0 0-1.4 0l-.75.75a8.962 8.962 0 0 0-5.62-1.98c-4.8 0-8.88 3.96-9 8.76a8.998 8.998 0 0 0 9 9.24 8.994 8.994 0 0 0 7.03-14.61ZM5.003 13.5c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7Z",
    fill: "currentColor"
  }))), _symbol217 || (_symbol217 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-timer_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.415 3.209h4c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1Zm2 5c-.51 0-.92.39-.98.89l1.98 1.97v-1.86c0-.55-.45-1-1-1Zm7 5c0-3.87-3.13-7-7-7-1.12 0-2.18.27-3.12.74l-1.45-1.45c1.35-.81 2.91-1.29 4.57-1.29 2.12 0 4.07.74 5.62 1.98l.75-.75a.993.993 0 0 1 1.4 0l.01.01c.39.39.38 1.02 0 1.4l-.75.75a8.963 8.963 0 0 1 1.97 5.61c0 1.68-.47 3.25-1.27 4.59l-1.47-1.47c.47-.94.74-2 .74-3.12Zm1.19 7.88L4.285 4.769a.996.996 0 1 0-1.41 1.41l2.07 2.07c-.92 1.38-1.48 2.99-1.53 4.72a8.998 8.998 0 0 0 9 9.24c1.84 0 3.55-.55 4.98-1.5l1.79 1.79c.39.39 1.02.39 1.41 0 .4-.39.4-1.02.01-1.41Zm-15.19-7.88c0 3.87 3.13 7 7 7 1.29 0 2.49-.35 3.53-.95l-9.57-9.57a6.876 6.876 0 0 0-.96 3.52Z",
    fill: "currentColor"
  }))), _symbol218 || (_symbol218 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-transform",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.005c0 .55.45 1 1 1h12c.55 0 1 .45 1 1s-.45 1-1 1h-3v2h.8c.44 0 .67.54.35.85l-1.79 1.79c-.2.2-.51.2-.71 0l-1.79-1.79c-.32-.31-.1-.85.35-.85H16v-2H8c-1.1 0-2-.9-2-2v-8H3c-.55 0-1-.45-1-1s.45-1 1-1h3v-2h-.79a.5.5 0 0 1-.36-.85l1.79-1.8c.2-.2.51-.2.71 0l1.79 1.8c.32.31.1.85-.35.85H8v11Zm10-1h-2v-5c0-.55-.45-1-1-1h-5v-2h6c1.1 0 2 .9 2 2v6Z",
    fill: "currentColor"
  }))), _symbol219 || (_symbol219 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-tune",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1s1 .45 1 1v1h3c.55 0 1 .45 1 1s-.45 1-1 1h-3v1ZM4 7c-.55 0-1-.45-1-1s.45-1 1-1h9v2H4Zm0 12c-.55 0-1-.45-1-1s.45-1 1-1h5v2H4Zm9 1v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1Zm-6-9v-1c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1v-1H4c-.55 0-1-.45-1-1s.45-1 1-1h3Zm14 1c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1Z",
    fill: "currentColor"
  }))), _symbol220 || (_symbol220 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-wb_cloudy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.356 10.04C18.666 6.59 15.637 4 11.999 4a7.492 7.492 0 0 0-6.647 4.04A5.993 5.993 0 0 0 .004 14c0 3.31 2.689 6 5.997 6h12.995a5 5 0 0 0 4.998-5c0-2.64-2.05-4.78-4.638-4.96Z",
    fill: "currentColor"
  }))), _symbol221 || (_symbol221 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-wb_incandescent",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.004 2.525v3.81c1.79 1.04 3 2.97 3 5.2 0 3.55-3.11 6.39-6.75 5.95-2.62-.32-4.78-2.41-5.18-5.02-.39-2.61.89-4.95 2.93-6.13v-3.81c0-.55.45-1 1-1h4c.55 0 1 .45 1 1Zm-11.99 8h-1.02c-.55 0-.99.44-.99.99v.01c0 .55.44.99.99.99h1.01c.55 0 .99-.44.99-.99v-.01a.971.971 0 0 0-.98-.99Zm2.65 8.74a.996.996 0 0 1-1.41 0c-.39-.39-.39-1.01-.01-1.41l.39-.39a.996.996 0 0 1 1.41 0l.01.01c.38.38.39 1.01 0 1.4l-.39.39Zm6.34 3.21h-.01c-.55 0-.99-.44-.99-.99v-.96c0-.55.44-.99.99-.99h.01c.55 0 .99.44.99.99v.96c0 .55-.44.99-.99.99Zm8-10.96v.01c0 .55.44.99.99.99h1.01c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99Zm-1.67 7.76-.39-.39a.987.987 0 0 1 .01-1.41.993.993 0 0 1 1.4 0l.39.39a.996.996 0 1 1-1.41 1.41Z",
    fill: "currentColor"
  }))), _symbol222 || (_symbol222 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-image-wb_sunny",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.004 1.05h.01c.55 0 .99.44.99.99v.97c0 .55-.44.99-1 .98h-.01c-.55 0-.99-.44-.99-.99v-.96c0-.55.44-.99 1-.99Zm-5.95 3.59-.39-.39a.993.993 0 0 0-1.4 0l-.01.01a.984.984 0 0 0 0 1.4l.39.39c.39.39 1.01.39 1.4 0l.01-.01a.984.984 0 0 0 0-1.4ZM3.014 11h-1.02c-.55 0-.99.44-.99.99V12c0 .55.44.99.99.99h1.01c.56.01 1-.43 1-.98V12c0-.56-.44-1-.99-1Zm16.74-6.74c-.39-.39-1.02-.39-1.41-.01l-.39.39a.984.984 0 0 0 0 1.4l.01.01c.39.39 1.02.39 1.4 0l.39-.39a.984.984 0 0 0 0-1.4Zm-1.42 15.49-.39-.39a.987.987 0 0 1 .01-1.41.993.993 0 0 1 1.4 0l.39.39a.996.996 0 1 1-1.41 1.41Zm1.67-7.76V12c0 .55.44.99.99.99h1.01c.55 0 .99-.44.99-.99v-.01c0-.55-.44-.99-.99-.99h-1.01c-.55 0-.99.44-.99.99Zm-14 .01c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6Zm5.99 10.95h.01c.55 0 .99-.44.99-.99V21c0-.55-.44-.99-.99-.99h-.01c-.55 0-.99.44-.99.99v.96c0 .55.44.99.99.99Zm-6.33-3.21a.996.996 0 0 1-1.41 0c-.39-.39-.39-1.01-.01-1.41l.39-.39a.996.996 0 0 1 1.41 0l.01.01c.38.38.39 1.01 0 1.4l-.39.39Z",
    fill: "currentColor"
  }))), _symbol223 || (_symbol223 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_bike",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 3.75c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2ZM0 17.25c0-2.8 2.2-5 5-5s5 2.2 5 5-2.2 5-5 5-5-2.2-5-5Zm5 3.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5Zm12.96-9.58c-1.58-.24-2.9-.96-3.96-2.02l-.8-.8-2.4 2.4 1.65 1.72c.35.37.55.86.55 1.38v4.4c0 .55-.45 1-1 1s-1-.45-1-1v-4l-3.2-2.8c-.4-.3-.6-.8-.6-1.4 0-.5.2-1 .6-1.4l2.8-2.8c.3-.4.8-.6 1.4-.6.6 0 1.1.2 1.6.6l1.9 1.9c.73.72 1.64 1.25 2.75 1.43.48.08.85.5.85.99 0 .61-.54 1.09-1.14 1ZM19 12.25c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5Zm-3.5 5c0 1.9 1.6 3.5 3.5 3.5s3.5-1.6 3.5-3.5-1.6-3.5-3.5-3.5-3.5 1.6-3.5 3.5Z",
    fill: "currentColor"
  }))), _symbol224 || (_symbol224 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_boat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.952 19h.05c1.42 0 2.7-.7 3.66-1.64.19-.18.5-.18.69 0 .95.94 2.23 1.64 3.65 1.64s2.7-.7 3.66-1.64c.19-.19.49-.19.69 0 .95.94 2.23 1.64 3.65 1.64h.05l1.89-6.68c.08-.26.06-.54-.06-.78a.997.997 0 0 0-.6-.5l-1.28-.42V6c0-1.1-.9-2-2-2h-3V2c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v2h-3c-1.1 0-2 .9-2 2v4.62l-1.29.42a1.007 1.007 0 0 0-.66 1.28l1.9 6.68Zm16.05 2c-1.29 0-2.58-.41-3.74-1.14-.16-.1-.37-.1-.53 0-2.31 1.47-5.16 1.47-7.47 0-.16-.1-.37-.1-.53 0-1.15.73-2.44 1.14-3.73 1.14h-1c-.55 0-1 .45-1 1s.45 1 1 1h1c1.38 0 2.74-.35 4-.99a8.752 8.752 0 0 0 8 0c1.26.65 2.62.99 4 .99h1c.55 0 1-.45 1-1s-.45-1-1-1h-1Zm-3-15h-10c-.55 0-1 .45-1 1v2.97l5.37-1.77c.41-.13.84-.13 1.25 0l5.38 1.77V7c0-.55-.45-1-1-1Z",
    fill: "currentColor"
  }))), _symbol225 || (_symbol225 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_bus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18.72c-.61-.55-1-1.34-1-2.22v-10c0-3.5 3.58-4 8-4s8 .5 8 4v10c0 .88-.39 1.67-1 2.22V20c0 .83-.68 1.5-1.5 1.5-.83 0-1.5-.68-1.5-1.5v-.5H8v.5c0 .83-.67 1.5-1.5 1.5S5 20.83 5 20v-1.28ZM6 16c0 .83.67 1.5 1.5 1.5S9 16.83 9 16s-.67-1.5-1.5-1.5S6 15.17 6 16Zm10.5 1.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM6 11.5h12v-5H6v5Z",
    fill: "currentColor"
  }))), _symbol226 || (_symbol226 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_car",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 4c.66 0 1.22.42 1.42 1.01l1.97 5.67c.07.21.11.44.11.66v7.16c0 .83-.68 1.5-1.5 1.5-.83 0-1.5-.68-1.5-1.5V18H6v.5c0 .83-.67 1.5-1.5 1.5S3 19.33 3 18.5v-7.16c0-.23.04-.45.11-.66l1.97-5.67C5.29 4.42 5.84 4 6.5 4h11ZM5 13.5c0 .83.67 1.5 1.5 1.5S8 14.33 8 13.5 7.33 12 6.5 12 5 12.67 5 13.5ZM17.5 15c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM6.27 6.18 5 10h14l-1.27-3.82c-.14-.4-.52-.68-.95-.68H7.22c-.43 0-.81.28-.95.68Z",
    fill: "currentColor"
  }))), _symbol227 || (_symbol227 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_run",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.46 3.25c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Zm-4.6 11.5-.57 2.5a2 2 0 0 1-2.34 1.52l-4.11-.82c-.54-.11-.89-.64-.78-1.18v-.04c.11-.54.64-.89 1.18-.78l3.92.8 1.6-8.1-1.8.7v2.4c0 .55-.45 1-1 1s-1-.45-1-1V9.38c0-.81.48-1.53 1.22-1.85l3.98-1.68c.15 0 .274-.025.4-.05.124-.025.25-.05.4-.05.7 0 1.3.4 1.7 1l1 1.6c.67 1.18 1.93 2.08 3.45 2.33.49.08.85.49.85.98 0 .61-.54 1.09-1.14 1a7.321 7.321 0 0 1-4.36-2.41l-.6 3 1.48 1.41c.4.38.62.9.62 1.45v5.64c0 .55-.45 1-1 1s-1-.45-1-1v-5l-2.1-2Z",
    fill: "currentColor"
  }))), _symbol228 || (_symbol228 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-directions_subway",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5c-4.42 0-8 .5-8 4V16c0 1.93 1.57 3.5 3.5 3.5l-1.15 1.15a.5.5 0 0 0 .36.85H17.3c.45 0 .67-.54.35-.85L16.5 19.5c1.93 0 3.5-1.57 3.5-3.5V6.5c0-3.5-3.58-4-8-4Zm-4.5 15c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5S9 15.17 9 16s-.67 1.5-1.5 1.5Zm-1.5-6h5v-5H6v5Zm10.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5Zm-3.5-6h5v-5h-5v5Z",
    fill: "currentColor"
  }))), _symbol229 || (_symbol229 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-fastfood",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.05 5h3.9c.59 0 1.05.51.99 1.1L21.4 21.53c-.1.82-.79 1.47-1.63 1.47h-1.7l-.02-8c0-4.23-3.1-6.84-6.78-7.69l-.12-1.21c-.05-.59.41-1.1 1-1.1h3.9V2c0-.55.45-1 1-1s1 .45 1 1v3Zm-3 16c.55 0 1 .45 1 1s-.45 1-1 1h-13c-.55 0-1-.45-1-1s.45-1 1-1h13Zm-.1-6c.62 0 1.11-.56.99-1.16-.65-3.23-4.02-4.85-7.39-4.85s-6.73 1.62-7.39 4.85c-.12.6.38 1.16.99 1.16h12.8Zm-13.9 3c0-.55.45-1 1-1h13c.55 0 1 .45 1 1s-.45 1-1 1h-13c-.55 0-1-.45-1-1Z",
    fill: "currentColor"
  }))), _symbol230 || (_symbol230 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-hotel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.5h6c2.21 0 4 1.79 4 4v8c0 .55-.45 1-1 1s-1-.45-1-1v-2H3v2c0 .55-.45 1-1 1s-1-.45-1-1v-13c0-.55.45-1 1-1s1 .45 1 1v8h8v-5c0-1.1.9-2 2-2Zm-3 3c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3Z",
    fill: "currentColor"
  }))), _symbol231 || (_symbol231 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-layers",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.994 10.255-6.76 5.26c-.72.57-1.74.57-2.46.01l-6.76-5.26c-.51-.4-.51-1.18 0-1.58l6.76-5.27c.73-.56 1.74-.56 2.46 0l6.76 5.26c.51.4.51 1.18 0 1.58Zm-8.62 8.28c.36.28.87.28 1.23 0l6.15-4.79a.991.991 0 0 1 1.22 0l.01.01c.51.4.51 1.17 0 1.57l-6.76 5.26c-.73.56-1.74.56-2.46 0l-6.76-5.26a.997.997 0 0 1 0-1.57.991.991 0 0 1 1.22 0l6.15 4.78Z",
    fill: "currentColor"
  }))), _symbol232 || (_symbol232 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-layers_clear",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.046 2.635 17.32 17.32c.39.39.39 1.02-.02 1.41a.996.996 0 0 1-1.41 0l-3.07-3.07-3.72 2.89c-.73.56-1.74.56-2.46 0l-6.76-5.26a.997.997 0 0 1 0-1.57.991.991 0 0 1 1.22 0l6.15 4.78c.36.28.87.28 1.23 0l2.92-2.27-1.42-1.42-.87.68c-.73.56-1.74.56-2.46 0l-6.76-5.26c-.51-.4-.51-1.18 0-1.58l2.22-1.72-3.52-3.52a.996.996 0 1 1 1.41-1.41Zm15.87 8.23c.51-.4.51-1.18 0-1.58l-6.76-5.26c-.72-.56-1.73-.56-2.46 0l-1.36 1.07 7.88 7.88 2.7-2.11Zm0 3.49-.01-.01a.991.991 0 0 0-1.22 0l-.05.04 1.4 1.4a.982.982 0 0 0-.12-1.43Z",
    fill: "currentColor"
  }))), _symbol233 || (_symbol233 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_airport",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 14.66c0-.36-.19-.69-.49-.89L13.5 9.08v-5.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.5l-7.51 4.69a1.05 1.05 0 0 0 .87 1.89l6.64-2.08v5.5l-1.8 1.35a.48.48 0 0 0-.2.4v.59c0 .33.32.57.64.48l2.86-.82 2.86.82c.32.09.64-.15.64-.48v-.59a.48.48 0 0 0-.2-.4l-1.8-1.35v-5.5l6.64 2.08c.68.21 1.36-.3 1.36-1Z",
    fill: "currentColor"
  }))), _symbol234 || (_symbol234 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_atm",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2Zm0 13c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v10Zm-5-8c0 .55-.45 1-1 1h-3v1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-1c0 .55-.45 1-1 1s-1-.45-1-1h-1c-.55 0-1-.45-1-1s.45-1 1-1h3v-1h-3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h1v-.01c0-.55.45-1 1-1s1 .45 1 1V8h1c.55 0 1 .45 1 1Z",
    fill: "currentColor"
  }))), _symbol235 || (_symbol235 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_dining",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.851 10.142c-1.59 1.59-3.74 2.09-5.27 1.38l-1.47 1.47 6.18 6.18a.996.996 0 1 1-1.41 1.41l-6.18-6.18-6.18 6.16a.996.996 0 1 1-1.41-1.41l9.05-9.05c-.71-1.53-.21-3.68 1.38-5.27 1.92-1.91 4.66-2.27 6.12-.81 1.47 1.47 1.1 4.21-.81 6.12Zm-9.22.36-2.83 2.83-4.19-4.18a4.016 4.016 0 0 1-.78-4.56c.3-.62 1.13-.75 1.61-.27l6.19 6.18Z",
    fill: "currentColor"
  }))), _symbol236 || (_symbol236 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_grocery_store",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.996 4h1l3.6 7.59-1.35 2.44c-.73 1.34.23 2.97 1.75 2.97h11c.55 0 1-.45 1-1s-.45-1-1-1h-11l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49a.996.996 0 0 0-.87-1.48h-14.8l-.67-1.43a.993.993 0 0 0-.9-.57h-1.64c-.55 0-1 .45-1 1s.45 1 1 1Zm5 14c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2Zm8.01 2c0-1.1.89-2 1.99-2s2 .9 2 2-.9 2-2 2-1.99-.9-1.99-2Z",
    fill: "currentColor"
  }))), _symbol237 || (_symbol237 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_library",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4.893c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3Zm-9.68 3.2c2.56.46 4.86 1.65 6.68 3.35 1.82-1.7 4.12-2.89 6.68-3.35 1.21-.21 2.32.75 2.32 1.98v6.92c0 .96-.77 1.89-1.71 2.02-2.52.32-4.81 1.37-6.68 2.9-.35.28-.92.25-1.27-.04a13.088 13.088 0 0 0-6.63-2.87c-.99-.13-1.71-1.01-1.71-2.69v-6.24c0-1.23 1.11-2.19 2.32-1.98Z",
    fill: "currentColor"
  }))), _symbol238 || (_symbol238 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_mall",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6.5h-2c0-2.76-2.24-5-5-5s-5 2.24-5 5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2Zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3ZM7.16 9.75A4.99 4.99 0 0 0 12 13.5a4.99 4.99 0 0 0 4.84-3.75c.16-.63-.32-1.25-.97-1.25-.47 0-.85.34-.98.8a2.997 2.997 0 0 1-5.78 0c-.13-.46-.51-.8-.98-.8-.65 0-1.14.62-.97 1.25Z",
    fill: "currentColor"
  }))), _symbol239 || (_symbol239 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_movies",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4v1h-2V4c0-.55-.45-1-1-1H9c-.55 0-1 .45-1 1v1H6V4c0-.55-.45-1-1-1s-1 .45-1 1v16c0 .55.45 1 1 1s1-.45 1-1v-1h2v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h2v1c0 .55.45 1 1 1s1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1ZM8 17H6v-2h2v2Zm-2-4h2v-2H6v2Zm2-4H6V7h2v2Zm8 8h2v-2h-2v2Zm2-4h-2v-2h2v2Zm-2-4h2V7h-2v2Z",
    fill: "currentColor"
  }))), _symbol240 || (_symbol240 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_offer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.41 2.58 9 9c.36.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-7 7c-.36.37-.86.59-1.41.59-.55 0-1.05-.22-1.41-.58l-9-9C2.22 12.05 2 11.55 2 11V4c0-1.1.9-2 2-2h7c.55 0 1.05.22 1.41.58ZM4 5.5C4 6.33 4.67 7 5.5 7S7 6.33 7 5.5 6.33 4 5.5 4 4 4.67 4 5.5Z",
    fill: "currentColor"
  }))), _symbol241 || (_symbol241 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_phone",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.223 15.268-2.54-.29a1.99 1.99 0 0 0-1.64.57l-1.84 1.84a15.045 15.045 0 0 1-6.59-6.59l1.85-1.85c.43-.43.64-1.03.57-1.64l-.29-2.52a2.001 2.001 0 0 0-1.99-1.77h-1.73c-1.13 0-2.07.94-2 2.07.53 8.54 7.36 15.36 15.89 15.89 1.13.07 2.07-.87 2.07-2v-1.73c.01-1.01-.75-1.86-1.76-1.98Z",
    fill: "currentColor"
  }))), _symbol242 || (_symbol242 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_post_office",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Zm9.06 8.34 6.54-4.09a.85.85 0 1 0-.9-1.44L12 11 5.3 6.81a.85.85 0 1 0-.9 1.44l6.54 4.09c.65.41 1.47.41 2.12 0Z",
    fill: "currentColor"
  }))), _symbol243 || (_symbol243 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_printshop",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3h10c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1ZM5 8h14c1.66 0 3 1.34 3 3v4c0 1.1-.9 2-2 2h-2v2c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-2H4c-1.1 0-2-.9-2-2v-4c0-1.66 1.34-3 3-3Zm4 11h6c.55 0 1-.45 1-1v-4H8v4c0 .55.45 1 1 1Zm10-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Z",
    fill: "currentColor"
  }))), _symbol244 || (_symbol244 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_see",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5h-3.17l-1.24-1.35A1.99 1.99 0 0 0 14.12 3H9.88c-.56 0-1.1.24-1.48.65L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm-8 4.8a3.2 3.2 0 1 0 0 6.4 3.2 3.2 0 0 0 0-6.4ZM7 13c0 2.76 2.24 5 5 5s5-2.24 5-5-2.24-5-5-5-5 2.24-5 5Z",
    fill: "currentColor"
  }))), _symbol245 || (_symbol245 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_shipping",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 8h2.5c.31 0 .61.15.8.4l2.3 3.07c.26.35.4.77.4 1.2V16c0 .55-.45 1-1 1h-1c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v2ZM5 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1Zm14.5-7.5 1.96 2.5H17V9.5h2.5ZM17 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol246 || (_symbol246 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-local_taxi",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5c.66 0 1.22.42 1.42 1.01l1.97 5.67c.07.21.11.44.11.66v7.16c0 .83-.68 1.5-1.5 1.5-.83 0-1.5-.68-1.5-1.5V19H6v.5c0 .83-.67 1.5-1.5 1.5S3 20.33 3 19.5v-7.16c0-.23.04-.45.11-.66l1.97-5.67C5.29 5.42 5.84 5 6.5 5H9V4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1h2.5ZM5 14.5c0 .83.67 1.5 1.5 1.5S8 15.33 8 14.5 7.33 13 6.5 13 5 13.67 5 14.5ZM17.5 16c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5Zm-11-9.5L5 11h14l-1.5-4.5h-11Z",
    fill: "currentColor"
  }))), _symbol247 || (_symbol247 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-map",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m9.654 3.23 5 1.75c.23.08.47.07.69-.01l2.93-1.14c1.31-.51 2.72.45 2.72 1.86v11.85c0 .86-.55 1.63-1.36 1.9l-3.99 1.34c-.42.14-.88.14-1.3-.01l-5-1.75a.966.966 0 0 0-.69.01l-2.93 1.14c-1.31.51-2.72-.45-2.72-1.86V6.46c0-.86.55-1.62 1.36-1.9l3.99-1.34c.42-.14.88-.14 1.3.01Zm-.65 13.55 6 2.11V7.22l-6-2.11v11.67Z",
    fill: "currentColor"
  }))), _symbol248 || (_symbol248 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-money",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2Zm3 3c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V9Zm7 7H9c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v6c0 .55-.45 1-1 1Zm3 0h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1Zm1-6h1v4h-1v-4Zm-6 0h1v4h-1v-4Zm-5 8h14c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol249 || (_symbol249 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-my_location",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.94 11A8.994 8.994 0 0 0 13 3.06V2c0-.55-.45-1-1-1s-1 .45-1 1v1.06A8.994 8.994 0 0 0 3.06 11H2c-.55 0-1 .45-1 1s.45 1 1 1h1.06A8.994 8.994 0 0 0 11 20.94V22c0 .55.45 1 1 1s1-.45 1-1v-1.06A8.994 8.994 0 0 0 20.94 13H22c.55 0 1-.45 1-1s-.45-1-1-1h-1.06ZM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm-7 4c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7-7 3.13-7 7Z",
    fill: "currentColor"
  }))), _symbol250 || (_symbol250 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-navigation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.925 4.126 6.15 14.99c.34.83-.51 1.66-1.33 1.29l-5.34-2.36c-.26-.11-.55-.11-.81 0l-5.34 2.36c-.82.36-1.67-.46-1.33-1.29l6.15-14.99c.33-.83 1.51-.83 1.85 0Z",
    fill: "currentColor"
  }))), _symbol251 || (_symbol251 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-near_me",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.949 3.738-14.68 6.14c-.83.35-.81 1.53.02 1.85l5.34 2.07a1 1 0 0 1 .57.57l2.06 5.33c.32.84 1.51.86 1.86.03l6.15-14.67c.33-.83-.5-1.66-1.32-1.32Z",
    fill: "currentColor"
  }))), _symbol252 || (_symbol252 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-person_pin",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1.709H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h4l2.29 2.29c.39.39 1.02.39 1.41 0l2.3-2.29h4c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2Zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7Zm-6 9.8v.9h12v-.9c0-2-4-3.1-6-3.1s-6 1.1-6 3.1Z",
    fill: "currentColor"
  }))), _symbol253 || (_symbol253 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-pin_drop",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 3.49 3.62 8.19 5.23 10.12.4.48 1.13.48 1.53 0C14.38 16.19 18 11.49 18 8Zm-8 0c0-1.1.9-2 2-2s2 .9 2 2a2 2 0 1 1-4 0ZM6 22c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1H6Z",
    fill: "currentColor"
  }))), _symbol254 || (_symbol254 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-place",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 9.265c0-3.87 3.13-7 7-7s7 3.13 7 7c0 4.17-4.42 9.92-6.23 12.11-.4.48-1.13.48-1.53 0C9.42 19.185 5 13.435 5 9.265Zm4.5 0a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z",
    fill: "currentColor"
  }))), _symbol255 || (_symbol255 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-restaurant",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9h2V3c0-.55.45-1 1-1s1 .45 1 1v6c0 2.21-1.79 4-4 4v8c0 .55-.45 1-1 1s-1-.45-1-1v-8c-2.21 0-4-1.79-4-4V3c0-.55.45-1 1-1s1 .45 1 1v6h2V3c0-.55.45-1 1-1s1 .45 1 1v6Zm9 5c-1.1 0-2-.9-2-2V6c0-1.49 1.6-3.32 3.76-3.85.63-.15 1.24.33 1.24.98V21c0 .55-.45 1-1 1s-1-.45-1-1v-7h-1Z",
    fill: "currentColor"
  }))), _symbol256 || (_symbol256 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-restaurant_menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.851 10.142c-1.59 1.59-3.74 2.09-5.27 1.38l-1.47 1.47 6.18 6.18a.996.996 0 1 1-1.41 1.41l-6.18-6.18-6.19 6.17a.996.996 0 1 1-1.41-1.41l9.06-9.06c-.71-1.53-.21-3.68 1.38-5.27 1.92-1.91 4.66-2.27 6.12-.81 1.47 1.47 1.1 4.21-.81 6.12Zm-9.22.36-2.83 2.83-4.19-4.18a4.016 4.016 0 0 1-.78-4.56c.3-.62 1.13-.75 1.61-.27l6.19 6.18Z",
    fill: "currentColor"
  }))), _symbol257 || (_symbol257 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-store_mall_directory",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6H5c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1Zm1.16 1.8c-.09-.46-.5-.8-.98-.8H4.82c-.48 0-.89.34-.98.8L3 12v1c0 .55.45 1 1 1v5c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-5h4v5c0 .55.45 1 1 1s1-.45 1-1v-5c.55 0 1-.45 1-1v-1l-.84-4.2ZM12 18H6v-4h6v4Z",
    fill: "currentColor"
  }))), _symbol258 || (_symbol258 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-terrain",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.2 6.738-2.95 3.93 2.25 3c.33.44.24 1.07-.2 1.4a.994.994 0 0 1-1.4-.2c-1.05-1.4-2.31-3.07-3.1-4.14-.4-.53-1.2-.53-1.6 0l-4 5.33c-.49.67-.02 1.61.8 1.61h18c.82 0 1.29-.94.8-1.6l-7-9.33a.993.993 0 0 0-1.6 0Z",
    fill: "currentColor"
  }))), _symbol259 || (_symbol259 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-train",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5c-4 0-8 .5-8 4V16c0 1.93 1.57 3.5 3.5 3.5l-1.15 1.15a.5.5 0 0 0 .36.85H7.8c.13 0 .26-.05.35-.15L10 19.5h4l1.85 1.85c.09.09.22.15.35.15h1.09c.45 0 .67-.54.35-.85L16.5 19.5c1.93 0 3.5-1.57 3.5-3.5V6.5c0-3.5-4-4-8-4Zm-4.5 15c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5S9 15.17 9 16s-.67 1.5-1.5 1.5Zm-1.5-7h5v-4H6v4Zm10.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5Zm-3.5-7h5v-4h-5v4Z",
    fill: "currentColor"
  }))), _symbol260 || (_symbol260 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-maps-zoom_out_map",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 6.7 3.85 8.15A.5.5 0 0 1 3 7.79V3.5c0-.28.22-.5.5-.5h4.29a.5.5 0 0 1 .36.85L6.7 5.3l2.18 2.16c.39.39.39 1.03 0 1.42-.39.39-1.03.39-1.42 0L5.3 6.7Zm12-1.4-1.45-1.45a.5.5 0 0 1 .36-.85h4.29c.28 0 .5.22.5.5v4.29a.5.5 0 0 1-.85.36L18.7 6.7l-2.16 2.18c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42L17.3 5.3ZM8.15 20.15 6.7 18.7l2.18-2.16c.39-.39.39-1.03 0-1.42-.39-.39-1.03-.39-1.42 0L5.3 17.3l-1.45-1.45a.5.5 0 0 0-.85.36v4.29c0 .28.22.5.5.5h4.29a.5.5 0 0 0 .36-.85ZM18.7 17.3l1.45-1.45a.5.5 0 0 1 .85.36v4.29c0 .28-.22.5-.5.5h-4.29a.5.5 0 0 1-.36-.85l1.45-1.45-2.18-2.16c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l2.16 2.18Z",
    fill: "currentColor"
  }))), _symbol261 || (_symbol261 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-apps",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8h4V4H4v4Zm6 12h4v-4h-4v4Zm-2 0H4v-4h4v4Zm-4-6h4v-4H4v4Zm10 0h-4v-4h4v4Zm2-10v4h4V4h-4Zm-2 4h-4V4h4v4Zm2 6h4v-4h-4v4Zm4 6h-4v-4h4v4Z",
    fill: "currentColor"
  }))), _symbol262 || (_symbol262 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_back",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.79 11.005H7.62l4.88-4.88c.39-.39.39-1.03 0-1.42a.996.996 0 0 0-1.41 0l-6.59 6.59a.996.996 0 0 0 0 1.41l6.59 6.59a.996.996 0 1 0 1.41-1.41l-4.88-4.88h11.17c.55 0 1-.45 1-1s-.45-1-1-1Z",
    fill: "currentColor"
  }))), _symbol263 || (_symbol263 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_back_ios",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.001 2.985a1.25 1.25 0 0 0-1.77 0l-8.31 8.31a.996.996 0 0 0 0 1.41l8.31 8.31c.49.49 1.28.49 1.77 0s.49-1.28 0-1.77l-7.24-7.25 7.25-7.25c.48-.48.48-1.28-.01-1.76Z",
    fill: "currentColor"
  }))), _symbol264 || (_symbol264 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.578 10.979 5.05 4.512c.76.679 1.989.679 2.749 0l5.05-4.512C19.655 9.88 18.777 8 17.042 8h-10.1C5.209 8 4.35 9.881 5.579 10.979Z",
    fill: "currentColor"
  }))), _symbol265 || (_symbol265 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_downward",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.007 5.209v11.17l-4.88-4.88c-.39-.39-1.03-.39-1.42 0a.996.996 0 0 0 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 1 0-1.41-1.41l-4.88 4.88V5.209c0-.55-.45-1-1-1s-1 .45-1 1Z",
    fill: "currentColor"
  }))), _symbol266 || (_symbol266 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_drop_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.578 10.979 5.05 4.512c.76.679 1.989.679 2.749 0l5.05-4.512C19.655 9.88 18.777 8 17.042 8h-10.1C5.209 8 4.35 9.881 5.579 10.979Z",
    fill: "currentColor"
  }))), _symbol267 || (_symbol267 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_drop_down_circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.48 2 12 2s10 4.48 10 10-4.48 10-10 10S2 17.52 2 12Zm6.86-.14 2.79 2.79c.19.19.51.19.71-.01l2.79-2.79c.32-.31.1-.85-.35-.85H9.21c-.45 0-.67.54-.35.86Z",
    fill: "currentColor"
  }))), _symbol268 || (_symbol268 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_drop_up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.707 12.586 2.59-2.59a.996.996 0 0 1 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71h-5.18c-.89 0-1.33-1.08-.7-1.71Z",
    fill: "currentColor"
  }))), _symbol269 || (_symbol269 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_forward",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.207 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41l4.87 4.89H5.207c-.55 0-1 .45-1 1s.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol270 || (_symbol270 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_forward_ios",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.998 21.015c.49.49 1.28.49 1.77 0l8.31-8.31a.996.996 0 0 0 0-1.41l-8.31-8.31a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77l7.24 7.25-7.25 7.25c-.48.48-.48 1.28.01 1.76Z",
    fill: "currentColor"
  }))), _symbol271 || (_symbol271 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.021 5.578-4.511 5.05c-.68.76-.68 1.989 0 2.749l4.511 5.05c1.098 1.228 2.979.35 2.979-1.385v-10.1c0-1.734-1.881-2.592-2.979-1.364Z",
    fill: "currentColor"
  }))), _symbol272 || (_symbol272 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.979 18.422 4.512-5.053c.679-.76.679-1.99 0-2.75l-4.512-5.054C9.88 4.355 8 5.214 8 6.95v10.087c0 1.756 1.881 2.614 2.979 1.385Z",
    fill: "currentColor"
  }))), _symbol273 || (_symbol273 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.578 13.021 5.05-4.511c.76-.68 1.989-.68 2.749 0l5.05 4.511c1.228 1.098.35 2.979-1.385 2.979h-10.1c-1.734 0-2.592-1.881-1.364-2.979Z",
    fill: "currentColor"
  }))), _symbol274 || (_symbol274 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-arrow_upward",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.999 18.791V7.621l4.88 4.88c.39.39 1.03.39 1.42 0a.996.996 0 0 0 0-1.41l-6.59-6.59a.996.996 0 0 0-1.41 0l-6.6 6.58a.996.996 0 1 0 1.41 1.41l4.89-4.87v11.17c0 .55.45 1 1 1s1-.45 1-1Z",
    fill: "currentColor"
  }))), _symbol275 || (_symbol275 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-cancel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47 6.47 2 12 2s10 4.47 10 10-4.47 10-10 10S2 17.53 2 12Zm12.89 4.3c.39.39 1.02.39 1.41 0 .38-.39.38-1.03 0-1.41L13.41 12l2.89-2.89a.996.996 0 1 0-1.41-1.41L12 10.59 9.11 7.7A.996.996 0 1 0 7.7 9.11L10.59 12 7.7 14.89a.996.996 0 1 0 1.41 1.41L12 13.41l2.89 2.89Z",
    fill: "currentColor"
  }))), _symbol276 || (_symbol276 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.794 15.875-3.47-3.47a.996.996 0 0 0-1.41 0 .996.996 0 0 0 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.58-10.58a.996.996 0 1 0-1.41-1.41l-9.88 9.87Z",
    fill: "currentColor"
  }))), _symbol277 || (_symbol277 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-chevron_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 6.705a.996.996 0 0 0-1.41 0L9 11.295a.996.996 0 0 0 0 1.41l4.59 4.59a.996.996 0 1 0 1.41-1.41l-3.88-3.89L15 8.115c.39-.39.38-1.03 0-1.41Z",
    fill: "currentColor"
  }))), _symbol278 || (_symbol278 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-chevron_right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6.71a.996.996 0 0 0 0 1.41L12.88 12 9 15.88a.996.996 0 1 0 1.41 1.41L15 12.7a.996.996 0 0 0 0-1.41L10.41 6.7c-.38-.38-1.02-.38-1.41.01Z",
    fill: "currentColor"
  }))), _symbol279 || (_symbol279 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.299 5.71a.996.996 0 0 0-1.41 0l-4.89 4.88-4.89-4.89a.996.996 0 1 0-1.41 1.41l4.89 4.89-4.89 4.89a.996.996 0 1 0 1.41 1.41l4.89-4.89 4.89 4.89a.996.996 0 1 0 1.41-1.41L13.409 12l4.89-4.89c.38-.38.38-1.02 0-1.4Z",
    fill: "currentColor"
  }))), _symbol280 || (_symbol280 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-expand_less",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.297 9-4.59 4.59A.996.996 0 1 0 8.117 15l3.89-3.88 3.88 3.88a.996.996 0 1 0 1.41-1.41L12.707 9a.996.996 0 0 0-1.41 0Z",
    fill: "currentColor"
  }))), _symbol281 || (_symbol281 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-expand_more",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.877 9-3.88 3.88L8.117 9a.996.996 0 1 0-1.41 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59a.996.996 0 0 0 0-1.41c-.39-.38-1.03-.39-1.42 0Z",
    fill: "currentColor"
  }))), _symbol282 || (_symbol282 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-first_page",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V7Zm5.82 5 3.88 3.89c.39.38.39 1.02.01 1.4a.996.996 0 0 1-1.41 0l-4.59-4.59a.996.996 0 0 1 0-1.41L16.3 6.7a.996.996 0 1 1 1.41 1.41L13.82 12Z",
    fill: "currentColor"
  }))), _symbol283 || (_symbol283 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-fullscreen",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9c0 .55-.45 1-1 1s-1-.45-1-1V6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1H7v2Zm-2 6c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1v-3Zm12 2h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2ZM15 7c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V7h-2Z",
    fill: "currentColor"
  }))), _symbol284 || (_symbol284 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-fullscreen_exit",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8h2V6c0-.55.45-1 1-1s1 .45 1 1v3c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1Zm2 8H6c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1s-1-.45-1-1v-2Zm7 3c.55 0 1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1h-3c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1Zm1-13v2h2c.55 0 1 .45 1 1s-.45 1-1 1h-3c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1s1 .45 1 1Z",
    fill: "currentColor"
  }))), _symbol285 || (_symbol285 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-last_page",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.003 7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1V7Zm-7.82 5-3.89-3.89c-.38-.38-.38-1.02 0-1.41a.996.996 0 0 1 1.41 0l4.59 4.6c.39.39.39 1.02 0 1.41l-4.59 4.59a.996.996 0 1 1-1.41-1.41l3.89-3.89Z",
    fill: "currentColor"
  }))), _symbol286 || (_symbol286 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8c-.55 0-1-.45-1-1s.45-1 1-1h16c.55 0 1 .45 1 1s-.45 1-1 1H4Zm0 5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1Zm0 5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol287 || (_symbol287 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-more_horiz",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-8 2c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Z",
    fill: "currentColor"
  }))), _symbol288 || (_symbol288 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-more_vert",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm-2 8c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2Z",
    fill: "currentColor"
  }))), _symbol289 || (_symbol289 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-refresh",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.642 6.351a7.95 7.95 0 0 0-6.48-2.31c-3.67.37-6.69 3.35-7.1 7.02-.55 4.85 3.2 8.94 7.93 8.94a7.98 7.98 0 0 0 7.21-4.56c.32-.67-.16-1.44-.9-1.44-.37 0-.72.2-.88.53a5.994 5.994 0 0 1-6.8 3.31c-2.22-.49-4.01-2.3-4.48-4.52a6.002 6.002 0 0 1 5.85-7.32c1.66 0 3.14.69 4.22 1.78l-1.51 1.51c-.63.63-.19 1.71.7 1.71h3.59c.55 0 1-.45 1-1v-3.59c0-.89-1.08-1.34-1.71-.71l-.64.65Z",
    fill: "currentColor"
  }))), _symbol290 || (_symbol290 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-subdirectory_arrow_left",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 15.419 4.58 4.58c.39.39 1.03.39 1.42 0 .39-.39.39-1.03 0-1.42l-2.88-2.87h10.17c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1s-1 .45-1 1v9H8.12l2.88-2.87c.39-.39.39-1.03 0-1.42-.39-.39-1.03-.39-1.42 0L5 13.999c-.39.39-.39 1.03 0 1.42Z",
    fill: "currentColor"
  }))), _symbol291 || (_symbol291 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-subdirectory_arrow_right",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.997 15.419-4.58 4.58c-.39.39-1.03.39-1.42 0-.39-.39-.39-1.03 0-1.42l2.88-2.87H5.707c-.55 0-1-.45-1-1v-10c0-.55.45-1 1-1s1 .45 1 1v9h9.17l-2.88-2.87c-.39-.39-.39-1.03 0-1.42.39-.39 1.03-.39 1.42 0l4.58 4.58c.39.39.39 1.03 0 1.42Z",
    fill: "currentColor"
  }))), _symbol292 || (_symbol292 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-unfold_less",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.176 4.408a.996.996 0 0 1 .695 1.712L12.7 9.29a.996.996 0 0 1-1.41 0L8.12 6.12c-.39-.39-.39-1.03 0-1.42a.996.996 0 0 1 1.41 0L12 7.17l2.47-2.47a.996.996 0 0 1 .705-.292ZM12 16.83 9.53 19.3a.996.996 0 0 1-1.41 0 .987.987 0 0 1 .01-1.41l3.17-3.17a.996.996 0 0 1 1.41 0l3.17 3.17a.996.996 0 1 1-1.41 1.41L12 16.83Z",
    fill: "currentColor"
  }))), _symbol293 || (_symbol293 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-navigation-unfold_more",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.46 8.29 12 5.83 9.53 8.29a.996.996 0 1 1-1.41-1.41l3.17-3.18a.996.996 0 0 1 1.41 0l3.17 3.18a.996.996 0 1 1-1.41 1.41Zm-4.92 7.42L12 18.17l2.47-2.45a.996.996 0 1 1 1.41 1.41l-3.17 3.17a.996.996 0 0 1-1.41 0l-3.17-3.18a.996.996 0 1 1 1.41-1.41Z",
    fill: "currentColor"
  }))), _symbol294 || (_symbol294 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-bluetooth_audio",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.78 8.415-3.59 3.58 3.6 3.58c.39.4.39 1.03 0 1.42l-4.3 4.3c-.63.63-1.71.18-1.71-.71v-6.18l-3.89 3.89a.996.996 0 1 1-1.41-1.41l4.89-4.89-4.89-4.89a.996.996 0 1 1 1.41-1.41l3.89 3.9v-6.18c0-.89 1.08-1.34 1.71-.71l4.29 4.29c.39.4.39 1.03 0 1.42Zm5.12-.64a.863.863 0 0 0-1.4-.24c-.26.26-.31.64-.17.98.46 1.07.72 2.24.72 3.47 0 1.24-.26 2.42-.73 3.49a.84.84 0 0 0 .16.94.84.84 0 0 0 1.35-.23c.63-1.3.98-2.76.98-4.3a9.995 9.995 0 0 0-.91-4.11Zm-4.12 2.5-1.38 1.38c-.2.2-.2.51 0 .71l1.38 1.38c.28.28.75.15.85-.23.11-.5.17-1 .17-1.52a6 6 0 0 0-.18-1.48.5.5 0 0 0-.84-.24Zm-5-4.45 1.88 1.88-1.88 1.88v-3.76Zm1.88 10.46-1.88-1.88v3.76l1.88-1.88Z",
    fill: "currentColor"
  }))), _symbol295 || (_symbol295 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-confirmation_number",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6v2.54c0 .69-.34 1.37-.94 1.7-.63.34-1.06 1-1.06 1.76s.43 1.42 1.06 1.76c.6.33.94 1.01.94 1.7V18c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-2.54c0-.69.34-1.37.94-1.7.63-.33 1.06-1 1.06-1.76s-.42-1.42-1.05-1.77c-.61-.32-.94-1-.94-1.69V6c0-1.11.89-2 1.99-2h16c1.1 0 2 .9 2 2ZM11 17.5h2v-2h-2v2Zm2-4.5h-2v-2h2v2Zm-2-4.5h2v-2h-2v2Z",
    fill: "currentColor"
  }))), _symbol296 || (_symbol296 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-drive_eta",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 4c.66 0 1.22.42 1.42 1.01l1.97 5.67c.07.21.11.44.11.66v7.16c0 .83-.68 1.5-1.5 1.5-.83 0-1.5-.68-1.5-1.5V18H6v.5c0 .83-.67 1.5-1.5 1.5S3 19.33 3 18.5v-7.16c0-.23.04-.45.11-.66l1.97-5.67C5.29 4.42 5.84 4 6.5 4h11ZM5 13.5c0 .83.67 1.5 1.5 1.5S8 14.33 8 13.5 7.33 12 6.5 12 5 12.67 5 13.5ZM17.5 15c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM6.27 6.18 5 10h14l-1.27-3.82c-.14-.4-.52-.68-.95-.68H7.22c-.43 0-.81.28-.95.68Z",
    fill: "currentColor"
  }))), _symbol297 || (_symbol297 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-enhanced_encryption",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.5h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2Zm-9.1-2c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9v-2Zm4.1 10h2c.55 0 1-.45 1-1s-.45-1-1-1h-2v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H9c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2Z",
    fill: "currentColor"
  }))), _symbol298 || (_symbol298 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-event_available",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm-3 7.53a.754.754 0 0 0-1.06 0l-4.35 4.35L9 14.29a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.94 1.94c.39.39 1.02.39 1.41 0l4.7-4.7c.3-.29.3-.77.01-1.06ZM6 20h12c.55 0 1-.45 1-1V9H5v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol299 || (_symbol299 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-event_busy",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4h-1V3c0-.55-.45-1-1-1s-1 .45-1 1v1H8V3c0-.55-.45-1-1-1s-1 .45-1 1v1H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2ZM9.84 17.47l1.91-1.91 1.91 1.91c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-1.91-1.91 1.91-1.91c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.91 1.91-1.91-1.91a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.91 1.91-1.91 1.91c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0ZM6 20h12c.55 0 1-.45 1-1V9H5v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol300 || (_symbol300 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-event_note",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4h1c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1V3c0-.55.45-1 1-1s1 .45 1 1v1h8V3c0-.55.45-1 1-1s1 .45 1 1v1ZM8 11h8c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1Zm10 9H6c-.55 0-1-.45-1-1V9h14v10c0 .55-.45 1-1 1ZM8 15h5c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1Z",
    fill: "currentColor"
  }))), _symbol301 || (_symbol301 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-folder_special",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h5.17c.53 0 1.04.21 1.42.59L12 6Zm3 9.28 1.94 1.13c.37.22.83-.12.72-.55l-.51-2.2 1.69-1.46a.5.5 0 0 0-.28-.88l-2.23-.19-.88-2.06c-.17-.4-.75-.4-.92 0l-.88 2.06-2.23.19c-.44.04-.61.59-.28.88l1.69 1.46-.51 2.2c-.1.43.36.77.74.55L15 15.28Z",
    fill: "currentColor"
  }))), _symbol302 || (_symbol302 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-ondemand_video",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v1c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-1h5c1.1 0 1.99-.9 1.99-2L23 5a2 2 0 0 0-2-2Zm-1 14H4c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v10c0 .55-.45 1-1 1Zm-9.5-2.85 3.98-2.28c.67-.39.67-1.35 0-1.74L10.5 7.85c-.67-.38-1.5.1-1.5.87v4.56c0 .76.83 1.25 1.5.87Z",
    fill: "currentColor"
  }))), _symbol303 || (_symbol303 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-personal_video",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3h18a2 2 0 0 1 2 2l-.01 12c0 1.1-.89 2-1.99 2h-5v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-1H3c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm1 14h16c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1Z",
    fill: "currentColor"
  }))), _symbol304 || (_symbol304 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-phone_in_talk",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.683 14.978 2.54.29c1.01.12 1.77.97 1.76 1.98v1.73c0 1.13-.94 2.07-2.07 2-8.53-.53-15.36-7.35-15.89-15.89-.07-1.13.87-2.07 2-2.07h1.73c1.02 0 1.87.76 1.99 1.77l.29 2.52c.07.61-.14 1.21-.57 1.64l-1.85 1.85c1.44 2.84 3.76 5.15 6.59 6.59l1.84-1.84a1.99 1.99 0 0 1 1.64-.57Zm-3.81-9.92c3.18.4 5.67 2.89 6.07 6.07.06.51.49.88.99.88.04 0 .08 0 .12-.01.55-.07.94-.57.87-1.12a8.981 8.981 0 0 0-7.81-7.81c-.55-.06-1.05.33-1.11.88-.07.55.32 1.05.87 1.11Zm.38 2.11a1 1 0 0 0-1.22.72c-.14.54.18 1.08.72 1.22a3 3 0 0 1 2.15 2.15 1.003 1.003 0 0 0 1.22.72c.53-.14.85-.69.72-1.22a5.018 5.018 0 0 0-3.59-3.59Z",
    fill: "currentColor"
  }))), _symbol305 || (_symbol305 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-priority_high",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5c0-1.1.9-2 2-2s2 .9 2 2v8c0 1.1-.9 2-2 2s-2-.9-2-2V5Zm0 14a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
    fill: "currentColor"
  }))), _symbol306 || (_symbol306 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-sd_card",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.83 2H18c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V8.82c0-.52.23-1.03.6-1.4l4.81-4.83c.38-.38.89-.59 1.42-.59ZM10 7c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v2Zm4 1c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1Zm2-1c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol307 || (_symbol307 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-sync",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.21V4c4.42 0 8 3.58 8 8 0 1.04-.2 2.04-.57 2.95-.27.67-1.13.85-1.64.34-.27-.27-.38-.68-.23-1.04.29-.69.44-1.46.44-2.25 0-3.31-2.69-6-6-6v1.79c0 .45-.54.67-.86.36L8.35 5.36c-.2-.2-.2-.51 0-.71l2.8-2.79c.31-.32.85-.1.85.35ZM6 12c0 3.31 2.69 6 6 6v-1.79a.5.5 0 0 1 .85-.36l2.79 2.79c.2.2.2.51 0 .71l-2.79 2.79c-.31.32-.85.1-.85-.35V20c-4.42 0-8-3.58-8-8 0-1.04.2-2.04.57-2.95.27-.67 1.13-.85 1.64-.34.27.27.38.68.23 1.04C6.15 10.44 6 11.21 6 12Z",
    fill: "currentColor"
  }))), _symbol308 || (_symbol308 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-vibration",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5ZM5 16c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8Zm-3-2c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4Zm20-4v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1Zm-1 6c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8ZM8 19h8V5H8v14Z",
    fill: "currentColor"
  }))), _symbol309 || (_symbol309 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-wc",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.195 6c1.11 0 2-.89 2-2 0-1.11-.89-2-2-2-1.11 0-2 .89-2 2 0 1.11.89 2 2 2Zm-2 8.5V21c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6.5h.5c.55 0 1-.45 1-1V9c0-1.1-.9-2-2-2h-3c-1.1 0-2 .9-2 2v4.5c0 .55.45 1 1 1h.5Zm12.5 1.5v5c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-5h-1.61a.998.998 0 0 1-.95-1.32l2.1-6.31a2 2 0 0 1 1.9-1.37h.12c.86 0 1.62.55 1.9 1.37l2.1 6.31c.21.65-.27 1.32-.95 1.32h-1.61Zm.5-12c0 1.11-.89 2-2 2-1.11 0-2-.89-2-2 0-1.11.89-2 2-2 1.11 0 2 .89 2 2Z",
    fill: "currentColor"
  }))), _symbol310 || (_symbol310 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-wifi",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.057 10.04c.51.51 1.32.56 1.87.1 4.67-3.84 11.45-3.84 16.13-.01.56.46 1.38.42 1.89-.09.59-.59.55-1.57-.1-2.1-5.71-4.67-13.97-4.67-19.69 0-.65.52-.7 1.5-.1 2.1Zm7.76 7.76 1.47 1.47c.39.39 1.02.39 1.41 0l1.47-1.47c.47-.47.37-1.28-.23-1.59a4.28 4.28 0 0 0-3.91 0c-.57.31-.68 1.12-.21 1.59Zm-1.9-3.6c-.57.41-1.34.36-1.83-.13-.61-.61-.57-1.62.12-2.12 3.45-2.49 8.14-2.49 11.58 0 .69.49.73 1.51.13 2.11l-.01.01c-.49.49-1.26.53-1.83.13a7.064 7.064 0 0 0-8.16 0Z",
    fill: "currentColor"
  }))), _symbol311 || (_symbol311 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-notification-wifi_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.113 3.525 15.56 15.56c.39.39.39 1.02 0 1.39a.996.996 0 0 1-1.41 0l-6.37-6.37c-1.39.03-2.78.45-3.97 1.29-.57.41-1.34.36-1.83-.13l-.01-.01c-.6-.6-.56-1.61.13-2.11.98-.71 2.06-1.21 3.19-1.51l-2.23-2.23c-1.15.47-2.25 1.11-3.25 1.93-.55.46-1.36.41-1.87-.1a1.42 1.42 0 0 1 .1-2.1c.9-.74 1.88-1.35 2.89-1.85l-2.34-2.35a.996.996 0 1 1 1.41-1.41Zm17.83 7.71c-.51.51-1.33.55-1.89.09a12.675 12.675 0 0 0-8.17-2.86l-2.59-2.59c4.35-.77 8.96.32 12.55 3.26.65.53.69 1.51.1 2.1Zm-6.68.62c.89.3 1.74.73 2.52 1.3.53.38.67 1.07.43 1.65l-2.95-2.95Zm-1.32 5.56a4.28 4.28 0 0 0-3.91 0c-.59.31-.7 1.12-.23 1.59l1.47 1.47c.39.39 1.02.39 1.41 0l1.47-1.47c.49-.47.39-1.28-.21-1.59Z",
    fill: "currentColor"
  }))), _symbol312 || (_symbol312 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-domain",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5v2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2ZM4 19h2v-2H4v2Zm2-4H4v-2h2v2Zm-2-4h2V9H4v2Zm2-4H4V5h2v2Zm2 12h2v-2H8v2Zm2-4H8v-2h2v2Zm-2-4h2V9H8v2Zm2-4H8V5h2v2Zm2 12h7c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-7v2h2v2h-2v2h2v2h-2v2Zm6-8h-2v2h2v-2Zm-2 4h2v2h-2v-2Z",
    fill: "currentColor"
  }))), _symbol313 || (_symbol313 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-group",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.99 8c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3Zm8 0c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3ZM8 13c-2.33 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-1.5c0-2.33-4.67-3.5-7-3.5Zm7.03.05c.35-.03.68-.05.97-.05 2.33 0 7 1.17 7 3.5V18c0 .55-.45 1-1 1h-5.18c.11-.31.18-.65.18-1v-1.5c0-1.47-.79-2.58-1.93-3.41a.12.12 0 0 1-.01-.011.092.092 0 0 0-.03-.029Z",
    fill: "currentColor"
  }))), _symbol314 || (_symbol314 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-group_add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.5c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86 0 1.07-.34 2.04-.9 2.86.28.09.59.14.91.14Zm-11-1H5v-2c0-.55-.45-1-1-1s-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1Zm8.99-2c0 1.66-1.33 3-2.99 3-1.66 0-3-1.34-3-3s1.34-3 3-3 2.99 1.34 2.99 3Zm-2.99 5c-2 0-6 1-6 3v1c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1c0-2-4-3-6-3Zm8 3c0-1.18-.55-2.11-1.38-2.84 2.01.35 4.38 1.3 4.38 2.84V18c0 .28-.22.5-.5.5h-2.55c.03-.16.05-.33.05-.5v-1.5Z",
    fill: "currentColor"
  }))), _symbol315 || (_symbol315 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-location_city",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.121v5.17h4c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-10c0-1.1.9-2 2-2h4v-1.17c0-.53.21-1.04.59-1.42l1.7-1.7a.996.996 0 0 1 1.41 0l1.71 1.71c.38.37.59.88.59 1.41ZM5 19.291h2v-2H5v2Zm2-4H5v-2h2v2Zm-2-4h2v-2H5v2Zm8 8h-2v-2h2v2Zm-2-4h2v-2h-2v2Zm2-4h-2v-2h2v2Zm-2-4h2v-2h-2v2Zm8 12h-2v-2h2v2Zm-2-4h2v-2h-2v2Z",
    fill: "currentColor"
  }))), _symbol316 || (_symbol316 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-mood",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm5-10.5c0 .83-.67 1.5-1.5 1.5S14 10.33 14 9.5 14.67 8 15.5 8s1.5.67 1.5 1.5ZM8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11Zm8.25 3.75A5.489 5.489 0 0 1 12 17.5c-2.03 0-3.8-1.11-4.75-2.75-.19-.33.06-.75.44-.75h8.62c.39 0 .63.42.44.75Z",
    fill: "currentColor"
  }))), _symbol317 || (_symbol317 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-mood_bad",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm5-10.5c0 .83-.67 1.5-1.5 1.5S14 10.33 14 9.5 14.67 8 15.5 8s1.5.67 1.5 1.5ZM8.5 11c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11Zm-1.25 5.25A5.489 5.489 0 0 1 12 13.5c2.03 0 3.8 1.11 4.75 2.75.19.33-.06.75-.44.75H7.69c-.38 0-.63-.42-.44-.75Z",
    fill: "currentColor"
  }))), _symbol318 || (_symbol318 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-notifications",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.75v5l1.29 1.29c.63.63.18 1.71-.71 1.71H5.41c-.89 0-1.33-1.08-.7-1.71L6 15.75v-5c0-3.08 1.63-5.64 4.5-6.32v-.68c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.68c2.86.68 4.5 3.25 4.5 6.32Zm-4 9a2 2 0 1 1-4 0h4Z",
    fill: "currentColor"
  }))), _symbol319 || (_symbol319 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-notifications_active",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.004 10.75v5l1.28 1.29c.63.63.18 1.71-.71 1.71H5.404c-.89 0-1.33-1.08-.7-1.71l1.3-1.29v-5c0-3.08 1.63-5.64 4.5-6.32v-.68c0-.83.66-1.5 1.49-1.5s1.51.67 1.51 1.5v.68c2.86.68 4.5 3.25 4.5 6.32Zm-4.01 9a2 2 0 1 1-4 0h4ZM6.774 4.48c.42-.38.43-1.03.03-1.43a1 1 0 0 0-1.39-.02 10.424 10.424 0 0 0-3.27 6.06c-.09.61.38 1.16 1 1.16.48 0 .9-.35.98-.83a8.44 8.44 0 0 1 2.65-4.94Zm10.43-1.43c.38-.38 1-.39 1.4-.02 1.7 1.57 2.87 3.68 3.25 6.05.1.61-.38 1.16-.99 1.16-.49 0-.91-.35-.98-.83a8.495 8.495 0 0 0-2.65-4.94.982.982 0 0 1-.03-1.42Z",
    fill: "currentColor"
  }))), _symbol320 || (_symbol320 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-notifications_none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.29 17.04 18 15.75v-5c0-3.07-1.64-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.11 6 7.67 6 10.75v5l-1.29 1.29c-.63.63-.19 1.71.7 1.71h13.17c.9 0 1.34-1.08.71-1.71ZM8 16.75v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6H8Zm6 3a2 2 0 1 1-4 0h4Z",
    fill: "currentColor"
  }))), _symbol321 || (_symbol321 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-notifications_off",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.305 10.75c0-3.07-1.64-5.64-4.5-6.32v-.68c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.202.05-.397.122-.585.191l-.105.039 8.19 8.19v-2.1Zm-6 11c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm-8-17.24 1.41-1.41 15.98 15.98-1.41 1.41-1.74-1.74H4.715c-.89 0-1.33-1.08-.7-1.71l1.29-1.29v-5c0-1.27.29-2.43.81-3.43l-2.81-2.81Z",
    fill: "currentColor"
  }))), _symbol322 || (_symbol322 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-people_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 8.5c0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5S7.07 5 9 5s3.5 1.57 3.5 3.5Zm-2 0C10.5 7.67 9.83 7 9 7s-1.5.67-1.5 1.5S8.17 10 9 10s1.5-.67 1.5-1.5ZM9 13.75c-2.34 0-7 1.17-7 3.5V18c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-.75c0-2.33-4.66-3.5-7-3.5Zm0 2c-1.79 0-3.82.67-4.66 1.25h9.32c-.84-.58-2.87-1.25-4.66-1.25Zm7.04-1.94c1.16.84 1.96 1.96 1.96 3.44V19h3c.55 0 1-.45 1-1v-.75c0-2.02-3.5-3.17-5.96-3.44ZM18.5 8.5c0 1.93-1.57 3.5-3.5 3.5-.54 0-1.04-.13-1.5-.35.63-.89 1-1.98 1-3.15s-.37-2.26-1-3.15c.46-.22.96-.35 1.5-.35 1.93 0 3.5 1.57 3.5 3.5Z",
    fill: "currentColor"
  }))), _symbol323 || (_symbol323 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-person",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM4 18c0-2.66 5.33-4 8-4s8 1.34 8 4v1c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-1Z",
    fill: "currentColor"
  }))), _symbol324 || (_symbol324 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-person_add",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm-9-2V8c0-.55-.45-1-1-1s-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1H6Zm1 8c0-2.66 5.33-4 8-4s8 1.34 8 4v1c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1v-1Z",
    fill: "currentColor"
  }))), _symbol325 || (_symbol325 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-person_outline",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm2.1 4a2.1 2.1 0 1 0-4.2 0 2.1 2.1 0 0 0 4.2 0Zm4 9c0-.64-3.13-2.1-6.1-2.1-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17ZM4 17c0-2.66 5.33-4 8-4s8 1.34 8 4v2c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1v-2Z",
    fill: "currentColor"
  }))), _symbol326 || (_symbol326 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-poll",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2Zm2 13c0 .55.45 1 1 1s1-.45 1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v5Zm5 1c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1Zm3-1c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1v2Z",
    fill: "currentColor"
  }))), _symbol327 || (_symbol327 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-sentiment_dissatisfied",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm6.5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-4.65-3.42C8.37 14.97 10.1 14 12 14c1.9 0 3.63.96 4.66 2.58.22.35.11.81-.24 1.03a.83.83 0 0 1-.4.11c-.25 0-.5-.12-.64-.35-.74-1.18-2-1.88-3.38-1.88s-2.64.7-3.38 1.88a.747.747 0 1 1-1.27-.79Z",
    fill: "currentColor"
  }))), _symbol328 || (_symbol328 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-sentiment_neutral",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM7 9.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM15.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 14.75c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4.5c-.41 0-.75.34-.75.75ZM4 12c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8-8 3.58-8 8Z",
    fill: "currentColor"
  }))), _symbol329 || (_symbol329 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-sentiment_satisfied",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.48 6.47 2 11.99 2 17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12Zm6.5-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm3.38-5.87c.21-.35.68-.46 1.03-.24.35.22.46.68.24 1.03-1.02 1.61-2.75 2.58-4.65 2.58-1.9 0-3.63-.96-4.65-2.59a.747.747 0 1 1 1.27-.79C9.36 15.3 10.62 16 12 16s2.64-.7 3.38-1.87Z",
    fill: "currentColor"
  }))), _symbol330 || (_symbol330 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-share",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16.12c-.76 0-1.44.3-1.96.77l-7.13-4.15c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.85c-.54-.5-1.25-.81-2.04-.81-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92Z",
    fill: "currentColor"
  }))), _symbol331 || (_symbol331 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-thumb_down_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.579 15.708-5.53 5.54c-.58.59-1.52.59-2.11.01-.36-.36-.51-.87-.41-1.37l.95-4.58h-5.65c-2.15 0-3.6-2.2-2.75-4.18l3.26-7.61a1.99 1.99 0 0 1 1.83-1.21h8.99c1.1 0 2 .9 2 2v9.99c0 .53-.21 1.04-.58 1.41Zm2.59-11.4c0-1.1.9-2 2-2s2 .9 2 2v8c0 1.1-.9 2-2 2s-2-.9-2-2v-8Z",
    fill: "currentColor"
  }))), _symbol332 || (_symbol332 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-social-thumb_up_alt",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.408 8.292 5.54-5.54c.58-.59 1.52-.59 2.11-.01.36.36.51.87.41 1.37l-.95 4.58h5.65c2.15 0 3.6 2.2 2.76 4.18l-3.26 7.61c-.32.73-1.04 1.21-1.84 1.21h-9c-1.1 0-2-.9-2-2v-9.99c0-.53.21-1.04.58-1.41Zm-2.58 11.4c0 1.1-.9 2-2 2s-2-.9-2-2v-8c0-1.1.9-2 2-2s2 .9 2 2v8Z",
    fill: "currentColor"
  }))), _symbol333 || (_symbol333 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-togglel-star_border",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.808 8.874 4.84.42c.88.07 1.23 1.17.56 1.75l-3.67 3.18 1.1 4.73c.2.86-.73 1.54-1.49 1.08l-4.15-2.51-4.15 2.5c-.76.46-1.69-.22-1.49-1.08l1.1-4.72-3.67-3.18c-.67-.58-.31-1.68.57-1.75l4.83-.41 1.89-4.46c.34-.81 1.5-.81 1.84 0l1.89 4.45Zm-6.57 9.05 3.76-2.27 3.77 2.28-1-4.28 3.32-2.88-4.38-.38-1.71-4.04-1.7 4.03-4.38.38 3.32 2.88-1 4.28Z",
    fill: "currentColor"
  }))), _symbol334 || (_symbol334 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-togglel-star_half",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.808 8.874 4.84.42c.88.07 1.23 1.17.56 1.75l-3.67 3.18 1.1 4.73c.2.86-.73 1.54-1.49 1.08l-4.15-2.51-4.15 2.5c-.76.46-1.69-.22-1.49-1.08l1.1-4.72-3.67-3.18c-.67-.58-.31-1.68.57-1.75l4.83-.41 1.89-4.46c.34-.81 1.5-.81 1.84 0l1.89 4.45Zm-2.81-2.52v9.3l3.77 2.28-1-4.28 3.32-2.88-4.38-.38-1.71-4.04Z",
    fill: "currentColor"
  }))), _symbol335 || (_symbol335 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-cef-togglel-star_purple500",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.998 17.52 4.15 2.51c.76.46 1.69-.22 1.49-1.08l-1.1-4.72 3.67-3.18c.67-.58.31-1.68-.57-1.75l-4.83-.41-1.89-4.46c-.34-.81-1.5-.81-1.84 0l-1.89 4.45-4.83.41c-.88.07-1.24 1.17-.57 1.75l3.67 3.18-1.1 4.72c-.2.86.73 1.54 1.49 1.08l4.15-2.5Z",
    fill: "currentColor"
  }))), _symbol336 || (_symbol336 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 24",
    id: "icon-cgu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.4H3.5c-.5 0-.9.4-.9.9s.4.9.9.9h7.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zM10.6 13.8H3.5c-.5 0-.9.4-.9.9s.4.9.9.9h7.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zM10.6 3.8H3.5c-.5 0-.9.4-.9.9s.4.9.9.9h7.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9zM10.6 7.2H3.5c-.5 0-.9.4-.9.9s.4.8.9.8h7.1c.5 0 .9-.4.9-.9s-.4-.8-.9-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 7.9 16 5.3v-.2c0-.2-.1-.4-.3-.6L11.2.2c0-.1-.2-.2-.5-.2H1.8C.8 0 0 .8 0 1.7v15.4c0 .9.8 1.7 1.8 1.7H3v1.6c0 .9.8 1.7 1.8 1.7h12.5c1 0 1.8-.8 1.8-1.7V8.5c0-.3-.1-.5-.3-.6zm-17 9.2V1.7h8.6l3.9 3.8v11.6H1.8zm15.5 3.3H4.8v-1.6h9.5c1 0 1.8-.8 1.8-1.7V7.6l1.2 1.2v11.6z"
  }))), _symbol337 || (_symbol337 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-chat",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.006 23.158a12.368 12.368 0 0 0 4.79-.958c.006 0 .012 0 .012-.006a1.86 1.86 0 0 1 1.345.023L23 24l-1.275-5.1c0-.306.086-.594.225-.842.046-.075.092-.15.144-.214A11.212 11.212 0 0 0 24 11.59C24.012 5.187 18.638 0 12.006 0S0 5.187 0 11.579c0 6.398 5.374 11.579 12.006 11.579Z"
  }))), _symbol338 || (_symbol338 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 14 10",
    id: "icon-check",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.222 9.444.778 5l1.258-1.258L5.222 6.93 11.964.187l1.258 1.257z"
  }))), _symbol339 || (_symbol339 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 20 20",
    id: "icon-checkAction",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm-2-5.83 5.88-5.88c.39-.39 1.03-.39 1.42 0 .39.39.39 1.02 0 1.41l-6.59 6.59a.996.996 0 0 1-1.41 0L4.71 11.7a.996.996 0 1 1 1.41-1.41L8 12.17Z"
  }))), _symbol340 || (_symbol340 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-checkmark",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 0C5.371 0 0 5.371 0 12s5.371 12 12 12 12-5.371 12-12S18.629 0 12 0Zm-1.852 16.252c-.138.138-.335.254-.508.254s-.369-.121-.513-.26l-3.23-3.23 1.026-1.028 2.723 2.724 7.2-7.252 1.01 1.044-7.708 7.748Z"
  }))), _symbol341 || (_symbol341 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 28 16",
    id: "icon-chevron",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 10.647 24.89.193a.712.712 0 0 1 .987.013l1.913 1.869a.678.678 0 0 1 .012.97L14.506 15.81a.652.652 0 0 1-.506.187.691.691 0 0 1-.506-.187L.198 3.044a.678.678 0 0 1 .012-.969L2.123.205a.712.712 0 0 1 .988-.012L14 10.647Z"
  }))), _symbol342 || (_symbol342 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "1 1 176 176",
    id: "icon-chrome",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("style", null, ".ezB{clip-path:url(#ezC)}.ezC{fill:#3e2723}.ezD{fill-opacity:.15}.ezE{fill-opacity:.2}"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "ezA",
    cx: 96,
    cy: 96,
    r: 88
  }), /*#__PURE__*/React.createElement("path", {
    id: "ezB",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ezC"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezA"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ezB",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezD",
    x1: 29.34,
    x2: 81.84,
    y1: 75.02,
    y2: 44.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a52714",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#ezD)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3 115.6 22.48 47.3l-.58 1 39.54 67.8z",
    className: "ezC ezD"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezB",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezE",
    x1: 110.9,
    x2: 52.54,
    y1: 164.5,
    y2: 130.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0.4,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055524",
    stopOpacity: 0,
    offset: 0.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#ezE)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.8 117.3-.83-.48-38.4 67.15h1.15l38.1-66.64z",
    fill: "#263238",
    className: "ezD"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ezF",
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ezG"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ezG)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezH",
    x1: 121.9,
    x2: 136.6,
    y1: 49.8,
    y2: 114.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0.3,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6100",
    stopOpacity: 0,
    offset: 0.66
  })), /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68H184V56z",
    fill: "url(#ezH)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68H184V56z",
    fill: "#ffcd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 56 34.65 60-38.88 68H184V56z",
    fill: "url(#ezH)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ezI",
    d: "m96 56 34.65 60-38.88 68H184V56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ezJ"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezI"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ezJ)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "#db4437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v108h39.4L96 56h88V8z",
    fill: "url(#ezD)"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ezK",
    cx: 668.2,
    cy: 55.95,
    r: 84.08,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96 56v20.95L174.4 56z",
    fill: "url(#ezK)",
    className: "ezB",
    transform: "translate(-7 -7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ezB",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ezL",
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ezM"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezL"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ezM)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ezB",
    fill: "#0f9d58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116h-69.3L8 24.48z",
    fill: "url(#ezE)"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ezN",
    cx: 597.9,
    cy: 48.52,
    r: 78.04,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e2723",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7 -7)",
    d: "m21.97 48.45 57.25 57.24L61.36 116z",
    fill: "url(#ezN)",
    className: "ezB"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ezO",
    cx: 671.8,
    cy: 96.14,
    r: 87.87,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0.2,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#263238",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m91.83 183.9 20.96-78.2 17.86 10.3z",
    fill: "url(#ezO)",
    className: "ezB",
    transform: "translate(-7 -7)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ezB",
    transform: "translate(-7 -7)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 40,
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 32,
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 55c-22.1 0-40 17.9-40 40v1c0-22.1 17.9-40 40-40h88v-1H96z",
    className: "ezC ezE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 116c-6.92 11.94-19.8 20-34.6 20s-27.7-8.06-34.6-20h-.04L8 24.48v1L61.4 117c6.92 11.94 19.8 20 34.6 20s27.68-8.05 34.6-20h.05v-1h-.06z",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.1 0 40-17.9 40-40s-17.9-40-40-40z",
    opacity: 0.1,
    className: "ezC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 117.3c3.4-5.88 5.37-12.68 5.37-19.96a39.87 39.87 0 0 0-1.87-12.09c.95 3.42 1.5 7 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16L131 117.3z",
    fill: "#fff",
    className: "ezE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 9c48.43 0 87.72 39.13 88 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fill: "#fff",
    className: "ezE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 183c48.43 0 87.72-39.13 88-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5.27 48.37 39.56 87.5 88 87.5z",
    className: "ezC ezD"
  })))), _symbol343 || (_symbol343 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 18 22",
    id: "icon-clipboard",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2h-4.18C11.4.84 10.3 0 9 0 7.7 0 6.6.84 6.18 2H2C.9 2 0 2.9 0 4v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM9 2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1ZM2 19c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1h-1v1c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4H3c-.55 0-1 .45-1 1v14Z"
  }))), _symbol344 || (_symbol344 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-clock",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M255.8 48C141 48 48 141.2 48 256s93 208 207.8 208c115 0 208.2-93.2 208.2-208S370.8 48 255.8 48zm.2 374.4c-91.9 0-166.4-74.5-166.4-166.4S164.1 89.6 256 89.6 422.4 164.1 422.4 256 347.9 422.4 256 422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.4 152h-31.2v124.8l109.2 65.5 15.6-25.6-93.6-55.5V152z"
  }))), _symbol345 || (_symbol345 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-clock-detailed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M255.988 32C132.285 32 32 132.298 32 256c0 123.715 100.285 224 223.988 224C379.703 480 480 379.715 480 256c0-123.702-100.297-224-224.012-224Zm135.773 359.765a193.666 193.666 0 0 1-32.886 26.42l-15.946-27.62-13.856 8 15.955 27.636c-24.838 13.03-52.372 20.455-81.027 21.624V416h-16v31.825c-28.656-1.166-56.191-8.59-81.03-21.62l15.958-27.641-13.856-8-15.949 27.625a193.574 193.574 0 0 1-32.889-26.424 193.571 193.571 0 0 1-26.422-32.889l27.624-15.949-8-13.855-27.641 15.958c-13.03-24.839-20.454-52.374-21.621-81.03H96v-16H64.175c1.167-28.655 8.592-56.19 21.623-81.029l27.638 15.958 8-13.856-27.623-15.948a193.662 193.662 0 0 1 26.419-32.885 193.632 193.632 0 0 1 32.89-26.426l15.949 27.624 13.856-8-15.958-27.64C191.81 72.765 219.345 65.34 248 64.175V96h16V64.176c28.654 1.169 56.188 8.595 81.026 21.626l-15.954 27.634 13.856 8 15.945-27.618a193.672 193.672 0 0 1 32.886 26.421 193.609 193.609 0 0 1 26.424 32.887l-27.619 15.946 8 13.856 27.636-15.956c13.031 24.839 20.457 52.373 21.624 81.027H416v16h31.824c-1.167 28.655-8.592 56.189-21.622 81.028l-27.637-15.957-8 13.856 27.621 15.947a193.57 193.57 0 0 1-26.425 32.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M400 241H284.268A32.136 32.136 0 0 0 272 228.292V160h-32v68.292c-9.562 5.534-16 15.866-16 27.708 0 17.673 14.327 32 32 32 11.425 0 21.444-5.992 27.106-15H400v-32Z"
  }))), _symbol346 || (_symbol346 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 48 48",
    id: "icon-close",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38 12.83 35.17 10 24 21.17 12.83 10 10 12.83 21.17 24 10 35.17 12.83 38 24 26.83 35.17 38 38 35.17 26.83 24Z"
  }))), _symbol347 || (_symbol347 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 24",
    fill: "none",
    id: "icon-contract",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.83C0 1.707.953.797 2.129.797h10.643c.282 0 .553.107.752.298l5.322 5.082c.2.19.312.45.312.719v14.23c0 1.123-.953 2.034-2.129 2.034h-14.9C.953 23.16 0 22.25 0 21.126V2.83Zm12.33 0H2.13v18.296h14.9V7.316L12.331 2.83ZM4.258 9.945c0-.561.477-1.016 1.065-1.016h8.514c.588 0 1.064.455 1.064 1.016 0 .562-.476 1.017-1.064 1.017H5.322c-.588 0-1.065-.455-1.065-1.017Zm0 4.066c0-.561.477-1.016 1.065-1.016h8.514c.588 0 1.064.455 1.064 1.016 0 .562-.476 1.017-1.064 1.017H5.322c-.588 0-1.065-.456-1.065-1.017Z",
    fill: "currentColor"
  }))), _symbol348 || (_symbol348 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-cross",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"
  }))), _symbol349 || (_symbol349 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 22 29",
    id: "icon-cv",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19.927,
    height: 27,
    rx: 4,
    stroke: "#C65BE1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12 8.368a1.444 1.444 0 1 0-1.435-.025c-.235.02-.476.073-.704.204-.482.275-1.444.894-1.444 1.444h5.776c0-.55-.963-1.17-1.444-1.444-.171-.098-.45-.151-.748-.179Z",
    fill: "#C65BE1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C65BE1",
    d: "M12.732 6.573h4.951M12.732 9.402h4.951M4.244 19.305H7.78M14.146 22.841h3.537M4.244 13.646h13.439M4.244 16.476h13.439M9.195 19.305h8.488M4.244 22.841h8.488"
  }))), _symbol350 || (_symbol350 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-delete",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }))), _symbol351 || (_symbol351 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 21",
    fill: "none",
    id: "icon-documents",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.286.448c1.084 0 1.99.777 2.12 1.856l.009.177v13.214c0 1.035-.813 1.901-1.943 2.025l-.186.009h-3.193v2.032c0 .716-.747 1.195-1.427.956l-.113-.046-1.653-.79-1.652.79c-.67.32-1.453-.104-1.534-.793l-.007-.117V17.73H2.13c-1.027 0-1.895-.697-2.093-1.689l-.027-.167L0 15.695V2.481C0 1.446.813.581 1.943.457L2.13.448h19.157Zm-5.321 15.645-.249.047a4.99 4.99 0 0 1-.534.057h-.048a4.532 4.532 0 0 1-.234.007l-.212-.005h-.007c-.299-.011-.58-.047-.845-.104v2.02l.588-.28c.3-.142.653-.142.952 0l.589.282v-2.024ZM2.19 2.48l-.061.001-.002 13.156.002.058h9.578v-.869a3.948 3.948 0 0 1-1.064-2.688c0-2.246 1.906-4.066 4.257-4.066s4.258 1.82 4.258 4.066c0 1.03-.402 1.972-1.064 2.688v.87l3.13.001.062-.002.002-13.155-.003-.059L2.19 2.48Zm12.71 7.625c-1.175 0-2.128.91-2.128 2.033 0 1.123.953 2.033 2.128 2.033l-.082-.003.082.003.084-.001a2.176 2.176 0 0 0 1.354-.535l-.007.008c.429-.372.698-.908.698-1.505 0-1.123-.953-2.033-2.129-2.033ZM7.45 11.63c.588 0 1.064.455 1.064 1.016 0 .521-.41.951-.94 1.01l-.124.006H5.322c-.588 0-1.065-.455-1.065-1.016 0-.521.411-.95.94-1.01l.125-.006H7.45Zm1.064-3.558c.588 0 1.065.455 1.065 1.016 0 .522-.411.951-.94 1.01l-.125.007H5.322c-.588 0-1.065-.455-1.065-1.017 0-.52.411-.95.94-1.01l.125-.006h3.192Zm9.58-3.558c.587 0 1.064.455 1.064 1.017 0 .521-.411.95-.94 1.01l-.125.006H5.322c-.588 0-1.065-.455-1.065-1.016 0-.522.411-.951.94-1.01l.125-.007h12.771Z",
    fill: "currentColor"
  }))), _symbol352 || (_symbol352 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 19 22",
    id: "icon-documentsV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0H2C.9 0 0 .9 0 2v13c0 .55.45 1 1 1s1-.45 1-1V3c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm4 4H6c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2ZM7 20h9c.55 0 1-.45 1-1V7c0-.55-.45-1-1-1H7c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1Z"
  }))), _symbol353 || (_symbol353 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 23 13",
    id: "icon-doubleCheck",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.712.291-9.88 9.88-3.48-3.47a.996.996 0 1 0-1.41 1.41l4.18 4.18c.39.39 1.02.39 1.41 0l10.59-10.58a.996.996 0 0 0 0-1.41h-.01a.975.975 0 0 0-1.4-.01Zm-4.24.01a.996.996 0 0 0-1.41 0l-5.64 5.64 1.41 1.41 5.64-5.65c.38-.38.38-1.02 0-1.4Zm-12 12-4.18-4.18c-.39-.39-.39-1.03 0-1.42a.996.996 0 0 1 1.41 0l4.88 4.9-.7.7a.996.996 0 0 1-1.41 0Z"
  }))), _symbol354 || (_symbol354 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-download",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M416 199.5h-91.4V64H187.4v135.5H96l160 158.1 160-158.1zM96 402.8V448h320v-45.2H96z"
  }))), _symbol355 || (_symbol355 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-email",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M67 148.7c11 5.8 163.8 89.1 169.5 92.1 5.7 3 11.5 4.4 20.5 4.4s14.8-1.4 20.5-4.4c5.7-3 158.5-86.3 169.5-92.1 4.1-2.1 11-5.9 12.5-10.2 2.6-7.6-.2-10.5-11.3-10.5H65.8c-11.1 0-13.9 3-11.3 10.5 1.5 4.4 8.4 8.1 12.5 10.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M455.7 153.2c-8.2 4.2-81.8 56.6-130.5 88.1l82.2 92.5c2 2 2.9 4.4 1.8 5.6-1.2 1.1-3.8.5-5.9-1.4l-98.6-83.2c-14.9 9.6-25.4 16.2-27.2 17.2-7.7 3.9-13.1 4.4-20.5 4.4s-12.8-.5-20.5-4.4c-1.9-1-12.3-7.6-27.2-17.2L110.7 338c-2 2-4.7 2.6-5.9 1.4-1.2-1.1-.3-3.6 1.7-5.6l82.1-92.5c-48.7-31.5-123.1-83.9-131.3-88.1-8.8-4.5-9.3.8-9.3 4.9v205c0 9.3 13.7 20.9 23.5 20.9h371c9.8 0 21.5-11.7 21.5-20.9v-205c0-4.2.6-9.4-8.3-4.9Z"
  }))), _symbol356 || (_symbol356 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 18 20",
    id: "icon-event"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 2h1c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h1V1c0-.55.45-1 1-1s1 .45 1 1v1h8V1c0-.55.45-1 1-1s1 .45 1 1v1ZM5 9h8c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1Zm10 9H3c-.55 0-1-.45-1-1V7h14v10c0 .55-.45 1-1 1ZM5 13h5c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1Z"
  }))), _symbol357 || (_symbol357 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 18 20",
    id: "icon-eventValid",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2h-1V1c0-.55-.45-1-1-1s-1 .45-1 1v1H5V1c0-.55-.45-1-1-1S3 .45 3 1v1H2C.89 2 .01 2.9.01 4L0 18a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-3 7.53a.754.754 0 0 0-1.06 0l-4.35 4.35L6 12.29a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.94 1.94c.39.39 1.02.39 1.41 0l4.7-4.7c.3-.29.3-.77.01-1.06ZM3 18h12c.55 0 1-.45 1-1V7H2v10c0 .55.45 1 1 1Z"
  }))), _symbol358 || (_symbol358 = /*#__PURE__*/React.createElement("symbol", {
    className: "ihsvg-inline--fa ihfa-external-link-alt ihfa-w-18",
    viewBox: "0 0 576 512",
    id: "icon-external-link",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z"
  }))), _symbol359 || (_symbol359 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-eye",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-failure",
    viewBox: "0 0 289 289.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", {
    id: "ijdefs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "ijstyle2"
  }, ".ijcls-1{fill:#f7931e}.ijcls-4{fill:#3f2f28}.ijcls-5{fill:#e2cfbc}.ijcls-6{fill:#fff}.ijcls-7{fill:#534741}"))), /*#__PURE__*/React.createElement("g", {
    id: "ijLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ijLayer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ijcls-1",
    d: "M127.396 235.29a3 3 0 0 0-3.45 2.47l-5.16 31.24c-6.87.75-12.63 6.17-13.51 11.48a3.002 3.002 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.7 10.33a3 3 0 0 0 2.47 3.45 3.29 3.29 0 0 0 1 0 3 3 0 0 0 2.46-2.47l1.81-11a9.37 9.37 0 0 1 3.7 3 6.85 6.85 0 0 1 1.54 4.93 3.002 3.002 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.22 15.22 0 0 0-7.52-5.4l5.1-30.86a3 3 0 0 0-2.48-3.51Z",
    id: "ijpath8",
    style: {
      fill: "#f7931e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-1",
    d: "M154.056 235.29a3 3 0 0 1 3.45 2.47l5.16 31.24c6.87.75 12.63 6.17 13.51 11.48a3.002 3.002 0 1 1-5.92 1c-.37-2.25-3.07-5.14-6.55-6.17l1.7 10.33a3 3 0 0 1-2.47 3.45 3.29 3.29 0 0 1-1 0 3 3 0 0 1-2.46-2.47l-1.81-11a9.37 9.37 0 0 0-3.7 3 6.85 6.85 0 0 0-1.54 4.93 3 3 0 0 1-2.46 3.45 3.05 3.05 0 0 1-1 0 3 3 0 0 1-2.45-2.47 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.49Z",
    id: "ijpath10",
    style: {
      fill: "#f7931e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.006 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61-21.24 11.45-42.87 15.41-62.16 15.67-35.68.47-63.27-11.71-65-12.5-1.73-.79-30-22-33-19.48-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42c0 3.87.08 7.78.12 11.74.82 70 22 126.89 99.72 125.64 83.2-1.35 97.56-57.9 96.74-127.92-.22-15.41-.62-30.18-2.15-43.82Z",
    id: "ijpath12",
    style: {
      fill: "#736357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.206 97.87c-.1-7.13 4.51-9.29 9.35-9.36 4.83-.07 9.59 2 9.69 9.1l-9.18 24.83c-2.75-4.44-9.86-24.57-9.86-24.57Z",
    id: "ijpath14",
    style: {
      fill: "#fbb03b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M288.312 84.342c-3.854-2.97-41.8 4.185-59.912 26.116-18.112 21.932-26.655 46.1-14.405 55.715 40.954 32.147 78.168-78.852 74.317-81.831Z",
    id: "ijpath16",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M87.406 221.18c-4.54 1.75-38.88-15.91-50-42.09-11.12-26.18-12.43-51.78 2-57.51 48.46-19.16 52.54 97.84 48 99.6Z",
    id: "ijpath18",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-5",
    d: "M227.076 78.81a39 39 0 1 1-39-38.64 38.81 38.81 0 0 1 39 38.64Z",
    id: "ijpath20",
    style: {
      fill: "#e2cfbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-6",
    d: "M221.676 80a34.8 34.8 0 1 1-34.81-34.45A34.64 34.64 0 0 1 221.676 80Z",
    id: "ijpath22",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.866 81.68a18 18 0 1 1-18-17.57 17.8 17.8 0 0 1 18 17.57Z",
    id: "ijpath24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-6",
    d: "M189.266 76.74a4.91 4.91 0 1 1-4.9-4.92 4.9 4.9 0 0 1 4.9 4.92Z",
    id: "ijpath26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-5",
    d: "M54.366 78.81a39 39 0 1 0 39-38.64 38.82 38.82 0 0 0-39 38.64Z",
    id: "ijpath28",
    style: {
      fill: "#e2cfbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-6",
    d: "M129.376 80a34.8 34.8 0 1 1-34.8-34.47 34.64 34.64 0 0 1 34.8 34.47Z",
    id: "ijpath30",
    style: {
      fill: "#fff"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.616 81.68a18 18 0 1 0 18-17.57 17.8 17.8 0 0 0-18 17.57Z",
    id: "ijpath32"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-6",
    d: "M111.036 75.93a4.91 4.91 0 1 1-4.9-4.93 4.9 4.9 0 0 1 4.9 4.93Z",
    id: "ijpath34",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-7",
    d: "M84.536 39.8c-21.56 4.52-34.37 25.66-29.85 47.2 0 0 33.53-25.69 77.07-16.38a39.88 39.88 0 0 0-47.22-30.82Z",
    id: "ijpath36",
    style: {
      fill: "#534741"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-7",
    d: "M195.956 40.93a39.88 39.88 0 0 1 30.85 47.22s-34.52-25.68-78.07-16.37a39.88 39.88 0 0 1 47.22-30.85Z",
    id: "ijpath38",
    style: {
      fill: "#534741"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M107.656 176.44h-.68c-3.19 0-6.14-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.6 2.41 3.66 3.75 5.81 3.75 2.15 0 4.22-1.31 5.82-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 21 21 0 0 1-3.2 11.46c-2.03 3.08-4.72 4.85-7.65 5.08Z",
    id: "ijpath40",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M141.336 176.52h-.65c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.42 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.62 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.02 8.78-4.85 16-10.88 16.47Z",
    id: "ijpath42",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M175.076 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.53 1.53 0 0 1 1.51-1.5 1.5 1.5 0 0 1 1.49 1.51c0 7.34 3.86 13.56 8.46 13.57 4.6.01 8.51-6.18 8.53-13.53a1.5 1.5 0 1 1 3 0c-.06 8.98-4.74 16.04-10.85 16.53Z",
    id: "ijpath44",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M123.386 199.19a5.3 5.3 0 0 1-.69 0c-6.44 0-11.47-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.86 13.56 8.46 13.57 4.6.01 8.51-6.18 8.52-13.53a1.52 1.52 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c-.02 8.98-4.73 16.05-10.84 16.53Z",
    id: "ijpath46",
    style: {
      fill: "#3f2f28"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "ijcls-4",
    d: "M159.236 199.28h-.68c-3.19 0-6.14-1.81-8.3-5.1a20.92 20.92 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.66 3.75 5.81 3.75 2.15 0 4.21-1.31 5.82-3.72a17.93 17.93 0 0 0 2.7-9.81 1.51 1.51 0 0 1 1.51-1.49 1.5 1.5 0 0 1 1.49 1.5 21 21 0 0 1-3.2 11.47c-2.02 3.06-4.72 4.83-7.65 5.06Z",
    id: "ijpath48",
    style: {
      fill: "#3f2f28"
    }
  })))), _symbol360 || (_symbol360 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-file",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }))), _symbol361 || (_symbol361 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 19 22",
    id: "icon-fileV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0H2C.9 0 0 .9 0 2v13c0 .55.45 1 1 1s1-.45 1-1V3c0-.55.45-1 1-1h10c.55 0 1-.45 1-1s-.45-1-1-1Zm.59 4.59 4.83 4.83c.37.37.58.88.58 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-14c0-1.1.89-2 1.99-2h6.17c.53 0 1.04.21 1.42.59ZM17.5 11H13c-.55 0-1-.45-1-1V5.5l5.5 5.5Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 77.42 79.97",
    id: "icon-firefox",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivb",
    cx: -7907,
    cy: -8515,
    r: 80.8,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd4f",
    offset: 0.129
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffac31",
    offset: 0.186
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9d17",
    offset: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.283
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff563b",
    offset: 0.403
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3750",
    offset: 0.467
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5156c",
    offset: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eb0878",
    offset: 0.782
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e50080",
    offset: 0.86
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivc",
    cx: -7937,
    cy: -8482,
    r: 80.8,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960e18",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b11927",
    stopOpacity: 0.74,
    offset: 0.351
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#db293d",
    stopOpacity: 0.343,
    offset: 0.435
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5334b",
    stopOpacity: 0.094,
    offset: 0.497
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3750",
    stopOpacity: 0,
    offset: 0.53
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivd",
    cx: -7927,
    cy: -8533,
    r: 58.53,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdc3e",
    offset: 0.252
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9d12",
    offset: 0.506
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.526
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ive",
    cx: -7946,
    cy: -8461,
    r: 38.47,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a8ee6",
    offset: 0.353
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c79f0",
    offset: 0.472
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059ff",
    offset: 0.669
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c139e6",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivf",
    cx: -7936,
    cy: -8492,
    r: 20.4,
    gradientTransform: "matrix(.972 -.235 .275 1.138 10090 7834)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059ff",
    stopOpacity: 0,
    offset: 0.206
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8c4ff3",
    stopOpacity: 0.064,
    offset: 0.278
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7716a8",
    stopOpacity: 0.45,
    offset: 0.747
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6e008b",
    stopOpacity: 0.6,
    offset: 0.975
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivg",
    cx: -7938,
    cy: -8518,
    r: 27.68,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe226",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdb27",
    offset: 0.121
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc82a",
    offset: 0.295
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa930",
    offset: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7e37",
    offset: 0.732
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7139",
    offset: 0.792
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivh",
    cx: -7916,
    cy: -8536,
    r: 118.1,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.113
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5634",
    offset: 0.622
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.716
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.904
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivi",
    cx: -7927,
    cy: -8523,
    r: 86.5,
    gradientTransform: "matrix(.105 .995 -.653 .069 -4685 8470)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe847",
    offset: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc830",
    offset: 0.168
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.304
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b16",
    offset: 0.356
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff672a",
    offset: 0.455
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.737
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivj",
    cx: -7938,
    cy: -8508,
    r: 73.72,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.137
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5634",
    offset: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.655
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.904
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ivk",
    cx: -7919,
    cy: -8504,
    r: 80.69,
    gradientTransform: "translate(7974 8524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe141",
    offset: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf1e",
    offset: 0.509
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.626
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iva",
    x1: 70.79,
    x2: 6.447,
    y1: 12.39,
    y2: 74.47,
    gradientTransform: "translate(-1.3 -.004)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    offset: 0.048
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe847",
    offset: 0.111
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc830",
    offset: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff980e",
    offset: 0.368
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b16",
    offset: 0.401
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff672a",
    offset: 0.462
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3647",
    offset: 0.534
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e31587",
    offset: 0.705
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ivl",
    x1: 70.01,
    x2: 15.27,
    y1: 12.06,
    y2: 66.81,
    gradientTransform: "translate(-1.3 -.004)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0.8,
    offset: 0.167
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0.634,
    offset: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0.217,
    offset: 0.489
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff44f",
    stopOpacity: 0,
    offset: 0.6
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.684-4.052-5.1-8.427-7.775-9.81a40.27 40.27 0 0 1 3.925 11.76l.007.065c-4.382-10.92-11.81-15.33-17.88-24.92a47.099 47.099 0 0 1-.913-1.484 12.24 12.24 0 0 1-.427-.8 7.053 7.053 0 0 1-.578-1.535.1.1 0 0 0-.088-.1.138.138 0 0 0-.073 0c-.005 0-.013.009-.019.011s-.019.011-.028.015l.015-.026c-9.735 5.7-13.04 16.25-13.34 21.53a19.39 19.39 0 0 0-10.67 4.111 11.59 11.59 0 0 0-1-.758 17.97 17.97 0 0 1-.109-9.473 28.7 28.7 0 0 0-9.329 7.21h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 0 0-1.294.687 28.22 28.22 0 0 0-3.788 3.245 33.84 33.84 0 0 0-3.623 4.347v.006-.007a32.73 32.73 0 0 0-5.2 11.74l-.052.256a61.89 61.89 0 0 0-.381 2.42c0 .029-.006.056-.009.085a36.94 36.94 0 0 0-.629 5.343v.2a38.76 38.76 0 0 0 76.95 6.554c.065-.5.118-.995.176-1.5a39.86 39.86 0 0 0-2.514-19.47zM29.95 57.17c.181.087.351.181.537.264l.027.017q-.282-.135-.564-.281zm40.828-28.314v-.037l.007.041z",
    style: {
      fill: "url(#iva)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.684-4.052-5.1-8.427-7.775-9.81a40.27 40.27 0 0 1 3.925 11.76v.037l.007.041a35.1 35.1 0 0 1-1.206 26.16c-4.442 9.531-15.19 19.3-32.02 18.82-18.18-.515-34.2-14.01-37.19-31.68-.545-2.787 0-4.2.274-6.465a28.88 28.88 0 0 0-.623 5.348v.2a38.76 38.76 0 0 0 76.95 6.554c.065-.5.118-.995.176-1.5a39.86 39.86 0 0 0-2.514-19.47z",
    style: {
      fill: "url(#ivb)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.684-4.052-5.1-8.427-7.775-9.81a40.27 40.27 0 0 1 3.925 11.76v.037l.007.041a35.1 35.1 0 0 1-1.206 26.16c-4.442 9.531-15.19 19.3-32.02 18.82-18.18-.515-34.2-14.01-37.19-31.68-.545-2.787 0-4.2.274-6.465a28.88 28.88 0 0 0-.623 5.348v.2a38.76 38.76 0 0 0 76.95 6.554c.065-.5.118-.995.176-1.5a39.86 39.86 0 0 0-2.514-19.47z",
    style: {
      fill: "url(#ivc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.78 31.38c.084.059.162.118.241.177a21.1 21.1 0 0 0-3.6-4.695C40.371 14.812 49.264.742 50.763.022L50.778 0c-9.735 5.7-13.04 16.25-13.34 21.53.452-.031.9-.069 1.362-.069a19.56 19.56 0 0 1 16.98 9.917z",
    style: {
      fill: "url(#ivd)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82 33.79c-.064.964-3.47 4.289-4.661 4.289-11.02 0-12.81 6.667-12.81 6.667.488 5.614 4.4 10.24 9.129 12.68.216.112.435.213.654.312q.569.252 1.138.466a17.24 17.24 0 0 0 5.043.973c19.32.906 23.06-23.1 9.119-30.07a13.38 13.38 0 0 1 9.345 2.269 19.56 19.56 0 0 0-16.98-9.917c-.46 0-.91.038-1.362.069a19.39 19.39 0 0 0-10.67 4.111c.591.5 1.258 1.168 2.663 2.553 2.63 2.591 9.375 5.275 9.39 5.59z",
    style: {
      fill: "url(#ive)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.82 33.79c-.064.964-3.47 4.289-4.661 4.289-11.02 0-12.81 6.667-12.81 6.667.488 5.614 4.4 10.24 9.129 12.68.216.112.435.213.654.312q.569.252 1.138.466a17.24 17.24 0 0 0 5.043.973c19.32.906 23.06-23.1 9.119-30.07a13.38 13.38 0 0 1 9.345 2.269 19.56 19.56 0 0 0-16.98-9.917c-.46 0-.91.038-1.362.069a19.39 19.39 0 0 0-10.67 4.111c.591.5 1.258 1.168 2.663 2.553 2.63 2.591 9.375 5.275 9.39 5.59z",
    style: {
      fill: "url(#ivf)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.96 24.36c.314.2.573.374.8.531a17.97 17.97 0 0 1-.109-9.473 28.7 28.7 0 0 0-9.329 7.21c.189-.005 5.811-.106 8.638 1.732z",
    style: {
      fill: "url(#ivg)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.354 42.16c2.991 17.67 19.01 31.17 37.19 31.68 16.83.476 27.58-9.294 32.02-18.82a35.1 35.1 0 0 0 1.206-26.16v-.037c0-.029-.006-.046 0-.037l.007.065c1.375 8.977-3.191 17.67-10.33 23.56l-.022.05c-13.91 11.33-27.22 6.834-29.91 5q-.282-.135-.564-.281c-8.109-3.876-11.46-11.26-10.74-17.6a9.953 9.953 0 0 1-9.181-5.775 14.62 14.62 0 0 1 14.25-.572 19.3 19.3 0 0 0 14.55.572c-.015-.315-6.76-3-9.39-5.59-1.405-1.385-2.072-2.052-2.663-2.553a11.59 11.59 0 0 0-1-.758c-.23-.157-.489-.327-.8-.531-2.827-1.838-8.449-1.737-8.635-1.732h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 0 0-1.294.687 28.22 28.22 0 0 0-3.788 3.245 33.84 33.84 0 0 0-3.638 4.337v.006-.007a32.73 32.73 0 0 0-5.2 11.74c-.019.079-1.396 6.099-.717 9.221z",
    style: {
      fill: "url(#ivh)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.42 26.86a21.1 21.1 0 0 1 3.6 4.7c.213.161.412.321.581.476 8.787 8.1 4.183 19.55 3.84 20.36 7.138-5.881 11.7-14.58 10.33-23.56-4.384-10.93-11.82-15.34-17.88-24.93a47.099 47.099 0 0 1-.913-1.484 12.24 12.24 0 0 1-.427-.8 7.053 7.053 0 0 1-.578-1.535.1.1 0 0 0-.088-.1.138.138 0 0 0-.073 0c-.005 0-.013.009-.019.011s-.019.011-.028.015c-1.499.711-10.39 14.79 1.66 26.83z",
    style: {
      fill: "url(#ivi)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6 32.04a8.083 8.083 0 0 0-.581-.476c-.079-.059-.157-.118-.241-.177a13.38 13.38 0 0 0-9.345-2.269c13.94 6.97 10.2 30.97-9.119 30.07a17.24 17.24 0 0 1-5.043-.973q-.569-.213-1.138-.466c-.219-.1-.438-.2-.654-.312l.027.017c2.694 1.839 16 6.332 29.91-5l.022-.05c.347-.81 4.951-12.26-3.84-20.36z",
    style: {
      fill: "url(#ivj)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.35 44.74s1.789-6.667 12.81-6.667c1.191 0 4.6-3.325 4.661-4.289a19.3 19.3 0 0 1-14.55-.572 14.62 14.62 0 0 0-14.25.572 9.953 9.953 0 0 0 9.181 5.775c-.718 6.337 2.632 13.72 10.74 17.6.181.087.351.181.537.264-4.733-2.445-8.641-7.069-9.129-12.68z",
    style: {
      fill: "url(#ivk)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.62 26.83c-1.684-4.052-5.1-8.427-7.775-9.81a40.27 40.27 0 0 1 3.925 11.76l.007.065c-4.382-10.92-11.81-15.33-17.88-24.92a47.099 47.099 0 0 1-.913-1.484 12.24 12.24 0 0 1-.427-.8 7.053 7.053 0 0 1-.578-1.535.1.1 0 0 0-.088-.1.138.138 0 0 0-.073 0c-.005 0-.013.009-.019.011s-.019.011-.028.015l.015-.026c-9.735 5.7-13.04 16.25-13.34 21.53.452-.031.9-.069 1.362-.069a19.56 19.56 0 0 1 16.98 9.917 13.38 13.38 0 0 0-9.345-2.269c13.94 6.97 10.2 30.97-9.119 30.07a17.24 17.24 0 0 1-5.043-.973q-.569-.213-1.138-.466c-.219-.1-.438-.2-.654-.312l.027.017q-.282-.135-.564-.281c.181.087.351.181.537.264-4.733-2.446-8.641-7.07-9.129-12.68 0 0 1.789-6.667 12.81-6.667 1.191 0 4.6-3.325 4.661-4.289-.015-.315-6.76-3-9.39-5.59-1.405-1.385-2.072-2.052-2.663-2.553a11.59 11.59 0 0 0-1-.758 17.97 17.97 0 0 1-.109-9.473 28.7 28.7 0 0 0-9.329 7.21h-.018c-1.536-1.947-1.428-8.367-1.34-9.708a6.928 6.928 0 0 0-1.294.687A28.22 28.22 0 0 0 9.9 16.858a33.84 33.84 0 0 0-3.623 4.347v.006-.007a32.73 32.73 0 0 0-5.2 11.74l-.052.256c-.073.341-.4 2.073-.447 2.445a45.09 45.09 0 0 0-.572 5.403v.2a38.76 38.76 0 0 0 76.95 6.554c.065-.5.118-.995.176-1.5a39.86 39.86 0 0 0-2.514-19.47zm-3.845 1.991.007.041z",
    style: {
      fill: "url(#ivl)"
    }
  })), _symbol362 || (_symbol362 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-folder",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M430.1 192H81.9c-17.7 0-18.6 9.2-17.6 20.5l13 183c.9 11.2 3.5 20.5 21.1 20.5h316.2c18 0 20.1-9.2 21.1-20.5l12.1-185.3c.9-11.2 0-18.2-17.7-18.2zM426.2 143.3c-.5-12.4-4.5-15.3-15.1-15.3H267.9c-21.8 0-24.4.3-40.9-17.4-13.7-14.8-8.3-14.6-36.6-14.6h-75.3c-17.4 0-23.6-1.5-25.2 16.6-1.5 16.7-5 57.2-5.5 63.4h343.4l-1.6-32.7z"
  }))), _symbol363 || (_symbol363 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 19 17",
    id: "icon-home",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.198 15.655v-5h4v5c0 .55.45 1 1 1h3c.55 0 1-.45 1-1v-7h1.7c.46 0 .68-.57.33-.87L9.868.255c-.38-.34-.96-.34-1.34 0l-8.36 7.53c-.34.3-.13.87.33.87h1.7v7c0 .55.45 1 1 1h3c.55 0 1-.45 1-1Z"
  }))), _symbol364 || (_symbol364 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-ids",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.066 1.323C4.646.82 6.76.526 9.046.526c2.288 0 4.402.294 5.982.797.784.25 1.495.57 2.032.974.526.395 1.033.991 1.033 1.787v3.642c3.02.484 5.322 2.993 5.322 6.015 0 3.368-2.86 6.099-6.386 6.099-.978 0-1.906-.211-2.737-.588-1.471.374-3.294.588-5.245.588-2.287 0-4.402-.294-5.981-.797-.785-.25-1.496-.57-2.033-.974C.508 17.674 0 17.078 0 16.282V4.084c0-.796.508-1.392 1.033-1.787.537-.405 1.248-.725 2.033-.974Zm9.023 16.282a6.015 6.015 0 0 1-1.108-1.903c-.623.047-1.27.072-1.934.072-2.287 0-4.402-.294-5.981-.797a9.437 9.437 0 0 1-.937-.35v1.627c.015.028.066.102.221.219.271.203.729.431 1.389.641 1.31.417 3.186.693 5.308.693 1.092 0 2.121-.073 3.042-.202Zm-1.446-3.918a5.843 5.843 0 0 1 .393-2.055c-.64.05-1.306.076-1.99.076-2.286 0-4.4-.294-5.98-.797a9.437 9.437 0 0 1-.937-.35v1.627c.015.028.066.102.221.219.271.203.729.431 1.389.642 1.31.416 3.186.692 5.308.692.549 0 1.083-.019 1.596-.054Zm1.894-4.282a6.481 6.481 0 0 1 3.428-1.679V6.495c-.295.13-.61.246-.937.35-1.58.503-3.694.797-5.981.797s-4.402-.294-5.981-.797a9.44 9.44 0 0 1-.937-.35v1.627c.015.028.066.102.221.219.271.203.729.431 1.389.642 1.31.416 3.186.692 5.308.692 1.269 0 2.457-.099 3.49-.27Zm7.64 2.6a.984.984 0 0 1 0 1.438l-2.928 2.795a1.1 1.1 0 0 1-1.505 0l-1.596-1.524a.984.984 0 0 1 0-1.438 1.1 1.1 0 0 1 1.505 0l.844.806 2.174-2.077a1.1 1.1 0 0 1 1.505 0Z",
    fill: "currentColor"
  }))), _symbol365 || (_symbol365 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
    fill: "currentColor"
  }))), _symbol366 || (_symbol366 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    fill: "none",
    id: "icon-info-agenda",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.999 11.84C23.908 5.212 18.465-.086 11.839 0 5.213.087-.085 5.534.001 12.161c.091 6.626 5.533 11.924 12.16 11.838 6.626-.091 11.929-5.534 11.838-12.16Zm-12-7.559c.95 0 1.715.766 1.715 1.714S12.948 7.71 12 7.71a1.712 1.712 0 0 1-1.714-1.714c0-.948.766-1.714 1.714-1.714Zm2.358 15.165H9.643v-.59h1.178v-8.57H9.643v-.643h3.535v9.214h1.179v.589Z",
    fill: "currentColor"
  }))), _symbol367 || (_symbol367 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 20 22",
    id: "icon-info-badge",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H0V2ZM0 22v-7h6l-6 7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7H9v5h2V7ZM11 3H9v2h2V3Z",
    fill: "#fff"
  }))), _symbol368 || (_symbol368 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 23 21",
    fill: "none",
    id: "icon-infos",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.918 4.629c0-2.526 2.144-4.574 4.79-4.574 2.644 0 4.789 2.048 4.789 4.574s-2.145 4.574-4.79 4.574-4.789-2.048-4.789-4.574Zm4.79-2.541c-1.47 0-2.661 1.137-2.661 2.54 0 1.404 1.19 2.542 2.66 2.542 1.47 0 2.661-1.138 2.661-2.541 0-1.404-1.191-2.541-2.66-2.541ZM10.642 12.76c-4.824 0-8.514 3.295-8.514 7.115 0 .561-.477 1.017-1.065 1.017-.587 0-1.064-.456-1.064-1.017 0-5.162 4.886-9.148 10.643-9.148.588 0 1.064.455 1.064 1.016 0 .562-.476 1.017-1.064 1.017Zm5.726-2.541a.473.473 0 0 0-.483.462v.737c-.326.088-.635.21-.923.365l-.546-.521a.5.5 0 0 0-.684 0l-.933.89a.447.447 0 0 0 0 .654l.546.522c-.162.275-.291.57-.382.88h-.773a.473.473 0 0 0-.484.463v1.26c0 .255.217.462.484.462h.773c.091.31.22.606.382.88l-.546.523a.447.447 0 0 0 0 .653l.932.891a.5.5 0 0 0 .685 0l.546-.522c.288.155.597.278.923.366v.737c0 .255.216.462.483.462h1.32a.473.473 0 0 0 .483-.462v-.738c.325-.087.635-.21.923-.365l.546.522a.5.5 0 0 0 .684 0l.933-.89a.447.447 0 0 0 0-.654l-.546-.522c.162-.275.29-.57.382-.881h.773a.473.473 0 0 0 .483-.462v-1.26a.473.473 0 0 0-.483-.462h-.773a3.914 3.914 0 0 0-.382-.881l.546-.522a.447.447 0 0 0 0-.653l-.933-.891a.5.5 0 0 0-.684 0l-.546.521a4.311 4.311 0 0 0-.923-.365v-.737a.473.473 0 0 0-.483-.463h-1.32Zm.484 1.567v-.643h.352v.643c0 .224.168.416.399.455.47.08.906.257 1.284.508a.5.5 0 0 0 .619-.052l.476-.455.25.237-.477.456a.446.446 0 0 0-.055.59c.263.361.448.777.532 1.227.041.22.242.38.476.38h.674v.337h-.674a.478.478 0 0 0-.476.381c-.084.45-.269.866-.532 1.226a.447.447 0 0 0 .055.591l.476.456-.249.237-.476-.455a.501.501 0 0 0-.62-.052 3.317 3.317 0 0 1-1.283.508.469.469 0 0 0-.4.455v.643h-.351v-.643a.469.469 0 0 0-.399-.455 3.318 3.318 0 0 1-1.284-.508.501.501 0 0 0-.619.052l-.476.455-.25-.238.477-.455a.447.447 0 0 0 .055-.59 3.015 3.015 0 0 1-.532-1.227.478.478 0 0 0-.476-.381h-.674v-.336h.674c.234 0 .435-.16.476-.381.084-.45.269-.866.532-1.226a.446.446 0 0 0-.055-.591l-.476-.456.249-.237.476.455a.5.5 0 0 0 .619.052 3.32 3.32 0 0 1 1.284-.508c.23-.04.399-.231.399-.455Zm.176 1.898c-.935 0-1.693.724-1.693 1.617s.758 1.617 1.693 1.617 1.693-.724 1.693-1.617-.758-1.617-1.693-1.617Zm-.726 1.617c0-.383.325-.693.726-.693.4 0 .726.31.726.693 0 .383-.325.693-.726.693-.4 0-.726-.31-.726-.693Z",
    fill: "currentColor"
  }))), _symbol369 || (_symbol369 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 27 25",
    id: "icon-japprends",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5D6D7E",
    d: "M6.335 24.044.457 21.898 8.075.788l5.877 2.145-7.617 21.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.134 20.212a1.637 1.637 0 0 1-2.099.987 1.65 1.65 0 0 1-.98-2.11 1.635 1.635 0 0 1 2.098-.986 1.65 1.65 0 0 1 .98 2.11",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.853 20.11a1.338 1.338 0 0 1-1.716.807 1.35 1.35 0 0 1-.803-1.726 1.338 1.338 0 0 1 1.717-.807 1.35 1.35 0 0 1 .802 1.726",
    fill: "#283A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.853 16.764a.297.297 0 0 1-.38.179l-3.36-1.226a.3.3 0 0 1-.179-.383L8.471 2.76a.298.298 0 0 1 .382-.18l3.358 1.227a.301.301 0 0 1 .178.383L7.853 16.764",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M10.455 8.016 7.516 6.943l.071-.196 2.939 1.072-.071.197M10.028 9.197 7.09 8.125l.072-.196L10.099 9l-.07.196M9.602 10.38l-2.94-1.072.072-.197 2.939 1.072-.071.197M9.176 11.562l-2.94-1.072.071-.197 2.94 1.073-.071.196M8.75 12.744l-2.94-1.072.07-.197 2.94 1.072-.07.197M8.323 13.927l-2.94-1.073.071-.196 2.94 1.072-.071.197M10.906 6.768l-2.94-1.073.83-2.299 2.94 1.073-.83 2.299M7.528 16.127l-2.94-1.072.416-1.15 2.94 1.073-.416 1.15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD160",
    d: "M13.952 1.586h6.254v22.458h-6.254z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.717 20.511c0 .91-.733 1.647-1.638 1.647a1.643 1.643 0 0 1-1.638-1.647c0-.91.734-1.647 1.638-1.647.905 0 1.638.738 1.638 1.647",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.42 20.511c0 .744-.6 1.348-1.341 1.348-.74 0-1.34-.604-1.34-1.348 0-.744.6-1.347 1.34-1.347.74 0 1.34.603 1.34 1.347",
    fill: "#283A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.164 16.68a.3.3 0 0 1-.299.3h-3.572a.3.3 0 0 1-.298-.3V3.303a.3.3 0 0 1 .298-.3h3.572a.3.3 0 0 1 .299.3V16.68",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M15.516 3.79h3.126v2.446h-3.126zM15.516 14.97h3.126v1.222h-3.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4BD6C0",
    d: "M20.206 1.586h6.234v22.458h-6.234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.97 20.511c0 .91-.733 1.647-1.637 1.647a1.643 1.643 0 0 1-1.638-1.647c0-.91.734-1.647 1.638-1.647.904 0 1.637.738 1.637 1.647",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.673 20.511c0 .744-.6 1.348-1.34 1.348-.74 0-1.34-.604-1.34-1.348 0-.744.6-1.347 1.34-1.347.74 0 1.34.603 1.34 1.347",
    fill: "#283A4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.417 16.68a.3.3 0 0 1-.298.3h-3.573a.3.3 0 0 1-.297-.3V3.303a.3.3 0 0 1 .297-.3h3.573a.3.3 0 0 1 .298.3V16.68",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6EAEE",
    d: "M21.77 3.79h3.126v2.446H21.77zM21.77 14.97h3.126v1.222H21.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.079 22.158a1.643 1.643 0 0 1-1.638-1.647c0-.91.734-1.647 1.638-1.647.905 0 1.638.738 1.638 1.647 0 .91-.733 1.647-1.638 1.647M13.952 2.933v21.11h6.254V9.222l-1.042-1.048v8.506a.3.3 0 0 1-.299.3h-3.572a.3.3 0 0 1-.298-.3V3.981l-1.043-1.048",
    fill: "#EBC45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.079 21.859c-.74 0-1.34-.604-1.34-1.348 0-.744.6-1.347 1.34-1.347.74 0 1.34.603 1.34 1.347s-.6 1.348-1.34 1.348m0-2.995c-.904 0-1.638.738-1.638 1.647 0 .91.734 1.647 1.638 1.647.905 0 1.638-.737 1.638-1.647s-.733-1.647-1.638-1.647",
    fill: "#EBEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.079 19.164c-.74 0-1.34.603-1.34 1.347s.6 1.348 1.34 1.348c.74 0 1.34-.604 1.34-1.348 0-.744-.6-1.347-1.34-1.347",
    fill: "#25364A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.516 14.97h3.126v1.222h-3.126V14.97Zm0-1.328h3.126v.21h-3.126v-.21Zm0-1.257h3.126v.209h-3.126v-.21Zm0-1.258h3.126v.209h-3.126v-.21Zm0-1.258h3.126v.21h-3.126v-.21Zm0-1.257h3.126v.21h-3.126v-.21Zm-.521-4.63v12.697a.3.3 0 0 0 .298.3h3.572a.3.3 0 0 0 .299-.3V8.173l-.606-.61h-3.042v-.208h2.834l-1.113-1.119h-1.721V4.505l-.521-.524Z",
    fill: "#EBEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBE5",
    d: "M15.516 4.505v1.731h1.721l-1.721-1.731M15.516 14.97h3.126v1.222h-3.126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 22.158a1.643 1.643 0 0 1-1.638-1.647c0-.91.734-1.647 1.638-1.647.904 0 1.637.738 1.637 1.647 0 .91-.733 1.647-1.637 1.647M20.206 9.221v14.823h6.253V15.51l-1.042-1.048v2.217a.3.3 0 0 1-.298.3h-3.573a.3.3 0 0 1-.297-.3v-6.41l-1.043-1.048",
    fill: "#45C9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 21.859c-.74 0-1.34-.604-1.34-1.348 0-.744.6-1.347 1.34-1.347.74 0 1.34.603 1.34 1.347s-.6 1.348-1.34 1.348m0-2.995c-.904 0-1.638.738-1.638 1.647 0 .91.734 1.647 1.638 1.647.904 0 1.637-.737 1.637-1.647s-.733-1.647-1.637-1.647",
    fill: "#EBEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 19.164c-.74 0-1.34.603-1.34 1.347s.6 1.348 1.34 1.348c.74 0 1.34-.604 1.34-1.348 0-.744-.6-1.347-1.34-1.347",
    fill: "#25364A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.77 14.97h3.126v1.222H21.77V14.97Zm-.521-4.7v6.41a.3.3 0 0 0 .297.3h3.573a.3.3 0 0 0 .298-.3v-2.218l-.606-.61h-3.042v-.21h2.833l-1.042-1.048h-1.79v-.21h1.582l-1.043-1.048h-.54v-.21h.332l-.852-.856Z",
    fill: "#EBEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4DBE5",
    d: "M21.77 14.97h3.126v1.222H21.77z"
  })))), _symbol370 || (_symbol370 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 29",
    id: "icon-jemevalue",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.058 5.536v16.86c0 1.393-1.1 2.52-2.463 2.52H4.262V5.536h24.796",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.193 21.969c0 .529-.197 1.058-.591 1.461a1.99 1.99 0 0 1-1.428.605H5.126V6.416h23.067V21.97",
    fill: "#CDD3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.697 23.298h.401v.058h-.4v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.804 0h.403v.058h-.403v-.058Zm-.802 0h.402v.058h-.402v-.058Zm-.804 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.802 0h.402v.058h-.402v-.058Zm-.804 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.401v.058h-.4v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.401v.058h-.401v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.803 0h.402v.058h-.402v-.058Zm-.804 0h.402v.058h-.402v-.058Zm-.802 0h.401v.058h-.401v-.058Zm-.803 0h.401v.058h-.401v-.058Zm-.804 0h.402v.058h-.402v-.058Zm-.802 0h.4v.058h-.4v-.058Zm-.804 0h.402v.058H8.03v-.058Zm-.803 0h.401v.058h-.4v-.058Zm-.802 0h.401v.058h-.401v-.058Zm20.08.018-.014-.059a1.24 1.24 0 0 0 .36-.154l.03.05a1.315 1.315 0 0 1-.376.163Zm.69-.432-.044-.039c.087-.102.159-.214.211-.337l.053.024a1.38 1.38 0 0 1-.22.352Zm.327-.755-.057-.007a1.45 1.45 0 0 0 .009-.153v-.255h.057v.255c0 .053-.003.107-.01.16Zm-.048-1.236h.057v.411h-.057v-.411Zm0-.822h.057v.411h-.057v-.411Zm0-.822h.057v.41h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.411Zm0-.822h.057v.41h-.057v-.41Zm0-.821h.057v.41h-.057v-.41Zm0-.823h.057v.411h-.057v-.41Zm0-.821h.057v.41h-.057v-.41Zm0-.823h.057v.412h-.057v-.412Zm0-.821h.057v.41h-.057v-.41Zm0-.822h.057v.41h-.057v-.41Zm0-.823h.057v.412h-.057v-.412Zm0-.821h.057v.411h-.057v-.411Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.058 5.536h-6.59v.88h5.725V21.97c0 .529-.197 1.058-.591 1.461a1.99 1.99 0 0 1-1.428.605h-3.707v.88h4.128c1.362 0 2.463-1.126 2.463-2.52V5.537",
    fill: "#CDD3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.485 23.298h.402v.058h-.402v-.058Zm.802 0h.403v.058h-.403v-.058Zm.804 0h.402v.058h-.402v-.058Zm.803 0h.402v.058h-.402v-.058Zm.803 0h.401v.058h-.4v-.058Zm.807.018-.014-.059a1.24 1.24 0 0 0 .36-.154l.03.05a1.315 1.315 0 0 1-.376.163Zm.69-.432-.044-.039c.087-.102.159-.214.211-.337l.053.024a1.38 1.38 0 0 1-.22.352Zm.327-.755-.057-.007a1.45 1.45 0 0 0 .009-.153v-.255h.057v.255c0 .053-.003.107-.01.16Zm-.048-1.236h.057v.411h-.057v-.411Zm0-.822h.057v.411h-.057v-.411Zm0-.822h.057v.41h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.411Zm0-.822h.057v.41h-.057v-.41Zm0-.821h.057v.41h-.057v-.41Zm0-.823h.057v.411h-.057v-.41Zm0-.821h.057v.41h-.057v-.41Zm0-.823h.057v.412h-.057v-.412Zm0-.821h.057v.41h-.057v-.41Zm0-.822h.057v.41h-.057v-.41Zm0-.823h.057v.412h-.057v-.412Zm0-.821h.057v.411h-.057v-.411Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Zm0-.822h.057v.411h-.057v-.41Zm-4.992-.647h.402v.06h-.402v-.06Zm.803 0h.402v.06h-.402v-.06Zm.804 0h.402v.06h-.402v-.06Zm.802 0h.402v.06h-.402v-.06Zm.804 0h.401v.06h-.401v-.06Zm.803 0h.4v.06h-.4v-.06Zm.802.06v-.06h.231v.236h-.057v-.176h-.174Zm.894-.739h-5.726v17.619h3.707a1.99 1.99 0 0 0 1.428-.605c.394-.403.591-.932.591-1.461V6.416Z",
    fill: "#A5AFBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.485 23.356h.402v-.058h-.402v.058Zm.802 0h.403v-.058h-.403v.058Zm.804 0h.402v-.058h-.402v.058Zm.803 0h.402v-.058h-.402v.058Zm.803 0h.401v-.058h-.4v.058Zm1.154-.253a1.24 1.24 0 0 1-.361.154l.014.059c.134-.034.26-.09.376-.162l-.03-.051Zm.51-.595a1.325 1.325 0 0 1-.211.337l.043.04a1.38 1.38 0 0 0 .22-.353l-.052-.024Zm.169-.794h-.057v.255c0 .051-.003.102-.009.153l.057.007c.006-.053.009-.107.009-.16v-.255Zm-.057-.41h.057v-.411h-.057v.411Zm0-.822h.057v-.411h-.057v.411Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.412h-.057v.412Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.41h-.057v.41Zm0-.821h.057v-.411h-.057v.41Zm0-.822h.057v-.412h-.057v.412Zm0-.823h.057v-.41h-.057v.41Zm0-.821h.057v-.411h-.057v.41Zm0-.822h.057v-.411h-.057v.411Zm0-.822h.057v-.412h-.057v.412Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.41h-.057v.41Zm0-.822h.057v-.41h-.057v.41Z",
    fill: "#CDD3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.596.494c1.36 0 2.462 1.128 2.462 2.52v19.384c0-1.392-1.102-2.52-2.462-2.52s-2.462 1.128-2.462 2.52V3.013c0-1.39 1.103-2.519 2.462-2.519",
    fill: "#E6EAEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.429 1.813v19.388A2.458 2.458 0 0 1 26 19.955V.567a2.46 2.46 0 0 0-1.572 1.246Zm2.166-1.32a1.64 1.64 0 0 0-.378.037v19.388c.124-.03.247-.038.378-.038l.087.008V.5l-.087-.008Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34495E",
    d: "M8.246 12.084h6.043v6.184H8.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7059",
    d: "m12.14 14.583 3.333-5.91 3.333 5.91H12.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.432 18.268c0 1.634-1.295 2.958-2.891 2.958s-2.89-1.324-2.89-2.958c0-1.634 1.294-2.958 2.89-2.958s2.89 1.324 2.89 2.958",
    fill: "#FFD160"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6D7E",
    d: "M8.347 26.594h15.179v.734H8.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#283A4D",
    d: "M8.347 27.328h15.179v.734H8.346z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.12 27.328h3.227v-.734l-3.228.734"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD3DA",
    d: "M5.12 27.328h3.227v.734l-3.228-.734M21.283 27.027h.133v.6l-.133.001v-.252h-.218v.252h-.133v-.601h.133v.23h.218v-.23Zm.684.425a.16.16 0 0 1-.06.128c-.043.034-.114.053-.232.054-.065 0-.113-.004-.144-.009v-.59a.937.937 0 0 1 .172-.013c.082 0 .131.008.173.034a.131.131 0 0 1 .072.118c0 .053-.03.103-.097.128v.002c.067.018.117.07.116.148Zm-.304-.187h.044c.07 0 .107-.03.107-.074 0-.046-.034-.07-.094-.07l-.057.004v.14Zm.165.182c0-.06-.053-.085-.12-.085h-.045l.001.169.05.002c.062 0 .114-.023.114-.086Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.526 28.062a.766.766 0 0 0 .529-.733.767.767 0 0 0-.53-.735v1.468",
    fill: "#FF7059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.172 13.194c0 2.912-2.314 5.28-5.159 5.28v2.943c4.437 0 8.034-3.682 8.034-8.223 0-4.54-3.597-8.222-8.034-8.222v2.943c2.845 0 5.159 2.369 5.159 5.28",
    fill: "#FFD160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.047 13.196c0-4.543-3.597-8.223-8.034-8.223v1.212c3.777 0 6.85 3.143 6.85 7.01 0 3.866-3.073 7.011-6.85 7.011v1.211c4.437 0 8.034-3.681 8.034-8.221",
    fill: "#FFC550"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD160",
    d: "M.138 3.673h2.875v19.042H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC550",
    d: "M.138 3.673h1.184v19.042H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5D6D7E",
    d: "m6.652 6.85-.088-.053.423-.749.087.052-.422.75M7.673 7.592l-.078-.066.544-.663.078.066-.544.663M8.552 8.506l-.064-.08.647-.556.066.08-.649.556M9.264 9.561l-.05-.09.732-.432.05.09-.732.432M9.213 16.919l.05-.09.733.433-.05.09-.733-.433M8.488 17.963l.064-.079.648.557-.065.08-.647-.558M7.595 18.864l.077-.066.544.663-.078.066-.543-.663M6.563 19.593l.088-.052.423.75-.088.051-.423-.75"
  })))), _symbol371 || (_symbol371 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 29 26",
    id: "icon-jerevise",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lfa",
    d: "M23.463 2.803V.173H.02v2.63z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lfc",
    d: "M.647 25.267h27.716V.401H.647z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.318 14.527V1.036a.638.638 0 0 0-.64-.635H5.607a.638.638 0 0 0-.64.635v13.491h23.35Z",
    fill: "#30363D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.9 14.38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lfa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.02.173v1.95c0 .376.308.68.686.68h22.072a.683.683 0 0 0 .685-.68V.173H.021Z",
    fill: "#E5E8EC",
    mask: "url(#lfb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.68 20.057s-.17-.083-.365-.156a9.551 9.551 0 0 1-.607-.245c-.257-.123-.28-.204-.376-.624-.106-.458-.205-1.426-.244-1.848h-4.89c-.04.422-.14 1.39-.244 1.848-.097.42-.119.5-.377.624-.147.069-.393.165-.6.242-.198.074-.36.132-.36.132s-.157.086.095.099h7.86c.238.004.108-.072.108-.072",
    fill: "#E5E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.139 17.694c-.022-.201-.04-.382-.052-.51h-4.89c-.012.128-.03.309-.052.51h4.994Z",
    fill: "#CDD5D7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484F59",
    d: "M9.16 14.527h4.86L22.904.401h-4.859zM15.41 14.527h1.773L26.065.401h-1.773z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lfd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lfc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F8FC",
    mask: "url(#lfd)",
    d: "M6.052 13.328h21.18V1.49H6.052z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#lfd)",
    d: "M9.915 13.328h4.86L22.219 1.49h-4.86zM17.937 13.328 25.38 1.49h-1.773l-7.446 11.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DA80",
    mask: "url(#lfd)",
    d: "m2.571 12.628 7.352-4.213 7.352 4.213v8.426l-7.352 4.213-7.352-4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3BD33",
    mask: "url(#lfd)",
    d: "m9.923 8.415 7.352 4.213v8.426l-7.352 4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484F59",
    mask: "url(#lfd)",
    d: "M.647 9.14 8 4.864l1.93 3.551-7.353 4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484F59",
    mask: "url(#lfd)",
    d: "m19.209 9.138-7.352-4.274-1.93 3.551 7.352 4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30363D",
    mask: "url(#lfd)",
    d: "m2.571 12.628 7.352-4.213 7.352 4.213-7.352 4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7BEC0",
    mask: "url(#lfd)",
    d: "M9.558 3.541H7.159v18.922h2.399z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD5D7",
    mask: "url(#lfd)",
    d: "M9.655 3.541H7.257v18.922h2.398z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.738 4.451h-.697V19.97l.001-.001c.021.09.169.16.347.16.18 0 .326-.07.347-.16v.001l.001-.001V4.45Z",
    fill: "#01C6DA",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.031 20.127c-.154-.013-.274-.078-.294-.16v.002-.002c-.022.092-.169.162-.347.162-.18 0-.327-.07-.348-.162v.002-.002c-.02.082-.14.147-.295.16l.643 1.474.641-1.474Z",
    fill: "#E5E8EC",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.031 20.127c-.154-.013-.274-.078-.294-.16v.002-.002c-.022.092-.347 1.634-.347 1.634l.641-1.474Z",
    fill: "#CDD5D7",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CA67",
    mask: "url(#lfd)",
    d: "M11.754 4.451h1.269V3.098h-1.269z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.493 18.749h.696V4.796l-.001-.002v.002c-.022-.091-.169-.161-.348-.162-.178 0-.325.07-.346.162v-.002l-.001.002v13.953Z",
    fill: "#FF876C",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 4.637c.153.012.273.077.293.159v-.002.002c.022-.091.169-.162.347-.162.18 0 .326.07.347.162v-.002l.002.002c.02-.082.14-.147.293-.16l-.642-1.474-.64 1.475Z",
    fill: "#E5E8EC",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 4.637c.153.012.273.077.293.159v-.002.002c.022-.091.347-1.634.347-1.634l-.64 1.475Z",
    fill: "#CDD5D7",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CA67",
    mask: "url(#lfd)",
    d: "M14.207 20.101h1.268v-1.353h-1.268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.571 18.702 5.005 13.52l-.579-2.006.866-.116.574 1.68s.651 3.01.735 3.98c.084.97.118 1.395-.03 1.645",
    fill: "#B7BEC0",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.571 18.702 5.05 13.511l-.579-2.006.866-.116.574 1.68s.652 3.011.735 3.98c.084.97.073 1.403-.075 1.653",
    fill: "#CDD5D8",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.511 18.724-.59-5.231.558-1.875-.872-.212-.6 2.124s.473 2.594.726 3.534c.252.94.555 1.475.778 1.66",
    fill: "#DCE4E7",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.904 6.523c-.262.918-.248 1.772-.093 2.784.05.337.343.585.618.542a18.2 18.2 0 0 1 .123-.019c.274-.045.432-.323.383-.61a6.445 6.445 0 0 1 .076-2.546c.06-.26-.013-.546-.27-.64-.04-.015-.147-.025-.189-.03-.309-.032-.572.255-.648.519m1.609-.3c.03.171-.005.316-.05.492-.197 1.419-.117 3.64-.091 4.245l.063.437a.077.077 0 0 1-.066.087l-.91.13a.078.078 0 0 1-.088-.066l-.035-.246c-.058-.276-.09-.735-.44-1.075-.088-.084-.436-.3-.467-1.119-.083-2.248.226-2.891.275-2.98a.93.93 0 0 1 1.809.095",
    fill: "#FF876C",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.489 8.952c.035.849.388 1.075.476 1.163.356.354.39.83.449 1.117l.038.255a.079.079 0 0 0 .088.07l.893-.127a.079.079 0 0 1-.064.054l-.91.13a.078.078 0 0 1-.088-.066l-.035-.246c-.058-.277-.09-.735-.44-1.075-.088-.084-.436-.3-.467-1.118-.052-1.4.048-2.178.143-2.587-.074.466-.133 1.225-.083 2.43",
    fill: "#E36E54",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.421 13.242a.32.32 0 0 0-.261.37.322.322 0 0 0 .633-.11.321.321 0 0 0-.372-.26",
    fill: "#B7BEC0",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.904 6.523c-.262.918-.248 1.772-.093 2.784.05.337.343.585.618.542a18.2 18.2 0 0 1 .123-.019c.274-.045.432-.323.383-.61a6.445 6.445 0 0 1 .076-2.546c.06-.26-.013-.546-.27-.64-.04-.015-.147-.025-.189-.03-.309-.032-.572.255-.648.519m.771-.934c.05.005.244.075.281.107.246.21.316.47.24.764-.24.905-.272 1.759-.106 2.751.053.322-.141.639-.474.695l-.152.022c-.333.053-.685-.222-.74-.6-.174-1.14-.176-2.105.157-3.145.095-.298.418-.626.794-.594",
    fill: "#E36E54",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99 8.111a.94.94 0 0 0-1.09-.76.936.936 0 0 0-.767 1.081.943.943 0 0 0 1.857-.32M6.784 6.794A1.335 1.335 0 0 1 8.33 7.873c.1.565-.178 1.108-.652 1.378-.742.51-.789 1.174-.789 1.174h-.01l-.292 1.222a.079.079 0 0 1-.095.058l-.894-.211a.078.078 0 0 1-.058-.094l.404-1.681a1.692 1.692 0 0 0-.146-.82c-.108-.223-.35-.411-.402-.505-.051-.095-.03-.697.048-.78.047-.05.309-.299.56-.471.189-.187.498-.3.78-.348",
    fill: "#FF876C",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.476 11.7a.075.075 0 0 0 .031-.044l.307-1.244.01-.001s.05-.678.811-1.193a1.349 1.349 0 0 0 .622-1.604 1.323 1.323 0 0 1-.579 1.637c-.742.51-.789 1.174-.789 1.174h-.01l-.292 1.222a.08.08 0 0 1-.094.058l-.017-.005ZM5.475 7.787c.26-.2.375-.088.332.012-.11.26.043.734.245 1.096.094.168-.008.615-.04.964l-.425 1.629a.077.077 0 0 1-.047-.088l.404-1.681a1.695 1.695 0 0 0-.146-.82c-.108-.223-.351-.411-.402-.505-.033-.062-.036-.332-.013-.539.024-.017.055-.039.092-.068",
    fill: "#E36E54",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.133 8.432a.943.943 0 0 0 1.857-.32.94.94 0 0 0-1.09-.762.936.936 0 0 0-.767 1.082m1.985-.482c.106.601-.288 1.172-.88 1.275a1.1 1.1 0 0 1-1.263-.903 1.093 1.093 0 0 1 .88-1.275 1.1 1.1 0 0 1 1.263.903",
    fill: "#E36E54",
    mask: "url(#lfd)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4DA80",
    mask: "url(#lfd)",
    d: "m2.571 12.628 7.352 4.183 7.352-4.183v8.426l-7.352 4.213-7.352-4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3BD33",
    mask: "url(#lfd)",
    d: "m9.923 16.901 7.352-4.273v8.426l-7.352 4.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CA67",
    mask: "url(#lfd)",
    d: "m9.934 16.909-7.352-4.274-1.93 3.55L8.005 20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0CA67",
    mask: "url(#lfd)",
    d: "m9.923 16.901 7.352-4.273 1.93 3.55-7.353 4.214z"
  })))), _symbol372 || (_symbol372 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 26 29",
    id: "icon-jereviseV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4.25a4.244 4.244 0 0 1-4.25 4.25A4.244 4.244 0 0 1 8.5 4.25 4.244 4.244 0 0 1 12.75 0 4.244 4.244 0 0 1 17 4.25ZM3.287 8.783a18.691 18.691 0 0 1 9.463 4.746 18.692 18.692 0 0 1 9.463-4.746c1.714-.297 3.287 1.063 3.287 2.805v9.804c0 1.36-1.09 2.677-2.422 2.861-3.57.454-6.815 1.941-9.464 4.109-.496.396-1.303.354-1.799-.057-2.635-2.153-5.85-3.613-9.393-4.066C1.02 24.055 0 22.81 0 20.43v-8.84c0-1.743 1.573-3.103 3.287-2.806Z"
  }))), _symbol373 || (_symbol373 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 18 28",
    id: "icon-lightbulb",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18 8.806c0 1.944-.825 3.694-1.887 5.194h.006c-.681.938-1.338 1.731-1.969 2.813-1.375 2.362-1.15 4.543-1.15 5.1V22h-2v-8l2-4h-1.031l-1.963 4v8h-2v-8l-1.962-4H5.006l2 4v8h-2v-.087c-.006-.457.207-2.738-1.169-5.1C3.208 15.73 2.55 14.938 1.87 14h.018C.825 12.5 0 10.75 0 8.812 0 3.944 4.131 0 9 0s9 3.944 9 8.806ZM7 27h4v1H7v-1Zm-1-2h6v1H6v-1Zm0-2h6v1H6v-1Z"
  }))), _symbol374 || (_symbol374 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-lightning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.2 224H268l52.4-186.9c.9-4.5-4.6-7.1-7.2-3.4L129.5 274.6c-3.8 5.6-.2 13.4 6.3 13.4H244l-52.4 186.9c-.9 4.5 4.6 7.1 7.2 3.4l183.7-240.8c3.7-5.7.2-13.5-6.3-13.5z",
    fill: "currentColor"
  }))), _symbol375 || (_symbol375 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-magnifying_glass",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.61 12.188a7.907 7.907 0 0 0 1.239-4.256C15.849 3.552 12.302 0 7.927 0A7.929 7.929 0 0 0 0 7.932c0 4.38 3.547 7.933 7.922 7.933a7.905 7.905 0 0 0 4.307-1.271l.36-.25L18.245 20 20 18.214l-5.651-5.657.26-.37ZM12.364 3.5a6.22 6.22 0 0 1 1.833 4.427 6.22 6.22 0 0 1-1.833 4.427 6.22 6.22 0 0 1-4.428 1.834 6.22 6.22 0 0 1-4.427-1.834 6.22 6.22 0 0 1-1.833-4.427A6.22 6.22 0 0 1 3.51 3.5a6.22 6.22 0 0 1 4.428-1.833A6.22 6.22 0 0 1 12.364 3.5Z"
  }))), _symbol376 || (_symbol376 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-mail",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.332 80H74.668C51.199 80 32 99.198 32 122.667v266.666C32 412.802 51.199 432 74.668 432h362.664C460.801 432 480 412.802 480 389.333V122.667C480 99.198 460.801 80 437.332 80zM432 170.667 256 288 80 170.667V128l176 117.333L432 128v42.667z",
    fill: "currentColor"
  }))), _symbol377 || (_symbol377 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-menu",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M432 176H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16zm0 96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
  }))), _symbol378 || (_symbol378 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 19 15",
    id: "icon-menuV2",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.5C0 .67.67 0 1.5 0S3 .67 3 1.5 2.33 3 1.5 3 0 2.33 0 1.5Zm0 6C0 6.67.67 6 1.5 6S3 6.67 3 7.5 2.33 9 1.5 9 0 8.33 0 7.5ZM1.5 12c-.83 0-1.5.68-1.5 1.5S.68 15 1.5 15 3 14.32 3 13.5 2.33 12 1.5 12Zm16 2.5h-12c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1Zm-12-6h12c.55 0 1-.45 1-1s-.45-1-1-1h-12c-.55 0-1 .45-1 1s.45 1 1 1Zm0-6c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1h-12Z"
  }))), _symbol379 || (_symbol379 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 32 32",
    id: "icon-message",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m23.751 21.127.874 3.498-3.498-.875a1.006 1.006 0 0 0-.731.098A8.99 8.99 0 0 1 16 25c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.038 9 9a8.997 8.997 0 0 1-1.151 4.395.995.995 0 0 0-.098.732z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M25.784 21.017A10.992 10.992 0 0 0 27 16c0-6.065-4.935-11-11-11S5 9.935 5 16s4.935 11 11 11c1.742 0 3.468-.419 5.018-1.215l4.74 1.185a.996.996 0 0 0 .949-.263 1 1 0 0 0 .263-.95l-1.186-4.74zm-2.033.11.874 3.498-3.498-.875a1.006 1.006 0 0 0-.731.098A8.99 8.99 0 0 1 16 25c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.038 9 9a8.997 8.997 0 0 1-1.151 4.395.995.995 0 0 0-.098.732z"
  }))), _symbol380 || (_symbol380 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-more",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 136c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0 240c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40zm0-120c0-22.002-17.998-40-40-40s-40 17.998-40 40 17.998 40 40 40 40-17.998 40-40z",
    fill: "currentColor"
  }))), _symbol381 || (_symbol381 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 22 29",
    id: "icon-motivation",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19.927,
    height: 27,
    rx: 4,
    stroke: "#6BBADC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6BBADC",
    d: "M4.244 9.402h9.902M4.244 4.451h4.951M12.732 6.573h4.951M4.244 12.232h13.439M4.244 15.061h13.439M4.244 17.89h13.439M4.244 20.72h13.439M4.244 23.549h13.439"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 223.72 289.1",
    id: "icon-note-0",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ojcls-1{fill:#f7931e}.ojcls-4{fill:#3f2f28}.ojcls-5{fill:#e2cfbc}.ojcls-6{fill:#fff}.ojcls-7{fill:#534741}.ojcls-8{fill:#5dc4e8}"))), /*#__PURE__*/React.createElement("g", {
    id: "ojLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ojLayer_1-2",
    "data-name": "Layer 1"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-1",
    d: "M98.53 235.29a3 3 0 0 0-3.45 2.47L89.92 269c-6.87.75-12.63 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.7 10.33a3 3 0 0 0 2.47 3.45 3.29 3.29 0 0 0 1 0 3 3 0 0 0 2.46-2.47l1.81-11a9.37 9.37 0 0 1 3.7 3 6.85 6.85 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.22 15.22 0 0 0-7.52-5.4l5.1-30.86a3 3 0 0 0-2.48-3.51ZM125.19 235.29a3 3 0 0 1 3.45 2.47L133.8 269c6.87.75 12.63 6.17 13.51 11.48a3 3 0 1 1-5.92 1c-.37-2.25-3.07-5.14-6.55-6.17l1.7 10.33a3 3 0 0 1-2.47 3.45 3.29 3.29 0 0 1-1 0 3 3 0 0 1-2.46-2.47l-1.81-11a9.37 9.37 0 0 0-3.7 3 6.85 6.85 0 0 0-1.54 4.93 3 3 0 0 1-2.46 3.45 3.05 3.05 0 0 1-1 0 3 3 0 0 1-2.45-2.47 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.14 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61-21.24 11.45-42.87 15.41-62.16 15.67-35.68.47-63.27-11.71-65-12.5s-30-22-33-19.48c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42c0 3.87.08 7.78.12 11.74.82 70 22 126.89 99.72 125.64 83.2-1.35 97.56-57.9 96.74-127.92-.22-15.41-.62-30.18-2.15-43.82Z",
    style: {
      fill: "#736357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34 97.87c-.1-7.13 4.51-9.29 9.35-9.36 4.83-.07 9.59 2 9.69 9.1l-9.18 24.83c-2.75-4.44-9.86-24.57-9.86-24.57Z",
    style: {
      fill: "#fbb03b"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-4",
    d: "M165.18 221.18c4.54 1.75 38.88-15.91 50-42.09s12.43-51.78-2.05-57.51c-48.41-19.16-52.49 97.84-47.95 99.6ZM58.54 221.18c-4.54 1.75-38.88-15.91-50-42.09s-12.43-51.78 2-57.51c48.46-19.16 52.54 97.84 48 99.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-5",
    d: "M198.21 78.81a39 39 0 1 1-39-38.64 38.81 38.81 0 0 1 39 38.64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-6",
    d: "M192.81 80A34.8 34.8 0 1 1 158 45.55 34.64 34.64 0 0 1 192.81 80Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169 81.68a18 18 0 1 1-18-17.57 17.8 17.8 0 0 1 18 17.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-6",
    d: "M160.4 76.74a4.91 4.91 0 1 1-4.9-4.92 4.9 4.9 0 0 1 4.9 4.92Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-5",
    d: "M25.5 78.81a39 39 0 1 0 39-38.64 38.82 38.82 0 0 0-39 38.64Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-6",
    d: "M100.51 80a34.8 34.8 0 1 1-34.8-34.47A34.64 34.64 0 0 1 100.51 80Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.75 81.68a18 18 0 1 0 18-17.57 17.8 17.8 0 0 0-18 17.57Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-6",
    d: "M82.17 75.93a4.91 4.91 0 1 1-4.9-4.93 4.9 4.9 0 0 1 4.9 4.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-7",
    d: "M55.67 39.8C34.11 44.32 21.3 65.46 25.82 87c0 0 33.53-25.69 77.07-16.38A39.88 39.88 0 0 0 55.67 39.8ZM167.09 40.93a39.88 39.88 0 0 1 30.85 47.22s-34.52-25.68-78.07-16.37a39.88 39.88 0 0 1 47.22-30.85Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-4",
    d: "M78.79 176.44h-.68c-3.19 0-6.14-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.6 2.41 3.66 3.75 5.81 3.75s4.22-1.31 5.82-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 21 21 0 0 1-3.2 11.46c-2.03 3.08-4.72 4.85-7.65 5.08ZM112.47 176.52h-.65c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.42 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.62 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.02 8.78-4.85 16-10.88 16.47ZM146.21 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.53 1.53 0 0 1 1.51-1.5 1.5 1.5 0 0 1 1.49 1.51c0 7.34 3.86 13.56 8.46 13.57s8.51-6.18 8.53-13.53a1.5 1.5 0 1 1 3 0c-.06 8.98-4.74 16.04-10.85 16.53ZM94.52 199.19a5.3 5.3 0 0 1-.69 0c-6.44 0-11.47-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.86 13.56 8.46 13.57s8.51-6.18 8.52-13.53a1.52 1.52 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM130.37 199.28h-.68c-3.19 0-6.14-1.81-8.3-5.1a20.92 20.92 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.66 3.75 5.81 3.75s4.21-1.31 5.82-3.72a17.93 17.93 0 0 0 2.7-9.81 1.51 1.51 0 0 1 1.51-1.49 1.5 1.5 0 0 1 1.49 1.5 21 21 0 0 1-3.2 11.47c-2.02 3.06-4.72 4.83-7.65 5.06Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ojcls-8",
    d: "M57.66 121.84c0 4.64-2.65 6-5.91 6s-5.92-1.37-5.92-6S51.75 111 51.75 111s5.91 6.19 5.91 10.84ZM179.46 126c0 4.11-2.35 5.33-5.24 5.33S169 130.06 169 126s5.25-9.58 5.25-9.58 5.21 5.41 5.21 9.58Z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 223.72 289.1",
    id: "icon-note-1",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".okcls-1{fill:#f7931e}.okcls-4{fill:#3f2f28}.okcls-5{fill:#e2cfbc}.okcls-6{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "okLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "okLayer_1-2",
    "data-name": "Layer 1"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-1",
    d: "M98.53 235.29a3 3 0 0 0-3.45 2.47L89.92 269c-6.87.75-12.63 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.7 10.33a3 3 0 0 0 2.47 3.45 3.29 3.29 0 0 0 1 0 3 3 0 0 0 2.46-2.47l1.81-11a9.37 9.37 0 0 1 3.7 3 6.85 6.85 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.22 15.22 0 0 0-7.52-5.4l5.1-30.86a3 3 0 0 0-2.48-3.51ZM125.19 235.29a3 3 0 0 1 3.45 2.47L133.8 269c6.87.75 12.63 6.17 13.51 11.48a3 3 0 1 1-5.92 1c-.37-2.25-3.07-5.14-6.55-6.17l1.7 10.33a3 3 0 0 1-2.47 3.45 3.29 3.29 0 0 1-1 0 3 3 0 0 1-2.46-2.47l-1.81-11a9.37 9.37 0 0 0-3.7 3 6.85 6.85 0 0 0-1.54 4.93 3 3 0 0 1-2.46 3.45 3.05 3.05 0 0 1-1 0 3 3 0 0 1-2.45-2.47 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.14 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61-21.24 11.45-42.87 15.41-62.16 15.67-35.68.47-63.27-11.71-65-12.5s-30-22-33-19.48c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42c0 3.87.08 7.78.12 11.74.82 70 22 126.89 99.72 125.64 83.2-1.35 97.56-57.9 96.74-127.92-.22-15.41-.62-30.18-2.15-43.82Z",
    style: {
      fill: "#736357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34 97.87c-.1-7.13 4.51-9.29 9.35-9.36 4.83-.07 9.59 2 9.69 9.1l-9.18 24.83c-2.75-4.44-9.86-24.57-9.86-24.57Z",
    style: {
      fill: "#fbb03b"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-4",
    d: "M165.18 221.18c4.54 1.75 38.88-15.91 50-42.09s12.43-51.78-2.05-57.51c-48.41-19.16-52.49 97.84-47.95 99.6ZM58.54 221.18c-4.54 1.75-38.88-15.91-50-42.09s-12.43-51.78 2-57.51c48.46-19.16 52.54 97.84 48 99.6ZM78.79 176.44h-.68c-3.19 0-6.14-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.6 2.41 3.66 3.75 5.81 3.75s4.22-1.31 5.82-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 21 21 0 0 1-3.2 11.46c-2.03 3.08-4.72 4.85-7.65 5.08ZM112.47 176.52h-.65c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.42 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.62 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.02 8.78-4.85 16-10.88 16.47ZM146.21 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.51 1.51 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c0 7.34 3.86 13.56 8.46 13.57s8.51-6.18 8.53-13.53a1.5 1.5 0 1 1 3 0c-.06 8.98-4.74 16.04-10.85 16.53ZM94.52 199.19a5.3 5.3 0 0 1-.69 0c-6.44 0-11.47-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.86 13.56 8.46 13.57s8.51-6.18 8.52-13.53a1.52 1.52 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM130.37 199.28h-.68c-3.19 0-6.14-1.81-8.3-5.1a20.92 20.92 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.66 3.75 5.81 3.75s4.21-1.31 5.82-3.72a17.93 17.93 0 0 0 2.7-9.81 1.51 1.51 0 0 1 1.51-1.49 1.5 1.5 0 0 1 1.49 1.5 21 21 0 0 1-3.2 11.47c-2.02 3.06-4.72 4.83-7.65 5.06Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-5",
    d: "M29.77 61.52a38.19 38.19 0 0 0-4.11 17.29 38.81 38.81 0 0 0 39 38.63c21.54 0 35-13.29 35-34.63Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-6",
    d: "M44.33 66.37c-4 5.08-7.19 9.5-7.42 16.47-.58 18 13.35 29.81 29.8 29.81S96.52 98.3 96.52 81.84Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m87.32 78.41-20.61-6.34a15.19 15.19 0 1 0 22 13.6 20.06 20.06 0 0 0-1.39-7.26Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-6",
    d: "M86.41 84.47a4.91 4.91 0 1 1-4.9-4.92 4.91 4.91 0 0 1 4.9 4.92Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-5",
    d: "M194 61.52a38.19 38.19 0 0 1 4.11 17.29 38.81 38.81 0 0 1-39 38.63c-21.54 0-35-13.29-35-34.63Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-6",
    d: "M179.39 66.37c4 5.08 7.19 9.5 7.41 16.47.59 18-13.34 29.81-29.8 29.81s-29.8-14.35-29.8-30.81Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.39 78.41 157 72.07a15.19 15.19 0 1 1-21.95 13.6 20.27 20.27 0 0 1 1.34-7.26Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "okcls-6",
    d: "M137.3 84.47a4.92 4.92 0 1 0 4.91-4.92 4.92 4.92 0 0 0-4.91 4.92Z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 223.72 289.1",
    id: "icon-note-2",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".olcls-1{fill:#f7931e}.olcls-4{fill:#3f2f28}"))), /*#__PURE__*/React.createElement("g", {
    id: "olLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "olLayer_1-2",
    "data-name": "Layer 1"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "olcls-1",
    d: "M98.53 235.29a3 3 0 0 0-3.45 2.47L89.92 269c-6.87.75-12.63 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.71 10.33a3 3 0 0 0 2.48 3.45 3.29 3.29 0 0 0 1 0 3 3 0 0 0 2.46-2.47l1.81-11a9.37 9.37 0 0 1 3.7 3 6.85 6.85 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.22 15.22 0 0 0-7.52-5.4l5.1-30.86a3 3 0 0 0-2.48-3.51ZM125.19 235.29a3 3 0 0 1 3.45 2.47L133.8 269c6.87.75 12.63 6.17 13.51 11.48a3 3 0 1 1-5.92 1c-.37-2.25-3.07-5.14-6.55-6.17l1.7 10.33a3 3 0 0 1-2.47 3.45 3.29 3.29 0 0 1-1 0 3 3 0 0 1-2.46-2.47l-1.81-11a9.37 9.37 0 0 0-3.7 3 6.8 6.8 0 0 0-1.54 4.93 3 3 0 0 1-2.46 3.45 3.05 3.05 0 0 1-1 0 3 3 0 0 1-2.45-2.47 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.14 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61-21.24 11.45-42.87 15.41-62.16 15.67-35.68.47-63.27-11.71-65-12.5s-30-22-33-19.48c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42c0 3.87.08 7.78.12 11.74.82 70 22 126.89 99.72 125.64 83.2-1.35 97.56-57.9 96.74-127.92-.22-15.41-.62-30.18-2.15-43.82Z",
    style: {
      fill: "#736357"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.34 97.87c-.1-7.13 4.51-9.29 9.35-9.36 4.83-.07 9.59 2 9.69 9.1l-9.18 24.83c-2.75-4.44-9.86-24.57-9.86-24.57Z",
    style: {
      fill: "#fbb03b"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "olcls-4",
    d: "M165.18 221.18c4.54 1.75 38.88-15.91 50-42.09s12.43-51.78-2.05-57.51c-48.41-19.16-52.49 97.84-47.95 99.6ZM58.54 221.18c-4.54 1.75-38.88-15.91-50-42.09s-12.43-51.78 2-57.51c48.46-19.16 52.54 97.84 48 99.6ZM78.79 176.44h-.68c-3.19 0-6.14-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.6 2.41 3.66 3.75 5.81 3.75s4.22-1.31 5.82-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 21 21 0 0 1-3.2 11.46c-2.03 3.08-4.72 4.85-7.65 5.08ZM112.47 176.52h-.65c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.42 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.62 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.02 8.78-4.85 16-10.88 16.47ZM146.21 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.51 1.51 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c0 7.34 3.86 13.56 8.46 13.57s8.51-6.18 8.53-13.53a1.5 1.5 0 1 1 3 0c-.06 8.98-4.74 16.04-10.85 16.53ZM94.52 199.19a5.3 5.3 0 0 1-.69 0c-6.44 0-11.47-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.86 13.56 8.46 13.57s8.51-6.18 8.52-13.53a1.52 1.52 0 0 1 1.51-1.49 1.48 1.48 0 0 1 1.49 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM130.37 199.28h-.68c-3.19 0-6.14-1.81-8.3-5.1a20.92 20.92 0 0 1-3.15-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.66 3.75 5.81 3.75s4.21-1.31 5.82-3.72a17.93 17.93 0 0 0 2.7-9.81 1.51 1.51 0 0 1 1.51-1.49 1.5 1.5 0 0 1 1.49 1.5 21 21 0 0 1-3.2 11.47c-2.02 3.06-4.72 4.83-7.65 5.06ZM89.22 88.47 54.71 67.86c-2-1.19-7.18 1.57-4.51 3.17L81.91 90l-30 11.4c-3.73 1.42-.4 4.17 2.48 3.07L88.2 91.59c1.14-.43 2.56-2.19 1.02-3.12ZM169.36 68.27l-34.51 20.62c-1.41.84-1.32 2.42.18 3l33.8 12.85c2.24.86 6.77-2.37 3.41-3.65l-30.63-11.65 31.51-18.83c3.36-2-1.53-3.67-3.76-2.34Z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 301.57 289.1",
    id: "icon-note-3",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".omcls-1{fill:#f7931e}.omcls-3{fill:#3f2f28}.omcls-4{fill:#fbb03b}.omcls-6{fill:#e2cfbc}.omcls-7{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "omLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "omLayer_1-2",
    "data-name": "Layer 1"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-1",
    d: "M137.45 235.29a3 3 0 0 0-3.45 2.47L128.85 269c-6.88.75-12.64 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.71 10.33a3 3 0 0 0 2.47 3.45 3.35 3.35 0 0 0 1 0 3 3 0 0 0 2.45-2.47l1.81-11a9.33 9.33 0 0 1 3.71 3 6.89 6.89 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.26 15.26 0 0 0-7.52-5.4l5.09-30.86a3 3 0 0 0-2.47-3.51ZM164.12 235.29a3 3 0 0 1 3.45 2.47l5.15 31.24c6.88.75 12.64 6.17 13.51 11.48a3 3 0 1 1-5.91 1c-.38-2.25-3.07-5.14-6.56-6.17l1.71 10.33a3 3 0 0 1-2.47 3.45 3.35 3.35 0 0 1-1 0 3 3 0 0 1-2.45-2.47l-1.81-11a9.33 9.33 0 0 0-3.71 3 6.89 6.89 0 0 0-1.54 4.93 3 3 0 1 1-5.91 1 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.07 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61C194 28.21 172.3 32.17 153 32.43c-35.67.47-63.26-11.71-65-12.5S58-2.07 55 .45c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42q0 5.8.12 11.74c.82 70 22 126.89 99.71 125.64C235.65 254.54 250 198 249.18 128c-.18-15.44-.59-30.21-2.11-43.85Z",
    style: {
      fill: "#736357"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-3",
    d: "M301.41 203.38c-3.43 3.45-42 1.38-62.81-18s-32.52-42.15-21.6-53.3c36.27-37.26 87.84 67.84 84.41 71.3ZM.16 203.38c3.43 3.45 42 1.38 62.81-18s32.52-42.18 21.65-53.33C48.3 94.82-3.26 199.92.16 203.38Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 24.83c-2.75-4.44-9.87-24.57-9.87-24.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 18.83c-2.75-4.44-9.87-18.57-9.87-18.57Z",
    style: {
      fill: "#f15a24"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 7.83Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-6",
    d: "M238.64 78.81a39 39 0 1 1-39-38.64 38.82 38.82 0 0 1 39 38.64Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-7",
    d: "M230.23 80a34.8 34.8 0 1 1-34.8-34.47A34.64 34.64 0 0 1 230.23 80Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M209.4 81.68a18 18 0 1 1-18-17.57 17.8 17.8 0 0 1 18 17.57Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-7",
    d: "M200.83 71.74a4.91 4.91 0 1 1-4.9-4.92 4.91 4.91 0 0 1 4.9 4.92Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-6",
    d: "M62.93 78.81a39 39 0 1 0 39-38.64 38.82 38.82 0 0 0-39 38.64Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-7",
    d: "M71.34 80a34.8 34.8 0 1 0 34.8-34.47A34.64 34.64 0 0 0 71.34 80Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M92.17 81.68a18 18 0 1 0 18-17.57 17.8 17.8 0 0 0-18 17.57Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-7",
    d: "M122.6 72.93a4.91 4.91 0 1 1-4.9-4.93 4.91 4.91 0 0 1 4.9 4.93Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "omcls-3",
    d: "M117.72 176.44h-.68c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.41 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.88 20.88 0 0 1-3.21 11.46c-2.02 3.08-4.72 4.85-7.64 5.08ZM151.4 176.52h-.66c-3.18 0-6.13-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.42 1.53 1.53 0 0 1 1.51-1.5 1.49 1.49 0 0 1 1.49 1.5 18 18 0 0 0 2.66 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.61 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.03 8.78-4.85 16-10.88 16.47ZM185.14 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.5 1.5 0 1 1 3 0c0 7.34 3.86 13.56 8.46 13.57s8.54-6.15 8.54-13.5a1.53 1.53 0 0 1 1.51-1.5 1.5 1.5 0 0 1 1.49 1.51c0 8.95-4.75 16.01-10.86 16.5ZM133.45 199.19h-.69c-6.45 0-11.48-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.85 13.56 8.45 13.57s8.51-6.18 8.53-13.53a1.52 1.52 0 0 1 1.5-1.49 1.5 1.5 0 0 1 1.5 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM169.3 199.28h-.68c-3.19 0-6.14-1.81-8.31-5.1a20.91 20.91 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a17.93 17.93 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.91 20.91 0 0 1-3.21 11.47c-2.02 3.07-4.72 4.84-7.64 5.07Z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 301.57 289.1",
    id: "icon-note-4",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".oncls-1{fill:#f7931e}.oncls-3{fill:#3f2f28}.oncls-4{fill:#fbb03b}.oncls-7{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "onLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "onLayer_1-2",
    "data-name": "Layer 1"
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-1",
    d: "M137.45 235.29a3 3 0 0 0-3.45 2.47L128.85 269c-6.88.75-12.64 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.71 10.33a3 3 0 0 0 2.47 3.45 3.35 3.35 0 0 0 1 0 3 3 0 0 0 2.45-2.47l1.81-11a9.33 9.33 0 0 1 3.71 3 6.89 6.89 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.26 15.26 0 0 0-7.52-5.4l5.09-30.86a3 3 0 0 0-2.47-3.51ZM164.12 235.29a3 3 0 0 1 3.45 2.47l5.15 31.24c6.88.75 12.64 6.17 13.51 11.48a3 3 0 1 1-5.91 1c-.38-2.25-3.07-5.14-6.56-6.17l1.71 10.33a3 3 0 0 1-2.47 3.45 3.35 3.35 0 0 1-1 0 3 3 0 0 1-2.45-2.47l-1.81-11a9.33 9.33 0 0 0-3.71 3 6.89 6.89 0 0 0-1.54 4.93 3 3 0 1 1-5.91 1 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.07 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61C194 28.21 172.3 32.17 153 32.43c-35.67.47-63.26-11.71-65-12.5S58-2.07 55 .45c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42q0 5.8.12 11.74c.82 70 22 126.89 99.71 125.64C235.65 254.54 250 198 249.18 128c-.18-15.44-.59-30.21-2.11-43.85Z",
    style: {
      fill: "#736357"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-3",
    d: "M301.41 203.38c-3.43 3.45-42 1.38-62.81-18s-32.52-42.15-21.6-53.3c36.27-37.26 87.84 67.84 84.41 71.3ZM.16 203.38c3.43 3.45 42 1.38 62.81-18s32.52-42.18 21.65-53.33C48.3 94.82-3.26 199.92.16 203.38Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 24.83c-2.75-4.44-9.87-24.57-9.87-24.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 18.83c-2.75-4.44-9.87-18.57-9.87-18.57Z",
    style: {
      fill: "#f15a24"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 7.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.93 80.81a39 39 0 1 0 39-38.64 38.81 38.81 0 0 0-39 38.64Z",
    style: {
      fill: "#e2cfbc"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-7",
    d: "M69.34 82a34.8 34.8 0 1 0 34.8-34.47A34.64 34.64 0 0 0 69.34 82Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.17 83.68a18 18 0 1 0 18-17.57 17.8 17.8 0 0 0-18 17.57Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-7",
    d: "M120.6 74.93a4.91 4.91 0 1 1-4.9-4.93 4.91 4.91 0 0 1 4.9 4.93Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "oncls-3",
    d: "M117.72 176.44h-.68c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.41 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.88 20.88 0 0 1-3.21 11.46c-2.02 3.08-4.72 4.85-7.64 5.08ZM151.4 176.52h-.66c-3.18 0-6.13-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.42 1.53 1.53 0 0 1 1.51-1.5 1.49 1.49 0 0 1 1.49 1.5 18 18 0 0 0 2.66 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.61 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.03 8.78-4.85 16-10.88 16.47ZM185.14 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.34 3.86 13.56 8.46 13.57s8.54-6.15 8.54-13.5a1.53 1.53 0 0 1 1.51-1.5 1.5 1.5 0 0 1 1.49 1.51c0 8.95-4.75 16.01-10.86 16.5ZM133.45 199.19a5.3 5.3 0 0 1-.69 0c-6.45 0-11.48-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.85 13.56 8.45 13.57s8.51-6.18 8.53-13.53a1.52 1.52 0 0 1 1.5-1.49 1.5 1.5 0 0 1 1.5 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM169.3 199.28h-.68c-3.19 0-6.14-1.81-8.31-5.1a20.91 20.91 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a17.93 17.93 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.91 20.91 0 0 1-3.21 11.47c-2.02 3.07-4.72 4.84-7.64 5.07ZM220.58 92.9a2.43 2.43 0 0 0 2.82-2.09 23.63 23.63 0 0 0-47-4.62 2.68 2.68 0 0 0 2.36 2.94 2.59 2.59 0 0 0 2.91-2.35 18.37 18.37 0 0 1 20.11-16.35 18.1 18.1 0 0 1 16.37 19.83 2.41 2.41 0 0 0 2.39 2.64Z"
  }))))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 301.57 289.1",
    id: "icon-note-5",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".oocls-1{fill:#f7931e}.oocls-3{fill:#3f2f28}.oocls-4{fill:#fbb03b}"))), /*#__PURE__*/React.createElement("g", {
    id: "ooLayer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ooLayer_1-2",
    "data-name": "Layer 1"
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "oocls-1",
    d: "M137.45 235.29a3 3 0 0 0-3.45 2.47L128.85 269c-6.88.75-12.64 6.17-13.51 11.48a3 3 0 0 0 5.92 1c.37-2.25 3.06-5.14 6.55-6.17l-1.71 10.33a3 3 0 0 0 2.47 3.45 3.35 3.35 0 0 0 1 0 3 3 0 0 0 2.45-2.47l1.81-11a9.33 9.33 0 0 1 3.71 3 6.89 6.89 0 0 1 1.54 4.93 3 3 0 1 0 5.92 1 12.73 12.73 0 0 0-2.65-9.49 15.26 15.26 0 0 0-7.52-5.4l5.09-30.86a3 3 0 0 0-2.47-3.51ZM164.12 235.29a3 3 0 0 1 3.45 2.47l5.15 31.24c6.88.75 12.64 6.17 13.51 11.48a3 3 0 1 1-5.91 1c-.38-2.25-3.07-5.14-6.56-6.17l1.71 10.33a3 3 0 0 1-2.47 3.45 3.35 3.35 0 0 1-1 0 3 3 0 0 1-2.45-2.47l-1.81-11a9.33 9.33 0 0 0-3.71 3 6.89 6.89 0 0 0-1.54 4.93 3 3 0 1 1-5.91 1 12.72 12.72 0 0 1 2.64-9.49 15.31 15.31 0 0 1 7.52-5.4l-5.09-30.86a3 3 0 0 1 2.47-3.51Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.07 84.15c-.81-34.33-2.34-82.24-4.59-84-2.42-1.9-25.64 15.7-27.31 16.61C194 28.21 172.3 32.17 153 32.43c-35.67.47-63.26-11.71-65-12.5S58-2.07 55 .45c-3.45 2.85-2.5 118.48-2.5 118.48l.13-.42q0 5.8.12 11.74c.82 70 22 126.89 99.71 125.64C235.65 254.54 250 198 249.18 128c-.18-15.44-.59-30.21-2.11-43.85Z",
    style: {
      fill: "#736357"
    }
  }), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "oocls-3",
    d: "M301.41 203.38c-3.43 3.45-42 1.38-62.81-18s-32.52-42.15-21.6-53.3c36.27-37.26 87.84 67.84 84.41 71.3ZM.16 203.38c3.43 3.45 42 1.38 62.81-18s32.52-42.18 21.65-53.33C48.3 94.82-3.26 199.92.16 203.38Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "oocls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 24.83c-2.75-4.44-9.87-24.57-9.87-24.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 18.83c-2.75-4.44-9.87-18.57-9.87-18.57Z",
    style: {
      fill: "#f15a24"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "oocls-4",
    d: "M141.26 97.87c-.09-7.13 4.52-9.29 9.35-9.36 4.84-.07 9.6 2 9.7 9.1l-9.18 7.83Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "oocls-3",
    d: "M82.37 93.5a2.41 2.41 0 0 1-2.81-2.09 23.62 23.62 0 0 1 47-4.62 2.68 2.68 0 0 1-2.36 2.94 2.59 2.59 0 0 1-2.91-2.35A18.36 18.36 0 0 0 101.21 71a18.11 18.11 0 0 0-16.38 19.86 2.41 2.41 0 0 1-2.39 2.64ZM219.2 93.5a2.41 2.41 0 0 0 2.8-2.09 23.62 23.62 0 0 0-47-4.62 2.68 2.68 0 0 0 2.36 2.94 2.59 2.59 0 0 0 2.91-2.35A18.37 18.37 0 0 1 200.36 71a18.1 18.1 0 0 1 16.38 19.83 2.41 2.41 0 0 0 2.39 2.64ZM117.72 176.44h-.68c-3.19 0-6.14-1.82-8.31-5.1a20.94 20.94 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.41 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a18 18 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.88 20.88 0 0 1-3.21 11.46c-2.02 3.08-4.72 4.85-7.64 5.08ZM151.4 176.52h-.66c-3.18 0-6.13-1.82-8.3-5.1a20.94 20.94 0 0 1-3.15-11.42 1.53 1.53 0 0 1 1.51-1.5 1.49 1.49 0 0 1 1.49 1.5 18 18 0 0 0 2.66 9.82c1.59 2.42 3.65 3.75 5.8 3.76 4.61 0 8.51-6.19 8.53-13.53a1.5 1.5 0 0 1 3 0c-.03 8.78-4.85 16-10.88 16.47ZM185.14 176.61h-.69c-6.44 0-11.47-7.3-11.45-16.58a1.5 1.5 0 1 1 3 0c0 7.34 3.86 13.56 8.46 13.57s8.54-6.15 8.54-13.5a1.53 1.53 0 0 1 1.51-1.5 1.5 1.5 0 0 1 1.49 1.51c0 8.95-4.75 16.01-10.86 16.5ZM133.45 199.19a5.3 5.3 0 0 1-.69 0c-6.45 0-11.48-7.29-11.45-16.58a1.5 1.5 0 0 1 3 0c0 7.35 3.85 13.56 8.45 13.57s8.51-6.18 8.53-13.53a1.52 1.52 0 0 1 1.5-1.49 1.5 1.5 0 0 1 1.5 1.5c-.02 8.98-4.73 16.05-10.84 16.53ZM169.3 199.28h-.68c-3.19 0-6.14-1.81-8.31-5.1a20.91 20.91 0 0 1-3.14-11.48 1.5 1.5 0 0 1 3 0 17.88 17.88 0 0 0 2.65 9.82c1.59 2.42 3.65 3.75 5.8 3.75s4.22-1.31 5.83-3.72a17.93 17.93 0 0 0 2.7-9.81 1.5 1.5 0 0 1 3 0 20.91 20.91 0 0 1-3.21 11.47c-2.02 3.07-4.72 4.84-7.64 5.07Z"
  }))))), _symbol382 || (_symbol382 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 23",
    fill: "none",
    id: "icon-params",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.192 1.066c0-.561.476-1.016 1.064-1.016h2.903c.588 0 1.064.455 1.064 1.016V2.69a9.487 9.487 0 0 1 2.03.804l1.201-1.148a1.1 1.1 0 0 1 1.506 0l2.052 1.96a.984.984 0 0 1 0 1.437L19.81 6.891c.356.605.64 1.254.841 1.938h1.7c.587 0 1.064.455 1.064 1.016v2.772c0 .562-.477 1.017-1.064 1.017h-1.7a8.608 8.608 0 0 1-.841 1.938l1.202 1.148a.984.984 0 0 1 0 1.437l-2.052 1.96a1.1 1.1 0 0 1-1.506 0l-1.202-1.148a9.488 9.488 0 0 1-2.029.804v1.623c0 .561-.476 1.016-1.064 1.016h-2.903c-.588 0-1.064-.455-1.064-1.016v-1.623a9.485 9.485 0 0 1-2.03-.804L5.96 20.118a1.1 1.1 0 0 1-1.505 0l-2.052-1.96a.984.984 0 0 1 0-1.438l1.202-1.148a8.608 8.608 0 0 1-.841-1.938h-1.7C.477 13.634 0 13.179 0 12.617V9.845c0-.561.477-1.016 1.064-1.016h1.7c.2-.684.485-1.333.841-1.938L2.403 5.742a.984.984 0 0 1 0-1.437l2.052-1.96a1.1 1.1 0 0 1 1.505 0l1.203 1.148a9.484 9.484 0 0 1 2.029-.804V1.066Zm2.128 1.017v1.415c0 .493-.37.915-.877 1.001a7.3 7.3 0 0 0-2.825 1.118 1.102 1.102 0 0 1-1.362-.115L5.208 4.501l-.548.523 1.05 1.001a.983.983 0 0 1 .12 1.3 6.633 6.633 0 0 0-1.171 2.698c-.09.485-.532.838-1.048.838H2.129v.74H3.61c.516 0 .957.353 1.048.838a6.634 6.634 0 0 0 1.17 2.698.983.983 0 0 1-.12 1.3L4.661 17.44l.547.522 1.048-1.001a1.102 1.102 0 0 1 1.362-.115 7.3 7.3 0 0 0 2.825 1.118c.508.086.877.508.877 1v1.416h.774v-1.415c0-.493.37-.915.878-1a7.3 7.3 0 0 0 2.825-1.12 1.102 1.102 0 0 1 1.361.116l1.049 1.001.547-.522-1.048-1.002a.983.983 0 0 1-.12-1.3c.579-.794.986-1.71 1.17-2.698.09-.485.532-.838 1.048-.838h1.482v-.74h-1.482c-.516 0-.957-.353-1.048-.838a6.635 6.635 0 0 0-1.17-2.698.983.983 0 0 1 .12-1.3l1.048-1.001-.547-.523-1.049 1.001a1.102 1.102 0 0 1-1.36.115A7.3 7.3 0 0 0 12.971 4.5c-.508-.086-.878-.508-.878-1V2.082h-.774ZM7.982 11.23c0-1.965 1.668-3.558 3.725-3.558 2.058 0 3.725 1.593 3.725 3.558 0 1.965-1.667 3.558-3.725 3.558-2.057 0-3.725-1.593-3.725-3.558Zm3.725-1.525c-.881 0-1.596.683-1.596 1.525 0 .842.715 1.525 1.596 1.525.882 0 1.597-.683 1.597-1.525 0-.842-.715-1.525-1.597-1.525Z",
    fill: "currentColor"
  }))), _symbol383 || (_symbol383 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 22 21",
    fill: "none",
    id: "icon-payment",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.322 1.083c0-.561.476-1.017 1.064-1.017H14.9c.588 0 1.065.456 1.065 1.017V4.64h4.257c.296 0 .578.117.78.324a.99.99 0 0 1 .281.767L20.22 19.455c-.041.53-.504.941-1.061.941H2.128c-.557 0-1.02-.41-1.06-.941L.002 5.732a.99.99 0 0 1 .281-.767c.202-.207.484-.324.78-.324h4.258V1.083Zm0 5.59V7.69c0 .561.476 1.017 1.064 1.017.588 0 1.064-.456 1.064-1.017V6.674h6.386V7.69c0 .561.476 1.017 1.064 1.017.588 0 1.065-.456 1.065-1.017V6.674h3.11l-.906 11.69H3.117L2.21 6.673h3.112Zm8.514-2.032H7.45V2.099h6.386v2.542ZM5.322 15.314c0-.562.476-1.017 1.064-1.017H14.9c.588 0 1.065.455 1.065 1.017 0 .561-.477 1.016-1.065 1.016H6.386c-.588 0-1.064-.455-1.064-1.016Z",
    fill: "currentColor"
  }))), _symbol384 || (_symbol384 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 32",
    id: "icon-pdf",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1v30h22V7.68L16.434 1H1ZM0 0h16.854L24 7.271V32H0V0Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M24 8h-8V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.304 17.976h.976c.144 0 .283-.01.416-.032a.968.968 0 0 0 .352-.124.676.676 0 0 0 .244-.26.914.914 0 0 0 .092-.44.914.914 0 0 0-.092-.44.676.676 0 0 0-.244-.26.968.968 0 0 0-.352-.124 2.63 2.63 0 0 0-.416-.032h-.976v1.712Zm-1.256-2.688h2.576c.357 0 .661.052.912.156.25.104.455.241.612.412.157.17.272.365.344.584a2.16 2.16 0 0 1 0 1.356 1.577 1.577 0 0 1-.344.588c-.157.17-.361.308-.612.412-.25.104-.555.156-.912.156h-1.32V21H5.048v-5.712Zm6.592 4.656h1.12c.181 0 .357-.03.528-.088.17-.059.323-.156.456-.292.133-.136.24-.313.32-.532.08-.219.12-.485.12-.8a3.33 3.33 0 0 0-.084-.78 1.556 1.556 0 0 0-.276-.596 1.224 1.224 0 0 0-.508-.38 2.028 2.028 0 0 0-.78-.132h-.896v3.6Zm-1.256-4.656h2.464c.368 0 .71.059 1.028.176.317.117.592.293.824.528.232.235.413.528.544.88.13.352.196.765.196 1.24 0 .416-.053.8-.16 1.152a2.535 2.535 0 0 1-.484.912 2.268 2.268 0 0 1-.808.604c-.323.147-.703.22-1.14.22h-2.464v-5.712Zm5.928 0h4.016v1.056h-2.76v1.32h2.392v.976h-2.392V21h-1.256v-5.712Z",
    fill: "#F03E3E"
  }))), _symbol385 || (_symbol385 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-pencil",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.018 21.834-4.852-4.852L15.577 3.571l4.852 4.852L7.018 21.834ZM23.557 3.021c.628.628.583 1.69-.1 2.374l-2.421 2.421-4.852-4.852L18.606.543c.682-.683 1.745-.728 2.373-.1l2.578 2.578ZM1.715 17.746l4.539 4.539L0 24l1.715-6.254Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    id: "icon-picture",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e6f9ff"
    },
    d: "M512 461H0V51h512v410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccefff"
    },
    d: "M512 461H256V51h256v410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ace3fc"
    },
    d: "M30 81h452v300H30z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#86d6f2"
    },
    d: "M256 81h226v300H256z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffdc40"
    },
    cx: 120,
    cy: 171,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66e26f"
    },
    d: "M482 381V224.787l-82-82-146.5 146.5-55-55L51.787 381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48cc4e"
    },
    d: "m400 142.787-144 144V381h226V224.787z"
  })), _symbol386 || (_symbol386 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 24",
    id: "icon-play",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.325 10.556 1.925.2a1.312 1.312 0 0 0-.681-.2C.563 0 .006.563.006 1.25H0v21.5h.006c0 .688.556 1.25 1.238 1.25.256 0 .468-.088.7-.213l17.381-10.343a1.883 1.883 0 0 0 0-2.887Z"
  }))), _symbol387 || (_symbol387 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 20 20",
    id: "icon-play-circle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.48 0 10 0s10 4.48 10 10-4.48 10-10 10S0 15.52 0 10Zm8.8-3.9a.5.5 0 0 0-.8.4v7c0 .41.47.65.8.4l4.67-3.5c.27-.2.27-.6 0-.8L8.8 6.1Z"
  }))), _symbol388 || (_symbol388 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 32 26",
    id: "icon-play_tv",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.333 0h-25.5A2.842 2.842 0 0 0 0 2.833v17a2.842 2.842 0 0 0 2.833 2.834h7.084v1.416c0 .78.637 1.417 1.416 1.417h8.5a1.42 1.42 0 0 0 1.417-1.417v-1.416h7.083a2.83 2.83 0 0 0 2.82-2.834l.014-17A2.833 2.833 0 0 0 28.333 0Zm-1.416 19.833H4.25a1.42 1.42 0 0 1-1.417-1.416V4.25c0-.78.638-1.417 1.417-1.417h22.667c.779 0 1.416.638 1.416 1.417v14.167a1.42 1.42 0 0 1-1.416 1.416Zm-13.459-4.037 5.639-3.23c.949-.553.949-1.913 0-2.465l-5.639-3.23c-.949-.539-2.125.141-2.125 1.232v6.46c0 1.077 1.176 1.771 2.125 1.233Z"
  }))), _symbol389 || (_symbol389 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 1280 1280",
    id: "icon-plus",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565.5 156.5c-3.8.8-10.8 3.3-15.5 5.6-6.9 3.4-10.2 5.9-17.5 13.3-9.6 9.7-13.6 16-17.7 28.1l-2.3 7-.3 155.2L512 521l-155.8.2-155.7.3-7.8 2.8c-10 3.5-17.5 8.3-25.5 16-12.3 12.1-18.3 24.6-20.3 42.3-.7 6.5-.9 35.1-.7 82.4.4 81 .1 77 7.8 92.5 7.5 15.3 21.9 27.8 38.9 33.9l8.6 3.1 155.3.3 155.2.2v151.3c.1 161.5 0 159.2 5 171.7 5.5 13.9 18.2 27.8 31.8 34.8 15.5 8.1 10.8 7.7 100.2 7.7 88.5 0 84.8.3 99.5-7 17.2-8.4 31.7-26.3 36-44.6 1.3-5.6 1.5-26.5 1.5-160.2V795h152c169.7 0 160.3.4 175.5-7 14.1-6.8 24.4-17.2 31.6-31.5 6.9-14.1 6.9-12.9 6.9-98.8 0-84.1 0-84.1-6-97.2-7.5-16.4-23.6-30.9-41-36.8l-6.5-2.2-156-.5-156-.5-.5-156-.5-156-2.2-6.5c-6.9-20-23.8-37-43.6-43.7l-8.2-2.8-79.5-.2c-64.6-.1-80.8.1-86.5 1.2z"
  }))), _symbol390 || (_symbol390 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 448 512",
    fill: "currentColor",
    id: "icon-podcast",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 0C100.3 0 0 100.3 0 224c0 92.22 55.77 171.4 135.4 205.7-3.48-20.75-6.17-41.59-6.998-58.15C80.08 340.1 48 285.8 48 224c0-97.05 78.95-176 176-176s176 78.95 176 176c0 61.79-32.08 116.1-80.39 147.6-.834 16.5-3.541 37.37-7.035 58.17C392.2 395.4 448 316.2 448 224 448 100.3 347.7 0 224 0zm0 312c-32.88 0-64 8.625-64 43.75 0 33.13 12.88 104.3 20.62 132.8C185.8 507.6 205.1 512 224 512s38.25-4.375 43.38-23.38C275.1 459.9 288 388.8 288 355.8c0-35.2-31.1-43.8-64-43.8zm0-32c30.95 0 56-25.05 56-56s-25.9-56-56-56-56 25-56 56 25 56 56 56zm144-56c0-79.53-64.47-144-144-144S80 144.5 80 224c0 44.83 20.92 84.38 53.04 110.8 4.857-12.65 14.13-25.88 32.05-35.04.01-.06.31-.06.51-.06-22.7-17.6-37.6-44.8-37.6-75.7 0-53.02 42.98-96 96-96s96 42.98 96 96c0 30.92-14.87 58.13-37.57 75.68.13.025.508.049.475.074 17.93 9.16 27.19 22.38 32.05 35.04C347.1 308.4 368 268.8 368 224z"
  }))), _symbol391 || (_symbol391 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-podium",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 224h128v192H32zm160-96h128v288H192zm160 160h128v128H352z"
  }))), _symbol392 || (_symbol392 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 347.2 371.8",
    xmlSpace: "preserve",
    id: "icon-professeur-individuel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0295E4",
    d: "M143.6 311.9c-42.5 0-85 0-127.5-.1-11.2 0-16.1-5-16.1-16.2V64.5c0-11 5-16 15.9-16h315.3c11 0 16 5 16 16v231.1c0 11.3-4.9 16.2-16.1 16.2-42.5 0-85 0-127.5.1-1.5 1.2-3.2 1.1-5 1.1-4.3 0-8.7.1-13-.1-8 .1-16 .2-23.9 0-4.6.2-9.2.1-13.8.1-1.5.1-3 0-4.3-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M203.6 347.7c7.1 0 14.2.1 21.3 0 2 0 2.9.6 3.3 2.5 1.4 6.2 2.9 12.3 4.6 18.4.7 2.5.2 3.1-2.4 3.1-16.9-.1-33.9-.1-50.8-.1-20.8 0-41.6-.1-62.4.1-3 0-3.5-.7-2.7-3.5 1.7-6 3.1-12 4.5-18.1.4-1.9 1.3-2.6 3.3-2.5 7.1.1 14.2 0 21.3 0 1.5-1.2 3.2-1.1 5-1.1h50c1.7.1 3.5 0 5 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M203.6 347.7h-60v-35.8h18c1.3 1.6.9 3.5 1 5.4.3 6.8 5 11.6 11.2 11.5 6-.1 10.5-4.9 10.8-11.5.1-1.8-.4-3.8 1-5.4h18v35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43DBFD",
    d: "M59.9 287.9c-10.7 0-21.4-.1-32.2.2-3.2.1-3.9-1-3.9-4 .1-57.8.1-115.7.1-173.5V78.1c0-6.1-.7-5.5 5.3-5.5h253.6c12.2 0 24.4.1 36.7-.1 2.8 0 3.9.6 3.9 3.7-.1 69.4-.1 138.9 0 208.3 0 2.3-.2 3.6-3.1 3.6-46.9-.1-93.7-.1-140.6-.1-.7-.9-.5-1.9-.4-2.9 1.1-6.3 2.4-12.5 3.7-18.7.3-1.4.8-2.7 2.3-3.1 2.1-.6 4.2-.4 6.3-.4h105.9c6.6 0 6.6 0 6.6-6.6v-8.6c0-5.3 0-5.3-4.8-7.2-1.6-1.9-1.1-4.2-1.1-6.4-.2-1.5-.1-3-.1-4.5v-114c0-5.7 0-5.8-5.9-5.8H55.1c-1.1 0-2.2 0-3.4.1-1.6.1-2.5.9-2.6 2.6-.1 1.5-.1 3-.1 4.5v112.2c0 1.6.1 3.2-.1 4.9 0 2.1.4 4.3-.8 6.3-4.8.9-5.6 4.1-5.2 8.4.3 3.5.2 7 0 10.5-.1 2.9 1.2 4 4 3.9 2.9-.1 5.7-.1 8.6 0 1.6 0 3.3-.1 4.6 1.2 1.4 2.7.8 5.6.8 8.4.1 3.8.1 7.7 0 11.5.1 1.1.1 2.5-1 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE6268",
    d: "M131.7 287.8H83.8c-1.3-1.4-1.1-3.2-1.1-4.9v-19.4c0-4.3-.3-4.7-4.6-5.8-4.6-1.2-9.1-2.3-13.7-3.5-1.6-.4-3.2-.7-4.5-1.8-2.3-4.6 0-8.5 1.9-12.4 1.7-2.6 4-4.8 6.4-6.7 4.5-2.9 9.7-3.3 14.8-4.1 4.2-.6 8.2-1.8 12.5-1.7 1.1.3 1.9 1.2 2.7 1.9 6.1 5.2 13.1 5.2 19.1.1.8-.7 1.6-1.6 2.7-1.9 4.3-.2 8.3 1.1 12.5 1.7 5.1.9 10.3 1.2 14.8 4.1 2.4 1.9 4.7 4.1 6.4 6.7 1.9 3.8 3.9 7.6 2.3 12.1-1.1 1.3-2.7 1.6-4.3 2-5.3 1.3-10.5 2.7-15.8 3.9-1.8.4-2.9 1.2-2.9 3.2-.5 7.1.1 14.3-.1 21.4-.1 1.7.2 3.6-1.2 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC8A5",
    d: "M132.3 260.4c-.6-2.1.5-2.7 2.4-3.1 7-1.6 13.9-3.4 20.9-5.2 2.3 1.9 1.7 4.8 2.4 7.2.4 1.4.5 2.9.8 4.4.2 3.4 1.6 6.8 1.2 9.6.6-2.8 1.8-6.2 3-9.6 2.6-7.9 5.3-15.7 7.8-23.6 1-2.2 1-4.9 3.3-6.4 1.9-.7 3.9-.5 5.9-.5 3.9-.1 7.8-.1 11.6 0 2.1.2 4.2-.4 6.1.8 1.4 1.8 1 3.9 1 5.9 0 3-.1 5.9 0 8.9.1 2.8-1 4.8-3.6 5.9-.6.3-1.1.7-1.7.8-4.5 1.3-7.1 4.5-8.7 8.7-1.7 8-3.4 15.9-5 23.9h-41.9c-.4-.4-1-.9-1.1-1.5-2-8.9-4.5-17.3-4.4-26.2zM60 252.1c7 1.7 13.9 3.5 20.9 5.1 2.2.5 3 1.5 3 3.8-.1 8.9 0 17.9 0 26.8H60c-.1-8-.1-15.9-.2-23.9-1.5-3.9-2-7.9.2-11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M185.5 311.9c0 2.2.1 4.5 0 6.7-.4 6.4-5.8 11.3-12.1 11.2-6.1-.1-11.4-5-11.7-11.2-.1-2.2 0-4.5 0-6.7h23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D32D3A",
    d: "M132.3 260.4c1.8 9.2 3.6 18.3 5.4 27.5h-6v-23.5c0-1.4-.4-2.9.6-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04947B",
    d: "M179.6 234c-2 0-4 .1-5.9.1-.4.3-.8.7-1.3.7-8.4.4-16.9 1.4-25.3-.7-4.4-2.6-9.5-3.1-14.4-4-.6-1.7.7-2.5 1.6-3.5 5.6-6.7 8.3-14.4 8.4-23.1 0-7.7.1-15.5 0-23.2-.2-13.4-6.2-23.8-17.8-30.5-12-6.9-24.2-6.4-35.8 1-10.2 6.5-15.7 16.2-16.1 28.4-.3 8.6-.2 17.2 0 25.8.2 7.8 2.9 14.8 7.8 21 1 1.2 2.6 2.1 2.1 4.1-4.9.9-9.9 1.4-14.4 4-6.8 1.6-13.6 2-20.4-.1 0-20.3-.1-40.6-.1-61 0-20.2.1-40.4-.1-60.6 0-3.1.5-4.2 4-4.2 81.2.1 162.4.1 243.6.1 2.1 0 4-.4 4 3-.1 40.7-.1 81.3-.1 122 0 .2-.1.5-.1.7-1.4 1.3-3.2 1.2-4.9 1.2h-91.8c-1.7 0-3.5 0-5-1.2-1.9 0-3.7-.1-5.6-.1-1.2-2.2.1-4.1.6-6.1 3-10.5 6-21 9-31.6.2-.8.5-1.7.7-2.5.6-3.1-.7-5.5-3.3-6.3-2.6-.7-5 .6-6.1 3.5-.7 1.9-1.2 3.8-1.7 5.7-3.1 11-6.3 22-9.4 33-.6 1.7-.9 3.3-2.2 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F4623",
    d: "M184.6 264c-.2-4.2 1.5-7.1 5.8-8.3 5.9-1.6 8.5-5.3 7.2-11.5-.3-1.3 0-2.7.1-4.1 1.4-1.4 3.2-1.2 4.9-1.2h91.8c1.7 0 3.5-.1 5 1.1 5.9.2 5.9.2 5.9 6.2 0 4.7-.2 9.5.1 14.2.2 2.9-.7 3.7-3.7 3.7-30.6-.1-61.1-.1-91.7-.1h-25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03705D",
    d: "M299.3 240c-33.9 0-67.8.1-101.7.1-.1-2-.1-4-.2-5.9h101.7c.1 1.9.2 3.8.2 5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F4623",
    d: "M60 252.1c-.1 4-.2 8-.2 11.9-5.1 0-10.2-.1-15.2 0-2.2.1-2.7-.7-2.7-2.7.1-5.7.2-11.4 0-17.1-.2-3.3.7-4.8 4.2-4.2.6.1 1.2 0 1.8-.1 5-1.7 10-1.8 14.9.1-1.9 3.8-3.4 7.7-2.8 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03705D",
    d: "M62.8 240.1c-5 0-9.9-.1-14.9-.1.1-2 .1-3.9.2-5.9 6.8 0 13.6.1 20.4.1-2 1.9-3.9 3.9-5.7 5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB440",
    d: "M82.8 230.2c-8.2-8.4-11.6-18.6-11-30.3.4-8.8-.8-17.7.7-26.5 2.9-16.7 18-29.2 35.2-29.2 17.2 0 32.6 12.4 35.2 29.2 1.8 11.6 1.1 23.4.4 35-.5 8.5-4.8 15.6-10.6 21.7-4.3-.7-8.6-1.4-13-2.1-2.2-3.2-.8-6.7-1.1-10.1-.1-1.9-.1-3.9.2-5.8.1-.5.2-1 .5-1.4 6-6.2 5.6-14 5.4-21.7-.1-1.8-.7-3.3-1.9-4.7-8.3-9.4-8.3-9.4-19.5-3.8-3.1 1.5-6.2 3.1-9.3 4.7-1.9 1-3.2 2.2-3.2 4.5-.2 7.4-.6 14.8 5.1 20.7.4.4.6 1.1.7 1.7.3 1.9.3 3.9.2 5.8-.3 3.4 1.1 7-1.1 10.2l-12.9 2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F4623",
    d: "M171.3 240.1c-2.2 8.1-5.1 16-7.9 24-1.9 1.2-3.8 1.3-5.6-.1-.8-4-1.6-8-2.3-11.9.6-4.3-.9-8.2-2.8-12 .8-.9 1.9-1.1 3-1.1 4.2-.1 8.4-.1 12.6 0 1.1 0 2.2.2 3 1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC8A5",
    d: "M119.6 217.7c0 3.5.1 6.9.1 10.4-5.1 8.3-18.9 8.3-24 0 0-3.5.1-6.9.1-10.4 1.2-.4 2.1.4 3.1.9 5.9 3.4 11.7 3.4 17.6 0 1-.6 1.9-1.4 3.1-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04705D",
    d: "M171.3 240.1h-18.6c-1.9-2-3.8-3.9-5.6-5.9 8.8 0 17.7-.1 26.5-.1-.7 2-1.5 4-2.3 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M179.6 234c4.1-14.5 8.1-29 12.3-43.4 1-3.4 4.3-5 7.3-4.1 3.4 1 5 4.2 3.9 8.1-3.7 13.2-7.4 26.3-11.2 39.5-4.1-.1-8.2-.1-12.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4ADAFA",
    d: "M157.9 264c1.9 0 3.8 0 5.6.1-1.1 3.5-2.2 7-3.4 10.6-1.3-3.6-2.2-7.1-2.2-10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M214.4 152.5c2.5-7.4 4.8-14.1 7-20.8 1.2-3.8 3.5-5.4 7.4-5.4 15.1.1 30.2 0 45.3 0 4.6 0 7.4 2.4 7.3 6.1-.1 3.6-2.7 5.8-7.2 5.8-12.7 0-25.4.1-38.2-.1-3 0-4.6.7-5.5 3.8-2.7 8.9-5.9 17.7-8.7 26.6-1 3-2.4 5.3-5.8 5.5-3.3.2-5.1-1.9-6.5-4.7-3.5-7.2-7.1-14.2-10.7-21.4-2-4.1-1.2-7.3 2-9 3.4-1.8 6.5-.4 8.7 3.8 1.5 3.1 3 6.1 4.9 9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M239.4 168.2c0-1.3.5-2.5 1.2-3.5 1.4-2 4.7-3.3 4.5-5.5-.2-1.9-3-3.4-4.4-5.3-2-2.6-1.9-5.4.4-7.8 2.3-2.3 5-2.5 7.8-.6 2.1 1.4 3.2 4.7 5.5 4.5 1.9-.2 3.4-3 5.3-4.4 2.7-2 5.5-1.8 7.8.6 2.3 2.3 2.5 5.1.5 7.8-1.4 1.9-4.1 3.4-4.4 5.3-.3 2.1 2.9 3.4 4.3 5.2 2 2.7 1.9 6-.5 8.1-2.5 2.2-5.1 2.3-7.8.3-1.9-1.4-3.1-4.4-5.2-4.4-2.2 0-3.4 3-5.3 4.4-2 1.4-4 1.8-6.3.7-2.2-1.1-3.1-3-3.4-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#03705D",
    d: "M260 198.2c-4.7 0-9.5.1-14.2 0-4-.1-6.5-2.5-6.4-6.2.1-3.5 2.5-5.8 6.4-5.8 9.7-.1 19.4-.1 29.1 0 4 0 6.5 2.5 6.4 6.2-.1 3.5-2.5 5.7-6.4 5.8H260zM236.1 222.1c-4.7 0-9.5.1-14.2 0-4.1-.1-6.5-2.5-6.4-6.2.1-3.5 2.5-5.8 6.4-5.8 9.7-.1 19.4-.1 29.1 0 4.1 0 6.5 2.5 6.4 6.2-.1 3.5-2.5 5.7-6.4 5.8h-14.9zM224.4 198.2c-1 0-2 .1-3 0-3.6-.2-5.8-2.5-5.9-5.9 0-3.4 2.2-5.8 5.7-6 1.9-.1 3.7-.1 5.6 0 4.1.1 6.6 2.3 6.6 5.9 0 3.6-2.4 5.9-6.5 6.1-.8-.1-1.7-.1-2.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC8A5",
    d: "M95.8 211.6c-7.4-6.7-6-15.5-6-24.1 0-1.4 1-1.9 2-2.4 6.7-3.3 13.4-6.6 20-10.1 1.7-.9 2.7-.5 3.9.8 1.1 1.2 2.1 2.5 3.4 3.4 9.3 6.4 7 15.4 5.7 24.2-.5 3.3-3 5.7-5.1 8.1-1.5 3.5-4.8 4.1-7.9 5-6 1.8-12.9-.5-16-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5BA92",
    d: "M95.8 211.6c8.8 6.1 16.1 6.1 23.9 0 0 2 0 4-.1 6-8.8 6.1-14.9 6.1-23.8 0v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M197.6 48.4c-6 7.1-14.6 11.5-23.9 12-9.6-.7-17.8-4.3-24-12-4.5-3.2-7.9-13.2-6-17.9.4-12.2 5.8-21.5 16.8-26.8 12-5.8 23.5-3.9 33.4 5 5.4 4.6 8.6 11.2 9 18.2.2 1.2.4 2.5.7 3.7.9 6.9-1.2 12.8-6 17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M197.6 48.4c3.3-5.4 5.4-11.5 6-17.9 3.1 0 6.2.1 9.3 0 2.1-.1 3.1.7 3.7 2.7 1.5 5.1 3.3 10.1 5 15.2h-24zM143.7 30.6c.1 6.4 2.2 12.7 6 17.9h-24c1.7-5 3.4-10.1 5-15.2.6-2 1.6-2.8 3.7-2.7h9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A9ACC",
    d: "M185.6 30.6c0 6.6-5.4 12-12 12s-12-5.4-12-12 5.4-12 12-12h.2c6.6.1 11.8 5.4 11.8 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BAEE9",
    d: "M173.5 24.6c3.3-.1 6.1 2.5 6.2 5.8.1 3.3-2.5 6.1-5.8 6.2s-6.1-2.5-6.2-5.8v-.2c-.1-3.2 2.4-5.9 5.6-6h.2z"
  }))), _symbol393 || (_symbol393 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-pulse",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428 269c-21.5 0-40.6 13.1-48.4 33h-41.2L307 221.3c-2.7-8.2-10.3-13.7-19-13.7h-.4c-8.8.2-16.4 6-18.8 14.5l-33.6 135.4-55.5-291.8C178 55.6 169.6 48 160 48c-9.5 0-16.9 6.2-19.4 16.2L90.3 302H32v40h74c9.2 0 17.2-6.2 19.4-15.2l30.7-160.6 54.1 282.1c1.5 8.8 8.9 15.1 18.6 15.7h1.2c9.3 0 16.9-5.3 19.2-13.5l40.2-162.9 15.5 40.7c2.7 8.2 10.3 13.7 19 13.7h56.4c8.3 19 27.1 31 47.6 31 13.9 0 26.9-5.6 36.8-15.8 9.8-10.1 15.2-23.3 15.2-37.2.1-28.6-22.7-51-51.9-51z",
    fill: "currentColor"
  }))), _symbol394 || (_symbol394 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 22 22",
    id: "icon-puzzle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 10.5h-1.5v-4c0-1.1-.9-2-2-2h-4V3a2.5 2.5 0 0 0-5 0v1.5h-4c-1.1 0-1.99.9-1.99 2v3.8H2c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7H.5v3.8c0 1.1.9 2 2 2h3.8V20c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7v1.5h3.8c1.1 0 2-.9 2-2v-4H19a2.5 2.5 0 0 0 0-5Z"
  }))), _symbol395 || (_symbol395 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-refresh",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 388c-72.597 0-132-59.405-132-132 0-72.601 59.403-132 132-132 36.3 0 69.299 15.4 92.406 39.601L278 234h154V80l-51.698 51.702C348.406 99.798 304.406 80 256 80c-96.797 0-176 79.203-176 176s78.094 176 176 176c81.045 0 148.287-54.134 169.401-128H378.85c-18.745 49.561-67.138 84-122.85 84z",
    fill: "currentColor"
  }))), _symbol396 || (_symbol396 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-ribbon",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256 72c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256 32c-70.692 0-128 57.308-128 128 0 70.692 57.308 128 128 128 70.692 0 128-57.308 128-128 0-70.692-57.308-128-128-128Zm0 224c-53.02 0-96-42.98-96-96s42.98-96 96-96 96 42.98 96 96-42.98 96-96 96Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M147.092 254.21 64 400h96l48 80 48-105.807 33.641-74.154A144.328 144.328 0 0 1 256 304c-43.505 0-82.503-19.293-108.908-49.79ZM364.908 254.211c-15.077 17.412-34.26 31.172-56.043 39.774l-44.752 98.092L304 480l48-80h96l-83.092-145.789Z"
  }))), _symbol397 || (_symbol397 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 21",
    fill: "none",
    id: "icon-rules",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1a3 3 0 0 1 3 3v2.143c0 .334 0 .501-.077.623a.5.5 0 0 1-.157.157C18.644 7 18.477 7 18.143 7H13m3-6a3 3 0 0 0-3 3v3m3-6H5c-1.886 0-2.828 0-3.414.586C1 2.172 1 3.114 1 5v14l3-1 3 1 3-1 3 1V7",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 5h4M6 9H5M5 13h3",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _symbol398 || (_symbol398 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 29 24",
    id: "icon-school",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.273 13.573v5.334L14.5 24l9.227-5.093v-5.334L14.5 18.667l-9.227-5.094ZM14.5 0 0 8l14.5 8 11.864-6.547v9.214H29V8L14.5 0Z"
  }))), _symbol399 || (_symbol399 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-send",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48 448 416-192L48 64v149.333L346 256 48 298.667z"
  }))), _symbol400 || (_symbol400 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 20",
    id: "icon-settings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34a.4.4 0 0 0-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
  }))), _symbol401 || (_symbol401 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-share",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M383.822 344.427c-16.045 0-31.024 5.326-41.721 15.979l-152.957-88.42c1.071-5.328 2.142-9.593 2.142-14.919 0-5.328-1.071-9.593-2.142-14.919l150.826-87.35c11.762 10.653 26.741 17.041 43.852 17.041 35.295 0 64.178-28.766 64.178-63.92C448 72.767 419.117 44 383.822 44c-35.297 0-64.179 28.767-64.179 63.92 0 5.327 1.065 9.593 2.142 14.919l-150.821 87.35c-11.767-10.654-26.741-17.041-43.856-17.041-35.296 0-63.108 28.766-63.108 63.92 0 35.153 28.877 63.92 64.178 63.92 17.115 0 32.089-6.389 43.856-17.042l151.891 88.421c-1.076 4.255-2.141 8.521-2.141 13.847 0 34.094 27.806 61.787 62.037 61.787 34.229 0 62.036-27.693 62.036-61.787.001-34.094-27.805-61.787-62.035-61.787z"
  }))), _symbol402 || (_symbol402 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-shield",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m466.5 83.7-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3Z",
    fill: "currentColor"
  }))), _symbol403 || (_symbol403 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 19",
    fill: "none",
    id: "icon-shippings",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.579.005c-1.176 0-2.129.91-2.129 2.033v4.066H4.79c-.268 0-.526.096-.723.27L.342 9.656a.996.996 0 0 0-.342.747v3.832c0 .561.477 1.016 1.064 1.016h2.129c0 1.684 1.43 3.05 3.193 3.05 1.763 0 3.193-1.366 3.193-3.05H14.9c0 1.684 1.43 3.05 3.193 3.05 1.764 0 3.193-1.366 3.193-3.05 1.176 0 2.129-.91 2.129-2.033V2.038c0-1.123-.953-2.033-2.129-2.033H9.58Zm9.579 15.247h-2.13c0 .561.478 1.017 1.065 1.017.588 0 1.065-.455 1.065-1.017ZM6.386 16.27c-.588 0-1.064-.455-1.064-1.017H7.45c0 .561-.476 1.017-1.064 1.017Zm3.193-3.05h11.707V2.038H9.58v11.181ZM7.45 8.137H5.206l-3.077 2.712v2.37H7.45V8.137Z",
    fill: "currentColor"
  }))), _symbol404 || (_symbol404 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 24 20",
    id: "icon-social_up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m7.409 6.292 5.54-5.54c.58-.59 1.52-.59 2.11-.01.36.36.51.87.41 1.37l-.95 4.58h5.65c2.15 0 3.6 2.2 2.76 4.18l-3.26 7.61c-.32.73-1.04 1.21-1.84 1.21h-9c-1.1 0-2-.9-2-2v-9.99c0-.53.21-1.04.58-1.41Zm-2.58 11.4c0 1.1-.9 2-2 2s-2-.9-2-2v-8c0-1.1.9-2 2-2s2 .9 2 2v8Z"
  }))), _symbol405 || (_symbol405 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-sort",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0c-.3 0-.5.1-.7.3l-8 8c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l1.4 1.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3l2-2c.3-.3.9-.1.9.4V23c0 .5.5 1 1 1h2c.5 0 1-.5 1-1V1c0-.3-.1-.5-.3-.7C9.5.1 9.3 0 9 0zM23.7 14.3l-1.4-1.4c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-2 2c-.3.3-.9.1-.9-.4V1c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v22c0 .3.1.5.3.7s.5.3.7.3c.3 0 .5-.1.7-.3l8-8c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7z"
  }))), _symbol406 || (_symbol406 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-sort_down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0c-.3 0-.5.1-.7.3l-8 8c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l1.4 1.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3l2-2c.3-.3.9-.1.9.4V23c0 .5.5 1 1 1h2c.5 0 1-.5 1-1V1c0-.3-.1-.5-.3-.7C9.5.1 9.3 0 9 0Z",
    fill: "#000",
    fillOpacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7 14.3-1.4-1.4c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-2 2c-.3.3-.9.1-.9-.4V1c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v22c0 .3.1.5.3.7.2.2.5.3.7.3.3 0 .5-.1.7-.3l8-8c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7Z",
    fill: "#000"
  }))), _symbol407 || (_symbol407 = /*#__PURE__*/React.createElement("symbol", {
    fill: "none",
    viewBox: "0 0 24 24",
    id: "icon-sort_up",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0c-.3 0-.5.1-.7.3l-8 8c-.2.2-.3.4-.3.7 0 .3.1.5.3.7l1.4 1.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3l2-2c.3-.3.9-.1.9.4V23c0 .5.5 1 1 1h2c.5 0 1-.5 1-1V1c0-.3-.1-.5-.3-.7C9.5.1 9.3 0 9 0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7 14.3-1.4-1.4c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-2 2c-.3.3-.9.1-.9-.4V1c0-.5-.5-1-1-1h-2c-.5 0-1 .5-1 1v22c0 .3.1.5.3.7.2.2.5.3.7.3.3 0 .5-.1.7-.3l8-8c.2-.2.3-.4.3-.7 0-.3-.1-.5-.3-.7Z",
    fill: "#000",
    fillOpacity: 0.37
  }))), _symbol408 || (_symbol408 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-star",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.702 9.846c.513-.532.342-1.065-.342-1.153l-6.15-.976c-.683-.089-1.537-.71-1.879-1.42L12.598.533c-.342-.71-.854-.71-1.196 0L8.67 6.298c-.342.71-1.196 1.33-1.88 1.42l-3.843.62-2.306.355c-.684.088-.855.62-.342 1.153l1.367 1.33 3.16 3.194c.342.355.598.887.683 1.508.086.266.086.62 0 .887l-.598 3.459-.512 2.927c-.085.71.256 1.065.94.71l5.466-3.016c.513-.266 1.367-.355 1.965-.177.17 0 .256.088.341.177l2.392 1.33 3.16 1.686c.598.355 1.025 0 .94-.71l-1.025-6.386c-.085-.71.17-1.774.683-2.307l4.442-4.612Z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    id: "icon-teacher",
    xmlns: "http://www.w3.org/2000/svg"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M350 10C162.2 10 10 162.2 10 350s152.2 340 340 340 340-152.2 340-340S537.8 10 350 10zM226 168.1c21.1 0 38.2 17.2 38.2 38.2 0 21.1-17.2 38.2-38.2 38.2s-38.2-17.2-38.2-38.2c-.1-21.2 17.1-38.2 38.2-38.2zm58.2 368c1.3 10.4-6.1 20.4-16.5 21.7h-2.6c-9.6 0-17.8-7-19.2-16.5l-19.5-139-19.5 139c-1.8 10.9-11.3 17.8-21.7 16.5-10.9-1.8-17.8-11.3-16.5-21.7l20.9-151.2-.8-79.6c-3 5.3-5.6 10.9-7 15.2-1.8 5.6-3.9 30.8-4.8 51.8-.5 8.6-7.8 15.7-16.5 15.7h-1.1c-9.1-.5-16.1-8.3-15.7-17.4.5-10.9 2.6-47.3 5.6-58.7 3.9-14.4 22.2-55.1 54.3-55.1h44.7c20.9 0 35.2 18.7 46.5 33.9 3.5 4.3 8.3 10.9 10.4 12.2 7.4 3 25.2 5.6 36.5 7l33.1-60.9c1.8-3 5.6-4.3 9.1-2.6 3 1.8 4.3 5.6 2.6 9.1L355 314.1c3.9 3 6.1 8.3 5.6 13.4-.8 9.1-8.6 15.7-17.8 15.2-3.5-.5-34.4-2.6-51.8-10.4-8.6-3.5-15.2-12.2-22.5-21.7-1.3-1.3-3-3.9-4.8-6.1l-.8 80.4 21.3 151.2zM558 364.8c0 17.4-14.4 31.3-31.3 31.3H442v105.6l41.7 33.9c4.8 3.5 5.6 10.4 1.8 15.2-2.2 2.6-5.6 3.9-8.6 3.9-2.6 0-4.8-.8-7-2.6l-39.1-31.7-39 31.7c-2.2 1.8-4.3 2.6-7 2.6-3.5 0-6.5-1.3-8.6-3.9-3.5-4.3-3-11.3 1.8-15.2l41.7-33.9V396.6H335c-17.4 0-31.3-14.4-31.3-31.3v-9.6c7.4 1.8 15.2 3 21.7 3.9v5.6c0 4.8 3.9 9.1 9.1 9.1h191.1c5.3 0 9.1-3.9 9.1-9.1V207.9c0-5.3-3.9-9.1-9.1-9.1H333.8c-5.3 0-9.1 3.9-9.1 9.1v81.7c-3.9-.8-7.4-1.3-10-2.2-1.8-2.2-4.3-5.6-5.6-7.4-1.8-2.2-3.9-5.3-6.1-7.8v-63.9c0-17.4 14.4-31.3 31.3-31.3H419v-10.9c0-6.1 4.8-10.9 10.9-10.9 6.1 0 10.9 4.8 10.9 10.9V177h84.7c17.4 0 31.3 13.9 32.6 30.8v157z"
  }))), _symbol409 || (_symbol409 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-text_bubble",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M256 64C141.1 64 48 139.2 48 232c0 64.9 45.6 121.2 112.3 149.2-5.2 25.8-21 47-33.5 60.5-2.3 2.5.2 6.5 3.6 6.3 11.5-.8 32.9-4.4 51-12.7 21.5-9.9 40.3-30.1 46.3-36.9 9.3 1 18.8 1.6 28.5 1.6 114.9 0 208-75.2 208-168C464 139.2 370.9 64 256 64z"
  }))), _symbol410 || (_symbol410 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 512 512",
    id: "icon-timer",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.9 371.6c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1c0-12.7-10.4-23.1-23.1-23.1s-23.1 10.3-23.1 23.1zm0-323.6v92.4h46.2V96.1c78.3 11.3 138.7 78.3 138.7 159.9 0 89.4-72.3 161.8-161.8 161.8S94.2 345.4 94.2 256c0-38.8 13.6-74.4 36.5-102.2L256 279.1l32.6-32.6L131.4 89.4v.5C80.8 127.7 48 187.8 48 256c0 114.9 92.9 208 208 208 114.9 0 208-93.1 208-208S370.9 48 256 48h-23.1zm161.8 208c0-12.7-10.4-23.1-23.1-23.1-12.7 0-23.1 10.4-23.1 23.1s10.4 23.1 23.1 23.1c12.7 0 23.1-10.4 23.1-23.1zm-277.4 0c0 12.7 10.4 23.1 23.1 23.1s23.1-10.4 23.1-23.1-10.4-23.1-23.1-23.1-23.1 10.4-23.1 23.1z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 347.2 347.47",
    id: "icon-visio-groupee",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.88 166.6c0-34-.11-68-.05-102 0-7 5.38-11.68 12.81-11.68h103.12c3.23 0 6.47-.07 9.7-.1a5.39 5.39 0 0 1 3.48-1c6.51 0 13-.31 19.54.19 1.46.21 2.37 1.23 3.35 2.19 5 4.93 10.69 8.43 17.88 9 1.88.16 3.73.55 4.49 2.7a14.38 14.38 0 0 1 .38 4.08v91.26c0 1.85.18 3.77-1 5.41-1.2 1.11-2.72 1.16-4.21 1.16q-23 .09-46 0a9.46 9.46 0 0 1-3-.39c-1.91-.75-1.84-2.47-1.89-4.07-.1-3-.05-6 0-8.94 0-7.28-3.15-12.52-9.63-15.94-4.26-2.25-8.94-3.74-12.71-6.9a2 2 0 0 1 .33-1.77c4-5 4.36-10.9 4-16.94v-6.33a16.88 16.88 0 0 0-16.95-16.71 16.6 16.6 0 0 0-16.94 16.63q-.06 3.16 0 6.34c-.34 6 0 11.91 4 16.93a2.22 2.22 0 0 1 .39 1.77c-3 2.79-6.75 4.15-10.34 5.71-8.69 3.81-12.8 10.14-12 19.65a53.34 53.34 0 0 1 0 6.69c-.07 1.47 0 3.05-1.74 3.81a14.15 14.15 0 0 1-4.8.48H54.54c-1.95 0-4.02.32-5.66-1.23Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#27c4a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88 166.6h47.86c1.46-1.28 3.26-1.11 5-1.11h61.72c1.73 0 3.53-.17 5 1.11l54 .05c.16.19.32.38.49.56.87 1.76.68 3.65.68 5.5v101.92c0 2 .25 4-.91 5.81-1.55 1.35-3.46 1.15-5.29 1.16-4.07 0-8.15.13-12.22-.07-8.82.21-17.65.06-26.47.07a6.25 6.25 0 0 1-4.25-1.08l-6-.2c-1.56-2.13-.79-4.58-.92-6.89-.19-3.22.34-6.49-.4-9.68-1.24-5.3-4.43-9-9.26-11.52-4.28-2.25-9-3.72-12.73-6.93a2.1 2.1 0 0 1 .37-1.75c4-5 4.36-10.8 4-16.79a55.7 55.7 0 0 0-.15-8.57 15.94 15.94 0 0 0-5.69-10.19c-2.18-1.81-2.64-3.74-1.39-6.53 2.42-5.39 1-10.4-3.28-13.66a10.85 10.85 0 0 0-12.88 0c-4.31 3.24-5.6 8.22-3.39 13.66.79 1.93 1.72 3.85-.28 5.41-6.61 5.12-7.49 12.12-6.84 19.77-.41 6.14.14 12 4.14 17.12a1.93 1.93 0 0 1 .27 1.42c-3.79 3.38-8.67 4.81-13 7.15-5.24 2.82-8.41 7-9.2 12.82-.47 3.46-.08 7-.16 10.47 0 1.59.26 3.27-.93 4.65-12.45 0-24.9.15-37.34.06-5.25 0-10.58-5.42-10.59-10.68q-.07-51.52.04-103.06Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#6ee6f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.41 166.61V64.83c.87-1.29 2.24-1.43 3.61-1.61a27.37 27.37 0 0 0 16.4-8.1c1.4-1.42 2.79-2.87 4.93-3.17 6.48-.4 12.95-.15 19.42-.16a5.34 5.34 0 0 1 3.52 1l81.54.11h32.54c6.08 0 11.59 5 11.59 10.86q.06 51.42-.07 102.85a4.93 4.93 0 0 1-3.81 1.16q-23.25.1-46.5 0a8.19 8.19 0 0 1-2.56-.38c-1.91-.77-1.82-2.49-1.87-4.09-.1-3.11 0-6.22 0-9.33-.08-6.8-3-11.94-9.05-15.16-3-1.57-6-3-9-4.55-1.32-.67-2.74-1.23-3.62-2.54a2.66 2.66 0 0 1 .33-2.77c2.17-3.05 2.91-6.65 4-10.12 7.85-4.06 6.73-8.92.06-12.07a13.91 13.91 0 0 1-1.1-4 16.83 16.83 0 0 0-16.55-13 17.32 17.32 0 0 0-16.64 13.07c-.38 1.51-.07 3.32-1.61 4.42-4.27 1.15-8.63.35-12.94.57a34.57 34.57 0 0 0-5.19.23c-2.62.54-4.27 2.08-4.18 4.86.08 2.59 1.7 4.1 4.18 4.48 3.44.53 6.92.12 10.39.25 2.58.1 5.21-.4 7.73.56 1.87 4.37 4 8.65 5.14 13.31-1.59 2.3-4.17 3.21-6.56 4.09-11.55 4.23-16.77 12.16-15.29 24.54.28 2.36 1.13 5.32-1.68 7.18a12.85 12.85 0 0 1-4.44.48H227.8c-1.84 0-3.77.21-5.35-1.12Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#43dbfd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.38 166.72 47.87-.17c1.47-1.21 3.25-1.1 5-1.11h61.9c1.73 0 3.51-.1 5 1.11l53.75.1q0 42.24.11 84.46c0 5.86.08 11.71 0 17.57a11.6 11.6 0 0 1-11.28 11.64c-14.2.11-28.4 0-42.6-.06-1.5-1.85-.85-4.06-1-6.12-.18-3.48.39-7-.4-10.43-1.21-5.3-4.42-9-9.25-11.52-4.28-2.25-9-3.72-12.73-6.93-.05-.36-.15-.79.07-1.08 4-5.17 4.59-11.24 4.55-17.46.84-2.67 2.77-4.7 4.16-7.05 3.81-6.49 3.84-13.07 0-17.87-4.82-6-10.74-8-18.3-5.48-2.88 1-4.72-.26-6.81-1.71-8.86-6.13-19.71-1.67-21.81 8.89-.65 3.26.39 6.15 1.7 9 2.18 4.75 5 9.19 6.74 14.16-.54 6.7 1.47 12.76 4.62 18.54-2.81 2.77-6.52 4-10 5.54-9 3.86-13.16 10.31-12.49 20.15.22 3.09 1 6.44-.94 9.4l.13.22a6.18 6.18 0 0 1-3.89 1c-8.93 0-17.86.15-26.8-.06-4.4.18-8.82.09-13.23.05-1.45 0-3 0-4.06-1.27Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fab440"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51 280.51h30.85l4 32.69q.93 7.53 1.88 15.05c-1.4 1.39-3.22 1.2-4.93 1.21h-97.85c-1.72 0-3.53.18-4.93-1.21q2.13-16.71 4.25-33.43c.6-4.78 1.12-9.57 1.67-14.35h30.79c1 1.26.37 2.64.26 4-.83 10 7.06 18.87 16.88 18.88s17.71-8.82 16.89-18.86c-.12-1.34-.77-2.72.24-3.98Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.52 328.26H283.7a10.66 10.66 0 0 1 10.5 10.43c.05 3-.22 6 .07 9 .34 3.53-.77 4.66-4.46 4.63-21.54-.17-43.09-.08-64.63-.08-23.42 0-46.83-.09-70.24.08-3.69 0-4.81-1.1-4.46-4.63.29-2.84 0-5.72.07-8.59a10.64 10.64 0 0 1 10.87-10.8c2.37-.05 4.73-.04 7.1-.04ZM246.28 52.81a33.53 33.53 0 0 1-23.9 12c-9.63-.68-17.81-4.29-24-12-4.54-3.21-7.89-13.23-6-17.89.38-12.21 5.84-21.5 16.79-26.83 12-5.85 23.52-3.86 33.4 5a25.76 25.76 0 0 1 9 18.21 25.17 25.17 0 0 0 .73 3.7c.92 6.9-1.24 12.79-6.02 17.81Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#e9e9e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.23 280.3v-13c0-6.42 2.47-11.6 8.16-14.8a110.14 110.14 0 0 1 15-7.32c1.28-.5 2.09.43 3 1 6.71 4.47 13.35 4.37 20-.16.79-.54 1.51-1.35 2.64-.85a101.93 101.93 0 0 1 15.65 7.8c5.1 3.12 7.28 8 7.44 13.81.12 4.48 0 9 0 13.45Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#db651e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.73 280.28c0-4.36-.09-8.72 0-13.07 0-6.3 2.5-11.42 8-14.62a113.92 113.92 0 0 1 15-7.41c1.28-.55 2.1.41 3 1 6.73 4.51 13.4 4.41 20-.17.79-.54 1.51-1.37 2.65-.83a113.35 113.35 0 0 1 15.33 7.62c5.27 3.11 7.57 8.07 7.71 14 .11 4.48 0 9 0 13.44Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#0baee9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.28 52.81a42.51 42.51 0 0 0 6-17.85c3.1 0 6.21.11 9.3 0 2.1-.09 3.09.71 3.69 2.72 1.54 5.09 3.3 10.12 5 15.16ZM192.44 35a31.49 31.49 0 0 0 6 17.89h-24c1.68-5 3.45-10.07 5-15.16.61-2 1.59-2.82 3.69-2.73 3.11.07 6.21 0 9.31 0Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.43 166.56H96.74c0-4.35-.08-8.7-.07-13.06 0-6.63 2.75-11.82 8.62-15 4.69-2.55 9.57-4.73 14.37-7.08 1.44-.6 2.29.53 3.27 1.16q10 6.41 19.67-.15c.87-.6 1.63-1.61 2.93-1 4.79 2.34 9.67 4.51 14.35 7.08 5.83 3.2 8.56 8.41 8.61 15 .03 4.35-.04 8.7-.06 13.05Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#02a337"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53 131.41c-9.16 7.17-16.82 7.18-25.87 0-4.93-5.38-5.57-11.89-4.91-18.73 5-3.92 9.87-7.84 17-5.68 4.74 1.44 9.61 2.47 14.43 3.66 1.56.39 3.19.64 4.25 2.08.64 6.82-.04 13.26-4.9 18.67Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fcc8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42 112.74c-6.69-1.69-13.41-3.27-20-5.12a8.83 8.83 0 0 0-7.35.91c-2.66 1.55-5.51 2.78-8.27 4.15-.08-3.84-.58-7.69.65-11.46a18.27 18.27 0 0 1 20.19-12.29 18 18 0 0 1 14.94 17.47c-.03 2.11-.12 4.22-.16 6.34Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#e99c2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.43 88.84c0 3.1-.07 6.21 0 9.31.06 1.83-.44 2.72-2.49 2.69q-9.5-.14-19 0c-2 0-2.51-.86-2.49-2.68.07-6.22.1-12.43 0-18.64 0-2.21.87-2.72 2.87-2.69 6.09.1 12.18.13 18.27 0 2.4-.06 3 .91 2.87 3.07-.13 2.97-.03 5.96-.03 8.94Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#02a337"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 226.38c-.82-8.24.41-15.7 7.85-20.83 2.12-1.46-.15-2.37-.6-3.3a12.07 12.07 0 0 1 1.89-13.87 11.91 11.91 0 0 1 13.39-2.81 12.19 12.19 0 0 1 7.23 12 11.48 11.48 0 0 1-2 5.57c-.55.83-1.32 1.51 0 2.41 7.45 5.1 8.68 12.59 7.87 20.83-2.61.66-4.48-1.12-6.48-2.15a23.35 23.35 0 0 0-22.71 0c-1.97 1.03-3.84 2.77-6.44 2.15Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#683b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 226.38a40.12 40.12 0 0 0 6-3c5.34-3.79 11.49-3.57 17.22-2.62 4.35.72 8.33 3.64 12.47 5.59.65 6.88 0 13.42-5 18.81-8.94 7.11-16.83 7.11-25.68 0-5.04-5.35-5.67-11.9-5.01-18.78Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fcc8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.51 280.51c2.24 11.11-2.26 19.89-11.85 22.95a16.52 16.52 0 0 1-17-3.7c-5.23-4.67-7.38-10.45-5.77-17.43.14-.61.21-1.23.31-1.84l17.15-.22Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.45 214.53a12 12 0 1 1 12-11.78 11.92 11.92 0 0 1-12 11.78Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#0baee9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.11 166.55h-71.86c0-4.61-.09-9.23.05-13.83.19-6.19 2.88-11.06 8.37-14.07 4.68-2.57 9.52-4.87 14.29-7.29 1.43-.65 2.35.4 3.33 1.07 6.76 4.57 13.46 4.44 20.13-.18.9-.62 1.73-1.51 3-.9 4.44 2.24 8.9 4.45 13.32 6.73 6.23 3.21 9.27 8.42 9.34 15.39.05 4.36.02 8.72.03 13.08Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#e72f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23 118.89c-5.58 0-11.15-.07-16.73-.13-4.56-.05-7.31-2.43-7.2-6.16s2.75-5.75 7.19-5.8c5.58-.06 11.15-.08 16.73-.12 1.23-1 2.74-1.07 4.22-1.08h27.48a6.11 6.11 0 0 1 4.22 1.08c3.42.53 5.81 2.28 5.9 5.91.09 3.84-2.35 5.68-5.92 6.29-1.23 1-2.73 1.06-4.22 1.06q-13.72.06-27.45 0c-1.45.06-2.99-.01-4.22-1.05Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#683b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.14 106.69h-35.92c.3-10.27 7.92-17.84 18-17.84s17.6 7.52 17.92 17.84Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#e99c2d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23 118.89h35.89c.17 4.8-2.2 8.65-4.69 12.46-5.94 4.77-12.35 7-19.91 4.08-2.48-1-4.31-2.83-6.56-4.07-2.54-3.79-4.88-7.66-4.73-12.47Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fcc8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 88.79a12 12 0 1 1-11.9-11.91A12 12 0 0 1 372 88.79Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#e72f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26 226.43c-2.41-4.77-4.91-9.49-7.2-14.32a14.57 14.57 0 0 1 4.29-18.37c5.51-4.32 12.74-4.13 18.49.72 1.71 1.44 3 1.82 5.21.92 6.58-2.68 13.47-.81 18.28 4.56a15.93 15.93 0 0 1 2.05 18.39c-1.54 2.82-3.5 5.42-5.27 8.12-2.36.69-4.07-.89-5.84-1.85-8.09-4.41-16.08-4.41-24.17 0-1.77.96-3.48 2.54-5.84 1.83Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#683b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26 226.43a30.65 30.65 0 0 0 5-2.46c5.42-4 11.63-3.71 17.78-3.38 3.54.18 6.27 2.75 9.44 4.08 1.25.52 2.44 1.18 3.66 1.78.49 6.85-.07 13.41-5.13 18.75-8.91 7.12-16.7 7.12-25.59 0-5.11-5.34-5.67-11.91-5.16-18.77Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#fcc8a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372 203.37c-.41 3.15 1.68 8-.84 10.48-2.31 2.24-7.12.54-10.83.66-3.24.11-6.48-.06-9.72.05-2 .07-2.61-.71-2.58-2.63.07-6.22.1-12.45 0-18.68 0-2.24.93-2.71 2.92-2.69q9.15.13 18.31 0c2.13 0 2.86.74 2.78 2.82-.11 3.11-.04 6.23-.04 9.99Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#db651e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.33 35a12 12 0 1 1-11.83-12 12 12 0 0 1 11.83 12Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#0a9acc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.2 29a6 6 0 1 1-5.81 6 5.82 5.82 0 0 1 5.81-6Z",
    transform: "translate(-48.8 -4.82)",
    style: {
      fill: "#0baee9"
    }
  })), _symbol411 || (_symbol411 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 347.2 347.5",
    xmlSpace: "preserve",
    id: "icon-visio-individuelle",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27C4A6",
    d: "M335.2 275.6H12c-6.6 0-12-5.4-12-12V58.9c0-6.6 5.4-12 12-12h323.2c6.6 0 12 5.4 12 12v204.7c0 6.6-5.4 12-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M190.7 275.7h30.8l4 32.7c.6 5 1.2 10 1.9 15-1.4 1.4-3.2 1.2-4.9 1.2h-97.9c-1.7 0-3.5.2-4.9-1.2 1.4-11.1 2.8-22.3 4.2-33.4.6-4.8 1.1-9.6 1.7-14.4h30.8c1 1.3.4 2.6.3 4-.8 10 7.1 18.9 16.9 18.9s17.7-8.8 16.9-18.9c-.2-1.3-.8-2.7.2-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E7",
    d: "M119.7 323.4h115.2c5.7.1 10.4 4.7 10.5 10.4 0 3-.2 6 .1 9 .3 3.5-.8 4.7-4.5 4.6-21.5-.2-43.1-.1-64.6-.1-23.4 0-46.8-.1-70.2.1-3.7 0-4.8-1.1-4.5-4.6.3-2.8 0-5.7.1-8.6-.1-5.9 4.6-10.7 10.5-10.8h7.4zM197.5 48c-6 7.1-14.6 11.5-23.9 12-9.6-.7-17.8-4.3-24-12-4.5-3.2-7.9-13.2-6-17.9.4-12.2 5.8-21.5 16.8-26.8 12-5.8 23.5-3.9 33.4 5 5.4 4.6 8.6 11.2 9 18.2.2 1.2.4 2.5.7 3.7.9 6.9-1.2 12.8-6 17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACACA",
    d: "M197.5 48c3.3-5.4 5.4-11.5 6-17.9 3.1 0 6.2.1 9.3 0 2.1-.1 3.1.7 3.7 2.7 1.5 5.1 3.3 10.1 5 15.2h-24zM143.6 30.2c.1 6.4 2.2 12.7 6 17.9h-24c1.7-5 3.4-10.1 5-15.2.6-2 1.6-2.8 3.7-2.7h9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02A337",
    d: "M232.6 275.5H70c0-9.9-.2-19.7-.2-29.6 0-15 6.2-26.8 19.5-34 10.6-5.8 21.7-10.7 32.6-16.1 3.3-1.4 5.2 1.2 7.4 2.6 15.1 9.7 30 9.6 44.6-.3 2-1.4 3.7-3.7 6.6-2.3 10.9 5.3 21.9 10.2 32.5 16.1 13.2 7.3 19.4 19.1 19.5 34 .3 9.8.1 19.7.1 29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC8A5",
    d: "M180.6 195.8c-20.8 16.3-38.1 16.3-58.7 0-11.2-12.2-12.6-27-11.1-42.5 11.3-8.9 22.4-17.8 38.5-12.9 10.7 3.3 21.8 5.6 32.7 8.3 3.5.9 7.2 1.5 9.6 4.7 1.6 15.5.1 30.1-11 42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E99C2D",
    d: "M191.7 153.4c-15.2-3.8-30.4-7.4-45.3-11.6-5.6-1.8-11.7-1-16.7 2.1-6 3.5-12.5 6.3-18.7 9.4-.2-8.7-1.3-17.4 1.5-26 6.4-19.2 25.8-31 45.8-27.9 19.3 3.3 33.6 20 33.9 39.6-.2 4.8-.4 9.6-.5 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02A337",
    d: "M300.6 99.2c0 7-.2 14.1 0 21.1.1 4.1-1 6.2-5.6 6.1-14.4-.2-28.7-.2-43.1 0-4.5 0-5.7-1.9-5.6-6.1.2-14.1.2-28.2 0-42.3 0-5 2-6.2 6.5-6.1 13.8.2 27.6.3 41.4 0 5.4-.1 6.8 2.1 6.5 7-.3 6.8-.1 13.6-.1 20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M190.7 275.7c2.2 11.1-2.3 19.9-11.9 23-5.9 2.1-12.5.7-17-3.7-5.2-4.7-7.4-10.5-5.8-17.4l.3-1.8 17.1-.2 17.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A9ACC",
    d: "M185.5 30.2c0 6.6-5.4 12-12 12s-12-5.4-12-12 5.4-12 12-12h.2c6.6.1 11.8 5.4 11.8 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0BAEE9",
    d: "M173.4 24.2c3.3-.1 6.1 2.5 6.2 5.8.1 3.3-2.5 6.1-5.8 6.2s-6.1-2.5-6.2-5.8v-.2c-.1-3.2 2.4-5.9 5.6-6h.2z"
  }))), _symbol412 || (_symbol412 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 24 24",
    id: "icon-warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    fill: "currentColor"
  }))), _symbol413 || (_symbol413 = /*#__PURE__*/React.createElement("symbol", {
    fill: "currentColor",
    viewBox: "0 0 20 20",
    id: "icon-warningRound",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.47 0 9.99 0 15.52 0 20 4.48 20 10S15.52 20 9.99 20C4.47 20 0 15.52 0 10Zm11-4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1V6Zm-1 12c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-1-5v2h2v-2H9Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.bdbc1f4f541f36c0495ca56e35626f84.svg";
export { ForwardRef as ReactComponent };